(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire64b2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire64b2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gOIrB", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("9xflP", function(module, exports) {

$parcel$export(module.exports, "normalizeClass", function () { return $6f131a8b96a87ba3$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "toDisplayString", function () { return $6f131a8b96a87ba3$export$b5b1545233b45293; });
$parcel$export(module.exports, "reactive", function () { return $6f131a8b96a87ba3$export$90a44edba14e47be; });
$parcel$export(module.exports, "withCtx", function () { return $6f131a8b96a87ba3$export$694b237e827a3d23; });
$parcel$export(module.exports, "withDirectives", function () { return $6f131a8b96a87ba3$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "provide", function () { return $6f131a8b96a87ba3$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $6f131a8b96a87ba3$export$a976684a0efeb93f; });
$parcel$export(module.exports, "watch", function () { return $6f131a8b96a87ba3$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "createCommentVNode", function () { return $6f131a8b96a87ba3$export$49553837c7236d3c; });
$parcel$export(module.exports, "Fragment", function () { return $6f131a8b96a87ba3$export$ffb0004e005737fa; });
$parcel$export(module.exports, "defineComponent", function () { return $6f131a8b96a87ba3$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "createVNode", function () { return $6f131a8b96a87ba3$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $6f131a8b96a87ba3$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return $6f131a8b96a87ba3$export$d75d499b4c16cf21; });
$parcel$export(module.exports, "resolveComponent", function () { return $6f131a8b96a87ba3$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $6f131a8b96a87ba3$export$b44c564a05ca975; });
$parcel$export(module.exports, "renderList", function () { return $6f131a8b96a87ba3$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "renderSlot", function () { return $6f131a8b96a87ba3$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $6f131a8b96a87ba3$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $6f131a8b96a87ba3$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "useAttrs", function () { return $6f131a8b96a87ba3$export$75e29435042cd2ea; });
$parcel$export(module.exports, "createElementBlock", function () { return $6f131a8b96a87ba3$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $6f131a8b96a87ba3$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "mergeProps", function () { return $6f131a8b96a87ba3$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $6f131a8b96a87ba3$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "computed", function () { return $6f131a8b96a87ba3$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "createApp", function () { return $6f131a8b96a87ba3$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "TransitionGroup", function () { return $6f131a8b96a87ba3$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "vModelText", function () { return $6f131a8b96a87ba3$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $6f131a8b96a87ba3$export$8847c2e532b35714; });
$parcel$export(module.exports, "withModifiers", function () { return $6f131a8b96a87ba3$export$26bd3b8e29e6f273; });
/**
* vue v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ let $6f131a8b96a87ba3$var$e1, $6f131a8b96a87ba3$var$t, $6f131a8b96a87ba3$var$n, $6f131a8b96a87ba3$var$r, $6f131a8b96a87ba3$var$i, $6f131a8b96a87ba3$var$l, $6f131a8b96a87ba3$var$s, $6f131a8b96a87ba3$var$o, $6f131a8b96a87ba3$var$a, $6f131a8b96a87ba3$var$c, $6f131a8b96a87ba3$var$u, $6f131a8b96a87ba3$var$d, $6f131a8b96a87ba3$var$p;
function $6f131a8b96a87ba3$var$h(e1) {
    let t = Object.create(null);
    for (let n of e1.split(","))t[n] = 1;
    return (e1)=>e1 in t;
}
let $6f131a8b96a87ba3$var$f = {}, $6f131a8b96a87ba3$var$g = [], $6f131a8b96a87ba3$var$m = ()=>{}, $6f131a8b96a87ba3$var$y = ()=>!1, $6f131a8b96a87ba3$var$v = (e1)=>111 === e1.charCodeAt(0) && 110 === e1.charCodeAt(1) && (e1.charCodeAt(2) > 122 || 97 > e1.charCodeAt(2)), $6f131a8b96a87ba3$var$b = (e1)=>e1.startsWith("onUpdate:"), $6f131a8b96a87ba3$var$_ = Object.assign, $6f131a8b96a87ba3$var$S = (e1, t)=>{
    let n = e1.indexOf(t);
    n > -1 && e1.splice(n, 1);
}, $6f131a8b96a87ba3$var$x = Object.prototype.hasOwnProperty, $6f131a8b96a87ba3$var$C = (e1, t)=>$6f131a8b96a87ba3$var$x.call(e1, t), $6f131a8b96a87ba3$var$k = Array.isArray, $6f131a8b96a87ba3$var$T = (e1)=>"function" == typeof e1, $6f131a8b96a87ba3$var$w = (e1)=>"string" == typeof e1, $6f131a8b96a87ba3$var$N = (e1)=>"symbol" == typeof e1, $6f131a8b96a87ba3$var$A = (e1)=>null !== e1 && "object" == typeof e1, $6f131a8b96a87ba3$var$E = (e1)=>($6f131a8b96a87ba3$var$A(e1) || $6f131a8b96a87ba3$var$T(e1)) && $6f131a8b96a87ba3$var$T(e1.then) && $6f131a8b96a87ba3$var$T(e1.catch), $6f131a8b96a87ba3$var$R = Object.prototype.toString, $6f131a8b96a87ba3$var$I = (e1)=>$6f131a8b96a87ba3$var$w(e1) && "NaN" !== e1 && "-" !== e1[0] && "" + parseInt(e1, 10) === e1, $6f131a8b96a87ba3$var$O = $6f131a8b96a87ba3$var$h(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"), $6f131a8b96a87ba3$var$M = $6f131a8b96a87ba3$var$h("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"), $6f131a8b96a87ba3$var$P = (e1)=>{
    let t = Object.create(null);
    return (n)=>t[n] || (t[n] = e1(n));
}, $6f131a8b96a87ba3$var$F = /-\w/g, $6f131a8b96a87ba3$export$161d051f5dd25de7 = $6f131a8b96a87ba3$var$P((e1)=>e1.replace($6f131a8b96a87ba3$var$F, (e1)=>e1.slice(1).toUpperCase())), $6f131a8b96a87ba3$var$L = /\B([A-Z])/g, $6f131a8b96a87ba3$var$V = $6f131a8b96a87ba3$var$P((e1)=>e1.replace($6f131a8b96a87ba3$var$L, "-$1").toLowerCase()), $6f131a8b96a87ba3$export$9a00dee1beb8f576 = $6f131a8b96a87ba3$var$P((e1)=>e1.charAt(0).toUpperCase() + e1.slice(1)), $6f131a8b96a87ba3$export$8c022799eeaaefcd = $6f131a8b96a87ba3$var$P((e1)=>e1 ? `on${$6f131a8b96a87ba3$export$9a00dee1beb8f576(e1)}` : ""), $6f131a8b96a87ba3$var$j = (e1, t)=>!Object.is(e1, t), $6f131a8b96a87ba3$var$U = (e1, ...t)=>{
    for(let n = 0; n < e1.length; n++)e1[n](...t);
}, $6f131a8b96a87ba3$var$H = (e1, t, n, r = !1)=>{
    Object.defineProperty(e1, t, {
        configurable: !0,
        enumerable: !1,
        writable: r,
        value: n
    });
}, $6f131a8b96a87ba3$var$q = (e1)=>{
    let t = parseFloat(e1);
    return isNaN(t) ? e1 : t;
}, $6f131a8b96a87ba3$var$W = (e1)=>{
    let t = $6f131a8b96a87ba3$var$w(e1) ? Number(e1) : 0 / 0;
    return isNaN(t) ? e1 : t;
}, $6f131a8b96a87ba3$var$K = ()=>$6f131a8b96a87ba3$var$e1 || ($6f131a8b96a87ba3$var$e1 = "u" > typeof globalThis ? globalThis : "u" > typeof self ? self : "u" > typeof window ? window : "u" > typeof $parcel$global ? $parcel$global : {}), $6f131a8b96a87ba3$var$z = $6f131a8b96a87ba3$var$h("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");
function $6f131a8b96a87ba3$export$8756898546458274(e1) {
    if ($6f131a8b96a87ba3$var$k(e1)) {
        let t = {};
        for(let n = 0; n < e1.length; n++){
            let r = e1[n], i = $6f131a8b96a87ba3$var$w(r) ? $6f131a8b96a87ba3$var$Z(r) : $6f131a8b96a87ba3$export$8756898546458274(r);
            if (i) for(let e1 in i)t[e1] = i[e1];
        }
        return t;
    }
    if ($6f131a8b96a87ba3$var$w(e1) || $6f131a8b96a87ba3$var$A(e1)) return e1;
}
let $6f131a8b96a87ba3$var$G = /;(?![^(]*\))/g, $6f131a8b96a87ba3$var$X = /:([^]+)/, $6f131a8b96a87ba3$var$Q = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $6f131a8b96a87ba3$var$Z(e1) {
    let t = {};
    return e1.replace($6f131a8b96a87ba3$var$Q, (e1)=>e1.startsWith("/*") ? "" : e1).split($6f131a8b96a87ba3$var$G).forEach((e1)=>{
        if (e1) {
            let n = e1.split($6f131a8b96a87ba3$var$X);
            n.length > 1 && (t[n[0].trim()] = n[1].trim());
        }
    }), t;
}
function $6f131a8b96a87ba3$export$4f7022d2d68e2c5a(e1) {
    let t = "";
    if ($6f131a8b96a87ba3$var$w(e1)) t = e1;
    else if ($6f131a8b96a87ba3$var$k(e1)) for(let n = 0; n < e1.length; n++){
        let r = $6f131a8b96a87ba3$export$4f7022d2d68e2c5a(e1[n]);
        r && (t += r + " ");
    }
    else if ($6f131a8b96a87ba3$var$A(e1)) for(let n in e1)e1[n] && (t += n + " ");
    return t.trim();
}
function $6f131a8b96a87ba3$export$601abcd8103db5e4(e1) {
    if (!e1) return null;
    let { class: t, style: n } = e1;
    return t && !$6f131a8b96a87ba3$var$w(t) && (e1.class = $6f131a8b96a87ba3$export$4f7022d2d68e2c5a(t)), n && (e1.style = $6f131a8b96a87ba3$export$8756898546458274(n)), e1;
}
let $6f131a8b96a87ba3$var$et = $6f131a8b96a87ba3$var$h("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot"), $6f131a8b96a87ba3$var$en = $6f131a8b96a87ba3$var$h("svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view"), $6f131a8b96a87ba3$var$er = $6f131a8b96a87ba3$var$h("annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics"), $6f131a8b96a87ba3$var$ei = $6f131a8b96a87ba3$var$h("area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr"), $6f131a8b96a87ba3$var$el = $6f131a8b96a87ba3$var$h("itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,playsinline,readonly");
function $6f131a8b96a87ba3$var$es(e1, t, n) {
    if (e1.length !== t.length) return !1;
    let r = !0;
    for(let i = 0; r && i < e1.length; i++)r = $6f131a8b96a87ba3$var$eu(e1[i], t[i], n);
    return r;
}
function $6f131a8b96a87ba3$var$eo(e1, t, n) {
    if (e1.size !== t.size) return !1;
    let r = Array.from(t), i = new Uint8Array(r.length);
    for (let t of e1){
        let e1 = -1;
        for(let l = 0; l < r.length; l++)if (!i[l] && $6f131a8b96a87ba3$var$eu(t, r[l], n)) {
            e1 = l;
            break;
        }
        if (e1 < 0) return !1;
        i[e1] = 1;
    }
    return !0;
}
function $6f131a8b96a87ba3$var$ea(e1, t, n) {
    let r, i, l, s, o = "[object Map]" === (r = e1, $6f131a8b96a87ba3$var$R.call(r)), a = "[object Map]" === (i = t, $6f131a8b96a87ba3$var$R.call(i));
    if (o || a) return !!o && !!a && $6f131a8b96a87ba3$var$eo(e1, t, n);
    o = "[object Set]" === (l = e1, $6f131a8b96a87ba3$var$R.call(l));
    if (a = "[object Set]" === (s = t, $6f131a8b96a87ba3$var$R.call(s)), o || a) return !!o && !!a && $6f131a8b96a87ba3$var$eo(e1, t, n);
    if (Object.keys(e1).length !== Object.keys(t).length) return !1;
    for(let r in e1){
        let i = e1.hasOwnProperty(r), l = t.hasOwnProperty(r);
        if (i && !l || !i && l || !$6f131a8b96a87ba3$var$eu(e1[r], t[r], n)) return !1;
    }
    return String(e1) === String(t);
}
function $6f131a8b96a87ba3$var$ec(e1, t, n, r) {
    n || (n = [
        new Map,
        new Map
    ]);
    let [i, l] = n;
    if (i.has(e1) || l.has(t)) return i.get(e1) === t && l.get(t) === e1;
    i.set(e1, t), l.set(t, e1);
    let s = r(e1, t, n);
    return i.delete(e1), l.delete(t), s;
}
function $6f131a8b96a87ba3$var$eu(e1, t, n) {
    let r, i;
    if (e1 === t) return !0;
    let l = "[object Date]" === (r = e1, $6f131a8b96a87ba3$var$R.call(r)), s = "[object Date]" === (i = t, $6f131a8b96a87ba3$var$R.call(i));
    return l || s ? !!l && !!s && e1.getTime() === t.getTime() : (l = $6f131a8b96a87ba3$var$N(e1), s = $6f131a8b96a87ba3$var$N(t), l || s) ? e1 === t : (l = $6f131a8b96a87ba3$var$k(e1), s = $6f131a8b96a87ba3$var$k(t), l || s) ? !!l && !!s && $6f131a8b96a87ba3$var$ec(e1, t, n, $6f131a8b96a87ba3$var$es) : (l = $6f131a8b96a87ba3$var$A(e1), s = $6f131a8b96a87ba3$var$A(t), l || s) ? !!l && !!s && $6f131a8b96a87ba3$var$ec(e1, t, n, $6f131a8b96a87ba3$var$ea) : String(e1) === String(t);
}
function $6f131a8b96a87ba3$var$ed(e1, t) {
    return e1.findIndex((e1)=>$6f131a8b96a87ba3$var$eu(e1, t));
}
let $6f131a8b96a87ba3$var$ep = (e1)=>!!(e1 && !0 === e1.__v_isRef), $6f131a8b96a87ba3$export$b5b1545233b45293 = (e1)=>$6f131a8b96a87ba3$var$w(e1) ? e1 : null == e1 ? "" : $6f131a8b96a87ba3$var$k(e1) || $6f131a8b96a87ba3$var$A(e1) && (e1.toString === $6f131a8b96a87ba3$var$R || !$6f131a8b96a87ba3$var$T(e1.toString)) ? $6f131a8b96a87ba3$var$ep(e1) ? $6f131a8b96a87ba3$export$b5b1545233b45293(e1.value) : JSON.stringify(e1, $6f131a8b96a87ba3$var$ef, 2) : String(e1), $6f131a8b96a87ba3$var$ef = (e1, t)=>{
    let n;
    if ($6f131a8b96a87ba3$var$ep(t)) return $6f131a8b96a87ba3$var$ef(e1, t.value);
    if ("[object Map]" === (n = t, $6f131a8b96a87ba3$var$R.call(n))) return {
        [`Map(${t.size})`]: [
            ...t.entries()
        ].reduce((e1, [t, n], r)=>(e1[$6f131a8b96a87ba3$var$eg(t, r) + " =>"] = n, e1), {})
    };
    {
        let e1;
        if ("[object Set]" === (e1 = t, $6f131a8b96a87ba3$var$R.call(e1))) return {
            [`Set(${t.size})`]: [
                ...t.values()
            ].map((e1)=>$6f131a8b96a87ba3$var$eg(e1))
        };
        else {
            if ($6f131a8b96a87ba3$var$N(t)) return $6f131a8b96a87ba3$var$eg(t);
            let e1;
            if ($6f131a8b96a87ba3$var$A(t) && !$6f131a8b96a87ba3$var$k(t) && "[object Object]" !== (e1 = t, $6f131a8b96a87ba3$var$R.call(e1))) return String(t);
        }
    }
    return t;
}, $6f131a8b96a87ba3$var$eg = (e1, t = "")=>{
    var n;
    return $6f131a8b96a87ba3$var$N(e1) ? `Symbol(${null != (n = e1.description) ? n : t})` : e1;
};
class $6f131a8b96a87ba3$export$1168ed9dbc71ddbd {
    constructor(e1 = !1){
        this.detached = e1, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e1 && $6f131a8b96a87ba3$var$t && ($6f131a8b96a87ba3$var$t.active ? (this.parent = $6f131a8b96a87ba3$var$t, this.index = ($6f131a8b96a87ba3$var$t.scopes || ($6f131a8b96a87ba3$var$t.scopes = [])).push(this) - 1) : (this._active = !1, this._warnOnRun = !1));
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            let e1, t;
            if (this._isPaused = !0, this.scopes) {
                let n = this.scopes.slice();
                for(e1 = 0, t = n.length; e1 < t; e1++)n[e1].pause();
            }
            for(e1 = 0, t = this.effects.length; e1 < t; e1++)this.effects[e1].pause();
        }
    }
    resume() {
        if (this._active && this._isPaused) {
            let e1, t;
            if (this._isPaused = !1, this.scopes) {
                let n = this.scopes.slice();
                for(e1 = 0, t = n.length; e1 < t; e1++)n[e1].resume();
            }
            let n = this.effects.slice();
            for(e1 = 0, t = n.length; e1 < t; e1++)n[e1].resume();
        }
    }
    run(e1) {
        if (this._active) {
            let n = $6f131a8b96a87ba3$var$t;
            try {
                return $6f131a8b96a87ba3$var$t = this, e1();
            } finally{
                $6f131a8b96a87ba3$var$t = n;
            }
        }
    }
    on() {
        1 == ++this._on && (this.prevScope = $6f131a8b96a87ba3$var$t, $6f131a8b96a87ba3$var$t = this);
    }
    off() {
        if (this._on > 0 && 0 == --this._on) {
            if ($6f131a8b96a87ba3$var$t === this) $6f131a8b96a87ba3$var$t = this.prevScope;
            else {
                let e1 = $6f131a8b96a87ba3$var$t;
                for(; e1;){
                    if (e1.prevScope === this) {
                        e1.prevScope = this.prevScope;
                        break;
                    }
                    e1 = e1.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(e1) {
        if (this._active) {
            let t, n;
            for(this._active = !1, t = 0, n = this.effects.length; t < n; t++)this.effects[t].stop();
            for(this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++)this.cleanups[t]();
            if (this.cleanups.length = 0, this.scopes) {
                let e1 = this.scopes.slice();
                for(t = 0, n = e1.length; t < n; t++)e1[t].stop(!0);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !e1) {
                let e1 = this.parent.scopes.pop();
                e1 && e1 !== this && (this.parent.scopes[this.index] = e1, e1.index = this.index);
            }
            this.parent = void 0;
        }
    }
}
function $6f131a8b96a87ba3$export$7056603ea81600be(e1) {
    return new $6f131a8b96a87ba3$export$1168ed9dbc71ddbd(e1);
}
function $6f131a8b96a87ba3$export$c7be4b0125a10cba() {
    return $6f131a8b96a87ba3$var$t;
}
function $6f131a8b96a87ba3$export$a780418acd4762da(e1, n = !1) {
    $6f131a8b96a87ba3$var$t && $6f131a8b96a87ba3$var$t.cleanups.push(e1);
}
let $6f131a8b96a87ba3$var$e_ = new WeakSet;
class $6f131a8b96a87ba3$export$28352bb4dd362521 {
    constructor(e1){
        this.fn = e1, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, $6f131a8b96a87ba3$var$t && ($6f131a8b96a87ba3$var$t.active ? $6f131a8b96a87ba3$var$t.effects.push(this) : this.flags &= -2);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        64 & this.flags && (this.flags &= -65, $6f131a8b96a87ba3$var$e_.has(this) && ($6f131a8b96a87ba3$var$e_.delete(this), this.trigger()));
    }
    notify() {
        (!(2 & this.flags) || 32 & this.flags) && (8 & this.flags || $6f131a8b96a87ba3$var$eC(this));
    }
    run() {
        if (!(1 & this.flags)) return this.fn();
        this.flags |= 2, $6f131a8b96a87ba3$var$eD(this), $6f131a8b96a87ba3$var$eT(this);
        let e1 = $6f131a8b96a87ba3$var$n, t = $6f131a8b96a87ba3$var$eO;
        $6f131a8b96a87ba3$var$n = this, $6f131a8b96a87ba3$var$eO = !0;
        try {
            return this.fn();
        } finally{
            $6f131a8b96a87ba3$var$ew(this), $6f131a8b96a87ba3$var$n = e1, $6f131a8b96a87ba3$var$eO = t, this.flags &= -3;
        }
    }
    stop() {
        if (1 & this.flags) {
            for(let e1 = this.deps; e1; e1 = e1.nextDep)$6f131a8b96a87ba3$var$eE(e1);
            this.deps = this.depsTail = void 0, $6f131a8b96a87ba3$var$eD(this), this.onStop && this.onStop(), this.flags &= -2;
        }
    }
    trigger() {
        64 & this.flags ? $6f131a8b96a87ba3$var$e_.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
    }
    runIfDirty() {
        $6f131a8b96a87ba3$var$eN(this) && this.run();
    }
    get dirty() {
        return $6f131a8b96a87ba3$var$eN(this);
    }
}
let $6f131a8b96a87ba3$var$ex = 0;
function $6f131a8b96a87ba3$var$eC(e1, t = !1) {
    if (e1.flags |= 8, t) {
        e1.next = $6f131a8b96a87ba3$var$i, $6f131a8b96a87ba3$var$i = e1;
        return;
    }
    e1.next = $6f131a8b96a87ba3$var$r, $6f131a8b96a87ba3$var$r = e1;
}
function $6f131a8b96a87ba3$var$ek() {
    let e1;
    if (!(--$6f131a8b96a87ba3$var$ex > 0)) {
        if ($6f131a8b96a87ba3$var$i) {
            let e1 = $6f131a8b96a87ba3$var$i;
            for($6f131a8b96a87ba3$var$i = void 0; e1;){
                let t = e1.next;
                e1.next = void 0, e1.flags &= -9, e1 = t;
            }
        }
        for(; $6f131a8b96a87ba3$var$r;){
            let t = $6f131a8b96a87ba3$var$r;
            for($6f131a8b96a87ba3$var$r = void 0; t;){
                let n = t.next;
                if (t.next = void 0, t.flags &= -9, 1 & t.flags) try {
                    t.trigger();
                } catch (t) {
                    e1 || (e1 = t);
                }
                t = n;
            }
        }
        if (e1) throw e1;
    }
}
function $6f131a8b96a87ba3$var$eT(e1) {
    for(let t = e1.deps; t; t = t.nextDep)t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function $6f131a8b96a87ba3$var$ew(e1) {
    let t, n = e1.depsTail, r = n;
    for(; r;){
        let e1 = r.prevDep;
        -1 === r.version ? (r === n && (n = e1), $6f131a8b96a87ba3$var$eE(r), function(e1) {
            let { prevDep: t, nextDep: n } = e1;
            t && (t.nextDep = n, e1.prevDep = void 0), n && (n.prevDep = t, e1.nextDep = void 0);
        }(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e1;
    }
    e1.deps = t, e1.depsTail = n;
}
function $6f131a8b96a87ba3$var$eN(e1) {
    for(let t = e1.deps; t; t = t.nextDep)if (t.dep.version !== t.version || t.dep.computed && ($6f131a8b96a87ba3$var$eA(t.dep.computed) || t.dep.version !== t.version)) return !0;
    return !!e1._dirty;
}
function $6f131a8b96a87ba3$var$eA(e1) {
    if (4 & e1.flags && !(16 & e1.flags) || (e1.flags &= -17, e1.globalVersion === $6f131a8b96a87ba3$var$eL) || (e1.globalVersion = $6f131a8b96a87ba3$var$eL, !e1.isSSR && 128 & e1.flags && (!e1.deps && !e1._dirty || !$6f131a8b96a87ba3$var$eN(e1)))) return;
    e1.flags |= 2;
    let t = e1.dep, r = $6f131a8b96a87ba3$var$n, i = $6f131a8b96a87ba3$var$eO;
    $6f131a8b96a87ba3$var$n = e1, $6f131a8b96a87ba3$var$eO = !0;
    try {
        $6f131a8b96a87ba3$var$eT(e1);
        let n = e1.fn(e1._value);
        (0 === t.version || $6f131a8b96a87ba3$var$j(n, e1._value)) && (e1.flags |= 128, e1._value = n, t.version++);
    } catch (e1) {
        throw t.version++, e1;
    } finally{
        $6f131a8b96a87ba3$var$n = r, $6f131a8b96a87ba3$var$eO = i, $6f131a8b96a87ba3$var$ew(e1), e1.flags &= -3;
    }
}
function $6f131a8b96a87ba3$var$eE(e1, t = !1) {
    let { dep: n, prevSub: r, nextSub: i } = e1;
    if (r && (r.nextSub = i, e1.prevSub = void 0), i && (i.prevSub = r, e1.nextSub = void 0), n.subs === e1 && (n.subs = r, !r && n.computed)) {
        n.computed.flags &= -5;
        for(let e1 = n.computed.deps; e1; e1 = e1.nextDep)$6f131a8b96a87ba3$var$eE(e1, !0);
    }
    t || --n.sc || !n.map || n.map.delete(n.key);
}
function $6f131a8b96a87ba3$export$dc573d8a6576cdb3(e1, t) {
    e1.effect instanceof $6f131a8b96a87ba3$export$28352bb4dd362521 && (e1 = e1.effect.fn);
    let n = new $6f131a8b96a87ba3$export$28352bb4dd362521(e1);
    t && $6f131a8b96a87ba3$var$_(n, t);
    try {
        n.run();
    } catch (e1) {
        throw n.stop(), e1;
    }
    let r = n.run.bind(n);
    return r.effect = n, r;
}
function $6f131a8b96a87ba3$export$fa6813432f753b0d(e1) {
    e1.effect.stop();
}
let $6f131a8b96a87ba3$var$eO = !0, $6f131a8b96a87ba3$var$eM = [];
function $6f131a8b96a87ba3$var$eP() {
    $6f131a8b96a87ba3$var$eM.push($6f131a8b96a87ba3$var$eO), $6f131a8b96a87ba3$var$eO = !1;
}
function $6f131a8b96a87ba3$var$eF() {
    let e1 = $6f131a8b96a87ba3$var$eM.pop();
    $6f131a8b96a87ba3$var$eO = void 0 === e1 || e1;
}
function $6f131a8b96a87ba3$var$eD(e1) {
    let { cleanup: t } = e1;
    if (e1.cleanup = void 0, t) {
        let e1 = $6f131a8b96a87ba3$var$n;
        $6f131a8b96a87ba3$var$n = void 0;
        try {
            t();
        } finally{
            $6f131a8b96a87ba3$var$n = e1;
        }
    }
}
let $6f131a8b96a87ba3$var$eL = 0;
class $6f131a8b96a87ba3$var$eV {
    constructor(e1, t){
        this.sub = e1, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $6f131a8b96a87ba3$var$e$ {
    constructor(e1){
        this.computed = e1, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
    }
    track(e1) {
        if (!$6f131a8b96a87ba3$var$n || !$6f131a8b96a87ba3$var$eO || $6f131a8b96a87ba3$var$n === this.computed) return;
        let t = this.activeLink;
        if (void 0 === t || t.sub !== $6f131a8b96a87ba3$var$n) t = this.activeLink = new $6f131a8b96a87ba3$var$eV($6f131a8b96a87ba3$var$n, this), $6f131a8b96a87ba3$var$n.deps ? (t.prevDep = $6f131a8b96a87ba3$var$n.depsTail, $6f131a8b96a87ba3$var$n.depsTail.nextDep = t, $6f131a8b96a87ba3$var$n.depsTail = t) : $6f131a8b96a87ba3$var$n.deps = $6f131a8b96a87ba3$var$n.depsTail = t, function e1(t) {
            if (t.dep.sc++, 4 & t.sub.flags) {
                let n = t.dep.computed;
                if (n && !t.dep.subs) {
                    n.flags |= 20;
                    for(let t = n.deps; t; t = t.nextDep)e1(t);
                }
                let r = t.dep.subs;
                r !== t && (t.prevSub = r, r && (r.nextSub = t)), t.dep.subs = t;
            }
        }(t);
        else if (-1 === t.version && (t.version = this.version, t.nextDep)) {
            let e1 = t.nextDep;
            e1.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e1), t.prevDep = $6f131a8b96a87ba3$var$n.depsTail, t.nextDep = void 0, $6f131a8b96a87ba3$var$n.depsTail.nextDep = t, $6f131a8b96a87ba3$var$n.depsTail = t, $6f131a8b96a87ba3$var$n.deps === t && ($6f131a8b96a87ba3$var$n.deps = e1);
        }
        return t;
    }
    trigger(e1) {
        this.version++, $6f131a8b96a87ba3$var$eL++, this.notify(e1);
    }
    notify(e1) {
        $6f131a8b96a87ba3$var$ex++;
        try {
            for(let e1 = this.subs; e1; e1 = e1.prevSub)e1.sub.notify() && e1.sub.dep.notify();
        } finally{
            $6f131a8b96a87ba3$var$ek();
        }
    }
}
let $6f131a8b96a87ba3$var$eB = new WeakMap, $6f131a8b96a87ba3$var$ej = Symbol(""), $6f131a8b96a87ba3$var$eU = Symbol(""), $6f131a8b96a87ba3$var$eH = Symbol("");
function $6f131a8b96a87ba3$var$eq(e1, t, r) {
    if ($6f131a8b96a87ba3$var$eO && $6f131a8b96a87ba3$var$n) {
        let t = $6f131a8b96a87ba3$var$eB.get(e1);
        t || $6f131a8b96a87ba3$var$eB.set(e1, t = new Map);
        let n = t.get(r);
        n || (t.set(r, n = new $6f131a8b96a87ba3$var$e$), n.map = t, n.key = r), n.track();
    }
}
function $6f131a8b96a87ba3$var$eW(e1, t, n, r, i, l) {
    let s = $6f131a8b96a87ba3$var$eB.get(e1);
    if (!s) return void $6f131a8b96a87ba3$var$eL++;
    let o = (e1)=>{
        e1 && e1.trigger();
    };
    if ($6f131a8b96a87ba3$var$ex++, "clear" === t) s.forEach(o);
    else {
        let i = $6f131a8b96a87ba3$var$k(e1), l = i && $6f131a8b96a87ba3$var$I(n);
        if (i && "length" === n) {
            let e1 = Number(r);
            s.forEach((t, n)=>{
                ("length" === n || n === $6f131a8b96a87ba3$var$eH || !$6f131a8b96a87ba3$var$N(n) && n >= e1) && o(t);
            });
        } else switch((void 0 !== n || s.has(void 0)) && o(s.get(n)), l && o(s.get($6f131a8b96a87ba3$var$eH)), t){
            case "add":
                if (i) l && o(s.get("length"));
                else {
                    let t;
                    o(s.get($6f131a8b96a87ba3$var$ej));
                    "[object Map]" === (t = e1, $6f131a8b96a87ba3$var$R.call(t)) && o(s.get($6f131a8b96a87ba3$var$eU));
                }
                break;
            case "delete":
                if (!i) {
                    let t;
                    o(s.get($6f131a8b96a87ba3$var$ej));
                    "[object Map]" === (t = e1, $6f131a8b96a87ba3$var$R.call(t)) && o(s.get($6f131a8b96a87ba3$var$eU));
                }
                break;
            case "set":
                let a;
                "[object Map]" === (a = e1, $6f131a8b96a87ba3$var$R.call(a)) && o(s.get($6f131a8b96a87ba3$var$ej));
        }
    }
    $6f131a8b96a87ba3$var$ek();
}
function $6f131a8b96a87ba3$var$eK(e1) {
    let t = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1);
    return t === e1 || ($6f131a8b96a87ba3$var$eq(t, "iterate", $6f131a8b96a87ba3$var$eH), $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1)) ? t : $6f131a8b96a87ba3$export$92d09b48637741e7(e1) ? $6f131a8b96a87ba3$export$352205f445242f02(e1) ? t.map((e1)=>$6f131a8b96a87ba3$var$tw($6f131a8b96a87ba3$var$tT(e1))) : t.map($6f131a8b96a87ba3$var$tw) : t.map($6f131a8b96a87ba3$var$tT);
}
function $6f131a8b96a87ba3$var$ez(e1) {
    return $6f131a8b96a87ba3$var$eq(e1 = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), "iterate", $6f131a8b96a87ba3$var$eH), e1;
}
function $6f131a8b96a87ba3$var$eJ(e1, t) {
    return $6f131a8b96a87ba3$export$92d09b48637741e7(e1) ? $6f131a8b96a87ba3$export$352205f445242f02(e1) ? $6f131a8b96a87ba3$var$tw($6f131a8b96a87ba3$var$tT(t)) : $6f131a8b96a87ba3$var$tw(t) : $6f131a8b96a87ba3$var$tT(t);
}
let $6f131a8b96a87ba3$var$eG = {
    __proto__: null,
    [Symbol.iterator] () {
        return $6f131a8b96a87ba3$var$eX(this, Symbol.iterator, (e1)=>$6f131a8b96a87ba3$var$eJ(this, e1));
    },
    concat (...e1) {
        return $6f131a8b96a87ba3$var$eK(this).concat(...e1.map((e1)=>$6f131a8b96a87ba3$var$k(e1) ? $6f131a8b96a87ba3$var$eK(e1) : e1));
    },
    entries () {
        return $6f131a8b96a87ba3$var$eX(this, "entries", (e1)=>(e1[1] = $6f131a8b96a87ba3$var$eJ(this, e1[1]), e1));
    },
    every (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "every", e1, t, void 0, arguments);
    },
    filter (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "filter", e1, t, (e1)=>e1.map((e1)=>$6f131a8b96a87ba3$var$eJ(this, e1)), arguments);
    },
    find (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "find", e1, t, (e1)=>$6f131a8b96a87ba3$var$eJ(this, e1), arguments);
    },
    findIndex (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "findIndex", e1, t, void 0, arguments);
    },
    findLast (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "findLast", e1, t, (e1)=>$6f131a8b96a87ba3$var$eJ(this, e1), arguments);
    },
    findLastIndex (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "findLastIndex", e1, t, void 0, arguments);
    },
    forEach (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "forEach", e1, t, void 0, arguments);
    },
    includes (...e1) {
        return $6f131a8b96a87ba3$var$e11(this, "includes", e1);
    },
    indexOf (...e1) {
        return $6f131a8b96a87ba3$var$e11(this, "indexOf", e1);
    },
    join (e1) {
        return $6f131a8b96a87ba3$var$eK(this).join(e1);
    },
    lastIndexOf (...e1) {
        return $6f131a8b96a87ba3$var$e11(this, "lastIndexOf", e1);
    },
    map (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "map", e1, t, void 0, arguments);
    },
    pop () {
        return $6f131a8b96a87ba3$var$e2(this, "pop");
    },
    push (...e1) {
        return $6f131a8b96a87ba3$var$e2(this, "push", e1);
    },
    reduce (e1, ...t) {
        return $6f131a8b96a87ba3$var$e0(this, "reduce", e1, t);
    },
    reduceRight (e1, ...t) {
        return $6f131a8b96a87ba3$var$e0(this, "reduceRight", e1, t);
    },
    shift () {
        return $6f131a8b96a87ba3$var$e2(this, "shift");
    },
    some (e1, t) {
        return $6f131a8b96a87ba3$var$eY(this, "some", e1, t, void 0, arguments);
    },
    splice (...e1) {
        return $6f131a8b96a87ba3$var$e2(this, "splice", e1);
    },
    toReversed () {
        return $6f131a8b96a87ba3$var$eK(this).toReversed();
    },
    toSorted (e1) {
        return $6f131a8b96a87ba3$var$eK(this).toSorted(e1);
    },
    toSpliced (...e1) {
        return $6f131a8b96a87ba3$var$eK(this).toSpliced(...e1);
    },
    unshift (...e1) {
        return $6f131a8b96a87ba3$var$e2(this, "unshift", e1);
    },
    values () {
        return $6f131a8b96a87ba3$var$eX(this, "values", (e1)=>$6f131a8b96a87ba3$var$eJ(this, e1));
    }
};
function $6f131a8b96a87ba3$var$eX(e1, t, n) {
    let r = $6f131a8b96a87ba3$var$ez(e1), i = r[t], l = i.call(r);
    if (r !== e1 && !$6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1)) {
        if ("Array Iterator" === l[Symbol.toStringTag]) {
            let e1 = Object.create(Object.getPrototypeOf(l));
            return e1.next = ()=>$6f131a8b96a87ba3$var$eQ(l.next(), n), i !== $6f131a8b96a87ba3$var$eZ[t] && Object.defineProperties(e1, {
                return: {
                    get () {
                        let e1 = l.return;
                        return "function" == typeof e1 ? e1.bind(l) : e1;
                    }
                },
                throw: {
                    get () {
                        let e1 = l.throw;
                        return "function" == typeof e1 ? e1.bind(l) : e1;
                    }
                }
            }), e1;
        }
        l._next = l.next, l.next = ()=>$6f131a8b96a87ba3$var$eQ(l._next(), n);
    }
    return l;
}
function $6f131a8b96a87ba3$var$eQ(e1, t) {
    return e1.done || (e1.value = t(e1.value)), e1;
}
let $6f131a8b96a87ba3$var$eZ = Array.prototype;
function $6f131a8b96a87ba3$var$eY(e1, t, n, r, i, l) {
    let s = $6f131a8b96a87ba3$var$ez(e1), o = s !== e1 && !$6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1), a = s[t];
    if (a !== $6f131a8b96a87ba3$var$eZ[t]) {
        let t = a.apply(e1, l);
        return o ? $6f131a8b96a87ba3$var$tT(t) : t;
    }
    let c = n;
    s !== e1 && (o ? c = function(t, r) {
        return n.call(this, $6f131a8b96a87ba3$var$eJ(e1, t), r, e1);
    } : n.length > 2 && (c = function(t, r) {
        return n.call(this, t, r, e1);
    }));
    let u = a.call(s, c, r);
    return o && i ? i(u) : u;
}
function $6f131a8b96a87ba3$var$e0(e1, t, n, r) {
    let i = $6f131a8b96a87ba3$var$ez(e1), l = i !== e1 && !$6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1), s = n, o = !1;
    i !== e1 && (l ? (o = 0 === r.length, s = function(t, r, i) {
        return o && (o = !1, t = $6f131a8b96a87ba3$var$eJ(e1, t)), n.call(this, t, $6f131a8b96a87ba3$var$eJ(e1, r), i, e1);
    }) : n.length > 3 && (s = function(t, r, i) {
        return n.call(this, t, r, i, e1);
    }));
    let a = i[t](s, ...r);
    return o ? $6f131a8b96a87ba3$var$eJ(e1, a) : a;
}
function $6f131a8b96a87ba3$var$e11(e1, t, n) {
    let r = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1);
    $6f131a8b96a87ba3$var$eq(r, "iterate", $6f131a8b96a87ba3$var$eH);
    let i = r[t](...n);
    return (-1 === i || !1 === i) && $6f131a8b96a87ba3$export$5f3ca29d057519b3(n[0]) ? (n[0] = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n[0]), r[t](...n)) : i;
}
function $6f131a8b96a87ba3$var$e2(e1, t, n = []) {
    $6f131a8b96a87ba3$var$eP(), $6f131a8b96a87ba3$var$ex++;
    let r = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1)[t].apply(e1, n);
    return $6f131a8b96a87ba3$var$ek(), $6f131a8b96a87ba3$var$eF(), r;
}
let $6f131a8b96a87ba3$var$e3 = $6f131a8b96a87ba3$var$h("__proto__,__v_isRef,__isVue"), $6f131a8b96a87ba3$var$e6 = new Set(Object.getOwnPropertyNames(Symbol).filter((e1)=>"arguments" !== e1 && "caller" !== e1).map((e1)=>Symbol[e1]).filter($6f131a8b96a87ba3$var$N));
function $6f131a8b96a87ba3$var$e4(e1) {
    $6f131a8b96a87ba3$var$N(e1) || (e1 = String(e1));
    let t = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(this);
    return $6f131a8b96a87ba3$var$eq(t, "has", e1), t.hasOwnProperty(e1);
}
class $6f131a8b96a87ba3$var$e8 {
    constructor(e1 = !1, t = !1){
        this._isReadonly = e1, this._isShallow = t;
    }
    get(e1, t, n) {
        if ("__v_skip" === t) return e1.__v_skip;
        let r = this._isReadonly, i = this._isShallow;
        if ("__v_isReactive" === t) return !r;
        if ("__v_isReadonly" === t) return r;
        if ("__v_isShallow" === t) return i;
        if ("__v_raw" === t) return n === (r ? i ? $6f131a8b96a87ba3$var$th : $6f131a8b96a87ba3$var$tp : i ? $6f131a8b96a87ba3$var$td : $6f131a8b96a87ba3$var$tu).get(e1) || Object.getPrototypeOf(e1) === Object.getPrototypeOf(n) ? e1 : void 0;
        let l = $6f131a8b96a87ba3$var$k(e1);
        if (!r) {
            let e1;
            if (l && (e1 = $6f131a8b96a87ba3$var$eG[t])) return e1;
            if ("hasOwnProperty" === t) return $6f131a8b96a87ba3$var$e4;
        }
        let s = Reflect.get(e1, t, $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? e1 : n);
        if (($6f131a8b96a87ba3$var$N(t) ? $6f131a8b96a87ba3$var$e6.has(t) : $6f131a8b96a87ba3$var$e3(t)) || (r || $6f131a8b96a87ba3$var$eq(e1, "get", t), i)) return s;
        if ($6f131a8b96a87ba3$export$4f9f5282de18fc69(s)) {
            let e1 = l && $6f131a8b96a87ba3$var$I(t) ? s : s.value;
            return r && $6f131a8b96a87ba3$var$A(e1) ? $6f131a8b96a87ba3$export$6ec456bd5b7b3c51(e1) : e1;
        }
        return $6f131a8b96a87ba3$var$A(s) ? r ? $6f131a8b96a87ba3$export$6ec456bd5b7b3c51(s) : $6f131a8b96a87ba3$export$90a44edba14e47be(s) : s;
    }
}
class $6f131a8b96a87ba3$var$e5 extends $6f131a8b96a87ba3$var$e8 {
    constructor(e1 = !1){
        super(!1, e1);
    }
    set(e1, t, n, r) {
        let i = e1[t], l = $6f131a8b96a87ba3$var$k(e1) && $6f131a8b96a87ba3$var$I(t);
        if (!this._isShallow) {
            let e1 = $6f131a8b96a87ba3$export$92d09b48637741e7(i);
            if ($6f131a8b96a87ba3$export$7f3fe6025abfa26e(n) || $6f131a8b96a87ba3$export$92d09b48637741e7(n) || (i = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(i), n = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n)), !l && $6f131a8b96a87ba3$export$4f9f5282de18fc69(i) && !$6f131a8b96a87ba3$export$4f9f5282de18fc69(n)) {
                if (e1) return !0;
                else return i.value = n, !0;
            }
        }
        let s = l ? Number(t) < e1.length : $6f131a8b96a87ba3$var$C(e1, t), o = Reflect.set(e1, t, n, $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? e1 : r);
        return e1 === $6f131a8b96a87ba3$export$ab18938b9fc5f28e(r) && o && (s ? $6f131a8b96a87ba3$var$j(n, i) && $6f131a8b96a87ba3$var$eW(e1, "set", t, n) : $6f131a8b96a87ba3$var$eW(e1, "add", t, n)), o;
    }
    deleteProperty(e1, t) {
        let n = $6f131a8b96a87ba3$var$C(e1, t);
        e1[t];
        let r = Reflect.deleteProperty(e1, t);
        return r && n && $6f131a8b96a87ba3$var$eW(e1, "delete", t, void 0), r;
    }
    has(e1, t) {
        let n = Reflect.has(e1, t);
        return $6f131a8b96a87ba3$var$N(t) && $6f131a8b96a87ba3$var$e6.has(t) || $6f131a8b96a87ba3$var$eq(e1, "has", t), n;
    }
    ownKeys(e1) {
        return $6f131a8b96a87ba3$var$eq(e1, "iterate", $6f131a8b96a87ba3$var$k(e1) ? "length" : $6f131a8b96a87ba3$var$ej), Reflect.ownKeys(e1);
    }
}
class $6f131a8b96a87ba3$var$e9 extends $6f131a8b96a87ba3$var$e8 {
    constructor(e1 = !1){
        super(!0, e1);
    }
    set(e1, t) {
        return !0;
    }
    deleteProperty(e1, t) {
        return !0;
    }
}
let $6f131a8b96a87ba3$var$e7 = new $6f131a8b96a87ba3$var$e5, $6f131a8b96a87ba3$var$te = new $6f131a8b96a87ba3$var$e9, $6f131a8b96a87ba3$var$tt = new $6f131a8b96a87ba3$var$e5(!0), $6f131a8b96a87ba3$var$tn = new $6f131a8b96a87ba3$var$e9(!0), $6f131a8b96a87ba3$var$tr = (e1)=>e1;
function $6f131a8b96a87ba3$var$ti(e1) {
    return function() {
        return "delete" !== e1 && ("clear" === e1 ? void 0 : this);
    };
}
function $6f131a8b96a87ba3$var$tl(e1, t) {
    let n, r = ($6f131a8b96a87ba3$var$_(n = {
        get (n) {
            let r = this.__v_raw, i = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(r), l = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n);
            e1 || ($6f131a8b96a87ba3$var$j(n, l) && $6f131a8b96a87ba3$var$eq(i, "get", n), $6f131a8b96a87ba3$var$eq(i, "get", l));
            let { has: s } = Reflect.getPrototypeOf(i), o = t ? $6f131a8b96a87ba3$var$tr : e1 ? $6f131a8b96a87ba3$var$tw : $6f131a8b96a87ba3$var$tT;
            return s.call(i, n) ? o(r.get(n)) : s.call(i, l) ? o(r.get(l)) : void (r !== i && r.get(n));
        },
        get size () {
            let t = this.__v_raw;
            return e1 || $6f131a8b96a87ba3$var$eq($6f131a8b96a87ba3$export$ab18938b9fc5f28e(t), "iterate", $6f131a8b96a87ba3$var$ej), t.size;
        },
        has (t) {
            let n = this.__v_raw, r = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n), i = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(t);
            return e1 || ($6f131a8b96a87ba3$var$j(t, i) && $6f131a8b96a87ba3$var$eq(r, "has", t), $6f131a8b96a87ba3$var$eq(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
        },
        forEach (n, r) {
            let i = this, l = i.__v_raw, s = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(l), o = t ? $6f131a8b96a87ba3$var$tr : e1 ? $6f131a8b96a87ba3$var$tw : $6f131a8b96a87ba3$var$tT;
            return e1 || $6f131a8b96a87ba3$var$eq(s, "iterate", $6f131a8b96a87ba3$var$ej), l.forEach((e1, t)=>n.call(r, o(e1), o(t), i));
        }
    }, e1 ? {
        add: $6f131a8b96a87ba3$var$ti("add"),
        set: $6f131a8b96a87ba3$var$ti("set"),
        delete: $6f131a8b96a87ba3$var$ti("delete"),
        clear: $6f131a8b96a87ba3$var$ti("clear")
    } : {
        add (e1) {
            let n = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(this), r = Reflect.getPrototypeOf(n), i = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), l = t || $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1) || $6f131a8b96a87ba3$export$92d09b48637741e7(e1) ? e1 : i;
            return r.has.call(n, l) || $6f131a8b96a87ba3$var$j(e1, l) && r.has.call(n, e1) || $6f131a8b96a87ba3$var$j(i, l) && r.has.call(n, i) || (n.add(l), $6f131a8b96a87ba3$var$eW(n, "add", l, l)), this;
        },
        set (e1, n) {
            t || $6f131a8b96a87ba3$export$7f3fe6025abfa26e(n) || $6f131a8b96a87ba3$export$92d09b48637741e7(n) || (n = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n));
            let r = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(this), { has: i, get: l } = Reflect.getPrototypeOf(r), s = i.call(r, e1);
            s || (e1 = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), s = i.call(r, e1));
            let o = l.call(r, e1);
            return r.set(e1, n), s ? $6f131a8b96a87ba3$var$j(n, o) && $6f131a8b96a87ba3$var$eW(r, "set", e1, n) : $6f131a8b96a87ba3$var$eW(r, "add", e1, n), this;
        },
        delete (e1) {
            let t = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(this), { has: n, get: r } = Reflect.getPrototypeOf(t), i = n.call(t, e1);
            i || (e1 = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), i = n.call(t, e1)), r && r.call(t, e1);
            let l = t.delete(e1);
            return i && $6f131a8b96a87ba3$var$eW(t, "delete", e1, void 0), l;
        },
        clear () {
            let e1 = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(this), t = 0 !== e1.size, n = e1.clear();
            return t && $6f131a8b96a87ba3$var$eW(e1, "clear", void 0, void 0), n;
        }
    }), [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ].forEach((r)=>{
        n[r] = function(...n) {
            let i, l = this.__v_raw, s = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(l), o = "[object Map]" === (i = s, $6f131a8b96a87ba3$var$R.call(i)), a = "entries" === r || r === Symbol.iterator && o, c = l[r](...n), u = t ? $6f131a8b96a87ba3$var$tr : e1 ? $6f131a8b96a87ba3$var$tw : $6f131a8b96a87ba3$var$tT;
            return e1 || $6f131a8b96a87ba3$var$eq(s, "iterate", "keys" === r && o ? $6f131a8b96a87ba3$var$eU : $6f131a8b96a87ba3$var$ej), $6f131a8b96a87ba3$var$_(Object.create(c), {
                next () {
                    let { value: e1, done: t } = c.next();
                    return t ? {
                        value: e1,
                        done: t
                    } : {
                        value: a ? [
                            u(e1[0]),
                            u(e1[1])
                        ] : u(e1),
                        done: t
                    };
                }
            });
        };
    }), n);
    return (n, i, l)=>"__v_isReactive" === i ? !e1 : "__v_isReadonly" === i ? e1 : "__v_isShallow" === i ? t : "__v_raw" === i ? n : Reflect.get($6f131a8b96a87ba3$var$C(r, i) && i in n ? r : n, i, l);
}
let $6f131a8b96a87ba3$var$ts = {
    get: $6f131a8b96a87ba3$var$tl(!1, !1)
}, $6f131a8b96a87ba3$var$to = {
    get: $6f131a8b96a87ba3$var$tl(!1, !0)
}, $6f131a8b96a87ba3$var$ta = {
    get: $6f131a8b96a87ba3$var$tl(!0, !1)
}, $6f131a8b96a87ba3$var$tc = {
    get: $6f131a8b96a87ba3$var$tl(!0, !0)
}, $6f131a8b96a87ba3$var$tu = new WeakMap, $6f131a8b96a87ba3$var$td = new WeakMap, $6f131a8b96a87ba3$var$tp = new WeakMap, $6f131a8b96a87ba3$var$th = new WeakMap;
function $6f131a8b96a87ba3$export$90a44edba14e47be(e1) {
    return $6f131a8b96a87ba3$export$92d09b48637741e7(e1) ? e1 : $6f131a8b96a87ba3$var$tv(e1, !1, $6f131a8b96a87ba3$var$e7, $6f131a8b96a87ba3$var$ts, $6f131a8b96a87ba3$var$tu);
}
function $6f131a8b96a87ba3$export$8d81cefd22d22260(e1) {
    return $6f131a8b96a87ba3$var$tv(e1, !1, $6f131a8b96a87ba3$var$tt, $6f131a8b96a87ba3$var$to, $6f131a8b96a87ba3$var$td);
}
function $6f131a8b96a87ba3$export$6ec456bd5b7b3c51(e1) {
    return $6f131a8b96a87ba3$var$tv(e1, !0, $6f131a8b96a87ba3$var$te, $6f131a8b96a87ba3$var$ta, $6f131a8b96a87ba3$var$tp);
}
function $6f131a8b96a87ba3$export$7c4b5f2b50f09f6b(e1) {
    return $6f131a8b96a87ba3$var$tv(e1, !0, $6f131a8b96a87ba3$var$tn, $6f131a8b96a87ba3$var$tc, $6f131a8b96a87ba3$var$th);
}
function $6f131a8b96a87ba3$var$tv(e1, t, n, r, i) {
    let l;
    if (!$6f131a8b96a87ba3$var$A(e1) || e1.__v_raw && !(t && e1.__v_isReactive) || e1.__v_skip || !Object.isExtensible(e1)) return e1;
    let s = i.get(e1);
    if (s) return s;
    let o = function(e1) {
        switch(e1){
            case "Object":
            case "Array":
                return 1;
            case "Map":
            case "Set":
            case "WeakMap":
            case "WeakSet":
                return 2;
            default:
                return 0;
        }
    }((l = e1, $6f131a8b96a87ba3$var$R.call(l)).slice(8, -1));
    if (0 === o) return e1;
    let a = new Proxy(e1, 2 === o ? r : n);
    return i.set(e1, a), a;
}
function $6f131a8b96a87ba3$export$352205f445242f02(e1) {
    return $6f131a8b96a87ba3$export$92d09b48637741e7(e1) ? $6f131a8b96a87ba3$export$352205f445242f02(e1.__v_raw) : !!(e1 && e1.__v_isReactive);
}
function $6f131a8b96a87ba3$export$92d09b48637741e7(e1) {
    return !!(e1 && e1.__v_isReadonly);
}
function $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1) {
    return !!(e1 && e1.__v_isShallow);
}
function $6f131a8b96a87ba3$export$5f3ca29d057519b3(e1) {
    return !!e1 && !!e1.__v_raw;
}
function $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1) {
    let t = e1 && e1.__v_raw;
    return t ? $6f131a8b96a87ba3$export$ab18938b9fc5f28e(t) : e1;
}
function $6f131a8b96a87ba3$export$995ab8b13ad7a9d0(e1) {
    return !$6f131a8b96a87ba3$var$C(e1, "__v_skip") && Object.isExtensible(e1) && $6f131a8b96a87ba3$var$H(e1, "__v_skip", !0), e1;
}
let $6f131a8b96a87ba3$var$tT = (e1)=>$6f131a8b96a87ba3$var$A(e1) ? $6f131a8b96a87ba3$export$90a44edba14e47be(e1) : e1, $6f131a8b96a87ba3$var$tw = (e1)=>$6f131a8b96a87ba3$var$A(e1) ? $6f131a8b96a87ba3$export$6ec456bd5b7b3c51(e1) : e1;
function $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) {
    return !!e1 && !0 === e1.__v_isRef;
}
function $6f131a8b96a87ba3$export$eff4d24c3ff7876e(e1) {
    return $6f131a8b96a87ba3$var$tR(e1, !1);
}
function $6f131a8b96a87ba3$export$9b7bc5fe3b17c8b3(e1) {
    return $6f131a8b96a87ba3$var$tR(e1, !0);
}
function $6f131a8b96a87ba3$var$tR(e1, t) {
    return $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? e1 : new $6f131a8b96a87ba3$var$tI(e1, t);
}
class $6f131a8b96a87ba3$var$tI {
    constructor(e1, t){
        this.dep = new $6f131a8b96a87ba3$var$e$, this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e1 : $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), this._value = t ? e1 : $6f131a8b96a87ba3$var$tT(e1), this.__v_isShallow = t;
    }
    get value() {
        return this.dep.track(), this._value;
    }
    set value(e1) {
        let t = this._rawValue, n = this.__v_isShallow || $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1) || $6f131a8b96a87ba3$export$92d09b48637741e7(e1);
        $6f131a8b96a87ba3$var$j(e1 = n ? e1 : $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), t) && (this._rawValue = e1, this._value = n ? e1 : $6f131a8b96a87ba3$var$tT(e1), this.dep.trigger());
    }
}
function $6f131a8b96a87ba3$export$f402f86588575ccc(e1) {
    e1.dep && e1.dep.trigger();
}
function $6f131a8b96a87ba3$export$a239a76781616204(e1) {
    return $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? e1.value : e1;
}
function $6f131a8b96a87ba3$export$30bdcc2218aa9458(e1) {
    return $6f131a8b96a87ba3$var$T(e1) ? e1() : $6f131a8b96a87ba3$export$a239a76781616204(e1);
}
let $6f131a8b96a87ba3$var$tF = {
    get: (e1, t, n)=>"__v_raw" === t ? e1 : $6f131a8b96a87ba3$export$a239a76781616204(Reflect.get(e1, t, n)),
    set: (e1, t, n, r)=>{
        let i = e1[t];
        return $6f131a8b96a87ba3$export$4f9f5282de18fc69(i) && !$6f131a8b96a87ba3$export$4f9f5282de18fc69(n) ? (i.value = n, !0) : Reflect.set(e1, t, n, r);
    }
};
function $6f131a8b96a87ba3$export$f353fd1b97db3fa0(e1) {
    return $6f131a8b96a87ba3$export$352205f445242f02(e1) ? e1 : new Proxy(e1, $6f131a8b96a87ba3$var$tF);
}
class $6f131a8b96a87ba3$var$tL {
    constructor(e1){
        this.__v_isRef = !0, this._value = void 0;
        let t = this.dep = new $6f131a8b96a87ba3$var$e$, { get: n, set: r } = e1(t.track.bind(t), t.trigger.bind(t));
        this._get = n, this._set = r;
    }
    get value() {
        return this._value = this._get();
    }
    set value(e1) {
        this._set(e1);
    }
}
function $6f131a8b96a87ba3$export$a20c2dd6199824cb(e1) {
    return new $6f131a8b96a87ba3$var$tL(e1);
}
function $6f131a8b96a87ba3$export$2e9533675e5e70e0(e1) {
    let t = $6f131a8b96a87ba3$var$k(e1) ? Array(e1.length) : {};
    for(let n in e1)t[n] = new $6f131a8b96a87ba3$var$tB(e1, n, void 0);
    return t;
}
class $6f131a8b96a87ba3$var$tB {
    constructor(e1, t, n){
        this._object = e1, this._defaultValue = n, this.__v_isRef = !0, this._value = void 0, this._key = $6f131a8b96a87ba3$var$N(t) ? t : String(t), this._raw = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1);
        let r = !0, i = e1;
        if (!$6f131a8b96a87ba3$var$k(e1) || $6f131a8b96a87ba3$var$N(this._key) || !$6f131a8b96a87ba3$var$I(this._key)) do r = !$6f131a8b96a87ba3$export$5f3ca29d057519b3(i) || $6f131a8b96a87ba3$export$7f3fe6025abfa26e(i);
        while (r && (i = i.__v_raw));
        this._shallow = r;
    }
    get value() {
        let e1 = this._object[this._key];
        return this._shallow && (e1 = $6f131a8b96a87ba3$export$a239a76781616204(e1)), this._value = void 0 === e1 ? this._defaultValue : e1;
    }
    set value(e1) {
        if (this._shallow && $6f131a8b96a87ba3$export$4f9f5282de18fc69(this._raw[this._key])) {
            let t = this._object[this._key];
            if ($6f131a8b96a87ba3$export$4f9f5282de18fc69(t)) {
                t.value = e1;
                return;
            }
        }
        this._object[this._key] = e1;
    }
    get dep() {
        var e1, t;
        let n;
        return e1 = this._raw, t = this._key, (n = $6f131a8b96a87ba3$var$eB.get(e1)) && n.get(t);
    }
}
class $6f131a8b96a87ba3$var$tj {
    constructor(e1){
        this._getter = e1, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $6f131a8b96a87ba3$export$1f60508e4f47b4b7(e1, t, n) {
    if ($6f131a8b96a87ba3$export$4f9f5282de18fc69(e1)) return e1;
    if ($6f131a8b96a87ba3$var$T(e1)) return new $6f131a8b96a87ba3$var$tj(e1);
    if (!$6f131a8b96a87ba3$var$A(e1) || !(arguments.length > 1)) return $6f131a8b96a87ba3$export$eff4d24c3ff7876e(e1);
    return new $6f131a8b96a87ba3$var$tB(e1, t, n);
}
class $6f131a8b96a87ba3$var$tH {
    constructor(e1, t, n){
        this.fn = e1, this.setter = t, this._value = void 0, this.dep = new $6f131a8b96a87ba3$var$e$(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = $6f131a8b96a87ba3$var$eL - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
    }
    notify() {
        if (this.flags |= 16, !(8 & this.flags) && $6f131a8b96a87ba3$var$n !== this) return $6f131a8b96a87ba3$var$eC(this, !0), !0;
    }
    get value() {
        let e1 = this.dep.track();
        return $6f131a8b96a87ba3$var$eA(this), e1 && (e1.version = this.dep.version), this._value;
    }
    set value(e1) {
        this.setter && this.setter(e1);
    }
}
let $6f131a8b96a87ba3$export$2ac2bd0a56e04551 = {
    GET: "get",
    HAS: "has",
    ITERATE: "iterate"
}, $6f131a8b96a87ba3$export$1e8941c92696a26 = {
    SET: "set",
    ADD: "add",
    DELETE: "delete",
    CLEAR: "clear"
}, $6f131a8b96a87ba3$var$tK = {}, $6f131a8b96a87ba3$var$tz = new WeakMap;
function $6f131a8b96a87ba3$export$2532f7acfca7c82d() {
    return $6f131a8b96a87ba3$var$d;
}
function $6f131a8b96a87ba3$export$8ddeeb083684a9d0(e1, t = !1, n = $6f131a8b96a87ba3$var$d) {
    if (n) {
        let t = $6f131a8b96a87ba3$var$tz.get(n);
        t || $6f131a8b96a87ba3$var$tz.set(n, t = []), t.push(e1);
    }
}
function $6f131a8b96a87ba3$var$tX(e1, t = 1 / 0, n) {
    if (t <= 0 || !$6f131a8b96a87ba3$var$A(e1) || e1.__v_skip || ((n = n || new Map).get(e1) || 0) >= t) return e1;
    if (n.set(e1, t), t--, $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1)) $6f131a8b96a87ba3$var$tX(e1.value, t, n);
    else if ($6f131a8b96a87ba3$var$k(e1)) for(let r = 0; r < e1.length; r++)$6f131a8b96a87ba3$var$tX(e1[r], t, n);
    else {
        let r, i;
        if ("[object Set]" === (r = e1, $6f131a8b96a87ba3$var$R.call(r)) || "[object Map]" === (i = e1, $6f131a8b96a87ba3$var$R.call(i))) e1.forEach((e1)=>{
            $6f131a8b96a87ba3$var$tX(e1, t, n);
        });
        else {
            let r;
            if ("[object Object]" === (r = e1, $6f131a8b96a87ba3$var$R.call(r))) {
                for(let r in e1)$6f131a8b96a87ba3$var$tX(e1[r], t, n);
                for (let r of Object.getOwnPropertySymbols(e1))Object.prototype.propertyIsEnumerable.call(e1, r) && $6f131a8b96a87ba3$var$tX(e1[r], t, n);
            }
        }
    }
    return e1;
}
function $6f131a8b96a87ba3$export$dfbcecb440255e4a(e1, t) {}
let $6f131a8b96a87ba3$export$10e8e1cf990558d7 = {
    SETUP_FUNCTION: 0,
    0: "SETUP_FUNCTION",
    RENDER_FUNCTION: 1,
    1: "RENDER_FUNCTION",
    NATIVE_EVENT_HANDLER: 5,
    5: "NATIVE_EVENT_HANDLER",
    COMPONENT_EVENT_HANDLER: 6,
    6: "COMPONENT_EVENT_HANDLER",
    VNODE_HOOK: 7,
    7: "VNODE_HOOK",
    DIRECTIVE_HOOK: 8,
    8: "DIRECTIVE_HOOK",
    TRANSITION_HOOK: 9,
    9: "TRANSITION_HOOK",
    APP_ERROR_HANDLER: 10,
    10: "APP_ERROR_HANDLER",
    APP_WARN_HANDLER: 11,
    11: "APP_WARN_HANDLER",
    FUNCTION_REF: 12,
    12: "FUNCTION_REF",
    ASYNC_COMPONENT_LOADER: 13,
    13: "ASYNC_COMPONENT_LOADER",
    SCHEDULER: 14,
    14: "SCHEDULER",
    COMPONENT_UPDATE: 15,
    15: "COMPONENT_UPDATE",
    APP_UNMOUNT_CLEANUP: 16,
    16: "APP_UNMOUNT_CLEANUP"
};
function $6f131a8b96a87ba3$export$b22fcaf88446e9bf(e1, t, n, r) {
    try {
        return r ? e1(...r) : e1();
    } catch (e1) {
        $6f131a8b96a87ba3$export$d3da1ecaf1206c58(e1, t, n);
    }
}
function $6f131a8b96a87ba3$export$dae85862a8d94378(e1, t, n, r) {
    if ($6f131a8b96a87ba3$var$T(e1)) {
        let i = $6f131a8b96a87ba3$export$b22fcaf88446e9bf(e1, t, n, r);
        return i && $6f131a8b96a87ba3$var$E(i) && i.catch((e1)=>{
            $6f131a8b96a87ba3$export$d3da1ecaf1206c58(e1, t, n);
        }), i;
    }
    if ($6f131a8b96a87ba3$var$k(e1)) {
        let i = [];
        for(let l = 0; l < e1.length; l++)i.push($6f131a8b96a87ba3$export$dae85862a8d94378(e1[l], t, n, r));
        return i;
    }
}
function $6f131a8b96a87ba3$export$d3da1ecaf1206c58(e1, t, n, r = !0) {
    let i = t ? t.vnode : null, { errorHandler: l, throwUnhandledErrorInProduction: s } = t && t.appContext.config || $6f131a8b96a87ba3$var$f;
    if (t) {
        let r = t.parent, i = t.proxy, s = `https://vuejs.org/error-reference/#runtime-${n}`;
        for(; r;){
            let t = r.ec;
            if (t) {
                for(let n = 0; n < t.length; n++)if (!1 === t[n](e1, i, s)) return;
            }
            r = r.parent;
        }
        if (l) {
            $6f131a8b96a87ba3$var$eP(), $6f131a8b96a87ba3$export$b22fcaf88446e9bf(l, null, 10, [
                e1,
                i,
                s
            ]), $6f131a8b96a87ba3$var$eF();
            return;
        }
    }
    !function(e1, t = !0, n = !1) {
        if (n) throw e1;
        console.error(e1);
    }(e1, r, s);
}
let $6f131a8b96a87ba3$var$t2 = [], $6f131a8b96a87ba3$var$t3 = -1, $6f131a8b96a87ba3$var$t6 = [], $6f131a8b96a87ba3$var$t4 = null, $6f131a8b96a87ba3$var$t8 = 0, $6f131a8b96a87ba3$var$t5 = Promise.resolve(), $6f131a8b96a87ba3$var$t9 = null;
function $6f131a8b96a87ba3$export$bdd553fddd433dcb(e1) {
    let t = $6f131a8b96a87ba3$var$t9 || $6f131a8b96a87ba3$var$t5;
    return e1 ? t.then(this ? e1.bind(this) : e1) : t;
}
function $6f131a8b96a87ba3$var$ne(e1) {
    if (!(1 & e1.flags)) {
        let t = $6f131a8b96a87ba3$var$ns(e1), n = $6f131a8b96a87ba3$var$t2[$6f131a8b96a87ba3$var$t2.length - 1];
        !n || !(2 & e1.flags) && t >= $6f131a8b96a87ba3$var$ns(n) ? $6f131a8b96a87ba3$var$t2.push(e1) : $6f131a8b96a87ba3$var$t2.splice(function(e1) {
            let t = $6f131a8b96a87ba3$var$t3 + 1, n = $6f131a8b96a87ba3$var$t2.length;
            for(; t < n;){
                let r = t + n >>> 1, i = $6f131a8b96a87ba3$var$t2[r], l = $6f131a8b96a87ba3$var$ns(i);
                l < e1 || l === e1 && 2 & i.flags ? t = r + 1 : n = r;
            }
            return t;
        }(t), 0, e1), e1.flags |= 1, $6f131a8b96a87ba3$var$nt();
    }
}
function $6f131a8b96a87ba3$var$nt() {
    $6f131a8b96a87ba3$var$t9 || ($6f131a8b96a87ba3$var$t9 = $6f131a8b96a87ba3$var$t5.then(function e1(t) {
        try {
            for($6f131a8b96a87ba3$var$t3 = 0; $6f131a8b96a87ba3$var$t3 < $6f131a8b96a87ba3$var$t2.length; $6f131a8b96a87ba3$var$t3++){
                let e1 = $6f131a8b96a87ba3$var$t2[$6f131a8b96a87ba3$var$t3];
                e1 && !(8 & e1.flags) && (4 & e1.flags && (e1.flags &= -2), $6f131a8b96a87ba3$export$b22fcaf88446e9bf(e1, e1.i, e1.i ? 15 : 14), 4 & e1.flags || (e1.flags &= -2));
            }
        } finally{
            for(; $6f131a8b96a87ba3$var$t3 < $6f131a8b96a87ba3$var$t2.length; $6f131a8b96a87ba3$var$t3++){
                let e1 = $6f131a8b96a87ba3$var$t2[$6f131a8b96a87ba3$var$t3];
                e1 && (e1.flags &= -2);
            }
            $6f131a8b96a87ba3$var$t3 = -1, $6f131a8b96a87ba3$var$t2.length = 0, $6f131a8b96a87ba3$var$ni(), $6f131a8b96a87ba3$var$t9 = null, ($6f131a8b96a87ba3$var$t2.length || $6f131a8b96a87ba3$var$t6.length) && e1();
        }
    }));
}
function $6f131a8b96a87ba3$export$59536a0199721cab(e1) {
    if ($6f131a8b96a87ba3$var$k(e1)) for(let t = 0; t < e1.length; t++)$6f131a8b96a87ba3$var$t6.push(e1[t]);
    else $6f131a8b96a87ba3$var$t4 && -1 === e1.id ? $6f131a8b96a87ba3$var$t4.splice($6f131a8b96a87ba3$var$t8 + 1, 0, e1) : 1 & e1.flags || ($6f131a8b96a87ba3$var$t6.push(e1), e1.flags |= 1);
    $6f131a8b96a87ba3$var$nt();
}
function $6f131a8b96a87ba3$var$nr(e1, t, n, r = $6f131a8b96a87ba3$var$t3 + 1) {
    for(; r < $6f131a8b96a87ba3$var$t2.length; r++){
        let n = $6f131a8b96a87ba3$var$t2[r];
        if (n && 2 & n.flags) {
            if (e1 && n.id !== e1.uid || void 0 !== t && !(n.id >= t)) continue;
            $6f131a8b96a87ba3$var$t2.splice(r, 1), r = e1 ? r - 1 : $6f131a8b96a87ba3$var$t3, 4 & n.flags && (n.flags &= -2), n(), 4 & n.flags || (n.flags &= -2);
        }
    }
}
function $6f131a8b96a87ba3$var$ni(e1, t, n = 0) {
    if ($6f131a8b96a87ba3$var$t6.length) {
        let e1 = $6f131a8b96a87ba3$var$t6, r = 0;
        if (t) {
            e1 = [];
            for(let i = 0; i < $6f131a8b96a87ba3$var$t6.length; i++){
                let l = $6f131a8b96a87ba3$var$t6[i];
                (void 0 !== l.i ? !l.i || l.i.uid < n : t.has(l)) ? $6f131a8b96a87ba3$var$t6[r++] = l : e1.push(l);
            }
        }
        let i = [
            ...new Set(e1)
        ].sort((e1, t)=>$6f131a8b96a87ba3$var$ns(e1) - $6f131a8b96a87ba3$var$ns(t));
        if ($6f131a8b96a87ba3$var$t6.length = r, $6f131a8b96a87ba3$var$t4) {
            for(let e1 = 0; e1 < i.length; e1++)$6f131a8b96a87ba3$var$t4.push(i[e1]);
            return;
        }
        for($6f131a8b96a87ba3$var$t4 = i, $6f131a8b96a87ba3$var$t8 = 0; $6f131a8b96a87ba3$var$t8 < $6f131a8b96a87ba3$var$t4.length; $6f131a8b96a87ba3$var$t8++){
            let e1 = $6f131a8b96a87ba3$var$t4[$6f131a8b96a87ba3$var$t8];
            4 & e1.flags && (e1.flags &= -2), 8 & e1.flags || e1(), e1.flags &= -2;
        }
        $6f131a8b96a87ba3$var$t4 = null, $6f131a8b96a87ba3$var$t8 = 0;
    }
}
let $6f131a8b96a87ba3$var$nl = !1, $6f131a8b96a87ba3$var$ns = (e1)=>null == e1.id ? 2 & e1.flags ? -1 : 1 / 0 : e1.id, $6f131a8b96a87ba3$var$no = null, $6f131a8b96a87ba3$var$na = null;
function $6f131a8b96a87ba3$var$nc(e1) {
    let t = $6f131a8b96a87ba3$var$no;
    return $6f131a8b96a87ba3$var$no = e1, $6f131a8b96a87ba3$var$na = e1 && e1.type.__scopeId || null, t;
}
function $6f131a8b96a87ba3$export$ac020265ca2cc4cd(e1) {
    $6f131a8b96a87ba3$var$na = e1;
}
function $6f131a8b96a87ba3$export$f2dc6805dc11834e() {
    $6f131a8b96a87ba3$var$na = null;
}
let $6f131a8b96a87ba3$export$15ba313e13f3dd04 = (e1)=>$6f131a8b96a87ba3$export$694b237e827a3d23;
function $6f131a8b96a87ba3$export$694b237e827a3d23(e1, t = $6f131a8b96a87ba3$var$no, n) {
    if (!t || e1._n) return e1;
    let r = (...n)=>{
        let i;
        r._d && $6f131a8b96a87ba3$export$c20bee82f26f1e27(-1);
        let l = $6f131a8b96a87ba3$var$nc(t), s = $6f131a8b96a87ba3$var$le.length;
        try {
            i = e1(...n);
        } finally{
            for(let e1 = $6f131a8b96a87ba3$var$le.length; e1 > s; e1--)$6f131a8b96a87ba3$var$lr();
            $6f131a8b96a87ba3$var$nc(l), r._d && $6f131a8b96a87ba3$export$c20bee82f26f1e27(1);
        }
        return i;
    };
    return r._n = !0, r._c = !0, r._d = !0, r;
}
function $6f131a8b96a87ba3$export$49729353e7c1e6c5(e1, t) {
    if (null === $6f131a8b96a87ba3$var$no) return e1;
    let n = $6f131a8b96a87ba3$var$lU($6f131a8b96a87ba3$var$no), r = e1.dirs || (e1.dirs = []);
    for(let e1 = 0; e1 < t.length; e1++){
        let [i, l, s, o = $6f131a8b96a87ba3$var$f] = t[e1];
        i && ($6f131a8b96a87ba3$var$T(i) && (i = {
            mounted: i,
            updated: i
        }), i.deep && $6f131a8b96a87ba3$var$tX(l), r.push({
            dir: i,
            instance: n,
            value: l,
            oldValue: void 0,
            arg: s,
            modifiers: o
        }));
    }
    return e1;
}
function $6f131a8b96a87ba3$var$ng(e1, t, n, r) {
    let i = e1.dirs, l = t && t.dirs;
    for(let s = 0; s < i.length; s++){
        let o = i[s];
        l && (o.oldValue = l[s].value);
        let a = o.dir[r];
        a && ($6f131a8b96a87ba3$var$eP(), $6f131a8b96a87ba3$export$dae85862a8d94378(a, n, 8, [
            e1.el,
            o,
            e1,
            t
        ]), $6f131a8b96a87ba3$var$eF());
    }
}
function $6f131a8b96a87ba3$export$abe1e183e22e10ad(e1, t) {
    if ($6f131a8b96a87ba3$var$lE) {
        let n = $6f131a8b96a87ba3$var$lE.provides, r = $6f131a8b96a87ba3$var$lE.parent && $6f131a8b96a87ba3$var$lE.parent.provides;
        r === n && (n = $6f131a8b96a87ba3$var$lE.provides = Object.create(r)), n[e1] = t;
    }
}
function $6f131a8b96a87ba3$export$a976684a0efeb93f(e1, t, n = !1) {
    let r = $6f131a8b96a87ba3$export$f13e630aa3915748();
    if (r || $6f131a8b96a87ba3$var$iy) {
        let i = $6f131a8b96a87ba3$var$iy ? $6f131a8b96a87ba3$var$iy._context.provides : r ? null == r.parent || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
        if (i && e1 in i) return i[e1];
        if (arguments.length > 1) return n && $6f131a8b96a87ba3$var$T(t) ? t.call(r && r.proxy) : t;
    }
}
function $6f131a8b96a87ba3$export$caf6761f24fc571a() {
    return !!($6f131a8b96a87ba3$export$f13e630aa3915748() || $6f131a8b96a87ba3$var$iy);
}
let $6f131a8b96a87ba3$export$f2549a27e18acf2d = Symbol.for("v-scx"), $6f131a8b96a87ba3$export$6b1c54dc4befcda = ()=>$6f131a8b96a87ba3$export$a976684a0efeb93f($6f131a8b96a87ba3$export$f2549a27e18acf2d);
function $6f131a8b96a87ba3$export$ede35fc0e5500309(e1, t) {
    return $6f131a8b96a87ba3$var$nT(e1, null, t);
}
function $6f131a8b96a87ba3$export$b7f27ea67102d543(e1, t) {
    return $6f131a8b96a87ba3$var$nT(e1, null, {
        flush: "post"
    });
}
function $6f131a8b96a87ba3$export$2035654f31b0e555(e1, t) {
    return $6f131a8b96a87ba3$var$nT(e1, null, {
        flush: "sync"
    });
}
function $6f131a8b96a87ba3$export$3db5d71bdb2d5499(e1, t, n) {
    return $6f131a8b96a87ba3$var$nT(e1, t, n);
}
function $6f131a8b96a87ba3$var$nT(e1, t, n = $6f131a8b96a87ba3$var$f) {
    let r, { immediate: i, flush: l } = n, s = $6f131a8b96a87ba3$var$_({}, n), o = t && i || !t && "post" !== l;
    if ($6f131a8b96a87ba3$var$lP) {
        if ("sync" === l) {
            let e1 = $6f131a8b96a87ba3$export$6b1c54dc4befcda();
            r = e1.__watcherHandles || (e1.__watcherHandles = []);
        } else if (!o) {
            let e1 = ()=>{};
            return e1.stop = $6f131a8b96a87ba3$var$m, e1.resume = $6f131a8b96a87ba3$var$m, e1.pause = $6f131a8b96a87ba3$var$m, e1;
        }
    }
    let a = $6f131a8b96a87ba3$var$lE;
    s.call = (e1, t, n)=>$6f131a8b96a87ba3$export$dae85862a8d94378(e1, a, t, n);
    let c = !1;
    "post" === l ? s.scheduler = (e1)=>{
        e1.i = a, $6f131a8b96a87ba3$var$iU(e1, a && a.suspense);
    } : "sync" !== l && (c = !0, s.scheduler = (e1, t)=>{
        t ? e1() : $6f131a8b96a87ba3$var$ne(e1);
    }), s.augmentJob = (e1)=>{
        t && (e1.flags |= 4), c && (e1.flags |= 2, a && (e1.id = a.uid, e1.i = a));
    };
    let u = function(e1, t, n = $6f131a8b96a87ba3$var$f) {
        let r, i, l, s, { immediate: o, deep: a, once: c, scheduler: u, augmentJob: p, call: h } = n, g = (e1)=>a ? e1 : $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1) || !1 === a || 0 === a ? $6f131a8b96a87ba3$var$tX(e1, 1) : $6f131a8b96a87ba3$var$tX(e1), y = !1, v = !1;
        if ($6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? (i = ()=>e1.value, y = $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1)) : $6f131a8b96a87ba3$export$352205f445242f02(e1) ? (i = ()=>g(e1), y = !0) : $6f131a8b96a87ba3$var$k(e1) ? (v = !0, y = e1.some((e1)=>$6f131a8b96a87ba3$export$352205f445242f02(e1) || $6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1)), i = ()=>e1.map((e1)=>$6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) ? e1.value : $6f131a8b96a87ba3$export$352205f445242f02(e1) ? g(e1) : $6f131a8b96a87ba3$var$T(e1) ? h ? h(e1, 2) : e1() : void 0)) : i = $6f131a8b96a87ba3$var$T(e1) ? t ? h ? ()=>h(e1, 2) : e1 : ()=>{
            if (l) {
                $6f131a8b96a87ba3$var$eP();
                try {
                    l();
                } finally{
                    $6f131a8b96a87ba3$var$eF();
                }
            }
            let t = $6f131a8b96a87ba3$var$d;
            $6f131a8b96a87ba3$var$d = r;
            try {
                return h ? h(e1, 3, [
                    s
                ]) : e1(s);
            } finally{
                $6f131a8b96a87ba3$var$d = t;
            }
        } : $6f131a8b96a87ba3$var$m, t && a) {
            let e1 = i, t = !0 === a ? 1 / 0 : a;
            i = ()=>$6f131a8b96a87ba3$var$tX(e1(), t);
        }
        let b = $6f131a8b96a87ba3$export$c7be4b0125a10cba(), _ = ()=>{
            r.stop(), b && b.active && $6f131a8b96a87ba3$var$S(b.effects, r);
        };
        if (c && t) {
            let e1 = t;
            t = (...t)=>{
                try {
                    return e1(...t);
                } finally{
                    _();
                }
            };
        }
        let x = v ? Array(e1.length).fill($6f131a8b96a87ba3$var$tK) : $6f131a8b96a87ba3$var$tK, C = (e1)=>{
            if (1 & r.flags && (r.dirty || e1)) {
                if (t) {
                    let n = r.run();
                    if (e1 || a || y || (v ? n.some((e1, t)=>$6f131a8b96a87ba3$var$j(e1, x[t])) : $6f131a8b96a87ba3$var$j(n, x))) {
                        let e1 = $6f131a8b96a87ba3$var$d;
                        $6f131a8b96a87ba3$var$eP();
                        try {
                            l && l(), $6f131a8b96a87ba3$var$d = r;
                            let e1 = [
                                n,
                                x === $6f131a8b96a87ba3$var$tK ? void 0 : v && x[0] === $6f131a8b96a87ba3$var$tK ? [] : x,
                                s
                            ];
                            x = n, h ? h(t, 3, e1) : t(...e1);
                        } finally{
                            $6f131a8b96a87ba3$var$d = e1, $6f131a8b96a87ba3$var$eF();
                        }
                    }
                } else r.run();
            }
        };
        return p && p(C), (r = new $6f131a8b96a87ba3$export$28352bb4dd362521(i)).scheduler = u ? ()=>u(C, !1) : C, s = (e1)=>$6f131a8b96a87ba3$export$8ddeeb083684a9d0(e1, !1, r), l = r.onStop = ()=>{
            let e1 = $6f131a8b96a87ba3$var$tz.get(r);
            if (e1) {
                if (h) h(e1, 4);
                else for (let t of e1)t();
                $6f131a8b96a87ba3$var$tz.delete(r);
            }
        }, t ? o ? C(!0) : x = r.run() : u ? u(C.bind(null, !0), !0) : r.run(), _.pause = r.pause.bind(r), _.resume = r.resume.bind(r), _.stop = _, _;
    }(e1, t, s);
    return $6f131a8b96a87ba3$var$lP && (r ? r.push(u) : o && u()), u;
}
function $6f131a8b96a87ba3$var$nw(e1, t, n) {
    let r, i = this.proxy, l = $6f131a8b96a87ba3$var$w(e1) ? e1.includes(".") ? $6f131a8b96a87ba3$var$nN(i, e1) : ()=>i[e1] : e1.bind(i, i);
    $6f131a8b96a87ba3$var$T(t) ? r = t : (r = t.handler, n = t);
    let s = $6f131a8b96a87ba3$var$lI(this), o = $6f131a8b96a87ba3$var$nT(l, r.bind(i), n);
    return s(), o;
}
function $6f131a8b96a87ba3$var$nN(e1, t) {
    let n = t.split(".");
    return ()=>{
        let t = e1;
        for(let e1 = 0; e1 < n.length && t; e1++)t = t[n[e1]];
        return t;
    };
}
let $6f131a8b96a87ba3$var$nA = new WeakMap, $6f131a8b96a87ba3$var$nE = Symbol("_vte"), $6f131a8b96a87ba3$var$nR = (e1)=>e1 && (e1.disabled || "" === e1.disabled), $6f131a8b96a87ba3$var$nI = (e1)=>"u" > typeof SVGElement && e1 instanceof SVGElement, $6f131a8b96a87ba3$var$nO = (e1)=>"function" == typeof MathMLElement && e1 instanceof MathMLElement, $6f131a8b96a87ba3$var$nM = (e1, t)=>{
    let n = e1 && e1.to;
    return $6f131a8b96a87ba3$var$w(n) ? t ? t(n) : null : n;
};
function $6f131a8b96a87ba3$var$nP(e1, t, n, { o: { insert: r }, m: i }, l = 2) {
    0 === l && (e1.targetStart && r(e1.targetStart, t, n), r(e1.targetAnchor, t, n), n = e1.targetAnchor);
    let { el: s, anchor: o, shapeFlag: a, children: c, props: u } = e1, d = 2 === l;
    if (d && r(s, t, n), !$6f131a8b96a87ba3$var$nA.has(e1) && (!d || $6f131a8b96a87ba3$var$nR(u)) && 16 & a) for(let e1 = 0; e1 < c.length; e1++)i(c[e1], t, n, 2);
    d && r(o, t, n);
}
let $6f131a8b96a87ba3$export$76d55a0304a371f4 = {
    name: "Teleport",
    __isTeleport: !0,
    process (e1, t, n, r, i, l, s, o, a, c) {
        let { mc: u, pc: d, pbc: p, o: { insert: h, querySelector: f, createText: g, parentNode: m } } = c, y = $6f131a8b96a87ba3$var$nR(t.props), { dynamicChildren: v } = t, b = (e1, t, n)=>{
            16 & e1.shapeFlag && u(e1.children, t, n, i, l, s, o, a);
        }, _ = (e1 = t)=>{
            let n = $6f131a8b96a87ba3$var$nR(e1.props), r = e1.target = $6f131a8b96a87ba3$var$nM(e1.props, f), l = $6f131a8b96a87ba3$var$nL(r, e1, g, h);
            r && ("svg" !== s && $6f131a8b96a87ba3$var$nI(r) ? s = "svg" : "mathml" !== s && $6f131a8b96a87ba3$var$nO(r) && (s = "mathml"), i && i.isCE && (i.ce._teleportTargets || (i.ce._teleportTargets = new Set)).add(r), n || (b(e1, r, l), $6f131a8b96a87ba3$var$nD(e1, !1)));
        }, S = (e1)=>{
            let t = ()=>{
                if ($6f131a8b96a87ba3$var$nA.get(e1) === t) {
                    if ($6f131a8b96a87ba3$var$nA.delete(e1), $6f131a8b96a87ba3$var$nR(e1.props)) {
                        let t = m(e1.el) || n;
                        b(e1, t, e1.anchor), $6f131a8b96a87ba3$var$nD(e1, !0);
                    }
                    _(e1);
                }
            };
            $6f131a8b96a87ba3$var$nA.set(e1, t), $6f131a8b96a87ba3$var$iU(t, l);
        };
        if (null == e1) {
            let e1, i = t.el = g(""), s = t.anchor = g("");
            if (h(i, n, r), h(s, n, r), (e1 = t.props) && (e1.defer || "" === e1.defer) || l && l.pendingBranch) return void S(t);
            y && (b(t, n, s), $6f131a8b96a87ba3$var$nD(t, !0)), _();
        } else {
            t.el = e1.el;
            let r = t.anchor = e1.anchor, u = $6f131a8b96a87ba3$var$nA.get(e1);
            if (u) {
                u.flags |= 8, $6f131a8b96a87ba3$var$nA.delete(e1), S(t);
                return;
            }
            t.targetStart = e1.targetStart;
            let h = t.target = e1.target, g = t.targetAnchor = e1.targetAnchor, m = $6f131a8b96a87ba3$var$nR(e1.props), b = m ? n : h, _ = m ? r : g;
            if ("svg" === s || $6f131a8b96a87ba3$var$nI(h) ? s = "svg" : ("mathml" === s || $6f131a8b96a87ba3$var$nO(h)) && (s = "mathml"), v ? (p(e1.dynamicChildren, v, b, i, l, s, o), $6f131a8b96a87ba3$var$iG(e1, t, !0)) : a || d(e1, t, b, _, i, l, s, o, !1), y) m ? t.props && e1.props && t.props.to !== e1.props.to && (t.props.to = e1.props.to) : $6f131a8b96a87ba3$var$nP(t, n, r, c, 1);
            else if ((t.props && t.props.to) !== (e1.props && e1.props.to)) {
                let e1 = $6f131a8b96a87ba3$var$nM(t.props, f);
                e1 && (t.target = e1, $6f131a8b96a87ba3$var$nP(t, e1, null, c, 0));
            } else m && $6f131a8b96a87ba3$var$nP(t, h, g, c, 1);
            $6f131a8b96a87ba3$var$nD(t, y);
        }
    },
    remove (e1, t, n, { um: r, o: { remove: i } }, l) {
        let { shapeFlag: s, children: o, anchor: a, targetStart: c, targetAnchor: u, target: d, props: p } = e1, h = $6f131a8b96a87ba3$var$nR(p), f = l || !h, g = $6f131a8b96a87ba3$var$nA.get(e1);
        if (g && (g.flags |= 8, $6f131a8b96a87ba3$var$nA.delete(e1)), d && (i(c), i(u)), l && i(a), !g && (h || d) && 16 & s) for(let e1 = 0; e1 < o.length; e1++){
            let i = o[e1];
            r(i, t, n, f, !!i.dynamicChildren);
        }
    },
    move: $6f131a8b96a87ba3$var$nP,
    hydrate: function(e1, t, n, r, i, l, { o: { nextSibling: s, parentNode: o, querySelector: a, insert: c, createText: u } }, d) {
        function p(e1, n) {
            let r = n;
            for(; r;){
                if (r && 8 === r.nodeType) {
                    if ("teleport start anchor" === r.data) t.targetStart = r;
                    else if ("teleport anchor" === r.data) {
                        t.targetAnchor = r, e1._lpa = t.targetAnchor && s(t.targetAnchor);
                        break;
                    }
                }
                r = s(r);
            }
        }
        function h(e1, t) {
            t.anchor = d(s(e1), t, o(e1), n, r, i, l);
        }
        let f = t.target = $6f131a8b96a87ba3$var$nM(t.props, a), g = $6f131a8b96a87ba3$var$nR(t.props);
        if (f) {
            let a = f._lpa || f.firstChild;
            16 & t.shapeFlag && (g ? (h(e1, t), p(f, a), t.targetAnchor || $6f131a8b96a87ba3$var$nL(f, t, u, c, o(e1) === f ? e1 : null)) : (t.anchor = s(e1), p(f, a), t.targetAnchor || $6f131a8b96a87ba3$var$nL(f, t, u, c), d(a && s(a), t, f, n, r, i, l))), $6f131a8b96a87ba3$var$nD(t, g);
        } else g && 16 & t.shapeFlag && (h(e1, t), t.targetStart = e1, t.targetAnchor = s(e1));
        return t.anchor && s(t.anchor);
    }
};
function $6f131a8b96a87ba3$var$nD(e1, t) {
    let n = e1.ctx;
    if (n && n.ut) {
        let r, i;
        for(t ? (r = e1.el, i = e1.anchor) : (r = e1.targetStart, i = e1.targetAnchor); r && r !== i;)1 === r.nodeType && r.setAttribute("data-v-owner", n.uid), r = r.nextSibling;
        n.ut();
    }
}
function $6f131a8b96a87ba3$var$nL(e1, t, n, r, i = null) {
    let l = t.targetStart = n(""), s = t.targetAnchor = n("");
    return l[$6f131a8b96a87ba3$var$nE] = s, e1 && (r(l, e1, i), r(s, e1, i)), s;
}
let $6f131a8b96a87ba3$var$nV = Symbol("_leaveCb"), $6f131a8b96a87ba3$var$n$ = Symbol("_enterCb");
function $6f131a8b96a87ba3$export$d2a0a1bc267c90f6() {
    let e1 = {
        isMounted: !1,
        isLeaving: !1,
        isUnmounting: !1,
        leavingVNodes: new Map
    };
    return $6f131a8b96a87ba3$export$6d1641039221b5cb(()=>{
        e1.isMounted = !0;
    }), $6f131a8b96a87ba3$export$40c420df62d2614(()=>{
        e1.isUnmounting = !0;
    }), e1;
}
let $6f131a8b96a87ba3$var$nj = [
    Function,
    Array
], $6f131a8b96a87ba3$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: $6f131a8b96a87ba3$var$nj,
    onEnter: $6f131a8b96a87ba3$var$nj,
    onAfterEnter: $6f131a8b96a87ba3$var$nj,
    onEnterCancelled: $6f131a8b96a87ba3$var$nj,
    onBeforeLeave: $6f131a8b96a87ba3$var$nj,
    onLeave: $6f131a8b96a87ba3$var$nj,
    onAfterLeave: $6f131a8b96a87ba3$var$nj,
    onLeaveCancelled: $6f131a8b96a87ba3$var$nj,
    onBeforeAppear: $6f131a8b96a87ba3$var$nj,
    onAppear: $6f131a8b96a87ba3$var$nj,
    onAfterAppear: $6f131a8b96a87ba3$var$nj,
    onAppearCancelled: $6f131a8b96a87ba3$var$nj
};
function $6f131a8b96a87ba3$var$nH(e1) {
    let t = e1[0];
    if (e1.length > 1) {
        for (let n of e1)if (n.type !== $6f131a8b96a87ba3$export$4d299b491347818a) {
            t = n;
            break;
        }
    }
    return t;
}
let $6f131a8b96a87ba3$export$abd95b5f5e8a8837 = {
    name: "BaseTransition",
    props: $6f131a8b96a87ba3$export$b876c99684f8cf3b,
    setup (e1, { slots: t }) {
        let n = $6f131a8b96a87ba3$export$f13e630aa3915748(), r = $6f131a8b96a87ba3$export$d2a0a1bc267c90f6();
        return ()=>{
            let i = t.default && $6f131a8b96a87ba3$export$a67f9b1229c7c97a(t.default(), !0), l = i && i.length ? $6f131a8b96a87ba3$var$nH(i) : n.subTree ? $6f131a8b96a87ba3$export$49553837c7236d3c() : void 0;
            if (!l) return;
            let s = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), { mode: o } = s;
            if (r.isLeaving) return $6f131a8b96a87ba3$var$nz(l);
            let a = $6f131a8b96a87ba3$var$nJ(l);
            if (!a) return $6f131a8b96a87ba3$var$nz(l);
            let c = $6f131a8b96a87ba3$export$76ac1779589cd824(a, s, r, n, (e1)=>c = e1);
            a.type !== $6f131a8b96a87ba3$export$4d299b491347818a && $6f131a8b96a87ba3$export$7770a22486565649(a, c);
            let u = n.subTree && $6f131a8b96a87ba3$var$nJ(n.subTree);
            if (u && u.type !== $6f131a8b96a87ba3$export$4d299b491347818a && !$6f131a8b96a87ba3$var$lu(u, a) && $6f131a8b96a87ba3$var$nQ(n.subTree)) {
                let e1 = $6f131a8b96a87ba3$export$76ac1779589cd824(u, s, r, n);
                if ($6f131a8b96a87ba3$export$7770a22486565649(u, e1), "out-in" === o && a.type !== $6f131a8b96a87ba3$export$4d299b491347818a) return r.isLeaving = !0, e1.afterLeave = ()=>{
                    r.isLeaving = !1, 8 & n.job.flags || n.update(), delete e1.afterLeave, u = void 0;
                }, $6f131a8b96a87ba3$var$nz(l);
                "in-out" === o && a.type !== $6f131a8b96a87ba3$export$4d299b491347818a ? e1.delayLeave = (e1, t, n)=>{
                    $6f131a8b96a87ba3$var$nW(r, u)[String(u.key)] = u, e1[$6f131a8b96a87ba3$var$nV] = ()=>{
                        t(), e1[$6f131a8b96a87ba3$var$nV] = void 0, delete c.delayedLeave, u = void 0;
                    }, c.delayedLeave = ()=>{
                        n(), delete c.delayedLeave, u = void 0;
                    };
                } : u = void 0;
            } else u && (u = void 0);
            return l;
        };
    }
};
function $6f131a8b96a87ba3$var$nW(e1, t) {
    let { leavingVNodes: n } = e1, r = n.get(t.type);
    return r || (r = Object.create(null), n.set(t.type, r)), r;
}
function $6f131a8b96a87ba3$export$76ac1779589cd824(e1, t, n, r, i) {
    let { appear: l, mode: s, persisted: o = !1, onBeforeEnter: a, onEnter: c, onAfterEnter: u, onEnterCancelled: d, onBeforeLeave: p, onLeave: h, onAfterLeave: f, onLeaveCancelled: g, onBeforeAppear: m, onAppear: y, onAfterAppear: v, onAppearCancelled: b } = t, _ = String(e1.key), S = $6f131a8b96a87ba3$var$nW(n, e1), x = (e1, t)=>{
        e1 && $6f131a8b96a87ba3$export$dae85862a8d94378(e1, r, 9, t);
    }, C = (e1, t)=>{
        let n = t[1];
        x(e1, t), $6f131a8b96a87ba3$var$k(e1) ? e1.every((e1)=>e1.length <= 1) && n() : e1.length <= 1 && n();
    }, T = {
        mode: s,
        persisted: o,
        beforeEnter (t) {
            let r = a;
            if (!n.isMounted) {
                if (!l) return;
                else r = m || a;
            }
            t[$6f131a8b96a87ba3$var$nV] && t[$6f131a8b96a87ba3$var$nV](!0);
            let i = S[_];
            if (i && $6f131a8b96a87ba3$var$lu(e1, i)) {
                let e1 = i.el[$6f131a8b96a87ba3$var$nV];
                if (!e1) {
                    let t = $6f131a8b96a87ba3$var$nQ(i);
                    e1 = t && t.el[$6f131a8b96a87ba3$var$nV];
                }
                e1 && e1();
            }
            x(r, [
                t
            ]);
        },
        enter (t) {
            if (S[_] === e1) return;
            let r = c, i = u, s = d;
            if (!n.isMounted) {
                if (!l) return;
                else r = y || c, i = v || u, s = b || d;
            }
            let o = !1;
            t[$6f131a8b96a87ba3$var$n$] = (e1)=>{
                o || (o = !0, e1 ? x(s, [
                    t
                ]) : x(i, [
                    t
                ]), T.delayedLeave && T.delayedLeave(), t[$6f131a8b96a87ba3$var$n$] = void 0);
            };
            let a = t[$6f131a8b96a87ba3$var$n$].bind(null, !1);
            r ? C(r, [
                t,
                a
            ]) : a();
        },
        leave (t, r) {
            let i = String(e1.key);
            if (t[$6f131a8b96a87ba3$var$n$] && t[$6f131a8b96a87ba3$var$n$](!0), n.isUnmounting) return r();
            x(p, [
                t
            ]);
            let l = !1;
            t[$6f131a8b96a87ba3$var$nV] = (n)=>{
                l || (l = !0, r(), n ? x(g, [
                    t
                ]) : x(f, [
                    t
                ]), t[$6f131a8b96a87ba3$var$nV] = void 0, S[i] === e1 && delete S[i]);
            };
            let s = t[$6f131a8b96a87ba3$var$nV].bind(null, !1);
            S[i] = e1, h ? C(h, [
                t,
                s
            ]) : s();
        },
        clone (e1) {
            let l = $6f131a8b96a87ba3$export$76ac1779589cd824(e1, t, n, r, i);
            return i && i(l), l;
        }
    };
    return T;
}
function $6f131a8b96a87ba3$var$nz(e1) {
    if ($6f131a8b96a87ba3$var$rg(e1)) return (e1 = $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1)).children = null, e1;
}
function $6f131a8b96a87ba3$var$nJ(e1) {
    if (!$6f131a8b96a87ba3$var$rg(e1)) return e1.type.__isTeleport && e1.children ? $6f131a8b96a87ba3$var$nH(e1.children) : e1;
    if (e1.component) return e1.component.subTree;
    let { shapeFlag: t, children: n } = e1;
    if (n) {
        if (16 & t) return n[0];
        if (32 & t && $6f131a8b96a87ba3$var$T(n.default)) return n.default();
    }
}
function $6f131a8b96a87ba3$export$7770a22486565649(e1, t) {
    if (6 & e1.shapeFlag && e1.component) {
        e1.transition = t;
        let n = e1.component.subTree;
        $6f131a8b96a87ba3$export$7770a22486565649(n.type.__isTeleport && $6f131a8b96a87ba3$var$nJ(n) || n, t);
    } else if (128 & e1.shapeFlag) e1.ssContent.transition = t.clone(e1.ssContent), e1.ssFallback.transition = t.clone(e1.ssFallback);
    else if (e1.transition = t, e1.type === $6f131a8b96a87ba3$export$ffb0004e005737fa && $6f131a8b96a87ba3$var$k(e1.children)) {
        let n = $6f131a8b96a87ba3$var$ik(e1.children, !1);
        n && $6f131a8b96a87ba3$export$7770a22486565649(n, t);
    }
}
function $6f131a8b96a87ba3$export$a67f9b1229c7c97a(e1, t = !1, n) {
    let r = [], i = 0;
    for(let l = 0; l < e1.length; l++){
        let s = e1[l], o = null == n ? s.key : String(n) + String(null != s.key ? s.key : l);
        s.type === $6f131a8b96a87ba3$export$ffb0004e005737fa ? (128 & s.patchFlag && i++, r = r.concat($6f131a8b96a87ba3$export$a67f9b1229c7c97a(s.children, t, o))) : (t || s.type !== $6f131a8b96a87ba3$export$4d299b491347818a) && r.push(null != o ? $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(s, {
            key: o
        }) : s);
    }
    if (i > 1) for(let e1 = 0; e1 < r.length; e1++)r[e1].patchFlag = -2;
    return r;
}
function $6f131a8b96a87ba3$var$nQ(e1) {
    if (e1.component) return $6f131a8b96a87ba3$var$nQ(e1.component.subTree);
    if (e1.type === $6f131a8b96a87ba3$export$ffb0004e005737fa) {
        let t = $6f131a8b96a87ba3$var$k(e1.children) && $6f131a8b96a87ba3$var$ik(e1.children, !1);
        return t ? $6f131a8b96a87ba3$var$nQ(t) : void 0;
    }
    if (e1.type !== $6f131a8b96a87ba3$export$4d299b491347818a) return e1;
}
function $6f131a8b96a87ba3$export$afa64b67e5a01c3b(e1, t) {
    return $6f131a8b96a87ba3$var$T(e1) ? $6f131a8b96a87ba3$var$_({
        name: e1.name
    }, t, {
        setup: e1
    }) : e1;
}
function $6f131a8b96a87ba3$export$f680877a34711e37() {
    let e1 = $6f131a8b96a87ba3$export$f13e630aa3915748();
    return e1 ? (e1.appContext.config.idPrefix || "v") + "-" + e1.ids[0] + e1.ids[1]++ : "";
}
function $6f131a8b96a87ba3$var$n0(e1) {
    e1.ids = [
        e1.ids[0] + e1.ids[2]++ + "-",
        0,
        0
    ];
}
function $6f131a8b96a87ba3$export$83a5dbc1f35517ca(e1) {
    let t = $6f131a8b96a87ba3$export$f13e630aa3915748(), n = $6f131a8b96a87ba3$export$9b7bc5fe3b17c8b3(null);
    return t && Object.defineProperty(t.refs === $6f131a8b96a87ba3$var$f ? t.refs = {} : t.refs, e1, {
        enumerable: !0,
        get: ()=>n.value,
        set: (e1)=>n.value = e1
    }), n;
}
function $6f131a8b96a87ba3$var$n2(e1, t) {
    let n;
    return !!((n = Object.getOwnPropertyDescriptor(e1, t)) && !n.configurable);
}
let $6f131a8b96a87ba3$var$n3 = new WeakMap;
function $6f131a8b96a87ba3$var$n6(e1, t, n, r, i = !1) {
    if ($6f131a8b96a87ba3$var$k(e1)) return void e1.forEach((e1, l)=>$6f131a8b96a87ba3$var$n6(e1, t && ($6f131a8b96a87ba3$var$k(t) ? t[l] : t), n, r, i));
    if ($6f131a8b96a87ba3$var$rp(r) && !i) {
        512 & r.shapeFlag && r.type.__asyncResolved && r.component.subTree.component && $6f131a8b96a87ba3$var$n6(e1, t, n, r.component.subTree);
        return;
    }
    let l = 4 & r.shapeFlag ? $6f131a8b96a87ba3$var$lU(r.component) : r.el, s = i ? null : l, { i: o, r: a } = e1, c = t && t.r, u = o.refs === $6f131a8b96a87ba3$var$f ? o.refs = {} : o.refs, d = o.setupState, p = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(d), h = d === $6f131a8b96a87ba3$var$f ? $6f131a8b96a87ba3$var$y : (e1)=>!$6f131a8b96a87ba3$var$n2(u, e1) && $6f131a8b96a87ba3$var$C(p, e1), g = (e1, t)=>!(t && $6f131a8b96a87ba3$var$n2(u, t));
    if (null != c && c !== a && ($6f131a8b96a87ba3$var$n4(t), $6f131a8b96a87ba3$var$w(c) ? (u[c] = null, h(c) && (d[c] = null)) : $6f131a8b96a87ba3$export$4f9f5282de18fc69(c) && (g(c, t.k) && (c.value = null), t.k && (u[t.k] = null))), $6f131a8b96a87ba3$var$T(a)) $6f131a8b96a87ba3$export$b22fcaf88446e9bf(a, o, 12, [
        s,
        u
    ]);
    else {
        let t = $6f131a8b96a87ba3$var$w(a), r = $6f131a8b96a87ba3$export$4f9f5282de18fc69(a);
        if (t || r) {
            let o = ()=>{
                if (e1.f) {
                    let n = t ? h(a) ? d[a] : u[a] : g() || !e1.k ? a.value : u[e1.k];
                    if (i) $6f131a8b96a87ba3$var$k(n) && $6f131a8b96a87ba3$var$S(n, l);
                    else if ($6f131a8b96a87ba3$var$k(n)) n.includes(l) || n.push(l);
                    else if (t) u[a] = [
                        l
                    ], h(a) && (d[a] = u[a]);
                    else {
                        let t = [
                            l
                        ];
                        g(a, e1.k) && (a.value = t), e1.k && (u[e1.k] = t);
                    }
                } else t ? (u[a] = s, h(a) && (d[a] = s)) : r && (g(a, e1.k) && (a.value = s), e1.k && (u[e1.k] = s));
            };
            if (s) {
                let t = ()=>{
                    o(), $6f131a8b96a87ba3$var$n3.delete(e1);
                };
                t.id = -1, $6f131a8b96a87ba3$var$n3.set(e1, t), $6f131a8b96a87ba3$var$iU(t, n);
            } else $6f131a8b96a87ba3$var$n4(e1), o();
        }
    }
}
function $6f131a8b96a87ba3$var$n4(e1) {
    let t = $6f131a8b96a87ba3$var$n3.get(e1);
    t && (t.flags |= 8, $6f131a8b96a87ba3$var$n3.delete(e1));
}
let $6f131a8b96a87ba3$var$n8 = !1, $6f131a8b96a87ba3$var$n5 = ()=>{
    $6f131a8b96a87ba3$var$n8 || (console.error("Hydration completed but contains mismatches."), $6f131a8b96a87ba3$var$n8 = !0);
}, $6f131a8b96a87ba3$var$n9 = (e1)=>{
    if (1 === e1.nodeType) {
        if (e1.namespaceURI.includes("svg") && "foreignObject" !== e1.tagName) return "svg";
        if (e1.namespaceURI.includes("MathML")) return "mathml";
    }
}, $6f131a8b96a87ba3$var$n7 = (e1)=>8 === e1.nodeType;
function $6f131a8b96a87ba3$var$re(e1) {
    let { mt: t, p: n, o: { patchProp: r, createText: i, nextSibling: l, parentNode: s, remove: o, insert: a, createComment: c } } = e1, u = (n, r, o, c, v, b = !1)=>{
        b = b || !!r.dynamicChildren;
        let _ = $6f131a8b96a87ba3$var$n7(n) && "[" === n.data, S = ()=>f(n, r, o, c, v, _), { type: x, ref: C, shapeFlag: k, patchFlag: T } = r, w = n.nodeType;
        r.el = n, -2 === T && (b = !1, r.dynamicChildren = null);
        let N = null;
        switch(x){
            case $6f131a8b96a87ba3$export$5f1af8db9871e1d6:
                3 !== w ? "" === r.children ? (a(r.el = i(""), s(n), n), N = n) : N = S() : (n.data !== r.children && ($6f131a8b96a87ba3$var$n5(), n.data = r.children), N = l(n));
                break;
            case $6f131a8b96a87ba3$export$4d299b491347818a:
                y(n) ? (N = l(n), m(r.el = n.content.firstChild, n, o)) : N = 8 !== w || _ ? S() : l(n);
                break;
            case $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6:
                if (_ && (w = (n = l(n)).nodeType), 1 === w || 3 === w) {
                    N = n;
                    let e1 = !r.children.length;
                    for(let t = 0; t < r.staticCount; t++)e1 && (r.children += 1 === N.nodeType ? N.outerHTML : N.data), t === r.staticCount - 1 && (r.anchor = N), N = l(N);
                    return _ ? l(N) : N;
                }
                S();
                break;
            case $6f131a8b96a87ba3$export$ffb0004e005737fa:
                N = _ ? h(n, r, o, c, v, b) : S();
                break;
            default:
                if (1 & k) N = 1 === w && r.type.toLowerCase() === n.tagName.toLowerCase() || y(n) ? d(n, r, o, c, v, b) : S();
                else if (6 & k) {
                    r.slotScopeIds = v;
                    let e1 = s(n);
                    if (N = _ ? g(n) : $6f131a8b96a87ba3$var$n7(n) && "teleport start" === n.data ? g(n, n.data, "teleport end") : l(n), t(r, e1, null, o, c, $6f131a8b96a87ba3$var$n9(e1), b), ($6f131a8b96a87ba3$var$rp(r) || r.component.asyncDep) && !r.component.subTree) {
                        let t;
                        _ ? (t = $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$c1b9a1d3af45b7b6)).anchor = N ? N.previousSibling : e1.lastChild : t = 3 === n.nodeType ? $6f131a8b96a87ba3$export$22f9b5ffd89dac9("") : $6f131a8b96a87ba3$export$bf5c4cf060303d58(8 === n.nodeType ? $6f131a8b96a87ba3$export$4d299b491347818a : "div"), t.el = n, r.component.subTree = t;
                    }
                } else 64 & k ? N = 8 !== w ? S() : r.type.hydrate(n, r, o, c, v, b, e1, p) : 128 & k && (N = r.type.hydrate(n, r, o, c, $6f131a8b96a87ba3$var$n9(s(n)), v, b, e1, u));
        }
        return null != C && $6f131a8b96a87ba3$var$n6(C, null, c, r), N;
    }, d = (e1, t, n, i, l, s)=>{
        s = s || !!t.dynamicChildren;
        let { type: a, dynamicProps: c, props: u, patchFlag: d, shapeFlag: h, dirs: f, transition: g } = t, b = "input" === a || "option" === a, _ = !!c;
        if (b || _ || -1 !== d) {
            let a;
            f && $6f131a8b96a87ba3$var$ng(t, null, n, "created");
            let k = !1;
            if (y(e1)) {
                k = $6f131a8b96a87ba3$var$iJ(null, g) && n && n.vnode.props && n.vnode.props.appear;
                let r = e1.content.firstChild;
                if (k) {
                    let e1 = r.getAttribute("class");
                    e1 && (r.$cls = e1), g.beforeEnter(r);
                }
                m(r, e1, n), t.el = e1 = r;
            }
            if (16 & h && !(u && (u.innerHTML || u.textContent))) {
                let r = p(e1.firstChild, t, e1, n, i, l, s);
                for(r && !$6f131a8b96a87ba3$var$ri(e1, 1) && $6f131a8b96a87ba3$var$n5(); r;){
                    let e1 = r;
                    r = r.nextSibling, o(e1);
                }
            } else if (8 & h) {
                let n = t.children;
                `
` === n[0] && ("PRE" === e1.tagName || "TEXTAREA" === e1.tagName) && (n = n.slice(1));
                let { textContent: r } = e1;
                r !== n && r !== n.replace(/\r\n|\r/g, `
`) && ($6f131a8b96a87ba3$var$ri(e1, 0) || $6f131a8b96a87ba3$var$n5(), e1.textContent = t.children);
            }
            if (u) {
                if (b || _ || !s || 48 & d) {
                    let t = e1.tagName.includes("-"), i = e1.namespaceURI.includes("svg") ? "svg" : e1.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(let l in u)if (b && (l.endsWith("value") || "indeterminate" === l) || $6f131a8b96a87ba3$var$v(l) && !$6f131a8b96a87ba3$var$O(l) || "." === l[0] || t && !$6f131a8b96a87ba3$var$O(l) || c && c.includes(l)) {
                        var S, x, C;
                        if (S = e1, x = l, C = u[l], $6f131a8b96a87ba3$var$rt.has(x) && S.getAttribute(x) === (null == C ? null : `${C}`)) continue;
                        r(e1, l, null, u[l], i, n);
                    }
                } else if (u.onClick) r(e1, "onClick", null, u.onClick, void 0, n);
                else if (4 & d && $6f131a8b96a87ba3$export$352205f445242f02(u.style)) for(let e1 in u.style)u.style[e1];
            }
            (a = u && u.onVnodeBeforeMount) && $6f131a8b96a87ba3$var$lT(a, n, t), f && $6f131a8b96a87ba3$var$ng(t, null, n, "beforeMount"), ((a = u && u.onVnodeMounted) || f || k) && $6f131a8b96a87ba3$var$i6(()=>{
                a && $6f131a8b96a87ba3$var$lT(a, n, t), k && g.enter(e1), f && $6f131a8b96a87ba3$var$ng(t, null, n, "mounted");
            }, i);
        }
        return e1.nextSibling;
    }, p = (e1, t, r, s, o, c, d)=>{
        d = d || !!t.dynamicChildren;
        let p = t.children, h = p.length, f = !1;
        for(let t = 0; t < h; t++){
            let g = d ? p[t] : p[t] = $6f131a8b96a87ba3$var$lS(p[t]), m = g.type === $6f131a8b96a87ba3$export$5f1af8db9871e1d6;
            e1 ? (m && !d && t + 1 < h && $6f131a8b96a87ba3$var$lS(p[t + 1]).type === $6f131a8b96a87ba3$export$5f1af8db9871e1d6 && (a(i(e1.data.slice(g.children.length)), r, l(e1)), e1.data = g.children), e1 = u(e1, g, s, o, c, d)) : m && !g.children ? a(g.el = i(""), r) : (!f && (f = !0, $6f131a8b96a87ba3$var$ri(r, 1) || $6f131a8b96a87ba3$var$n5()), n(null, g, r, null, s, o, $6f131a8b96a87ba3$var$n9(r), c));
        }
        return e1;
    }, h = (e1, t, n, r, i, o)=>{
        let { slotScopeIds: u } = t;
        u && (i = i ? i.concat(u) : u);
        let d = s(e1), h = p(l(e1), t, d, n, r, i, o);
        return h && $6f131a8b96a87ba3$var$n7(h) && "]" === h.data ? l(t.anchor = h) : ($6f131a8b96a87ba3$var$n5(), a(t.anchor = c("]"), d, h), h);
    }, f = (e1, t, r, i, a, c)=>{
        var u, d, p;
        if (u = e1, d = t, $6f131a8b96a87ba3$var$ri(u.parentElement, 1) || 1 === (p = u).nodeType && $6f131a8b96a87ba3$var$rl(p.getAttribute($6f131a8b96a87ba3$var$rn), 1) || function({ props: e1 }) {
            let t = e1 && e1[$6f131a8b96a87ba3$var$rn];
            return "string" == typeof t && $6f131a8b96a87ba3$var$rl(t, 1);
        }(d) || $6f131a8b96a87ba3$var$n5(), t.el = null, c) {
            let t = g(e1);
            for(;;){
                let n = l(e1);
                if (n && n !== t) o(n);
                else break;
            }
        }
        let h = l(e1), f = s(e1);
        return o(e1), n(null, t, f, h, r, i, $6f131a8b96a87ba3$var$n9(f), a), r && (r.vnode.el = t.el, $6f131a8b96a87ba3$var$iE(r, t.el)), h;
    }, g = (e1, t = "[", n = "]")=>{
        let r = 0;
        for(; e1;)if ((e1 = l(e1)) && $6f131a8b96a87ba3$var$n7(e1) && (e1.data === t && r++, e1.data === n)) {
            if (0 === r) return l(e1);
            else r--;
        }
        return e1;
    }, m = (e1, t, n)=>{
        let r = t.parentNode;
        r && r.replaceChild(e1, t);
        let i = n;
        for(; i;)i.vnode.el === t && (i.vnode.el = i.subTree.el = e1), i = i.parent;
    }, y = (e1)=>1 === e1.nodeType && "TEMPLATE" === e1.tagName;
    return [
        (e1, t)=>{
            if (!t.hasChildNodes()) {
                n(null, e1, t), $6f131a8b96a87ba3$var$ni(), t._vnode = e1;
                return;
            }
            u(t.firstChild, e1, null, null, null), $6f131a8b96a87ba3$var$ni(), t._vnode = e1;
        },
        u
    ];
}
let $6f131a8b96a87ba3$var$rt = new Set([
    "src",
    "srcset",
    "href",
    "poster"
]), $6f131a8b96a87ba3$var$rn = "data-allow-mismatch", $6f131a8b96a87ba3$var$rr = {
    0: "text",
    1: "children",
    2: "class",
    3: "style",
    4: "attribute"
};
function $6f131a8b96a87ba3$var$ri(e1, t) {
    if (0 === t || 1 === t) for(; e1 && !e1.hasAttribute($6f131a8b96a87ba3$var$rn);)e1 = e1.parentElement;
    return $6f131a8b96a87ba3$var$rl(e1 && e1.getAttribute($6f131a8b96a87ba3$var$rn), t);
}
function $6f131a8b96a87ba3$var$rl(e1, t) {
    if (null == e1) return !1;
    {
        if ("" === e1) return !0;
        let n = e1.split(",");
        return !!(0 === t && n.includes("children")) || n.includes($6f131a8b96a87ba3$var$rr[t]);
    }
}
let $6f131a8b96a87ba3$var$rs = $6f131a8b96a87ba3$var$K().requestIdleCallback || ((e1)=>setTimeout(e1, 1)), $6f131a8b96a87ba3$var$ro = $6f131a8b96a87ba3$var$K().cancelIdleCallback || ((e1)=>clearTimeout(e1)), $6f131a8b96a87ba3$export$8bfca283fd254627 = (e1 = 1e4)=>(t)=>{
        let n = $6f131a8b96a87ba3$var$rs(t, {
            timeout: e1
        });
        return ()=>$6f131a8b96a87ba3$var$ro(n);
    }, $6f131a8b96a87ba3$export$2b04cd335e660930 = (e1)=>(t, n)=>{
        let r = new IntersectionObserver((e1)=>{
            for (let n of e1)if (n.isIntersecting) {
                r.disconnect(), t();
                break;
            }
        }, e1), i = (e1)=>{
            if (function(e1) {
                let { top: t, left: n, bottom: r, right: i } = e1.getBoundingClientRect(), { innerHeight: l, innerWidth: s } = window;
                return (t > 0 && t < l || r > 0 && r < l) && (n > 0 && n < s || i > 0 && i < s);
            }(e1)) return t(), r.disconnect(), !1;
            if ("contents" === getComputedStyle(e1).display) {
                for(let t = 0; t < e1.children.length; t++)if (!1 === i(e1.children[t])) return !1;
            }
            r.observe(e1);
        };
        return n((e1)=>{
            if (e1 instanceof Element) return i(e1);
        }), ()=>r.disconnect();
    }, $6f131a8b96a87ba3$export$804dbb6002787b74 = (e1)=>(t)=>{
        if (e1) {
            let n = matchMedia(e1);
            if (!n.matches) return n.addEventListener("change", t, {
                once: !0
            }), ()=>n.removeEventListener("change", t);
            t();
        }
    }, $6f131a8b96a87ba3$export$288f5a9b4248e114 = (e1 = [])=>(t, n)=>{
        $6f131a8b96a87ba3$var$w(e1) && (e1 = [
            e1
        ]);
        let r = !1, i = (e1)=>{
            r || (r = !0, l(), t(), e1.target.dispatchEvent(new e1.constructor(e1.type, e1)));
        }, l = ()=>{
            n((t)=>{
                for (let n of e1)t.removeEventListener(n, i);
            });
        };
        return n((t)=>{
            for (let n of e1)t.addEventListener(n, i, {
                once: !0
            });
        }), l;
    }, $6f131a8b96a87ba3$var$rp = (e1)=>!!e1.type.__asyncLoader;
function $6f131a8b96a87ba3$export$d75d499b4c16cf21(e1) {
    let t;
    $6f131a8b96a87ba3$var$T(e1) && (e1 = {
        loader: e1
    });
    let { loader: n, loadingComponent: r, errorComponent: i, delay: l = 200, hydrate: s, timeout: o, suspensible: a = !0, onError: c } = e1, u = null, d = 0, p = ()=>{
        let e1;
        return u || (e1 = u = n().catch((e1)=>{
            if (e1 = e1 instanceof Error ? e1 : Error(String(e1)), c) return new Promise((t, n)=>{
                c(e1, ()=>t((d++, u = null, p())), ()=>n(e1), d + 1);
            });
            throw e1;
        }).then((n)=>e1 !== u && u ? u : (n && (n.__esModule || "Module" === n[Symbol.toStringTag]) && (n = n.default), t = n, n)));
    };
    return $6f131a8b96a87ba3$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: p,
        __asyncHydrate (e1, n, r) {
            let i = e1.isConnected, l = !1;
            (n.bu || (n.bu = [])).push(()=>l = !0);
            let o = ()=>{
                l || e1.parentNode && (!i || e1.isConnected) && r();
            }, a = s ? ()=>{
                let t = s(o, (t)=>(function(e1, t) {
                        if ($6f131a8b96a87ba3$var$n7(e1) && "[" === e1.data) {
                            let n = 1, r = e1.nextSibling;
                            for(; r;){
                                if (1 === r.nodeType) {
                                    if (!1 === t(r)) break;
                                } else if ($6f131a8b96a87ba3$var$n7(r)) {
                                    if ("]" === r.data) {
                                        if (0 == --n) break;
                                    } else "[" === r.data && n++;
                                }
                                r = r.nextSibling;
                            }
                        } else t(e1);
                    })(e1, t));
                t && (n.bum || (n.bum = [])).push(t);
            } : o;
            t ? a() : p().then(()=>!n.isUnmounted && a());
        },
        get __asyncResolved () {
            return t;
        },
        setup () {
            let e1, n, s = $6f131a8b96a87ba3$var$lE;
            if ($6f131a8b96a87ba3$var$n0(s), t) return ()=>$6f131a8b96a87ba3$var$rf(t, s);
            let c = (e1)=>{
                u = null, $6f131a8b96a87ba3$export$d3da1ecaf1206c58(e1, s, 13, !i);
            };
            if (a && s.suspense || $6f131a8b96a87ba3$var$lP) return p().then((e1)=>()=>$6f131a8b96a87ba3$var$rf(e1, s)).catch((e1)=>(c(e1), ()=>i ? $6f131a8b96a87ba3$export$bf5c4cf060303d58(i, {
                        error: e1
                    }) : null));
            let d = $6f131a8b96a87ba3$export$eff4d24c3ff7876e(!1), h = $6f131a8b96a87ba3$export$eff4d24c3ff7876e(), f = $6f131a8b96a87ba3$export$eff4d24c3ff7876e(!!l);
            return $6f131a8b96a87ba3$export$13348a43ccacfe58(()=>{
                null != e1 && clearTimeout(e1), null != n && clearTimeout(n);
            }), l && (n = setTimeout(()=>{
                s.isUnmounted || (f.value = !1);
            }, l)), null != o && (e1 = setTimeout(()=>{
                if (!s.isUnmounted && !d.value && !h.value) {
                    let e1 = Error(`Async component timed out after ${o}ms.`);
                    c(e1), h.value = e1;
                }
            }, o)), p().then(()=>{
                !s.isUnmounted && (d.value = !0, s.parent && $6f131a8b96a87ba3$var$rg(s.parent.vnode) && s.parent.update());
            }).catch((e1)=>{
                if (s.isUnmounted) {
                    u = null;
                    return;
                }
                c(e1), h.value = e1;
            }), ()=>d.value && t ? $6f131a8b96a87ba3$var$rf(t, s) : h.value && i ? $6f131a8b96a87ba3$export$bf5c4cf060303d58(i, {
                    error: h.value
                }) : r && !f.value ? $6f131a8b96a87ba3$var$rf(r, s) : void 0;
        }
    });
}
function $6f131a8b96a87ba3$var$rf(e1, t) {
    let { ref: n, props: r, children: i, ce: l } = t.vnode, s = $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, r, i);
    return s.ref = n, s.ce = l, delete t.vnode.ce, s;
}
let $6f131a8b96a87ba3$var$rg = (e1)=>e1.type.__isKeepAlive, $6f131a8b96a87ba3$export$70eb8a58709972df = {
    name: "KeepAlive",
    __isKeepAlive: !0,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (e1, { slots: t }) {
        let n = $6f131a8b96a87ba3$export$f13e630aa3915748(), r = n.ctx;
        if (!r.renderer) return ()=>{
            let e1 = t.default && t.default();
            return e1 && 1 === e1.length ? e1[0] : e1;
        };
        let i = new Map, l = new Set, s = null, o = n.suspense, { renderer: { p: a, m: c, um: u, o: { createElement: d } } } = r, p = d("div");
        function h(e1) {
            $6f131a8b96a87ba3$var$rS(e1), u(e1, n, o, !0);
        }
        function f(e1) {
            i.forEach((t, n)=>{
                let r = $6f131a8b96a87ba3$var$lH($6f131a8b96a87ba3$var$rp(t) ? t.type.__asyncResolved || {} : t.type);
                r && !e1(r) && g(n);
            });
        }
        function g(e1) {
            let t = i.get(e1);
            !t || s && $6f131a8b96a87ba3$var$lu(t, s) ? s && ($6f131a8b96a87ba3$var$rS(s), t && $6f131a8b96a87ba3$var$rS(t)) : h(t), i.delete(e1), l.delete(e1);
        }
        r.activate = (e1, t, n, r, i)=>{
            let l = e1.component;
            c(e1, t, n, 0, o), a(l.vnode, e1, t, n, l, o, r, e1.slotScopeIds, i), $6f131a8b96a87ba3$var$iU(()=>{
                l.isDeactivated = !1, l.a && $6f131a8b96a87ba3$var$U(l.a);
                let t = e1.props && e1.props.onVnodeMounted;
                t && $6f131a8b96a87ba3$var$lT(t, l.parent, e1);
            }, o);
        }, r.deactivate = (e1)=>{
            let t = e1.component;
            $6f131a8b96a87ba3$var$iX(t.m), $6f131a8b96a87ba3$var$iX(t.a), c(e1, p, null, 1, o), $6f131a8b96a87ba3$var$iU(()=>{
                t.da && $6f131a8b96a87ba3$var$U(t.da);
                let n = e1.props && e1.props.onVnodeUnmounted;
                n && $6f131a8b96a87ba3$var$lT(n, t.parent, e1), t.isDeactivated = !0;
            }, o);
        }, $6f131a8b96a87ba3$export$3db5d71bdb2d5499(()=>[
                e1.include,
                e1.exclude
            ], ([e1, t])=>{
            e1 && f((t)=>$6f131a8b96a87ba3$var$ry(e1, t)), t && f((e1)=>!$6f131a8b96a87ba3$var$ry(t, e1));
        }, {
            flush: "post",
            deep: !0
        });
        let m = null, y = ()=>{
            null != m && ($6f131a8b96a87ba3$var$iZ(n.subTree.type) ? $6f131a8b96a87ba3$var$iU(()=>{
                let e1 = $6f131a8b96a87ba3$var$rx(n.subTree);
                e1.component && i.set(m, e1);
            }, n.subTree.suspense) : i.set(m, $6f131a8b96a87ba3$var$rx(n.subTree)));
        };
        return $6f131a8b96a87ba3$export$6d1641039221b5cb(y), $6f131a8b96a87ba3$export$5876c47052fb88b1(y), $6f131a8b96a87ba3$export$40c420df62d2614(()=>{
            i.forEach((e1)=>{
                let { subTree: t, suspense: r } = n, i = $6f131a8b96a87ba3$var$rx(t);
                if (e1.type === i.type && e1.key === i.key) {
                    $6f131a8b96a87ba3$var$rS(i);
                    let e1 = i.component.da;
                    e1 && $6f131a8b96a87ba3$var$iU(e1, r);
                    return;
                }
                h(e1);
            });
        }), ()=>{
            if (m = null, !t.default) return s = null;
            let n = t.default(), r = n[0];
            if (n.length > 1) return s = null, n;
            if (!$6f131a8b96a87ba3$export$3868d13f8734ae81(r) || !(4 & r.shapeFlag) && !(128 & r.shapeFlag)) return s = null, r;
            let o = $6f131a8b96a87ba3$var$rx(r);
            if (o.type === $6f131a8b96a87ba3$export$4d299b491347818a) return s = null, o;
            let a = o.type, c = $6f131a8b96a87ba3$var$lH($6f131a8b96a87ba3$var$rp(o) ? o.type.__asyncResolved || {} : a), { include: u, exclude: d, max: p } = e1;
            if (u && (!c || !$6f131a8b96a87ba3$var$ry(u, c)) || d && c && $6f131a8b96a87ba3$var$ry(d, c)) return o.shapeFlag &= -257, s = o, r;
            let h = null == o.key ? a : o.key, f = i.get(h);
            return o.el && (o = $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(o), 128 & r.shapeFlag && (r.ssContent = o)), m = h, f ? (o.el = f.el, o.component = f.component, o.transition && $6f131a8b96a87ba3$export$7770a22486565649(o, o.transition), o.shapeFlag |= 512, l.delete(h), l.add(h)) : (l.add(h), p && l.size > parseInt(p, 10) && g(l.values().next().value)), o.shapeFlag |= 256, s = o, $6f131a8b96a87ba3$var$iZ(r.type) ? r : o;
        };
    }
};
function $6f131a8b96a87ba3$var$ry(e1, t) {
    let n;
    if ($6f131a8b96a87ba3$var$k(e1)) return e1.some((e1)=>$6f131a8b96a87ba3$var$ry(e1, t));
    if ($6f131a8b96a87ba3$var$w(e1)) return e1.split(",").includes(t);
    return "[object RegExp]" === (n = e1, $6f131a8b96a87ba3$var$R.call(n)) && (e1.lastIndex = 0, e1.test(t));
}
function $6f131a8b96a87ba3$export$ba52d824b95a2154(e1, t) {
    $6f131a8b96a87ba3$var$r_(e1, "a", t);
}
function $6f131a8b96a87ba3$export$bf1440eeaf5fa709(e1, t) {
    $6f131a8b96a87ba3$var$r_(e1, "da", t);
}
function $6f131a8b96a87ba3$var$r_(e1, t, n = $6f131a8b96a87ba3$var$lE) {
    let r = e1.__wdc || (e1.__wdc = ()=>{
        let t = n;
        for(; t;){
            if (t.isDeactivated) return;
            t = t.parent;
        }
        return e1();
    });
    if ($6f131a8b96a87ba3$var$rC(t, r, n), n) {
        let e1 = n.parent;
        for(; e1 && e1.parent;)$6f131a8b96a87ba3$var$rg(e1.parent.vnode) && function(e1, t, n, r) {
            let i = $6f131a8b96a87ba3$var$rC(t, e1, r, !0);
            $6f131a8b96a87ba3$export$13348a43ccacfe58(()=>{
                $6f131a8b96a87ba3$var$S(r[t], i);
            }, n);
        }(r, t, n, e1), e1 = e1.parent;
    }
}
function $6f131a8b96a87ba3$var$rS(e1) {
    e1.shapeFlag &= -257, e1.shapeFlag &= -513;
}
function $6f131a8b96a87ba3$var$rx(e1) {
    return 128 & e1.shapeFlag ? e1.ssContent : e1;
}
function $6f131a8b96a87ba3$var$rC(e1, t, n = $6f131a8b96a87ba3$var$lE, r = !1) {
    if (n) {
        let i = n[e1] || (n[e1] = []), l = t.__weh || (t.__weh = (...r)=>{
            $6f131a8b96a87ba3$var$eP();
            let i = $6f131a8b96a87ba3$var$lI(n), l = $6f131a8b96a87ba3$export$dae85862a8d94378(t, n, e1, r);
            return i(), $6f131a8b96a87ba3$var$eF(), l;
        });
        return r ? i.unshift(l) : i.push(l), l;
    }
}
let $6f131a8b96a87ba3$var$rk = (e1)=>(t, n = $6f131a8b96a87ba3$var$lE)=>{
        $6f131a8b96a87ba3$var$lP && "sp" !== e1 || $6f131a8b96a87ba3$var$rC(e1, (...e1)=>t(...e1), n);
    }, $6f131a8b96a87ba3$export$23b7aeb0d671f804 = $6f131a8b96a87ba3$var$rk("bm"), $6f131a8b96a87ba3$export$6d1641039221b5cb = $6f131a8b96a87ba3$var$rk("m"), $6f131a8b96a87ba3$export$ab91988a13872e4c = $6f131a8b96a87ba3$var$rk("bu"), $6f131a8b96a87ba3$export$5876c47052fb88b1 = $6f131a8b96a87ba3$var$rk("u"), $6f131a8b96a87ba3$export$40c420df62d2614 = $6f131a8b96a87ba3$var$rk("bum"), $6f131a8b96a87ba3$export$13348a43ccacfe58 = $6f131a8b96a87ba3$var$rk("um"), $6f131a8b96a87ba3$export$ebf0c601f267bceb = $6f131a8b96a87ba3$var$rk("sp"), $6f131a8b96a87ba3$export$898295a813d662eb = $6f131a8b96a87ba3$var$rk("rtg"), $6f131a8b96a87ba3$export$2b41f4235363e921 = $6f131a8b96a87ba3$var$rk("rtc");
function $6f131a8b96a87ba3$export$6a3a15856e50ad19(e1, t = $6f131a8b96a87ba3$var$lE) {
    $6f131a8b96a87ba3$var$rC("ec", e1, t);
}
let $6f131a8b96a87ba3$var$rF = "components";
function $6f131a8b96a87ba3$export$681d65eec9d1d1e8(e1, t) {
    return $6f131a8b96a87ba3$var$rB($6f131a8b96a87ba3$var$rF, e1, !0, t) || e1;
}
let $6f131a8b96a87ba3$var$rL = Symbol.for("v-ndc");
function $6f131a8b96a87ba3$export$b44c564a05ca975(e1) {
    return $6f131a8b96a87ba3$var$w(e1) ? $6f131a8b96a87ba3$var$rB($6f131a8b96a87ba3$var$rF, e1, !1) || e1 : e1 || $6f131a8b96a87ba3$var$rL;
}
function $6f131a8b96a87ba3$export$a1989e995cd481be(e1) {
    return $6f131a8b96a87ba3$var$rB("directives", e1);
}
function $6f131a8b96a87ba3$var$rB(e1, t, n = !0, r = !1) {
    let i = $6f131a8b96a87ba3$var$no || $6f131a8b96a87ba3$var$lE;
    if (i) {
        let n = i.type;
        if (e1 === $6f131a8b96a87ba3$var$rF) {
            let e1 = $6f131a8b96a87ba3$var$lH(n, !1);
            if (e1 && (e1 === t || e1 === $6f131a8b96a87ba3$export$161d051f5dd25de7(t) || e1 === $6f131a8b96a87ba3$export$9a00dee1beb8f576($6f131a8b96a87ba3$export$161d051f5dd25de7(t)))) return n;
        }
        let l = $6f131a8b96a87ba3$var$rj(i[e1] || n[e1], t) || $6f131a8b96a87ba3$var$rj(i.appContext[e1], t);
        return !l && r ? n : l;
    }
}
function $6f131a8b96a87ba3$var$rj(e1, t) {
    return e1 && (e1[t] || e1[$6f131a8b96a87ba3$export$161d051f5dd25de7(t)] || e1[$6f131a8b96a87ba3$export$9a00dee1beb8f576($6f131a8b96a87ba3$export$161d051f5dd25de7(t))]);
}
function $6f131a8b96a87ba3$export$4bf387f59bfc6d67(e1, t, n, r) {
    let i, l = n && n[r], s = $6f131a8b96a87ba3$var$k(e1);
    if (s || $6f131a8b96a87ba3$var$w(e1)) {
        let n = s && $6f131a8b96a87ba3$export$352205f445242f02(e1), r = !1, o = !1;
        n && (r = !$6f131a8b96a87ba3$export$7f3fe6025abfa26e(e1), o = $6f131a8b96a87ba3$export$92d09b48637741e7(e1), e1 = $6f131a8b96a87ba3$var$ez(e1)), i = Array(e1.length);
        for(let n = 0, s = e1.length; n < s; n++)i[n] = t(r ? o ? $6f131a8b96a87ba3$var$tw($6f131a8b96a87ba3$var$tT(e1[n])) : $6f131a8b96a87ba3$var$tT(e1[n]) : e1[n], n, void 0, l && l[n]);
    } else if ("number" == typeof e1) {
        if (!Number.isInteger(e1) || e1 < 0) i = [];
        else {
            i = Array(e1);
            for(let n = 0; n < e1; n++)i[n] = t(n + 1, n, void 0, l && l[n]);
        }
    } else if ($6f131a8b96a87ba3$var$A(e1)) {
        if (e1[Symbol.iterator]) i = Array.from(e1, (e1, n)=>t(e1, n, void 0, l && l[n]));
        else {
            let n = Object.keys(e1);
            i = Array(n.length);
            for(let r = 0, s = n.length; r < s; r++){
                let s = n[r];
                i[r] = t(e1[s], s, r, l && l[r]);
            }
        }
    } else i = [];
    return n && (n[r] = i), i;
}
function $6f131a8b96a87ba3$export$85738f8fcd0a5430(e1, t) {
    for(let n = 0; n < t.length; n++){
        let r = t[n];
        if ($6f131a8b96a87ba3$var$k(r)) for(let t = 0; t < r.length; t++)e1[r[t].name] = r[t].fn;
        else r && (e1[r.name] = r.key ? (...e1)=>{
            let t = r.fn(...e1);
            return t && (t.key = r.key), t;
        } : r.fn);
    }
    return e1;
}
function $6f131a8b96a87ba3$export$4abee4c34694ada1(e1, t, n, r, i, l) {
    let s;
    if (null == n && (n = {}), $6f131a8b96a87ba3$var$no.ce || $6f131a8b96a87ba3$var$no.parent && $6f131a8b96a87ba3$var$rp($6f131a8b96a87ba3$var$no.parent) && $6f131a8b96a87ba3$var$no.parent.ce) {
        let e1 = null != l && null == n.key ? $6f131a8b96a87ba3$var$_({}, n, {
            key: l
        }) : n, i = Object.keys(e1).length > 0;
        return "default" !== t && (e1.name = t), $6f131a8b96a87ba3$export$e7eaa45e502fe5cc(), $6f131a8b96a87ba3$export$9f2dfe8048dfb22b($6f131a8b96a87ba3$export$ffb0004e005737fa, null, [
            $6f131a8b96a87ba3$export$bf5c4cf060303d58("slot", e1, r && r())
        ], i ? -2 : 64);
    }
    let o = e1[t];
    o && o._c && (o._d = !1);
    let a = $6f131a8b96a87ba3$var$le.length;
    $6f131a8b96a87ba3$export$e7eaa45e502fe5cc();
    try {
        let i = o && $6f131a8b96a87ba3$var$rW(o(n)), a = n.key || l || i && i.key;
        s = $6f131a8b96a87ba3$export$9f2dfe8048dfb22b($6f131a8b96a87ba3$export$ffb0004e005737fa, {
            key: (a && !$6f131a8b96a87ba3$var$N(a) ? a : `_${t}`) + (!i && r ? "_fb" : "")
        }, i || (r ? r() : []), i && 1 === e1._ ? 64 : -2);
    } catch (e1) {
        for(let e1 = $6f131a8b96a87ba3$var$le.length; e1 > a; e1--)$6f131a8b96a87ba3$var$lr();
        throw e1;
    } finally{
        o && o._c && (o._d = !0);
    }
    return !i && s.scopeId && (s.slotScopeIds = [
        s.scopeId + "-s"
    ]), s;
}
function $6f131a8b96a87ba3$var$rW(e1) {
    return e1.some((e1)=>!$6f131a8b96a87ba3$export$3868d13f8734ae81(e1) || e1.type !== $6f131a8b96a87ba3$export$4d299b491347818a && (e1.type !== $6f131a8b96a87ba3$export$ffb0004e005737fa || !!$6f131a8b96a87ba3$var$rW(e1.children))) ? e1 : null;
}
function $6f131a8b96a87ba3$export$2fb94ff667a6a1a(e1, t) {
    let n = {};
    for(let r in e1)n[t && /[A-Z]/.test(r) ? `on:${r}` : $6f131a8b96a87ba3$export$8c022799eeaaefcd(r)] = e1[r];
    return n;
}
let $6f131a8b96a87ba3$var$rz = (e1)=>e1 ? $6f131a8b96a87ba3$var$lM(e1) ? $6f131a8b96a87ba3$var$lU(e1) : $6f131a8b96a87ba3$var$rz(e1.parent) : null, $6f131a8b96a87ba3$var$rJ = $6f131a8b96a87ba3$var$_(Object.create(null), {
    $: (e1)=>e1,
    $el: (e1)=>e1.vnode.el,
    $data: (e1)=>e1.data,
    $props: (e1)=>e1.props,
    $attrs: (e1)=>e1.attrs,
    $slots: (e1)=>e1.slots,
    $refs: (e1)=>e1.refs,
    $parent: (e1)=>$6f131a8b96a87ba3$var$rz(e1.parent),
    $root: (e1)=>$6f131a8b96a87ba3$var$rz(e1.root),
    $host: (e1)=>e1.ce,
    $emit: (e1)=>e1.emit,
    $options: (e1)=>$6f131a8b96a87ba3$var$is(e1),
    $forceUpdate: (e1)=>e1.f || (e1.f = ()=>{
            $6f131a8b96a87ba3$var$ne(e1.update);
        }),
    $nextTick: (e1)=>e1.n || (e1.n = $6f131a8b96a87ba3$export$bdd553fddd433dcb.bind(e1.proxy)),
    $watch: (e1)=>$6f131a8b96a87ba3$var$nw.bind(e1)
}), $6f131a8b96a87ba3$var$rG = (e1, t)=>e1 !== $6f131a8b96a87ba3$var$f && !e1.__isScriptSetup && $6f131a8b96a87ba3$var$C(e1, t), $6f131a8b96a87ba3$var$rX = {
    get ({ _: e1 }, t) {
        let n, r;
        if ("__v_skip" === t) return !0;
        let { ctx: i, setupState: l, data: s, props: o, accessCache: a, type: c, appContext: u } = e1;
        if ("$" !== t[0]) {
            let e1 = a[t];
            if (void 0 !== e1) switch(e1){
                case 1:
                    return l[t];
                case 2:
                    return s[t];
                case 4:
                    return i[t];
                case 3:
                    return o[t];
            }
            else {
                if ($6f131a8b96a87ba3$var$rG(l, t)) return a[t] = 1, l[t];
                if (s !== $6f131a8b96a87ba3$var$f && $6f131a8b96a87ba3$var$C(s, t)) return a[t] = 2, s[t];
                if ($6f131a8b96a87ba3$var$C(o, t)) return a[t] = 3, o[t];
                if (i !== $6f131a8b96a87ba3$var$f && $6f131a8b96a87ba3$var$C(i, t)) return a[t] = 4, i[t];
                $6f131a8b96a87ba3$var$ii && (a[t] = 0);
            }
        }
        let d = $6f131a8b96a87ba3$var$rJ[t];
        return d ? ("$attrs" === t && $6f131a8b96a87ba3$var$eq(e1.attrs, "get", ""), d(e1)) : (n = c.__cssModules) && (n = n[t]) ? n : i !== $6f131a8b96a87ba3$var$f && $6f131a8b96a87ba3$var$C(i, t) ? (a[t] = 4, i[t]) : $6f131a8b96a87ba3$var$C(r = u.config.globalProperties, t) ? r[t] : void 0;
    },
    set ({ _: e1 }, t, n) {
        let { data: r, setupState: i, ctx: l } = e1;
        return $6f131a8b96a87ba3$var$rG(i, t) ? (i[t] = n, !0) : r !== $6f131a8b96a87ba3$var$f && $6f131a8b96a87ba3$var$C(r, t) ? (r[t] = n, !0) : !$6f131a8b96a87ba3$var$C(e1.props, t) && !("$" === t[0] && t.slice(1) in e1) && (l[t] = n, !0);
    },
    has ({ _: { data: e1, setupState: t, accessCache: n, ctx: r, appContext: i, props: l, type: s } }, o) {
        let a;
        return !!(n[o] || e1 !== $6f131a8b96a87ba3$var$f && "$" !== o[0] && $6f131a8b96a87ba3$var$C(e1, o) || $6f131a8b96a87ba3$var$rG(t, o) || $6f131a8b96a87ba3$var$C(l, o) || $6f131a8b96a87ba3$var$C(r, o) || $6f131a8b96a87ba3$var$C($6f131a8b96a87ba3$var$rJ, o) || $6f131a8b96a87ba3$var$C(i.config.globalProperties, o) || (a = s.__cssModules) && a[o]);
    },
    defineProperty (e1, t, n) {
        return null != n.get ? e1._.accessCache[t] = 0 : $6f131a8b96a87ba3$var$C(n, "value") && this.set(e1, t, n.value, null), Reflect.defineProperty(e1, t, n);
    }
}, $6f131a8b96a87ba3$var$rQ = $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$rX, {
    get (e1, t) {
        if (t !== Symbol.unscopables) return $6f131a8b96a87ba3$var$rX.get(e1, t, e1);
    },
    has: (e1, t)=>"_" !== t[0] && !$6f131a8b96a87ba3$var$z(t)
});
function $6f131a8b96a87ba3$export$80b33eababae110e() {
    return null;
}
function $6f131a8b96a87ba3$export$51ecece22fc17ddc() {
    return null;
}
function $6f131a8b96a87ba3$export$da25b65ca24b518a(e1) {}
function $6f131a8b96a87ba3$export$77e79129327f3d0d(e1) {}
function $6f131a8b96a87ba3$export$1b3acd4bb805b712() {
    return null;
}
function $6f131a8b96a87ba3$export$acd55aa037e791bb() {}
function $6f131a8b96a87ba3$export$4df9c0969a9e0160(e1, t) {
    return null;
}
function $6f131a8b96a87ba3$export$9203a8e84125433c() {
    return $6f131a8b96a87ba3$var$r5().slots;
}
function $6f131a8b96a87ba3$export$75e29435042cd2ea() {
    return $6f131a8b96a87ba3$var$r5().attrs;
}
function $6f131a8b96a87ba3$var$r5(e1) {
    let t = $6f131a8b96a87ba3$export$f13e630aa3915748();
    return t.setupContext || (t.setupContext = $6f131a8b96a87ba3$var$lj(t));
}
function $6f131a8b96a87ba3$var$r9(e1) {
    return $6f131a8b96a87ba3$var$k(e1) ? e1.reduce((e1, t)=>(e1[t] = null, e1), {}) : e1;
}
function $6f131a8b96a87ba3$export$ec60f47d4a8a2e7f(e1, t) {
    let n = $6f131a8b96a87ba3$var$r9(e1);
    for(let e1 in t){
        if (e1.startsWith("__skip")) continue;
        let r = n[e1];
        r ? $6f131a8b96a87ba3$var$k(r) || $6f131a8b96a87ba3$var$T(r) ? r = n[e1] = {
            type: r,
            default: t[e1]
        } : r.default = t[e1] : null === r && (r = n[e1] = {
            default: t[e1]
        }), r && t[`__skip_${e1}`] && (r.skipFactory = !0);
    }
    return n;
}
function $6f131a8b96a87ba3$export$ad4f724f587e6828(e1, t) {
    return e1 && t ? $6f131a8b96a87ba3$var$k(e1) && $6f131a8b96a87ba3$var$k(t) ? e1.concat(t) : $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$r9(e1), $6f131a8b96a87ba3$var$r9(t)) : e1 || t;
}
function $6f131a8b96a87ba3$export$7c343e855c563faa(e1, t) {
    let n = {};
    for(let r in e1)t.includes(r) || Object.defineProperty(n, r, {
        enumerable: !0,
        get: ()=>e1[r]
    });
    return n;
}
function $6f131a8b96a87ba3$export$d6d6f7369f1fb104(e1) {
    let t = $6f131a8b96a87ba3$export$f13e630aa3915748(), n = $6f131a8b96a87ba3$var$lP, r = e1();
    $6f131a8b96a87ba3$var$lO(), n && $6f131a8b96a87ba3$var$s(!1);
    let i = ()=>{
        $6f131a8b96a87ba3$var$lI(t), n && $6f131a8b96a87ba3$var$s(!0);
    }, l = ()=>{
        $6f131a8b96a87ba3$export$f13e630aa3915748() !== t && t.scope.off(), $6f131a8b96a87ba3$var$lO(), n && $6f131a8b96a87ba3$var$s(!1);
    };
    return $6f131a8b96a87ba3$var$E(r) && (r = r.catch((e1)=>{
        throw i(), Promise.resolve().then(()=>Promise.resolve().then(l)), e1;
    })), [
        r,
        ()=>{
            i(), Promise.resolve().then(l);
        }
    ];
}
let $6f131a8b96a87ba3$var$ii = !0;
function $6f131a8b96a87ba3$var$il(e1, t, n) {
    $6f131a8b96a87ba3$export$dae85862a8d94378($6f131a8b96a87ba3$var$k(e1) ? e1.map((e1)=>e1.bind(t.proxy)) : e1.bind(t.proxy), t, n);
}
function $6f131a8b96a87ba3$var$is(e1) {
    let t, n = e1.type, { mixins: r, extends: i } = n, { mixins: l, optionsCache: s, config: { optionMergeStrategies: o } } = e1.appContext, a = s.get(n);
    return a ? t = a : l.length || r || i ? (t = {}, l.length && l.forEach((e1)=>$6f131a8b96a87ba3$var$io(t, e1, o, !0)), $6f131a8b96a87ba3$var$io(t, n, o)) : t = n, $6f131a8b96a87ba3$var$A(n) && s.set(n, t), t;
}
function $6f131a8b96a87ba3$var$io(e1, t, n, r = !1) {
    let { mixins: i, extends: l } = t;
    for(let s in l && $6f131a8b96a87ba3$var$io(e1, l, n, !0), i && i.forEach((t)=>$6f131a8b96a87ba3$var$io(e1, t, n, !0)), t)if (r && "expose" === s) ;
    else {
        let r = $6f131a8b96a87ba3$var$ia[s] || n && n[s];
        e1[s] = r ? r(e1[s], t[s]) : t[s];
    }
    return e1;
}
let $6f131a8b96a87ba3$var$ia = {
    data: $6f131a8b96a87ba3$var$ic,
    props: $6f131a8b96a87ba3$var$ih,
    emits: $6f131a8b96a87ba3$var$ih,
    methods: $6f131a8b96a87ba3$var$ip,
    computed: $6f131a8b96a87ba3$var$ip,
    beforeCreate: $6f131a8b96a87ba3$var$id,
    created: $6f131a8b96a87ba3$var$id,
    beforeMount: $6f131a8b96a87ba3$var$id,
    mounted: $6f131a8b96a87ba3$var$id,
    beforeUpdate: $6f131a8b96a87ba3$var$id,
    updated: $6f131a8b96a87ba3$var$id,
    beforeDestroy: $6f131a8b96a87ba3$var$id,
    beforeUnmount: $6f131a8b96a87ba3$var$id,
    destroyed: $6f131a8b96a87ba3$var$id,
    unmounted: $6f131a8b96a87ba3$var$id,
    activated: $6f131a8b96a87ba3$var$id,
    deactivated: $6f131a8b96a87ba3$var$id,
    errorCaptured: $6f131a8b96a87ba3$var$id,
    serverPrefetch: $6f131a8b96a87ba3$var$id,
    components: $6f131a8b96a87ba3$var$ip,
    directives: $6f131a8b96a87ba3$var$ip,
    watch: function(e1, t) {
        if (!e1) return t;
        if (!t) return e1;
        let n = $6f131a8b96a87ba3$var$_(Object.create(null), e1);
        for(let r in t)n[r] = $6f131a8b96a87ba3$var$id(e1[r], t[r]);
        return n;
    },
    provide: $6f131a8b96a87ba3$var$ic,
    inject: function(e1, t) {
        return $6f131a8b96a87ba3$var$ip($6f131a8b96a87ba3$var$iu(e1), $6f131a8b96a87ba3$var$iu(t));
    }
};
function $6f131a8b96a87ba3$var$ic(e1, t) {
    return t ? e1 ? function() {
        return $6f131a8b96a87ba3$var$_($6f131a8b96a87ba3$var$T(e1) ? e1.call(this, this) : e1, $6f131a8b96a87ba3$var$T(t) ? t.call(this, this) : t);
    } : t : e1;
}
function $6f131a8b96a87ba3$var$iu(e1) {
    if ($6f131a8b96a87ba3$var$k(e1)) {
        let t = {};
        for(let n = 0; n < e1.length; n++)t[e1[n]] = e1[n];
        return t;
    }
    return e1;
}
function $6f131a8b96a87ba3$var$id(e1, t) {
    return e1 ? [
        ...new Set([].concat(e1, t))
    ] : t;
}
function $6f131a8b96a87ba3$var$ip(e1, t) {
    return e1 ? $6f131a8b96a87ba3$var$_(Object.create(null), e1, t) : t;
}
function $6f131a8b96a87ba3$var$ih(e1, t) {
    return e1 ? $6f131a8b96a87ba3$var$k(e1) && $6f131a8b96a87ba3$var$k(t) ? [
        ...new Set([
            ...e1,
            ...t
        ])
    ] : $6f131a8b96a87ba3$var$_(Object.create(null), $6f131a8b96a87ba3$var$r9(e1), $6f131a8b96a87ba3$var$r9(null != t ? t : {})) : t;
}
function $6f131a8b96a87ba3$var$ig() {
    return {
        app: null,
        config: {
            isNativeTag: $6f131a8b96a87ba3$var$y,
            performance: !1,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap,
        propsCache: new WeakMap,
        emitsCache: new WeakMap
    };
}
let $6f131a8b96a87ba3$var$im = 0, $6f131a8b96a87ba3$var$iy = null;
function $6f131a8b96a87ba3$export$fb78bd113157f1a1(e1, t, n = $6f131a8b96a87ba3$var$f) {
    let r = $6f131a8b96a87ba3$export$f13e630aa3915748(), i = $6f131a8b96a87ba3$export$161d051f5dd25de7(t), l = $6f131a8b96a87ba3$var$V(t), s = $6f131a8b96a87ba3$var$ib(e1, i), o = $6f131a8b96a87ba3$export$a20c2dd6199824cb((s, o)=>{
        let a, c, u = $6f131a8b96a87ba3$var$f;
        return $6f131a8b96a87ba3$export$2035654f31b0e555(()=>{
            let t = e1[i];
            $6f131a8b96a87ba3$var$j(a, t) && (a = t, o());
        }), {
            get: ()=>(s(), n.get ? n.get(a) : a),
            set (e1) {
                let s = n.set ? n.set(e1) : e1;
                if (!$6f131a8b96a87ba3$var$j(s, a) && !(u !== $6f131a8b96a87ba3$var$f && $6f131a8b96a87ba3$var$j(e1, u))) return;
                let d = r.vnode.props, p = !!(d && (t in d || i in d || l in d) && (`onUpdate:${t}` in d || `onUpdate:${i}` in d || `onUpdate:${l}` in d));
                p || (a = e1, o()), r.emit(`update:${t}`, s), $6f131a8b96a87ba3$var$j(e1, u) && ($6f131a8b96a87ba3$var$j(e1, s) && !$6f131a8b96a87ba3$var$j(s, c) || p && u !== $6f131a8b96a87ba3$var$f && !$6f131a8b96a87ba3$var$j(s, a)) && o(), u = e1, c = s;
            }
        };
    });
    return o[Symbol.iterator] = ()=>{
        let e1 = 0;
        return {
            next: ()=>e1 < 2 ? {
                    value: e1++ ? s || $6f131a8b96a87ba3$var$f : o,
                    done: !1
                } : {
                    done: !0
                }
        };
    }, o;
}
let $6f131a8b96a87ba3$var$ib = (e1, t)=>"modelValue" === t || "model-value" === t ? e1.modelModifiers : e1[`${t}Modifiers`] || e1[`${$6f131a8b96a87ba3$export$161d051f5dd25de7(t)}Modifiers`] || e1[`${$6f131a8b96a87ba3$var$V(t)}Modifiers`];
function $6f131a8b96a87ba3$var$i_(e1, t, ...n) {
    let r;
    if (e1.isUnmounted) return;
    let i = e1.vnode.props || $6f131a8b96a87ba3$var$f, l = n, s = t.startsWith("update:"), o = s && $6f131a8b96a87ba3$var$ib(i, t.slice(7));
    o && (o.trim && (l = n.map((e1)=>$6f131a8b96a87ba3$var$w(e1) ? e1.trim() : e1)), o.number && (l = l.map($6f131a8b96a87ba3$var$q)));
    let a = i[r = $6f131a8b96a87ba3$export$8c022799eeaaefcd(t)] || i[r = $6f131a8b96a87ba3$export$8c022799eeaaefcd($6f131a8b96a87ba3$export$161d051f5dd25de7(t))];
    !a && s && (a = i[r = $6f131a8b96a87ba3$export$8c022799eeaaefcd($6f131a8b96a87ba3$var$V(t))]), a && $6f131a8b96a87ba3$export$dae85862a8d94378(a, e1, 6, l);
    let c = i[r + "Once"];
    if (c) {
        if (e1.emitted) {
            if (e1.emitted[r]) return;
        } else e1.emitted = {};
        e1.emitted[r] = !0, $6f131a8b96a87ba3$export$dae85862a8d94378(c, e1, 6, l);
    }
}
let $6f131a8b96a87ba3$var$iS = new WeakMap;
function $6f131a8b96a87ba3$var$ix(e1, t) {
    return !!e1 && !!$6f131a8b96a87ba3$var$v(t) && ($6f131a8b96a87ba3$var$C(e1, (t = "Once" === (t = t.slice(2)) ? t : t.replace(/Once$/, ""))[0].toLowerCase() + t.slice(1)) || $6f131a8b96a87ba3$var$C(e1, $6f131a8b96a87ba3$var$V(t)) || $6f131a8b96a87ba3$var$C(e1, t));
}
function $6f131a8b96a87ba3$var$iC(e1) {
    let t, n, { type: r, vnode: i, proxy: l, withProxy: s, propsOptions: [o], slots: a, attrs: c, emit: u, render: d, renderCache: p, props: h, data: f, setupState: g, ctx: m, inheritAttrs: y } = e1, v = $6f131a8b96a87ba3$var$nc(e1);
    try {
        if (4 & i.shapeFlag) {
            let e1 = s || l;
            t = $6f131a8b96a87ba3$var$lS(d.call(e1, e1, p, h, g, f, m)), n = c;
        } else t = $6f131a8b96a87ba3$var$lS(r.length > 1 ? r(h, {
            attrs: c,
            slots: a,
            emit: u
        }) : r(h, null)), n = r.props ? c : $6f131a8b96a87ba3$var$iT(c);
    } catch (n) {
        $6f131a8b96a87ba3$var$le.length = 0, $6f131a8b96a87ba3$export$d3da1ecaf1206c58(n, e1, 1), t = $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$4d299b491347818a);
    }
    let _ = t;
    if (n && !1 !== y) {
        let e1 = Object.keys(n), { shapeFlag: t } = _;
        e1.length && 7 & t && (o && e1.some($6f131a8b96a87ba3$var$b) && (n = $6f131a8b96a87ba3$var$iw(n, o)), _ = $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(_, n, !1, !0));
    }
    return i.dirs && ((_ = $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(_, null, !1, !0)).dirs = _.dirs ? _.dirs.concat(i.dirs) : i.dirs), i.transition && $6f131a8b96a87ba3$export$7770a22486565649(_.type.__isTeleport && $6f131a8b96a87ba3$var$nJ(_) || _, i.transition), t = _, $6f131a8b96a87ba3$var$nc(v), t;
}
function $6f131a8b96a87ba3$var$ik(e1, t = !0) {
    let n;
    for(let t = 0; t < e1.length; t++){
        let r = e1[t];
        if (!$6f131a8b96a87ba3$export$3868d13f8734ae81(r)) return;
        if (r.type !== $6f131a8b96a87ba3$export$4d299b491347818a || "v-if" === r.children) {
            if (n) return;
            else n = r;
        }
    }
    return n;
}
let $6f131a8b96a87ba3$var$iT = (e1)=>{
    let t;
    for(let n in e1)("class" === n || "style" === n || $6f131a8b96a87ba3$var$v(n)) && ((t || (t = {}))[n] = e1[n]);
    return t;
}, $6f131a8b96a87ba3$var$iw = (e1, t)=>{
    let n = {};
    for(let r in e1)$6f131a8b96a87ba3$var$b(r) && r.slice(9) in t || (n[r] = e1[r]);
    return n;
};
function $6f131a8b96a87ba3$var$iN(e1, t, n) {
    let r = Object.keys(t);
    if (r.length !== Object.keys(e1).length) return !0;
    for(let i = 0; i < r.length; i++){
        let l = r[i];
        if (!$6f131a8b96a87ba3$var$C(e1, l) || $6f131a8b96a87ba3$var$iA(t, e1, l) && !$6f131a8b96a87ba3$var$ix(n, l)) return !0;
    }
    return !1;
}
function $6f131a8b96a87ba3$var$iA(e1, t, n) {
    let r = e1[n], i = t[n];
    return "style" === n && $6f131a8b96a87ba3$var$A(r) && $6f131a8b96a87ba3$var$A(i) ? !$6f131a8b96a87ba3$var$eu(r, i) : r !== i;
}
function $6f131a8b96a87ba3$var$iE({ vnode: e1, parent: t, suspense: n }, r) {
    for(; t;){
        let n = t.subTree;
        if (n.suspense && n.suspense.activeBranch === e1 && (n.suspense.vnode.el = n.el = r, e1 = n), n === e1) (e1 = t.vnode).el = r, t = t.parent;
        else break;
    }
    n && n.activeBranch === e1 && (n.vnode.el = r);
}
let $6f131a8b96a87ba3$var$iR = {}, $6f131a8b96a87ba3$var$iI = (e1)=>Object.getPrototypeOf(e1) === $6f131a8b96a87ba3$var$iR;
function $6f131a8b96a87ba3$var$iO(e1, t, n, r) {
    let i, [l, s] = e1.propsOptions, o = !1;
    if (t) for(let a in t){
        let c;
        if ($6f131a8b96a87ba3$var$O(a)) continue;
        let u = t[a];
        l && $6f131a8b96a87ba3$var$C(l, c = $6f131a8b96a87ba3$export$161d051f5dd25de7(a)) ? s && s.includes(c) ? (i || (i = {}))[c] = u : n[c] = u : $6f131a8b96a87ba3$var$ix(e1.emitsOptions, a) || a in r && u === r[a] || (r[a] = u, o = !0);
    }
    if (s) {
        let t = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(n), r = i || $6f131a8b96a87ba3$var$f;
        for(let i = 0; i < s.length; i++){
            let o = s[i];
            n[o] = $6f131a8b96a87ba3$var$iM(l, t, o, r[o], e1, !$6f131a8b96a87ba3$var$C(r, o));
        }
    }
    return o;
}
function $6f131a8b96a87ba3$var$iM(e1, t, n, r, i, l) {
    let s = e1[n];
    if (null != s) {
        let e1 = $6f131a8b96a87ba3$var$C(s, "default");
        if (e1 && void 0 === r) {
            let e1 = s.default;
            if (s.type !== Function && !s.skipFactory && $6f131a8b96a87ba3$var$T(e1)) {
                let { propsDefaults: l } = i;
                if (n in l) r = l[n];
                else {
                    let s = $6f131a8b96a87ba3$var$lI(i);
                    r = l[n] = e1.call(null, t), s();
                }
            } else r = e1;
            i.ce && i.ce._setProp(n, r);
        }
        s[0] && (l && !e1 ? r = !1 : s[1] && ("" === r || r === $6f131a8b96a87ba3$var$V(n)) && (r = !0));
    }
    return r;
}
let $6f131a8b96a87ba3$var$iP = new WeakMap;
function $6f131a8b96a87ba3$var$iF(e1) {
    return !("$" === e1[0] || $6f131a8b96a87ba3$var$O(e1));
}
let $6f131a8b96a87ba3$var$iD = (e1)=>"_" === e1 || "_ctx" === e1 || "$stable" === e1, $6f131a8b96a87ba3$var$iL = (e1)=>$6f131a8b96a87ba3$var$k(e1) ? e1.map($6f131a8b96a87ba3$var$lS) : [
        $6f131a8b96a87ba3$var$lS(e1)
    ], $6f131a8b96a87ba3$var$iV = (e1, t, n)=>{
    if (t._n) return t;
    let r = $6f131a8b96a87ba3$export$694b237e827a3d23((...e1)=>$6f131a8b96a87ba3$var$iL(t(...e1)), n);
    return r._c = !1, r;
}, $6f131a8b96a87ba3$var$i$ = (e1, t, n)=>{
    let r = e1._ctx;
    for(let n in e1){
        if ($6f131a8b96a87ba3$var$iD(n)) continue;
        let i = e1[n];
        if ($6f131a8b96a87ba3$var$T(i)) t[n] = $6f131a8b96a87ba3$var$iV(n, i, r);
        else if (null != i) {
            let e1 = $6f131a8b96a87ba3$var$iL(i);
            t[n] = ()=>e1;
        }
    }
}, $6f131a8b96a87ba3$var$iB = (e1, t)=>{
    let n = $6f131a8b96a87ba3$var$iL(t);
    e1.slots.default = ()=>n;
}, $6f131a8b96a87ba3$var$ij = (e1, t, n)=>{
    for(let r in t)(n || !$6f131a8b96a87ba3$var$iD(r)) && (e1[r] = t[r]);
}, $6f131a8b96a87ba3$var$iU = $6f131a8b96a87ba3$var$i6;
function $6f131a8b96a87ba3$export$53ae2f996c64e9a(e1) {
    return $6f131a8b96a87ba3$var$iW(e1);
}
function $6f131a8b96a87ba3$export$200524cf0d997ff0(e1) {
    return $6f131a8b96a87ba3$var$iW(e1, $6f131a8b96a87ba3$var$re);
}
function $6f131a8b96a87ba3$var$iW(e1, t) {
    var n;
    let r, i;
    $6f131a8b96a87ba3$var$K().__VUE__ = !0;
    let { insert: l, remove: s, patchProp: o, createElement: a, createText: c, createComment: u, setText: d, setElementText: p, parentNode: h, nextSibling: y, setScopeId: v = $6f131a8b96a87ba3$var$m, insertStaticContent: b } = e1, S = (e1, t, n, r = null, i = null, l = null, s, o = null, a = !!t.dynamicChildren)=>{
        if (e1 === t) return;
        e1 && !$6f131a8b96a87ba3$var$lu(e1, t) && (r = et(e1), X(e1, i, l, !0), e1 = null), -2 === t.patchFlag && (a = !1, t.dynamicChildren = null), t.dynamicChildren && e1 && e1.dynamicChildren && e1.dynamicChildren.hasOnce && (t.dynamicChildren === $6f131a8b96a87ba3$var$g && (t.dynamicChildren = []), t.dynamicChildren.hasOnce = !0);
        let { type: c, ref: u, shapeFlag: d } = t;
        switch(c){
            case $6f131a8b96a87ba3$export$5f1af8db9871e1d6:
                x(e1, t, n, r);
                break;
            case $6f131a8b96a87ba3$export$4d299b491347818a:
                k(e1, t, n, r);
                break;
            case $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6:
                null == e1 && w(t, n, r, s);
                break;
            case $6f131a8b96a87ba3$export$ffb0004e005737fa:
                L(e1, t, n, r, i, l, s, o, a);
                break;
            default:
                1 & d ? N(e1, t, n, r, i, l, s, o, a) : 6 & d ? $(e1, t, n, r, i, l, s, o, a) : 64 & d ? c.process(e1, t, n, r, i, l, s, o, a, er) : 128 & d && c.process(e1, t, n, r, i, l, s, o, a, er);
        }
        null != u && i ? $6f131a8b96a87ba3$var$n6(u, e1 && e1.ref, l, t || e1, !t) : null == u && e1 && null != e1.ref && $6f131a8b96a87ba3$var$n6(e1.ref, null, l, e1, !0);
    }, x = (e1, t, n, r)=>{
        if (null == e1) l(t.el = c(t.children), n, r);
        else {
            let n = t.el = e1.el;
            t.children !== e1.children && d(n, t.children);
        }
    }, k = (e1, t, n, r)=>{
        null == e1 ? l(t.el = u(t.children || ""), n, r) : t.el = e1.el;
    }, w = (e1, t, n, r)=>{
        [e1.el, e1.anchor] = b(e1.children, t, n, r, e1.el, e1.anchor);
    }, N = (e1, t, n, r, i, l, s, o, a)=>{
        if ("svg" === t.type ? s = "svg" : "math" === t.type && (s = "mathml"), null == e1) E(t, n, r, i, l, s, o, a);
        else {
            let n = e1.el && e1.el._isVueCE ? e1.el : null;
            try {
                n && n._beginPatch(), M(e1, t, i, l, s, o, a);
            } finally{
                n && n._endPatch();
            }
        }
    }, E = (e1, t, n, r, i, s, c, u)=>{
        let d, h, { props: f, shapeFlag: g, transition: m, dirs: y } = e1;
        if (d = e1.el = a(e1.type, s, f && f.is, f), 8 & g ? p(d, e1.children) : 16 & g && I(e1.children, d, null, r, i, $6f131a8b96a87ba3$var$iK(e1, s), c, u), y && $6f131a8b96a87ba3$var$ng(e1, null, r, "created"), R(d, e1, e1.scopeId, c, r), f) {
            for(let e1 in f)"value" === e1 || $6f131a8b96a87ba3$var$O(e1) || o(d, e1, null, f[e1], s, r);
            "value" in f && o(d, "value", null, f.value, s), (h = f.onVnodeBeforeMount) && $6f131a8b96a87ba3$var$lT(h, r, e1);
        }
        y && $6f131a8b96a87ba3$var$ng(e1, null, r, "beforeMount");
        let v = $6f131a8b96a87ba3$var$iJ(i, m);
        v && m.beforeEnter(d), l(d, t, n), ((h = f && f.onVnodeMounted) || v || y) && $6f131a8b96a87ba3$var$iU(()=>{
            h && $6f131a8b96a87ba3$var$lT(h, r, e1), v && m.enter(d), y && $6f131a8b96a87ba3$var$ng(e1, null, r, "mounted");
        }, i);
    }, R = (e1, t, n, r, i)=>{
        if (n && v(e1, n), r) for(let t = 0; t < r.length; t++)v(e1, r[t]);
        if (i) {
            let n = i.subTree;
            if (t === n || $6f131a8b96a87ba3$var$iZ(n.type) && (n.ssContent === t || n.ssFallback === t)) {
                let t = i.vnode;
                R(e1, t, t.scopeId, t.slotScopeIds, i.parent);
            }
        }
    }, I = (e1, t, n, r, i, l, s, o, a = 0)=>{
        for(let c = a; c < e1.length; c++)S(null, e1[c] = o ? $6f131a8b96a87ba3$var$lx(e1[c]) : $6f131a8b96a87ba3$var$lS(e1[c]), t, n, r, i, l, s, o);
    }, M = (e1, t, n, r, i, l, s)=>{
        let a, c = t.el = e1.el, { patchFlag: u, dynamicChildren: d, dirs: h } = t;
        u |= 16 & e1.patchFlag;
        let g = e1.props || $6f131a8b96a87ba3$var$f, m = t.props || $6f131a8b96a87ba3$var$f;
        if (n && $6f131a8b96a87ba3$var$iz(n, !1), (a = m.onVnodeBeforeUpdate) && $6f131a8b96a87ba3$var$lT(a, n, t, e1), h && $6f131a8b96a87ba3$var$ng(t, e1, n, "beforeUpdate"), n && $6f131a8b96a87ba3$var$iz(n, !0), d && (!e1.dynamicChildren || e1.dynamicChildren.length !== d.length) && (u = 0, s = !1, d = null), (g.innerHTML && null == m.innerHTML || g.textContent && null == m.textContent) && p(c, ""), d ? P(e1.dynamicChildren, d, c, n, r, $6f131a8b96a87ba3$var$iK(t, i), l) : s || W(e1, t, c, null, n, r, $6f131a8b96a87ba3$var$iK(t, i), l, !1), u > 0) {
            if (16 & u) F(c, g, m, n, i);
            else if (2 & u && g.class !== m.class && o(c, "class", null, m.class, i), 4 & u && o(c, "style", g.style, m.style, i), 8 & u) {
                let e1 = t.dynamicProps;
                for(let t = 0; t < e1.length; t++){
                    let r = e1[t], l = g[r], s = m[r];
                    (s !== l || "value" === r) && o(c, r, l, s, i, n);
                }
            }
            1 & u && e1.children !== t.children && p(c, t.children);
        } else s || null != d || F(c, g, m, n, i);
        ((a = m.onVnodeUpdated) || h) && $6f131a8b96a87ba3$var$iU(()=>{
            a && $6f131a8b96a87ba3$var$lT(a, n, t, e1), h && $6f131a8b96a87ba3$var$ng(t, e1, n, "updated");
        }, r);
    }, P = (e1, t, n, r, i, l, s)=>{
        for(let o = 0; o < t.length; o++){
            let a = e1[o], c = t[o], u = a.el || $6f131a8b96a87ba3$var$iQ(a), d = u && (a.type === $6f131a8b96a87ba3$export$ffb0004e005737fa || !$6f131a8b96a87ba3$var$lu(a, c) || 198 & a.shapeFlag) ? h(u) : n;
            S(a, c, d, null, r, i, l, s, !0);
        }
    }, F = (e1, t, n, r, i)=>{
        if (t !== n) {
            if (t !== $6f131a8b96a87ba3$var$f) for(let l in t)$6f131a8b96a87ba3$var$O(l) || l in n || o(e1, l, t[l], null, i, r);
            for(let l in n){
                if ($6f131a8b96a87ba3$var$O(l)) continue;
                let s = n[l], a = t[l];
                s !== a && "value" !== l && o(e1, l, a, s, i, r);
            }
            "value" in n && o(e1, "value", t.value, n.value, i);
        }
    }, L = (e1, t, n, r, i, s, o, a, u)=>{
        let d = t.el = e1 ? e1.el : c(""), p = t.anchor = e1 ? e1.anchor : c(""), { patchFlag: h, dynamicChildren: f, slotScopeIds: g } = t;
        g && (a = a ? a.concat(g) : g), null == e1 ? (l(d, n, r), l(p, n, r), I(t.children || [], n, p, i, s, o, a, u)) : h > 0 && 64 & h && f && e1.dynamicChildren && e1.dynamicChildren.length === f.length ? (P(e1.dynamicChildren, f, n, i, s, o, a), (null != t.key || i && t === i.subTree) && $6f131a8b96a87ba3$var$iG(e1, t, !0)) : W(e1, t, n, p, i, s, o, a, u);
    }, $ = (e1, t, n, r, i, l, s, o, a)=>{
        t.slotScopeIds = o, null == e1 ? 512 & t.shapeFlag ? i.ctx.activate(t, n, r, s, a) : B(t, n, r, i, l, s, a) : j(e1, t, a);
    }, B = (e1, t, n, r, i, l, s)=>{
        let o = e1.component = $6f131a8b96a87ba3$var$lA(e1, r, i);
        if ($6f131a8b96a87ba3$var$rg(e1) && (o.ctx.renderer = er), $6f131a8b96a87ba3$var$lF(o, !1, s), o.asyncDep) {
            if (i && i.registerDep(o, H, s, l), !e1.el) {
                let r = o.subTree = $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$4d299b491347818a);
                k(null, r, t, n), e1.placeholder = r.el;
            }
        } else H(o, e1, t, n, i, l, s);
    }, j = (e1, t, n)=>{
        let r = t.component = e1.component;
        if (function(e1, t, n) {
            let { props: r, children: i, component: l } = e1, { props: s, children: o, patchFlag: a } = t, c = l.emitsOptions;
            if (t.dirs || t.transition) return !0;
            if (!n || !(a >= 0)) return (!!i || !!o) && (!o || !o.$stable) || r !== s && (r ? !s || $6f131a8b96a87ba3$var$iN(r, s, c) : !!s);
            if (1024 & a) return !0;
            if (16 & a) return r ? $6f131a8b96a87ba3$var$iN(r, s, c) : !!s;
            if (8 & a) {
                let e1 = t.dynamicProps;
                for(let t = 0; t < e1.length; t++){
                    let n = e1[t];
                    if ($6f131a8b96a87ba3$var$iA(s, r, n) && !$6f131a8b96a87ba3$var$ix(c, n)) return !0;
                }
            }
            return !1;
        }(e1, t, n)) {
            if (r.asyncDep && !r.asyncResolved) {
                t.el = e1.el, t.placeholder = e1.placeholder, q(r, t, n);
                return;
            } else r.next = t, r.update();
        } else t.el = e1.el, t.placeholder = e1.placeholder, r.vnode = t;
    }, H = (e1, t, n, r, l, s, o)=>{
        e1.scope.on();
        let a = e1.effect = new $6f131a8b96a87ba3$export$28352bb4dd362521(()=>{
            if (e1.isMounted) {
                let t, { next: n, bu: r, u: i, parent: a, vnode: u } = e1;
                {
                    let t = function e1(t) {
                        let n = t.subTree.component;
                        if (n) {
                            if (n.asyncDep && !n.asyncResolved) return n;
                            else return e1(n);
                        }
                    }(e1);
                    if (t) {
                        n && (n.el = u.el, q(e1, n, o)), t.asyncDep.then(()=>{
                            $6f131a8b96a87ba3$var$iU(()=>{
                                e1.isUnmounted || c();
                            }, l);
                        });
                        return;
                    }
                }
                let d = n;
                $6f131a8b96a87ba3$var$iz(e1, !1), n ? (n.el = u.el, q(e1, n, o)) : n = u, r && $6f131a8b96a87ba3$var$U(r), (t = n.props && n.props.onVnodeBeforeUpdate) && $6f131a8b96a87ba3$var$lT(t, a, n, u), $6f131a8b96a87ba3$var$iz(e1, !0);
                let p = $6f131a8b96a87ba3$var$iC(e1), f = e1.subTree;
                e1.subTree = p, S(f, p, h(f.el), et(f), e1, l, s), n.el = p.el, null === d && $6f131a8b96a87ba3$var$iE(e1, p.el), i && $6f131a8b96a87ba3$var$iU(i, l), (t = n.props && n.props.onVnodeUpdated) && $6f131a8b96a87ba3$var$iU(()=>$6f131a8b96a87ba3$var$lT(t, a, n, u), l);
            } else {
                let o, { el: a, props: c } = t, { bm: u, m: d, parent: p, root: h, type: f } = e1, g = $6f131a8b96a87ba3$var$rp(t);
                if ($6f131a8b96a87ba3$var$iz(e1, !1), u && $6f131a8b96a87ba3$var$U(u), !g && (o = c && c.onVnodeBeforeMount) && $6f131a8b96a87ba3$var$lT(o, p, t), $6f131a8b96a87ba3$var$iz(e1, !0), a && i) {
                    let t = ()=>{
                        e1.subTree = $6f131a8b96a87ba3$var$iC(e1), i(a, e1.subTree, e1, l, null);
                    };
                    g && f.__asyncHydrate ? f.__asyncHydrate(a, e1, t) : t();
                } else {
                    h.ce && h.ce._hasShadowRoot() && h.ce._injectChildStyle(f, e1.parent ? e1.parent.type : void 0);
                    let i = e1.subTree = $6f131a8b96a87ba3$var$iC(e1);
                    S(null, i, n, r, e1, l, s), t.el = i.el;
                }
                if (d && $6f131a8b96a87ba3$var$iU(d, l), !g && (o = c && c.onVnodeMounted)) {
                    let e1 = t;
                    $6f131a8b96a87ba3$var$iU(()=>$6f131a8b96a87ba3$var$lT(o, p, e1), l);
                }
                (256 & t.shapeFlag || p && $6f131a8b96a87ba3$var$rp(p.vnode) && 256 & p.vnode.shapeFlag) && e1.a && $6f131a8b96a87ba3$var$iU(e1.a, l), e1.isMounted = !0, t = n = r = null;
            }
        });
        e1.scope.off();
        let c = e1.update = a.run.bind(a), u = e1.job = a.runIfDirty.bind(a);
        u.i = e1, u.id = e1.uid, a.scheduler = ()=>$6f131a8b96a87ba3$var$ne(u), $6f131a8b96a87ba3$var$iz(e1, !0), c();
    }, q = (e1, t, n)=>{
        t.component = e1;
        let r = e1.vnode.props;
        e1.vnode = t, e1.next = null, function(e1, t, n, r) {
            let { props: i, attrs: l, vnode: { patchFlag: s } } = e1, o = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(i), [a] = e1.propsOptions, c = !1;
            if ((r || s > 0) && !(16 & s)) {
                if (8 & s) {
                    let n = e1.vnode.dynamicProps;
                    for(let r = 0; r < n.length; r++){
                        let s = n[r];
                        if ($6f131a8b96a87ba3$var$ix(e1.emitsOptions, s)) continue;
                        let u = t[s];
                        if (a) {
                            if ($6f131a8b96a87ba3$var$C(l, s)) u !== l[s] && (l[s] = u, c = !0);
                            else {
                                let t = $6f131a8b96a87ba3$export$161d051f5dd25de7(s);
                                i[t] = $6f131a8b96a87ba3$var$iM(a, o, t, u, e1, !1);
                            }
                        } else u !== l[s] && (l[s] = u, c = !0);
                    }
                }
            } else {
                let r;
                for(let s in $6f131a8b96a87ba3$var$iO(e1, t, i, l) && (c = !0), o)t && ($6f131a8b96a87ba3$var$C(t, s) || (r = $6f131a8b96a87ba3$var$V(s)) !== s && $6f131a8b96a87ba3$var$C(t, r)) || (a ? n && (void 0 !== n[s] || void 0 !== n[r]) && (i[s] = $6f131a8b96a87ba3$var$iM(a, o, s, void 0, e1, !0)) : delete i[s]);
                if (l !== o) for(let e1 in l)t && $6f131a8b96a87ba3$var$C(t, e1) || (delete l[e1], c = !0);
            }
            c && $6f131a8b96a87ba3$var$eW(e1.attrs, "set", "");
        }(e1, t.props, r, n), ((e1, t, n)=>{
            let { vnode: r, slots: i } = e1, l = !0, s = $6f131a8b96a87ba3$var$f;
            if (32 & r.shapeFlag) {
                let e1 = t._;
                e1 ? n && 1 === e1 ? l = !1 : $6f131a8b96a87ba3$var$ij(i, t, n) : (l = !t.$stable, $6f131a8b96a87ba3$var$i$(t, i)), s = t;
            } else t && ($6f131a8b96a87ba3$var$iB(e1, t), s = {
                default: 1
            });
            if (l) for(let e1 in i)$6f131a8b96a87ba3$var$iD(e1) || null != s[e1] || delete i[e1];
        })(e1, t.children, n), $6f131a8b96a87ba3$var$eP(), $6f131a8b96a87ba3$var$nr(e1), $6f131a8b96a87ba3$var$eF();
    }, W = (e1, t, n, r, i, l, s, o, a = !1)=>{
        let c = e1 && e1.children, u = e1 ? e1.shapeFlag : 0, d = t.children, { patchFlag: h, shapeFlag: f } = t;
        if (h > 0) {
            if (128 & h) return void J(c, d, n, r, i, l, s, o, a);
            else if (256 & h) return void z(c, d, n, r, i, l, s, o, a);
        }
        8 & f ? (16 & u && ee(c, i, l), d !== c && p(n, d)) : 16 & u ? 16 & f ? J(c, d, n, r, i, l, s, o, a) : ee(c, i, l, !0) : (8 & u && p(n, ""), 16 & f && I(d, n, r, i, l, s, o, a));
    }, z = (e1, t, n, r, i, l, s, o, a)=>{
        let c;
        e1 = e1 || $6f131a8b96a87ba3$var$g, t = t || $6f131a8b96a87ba3$var$g;
        let u = e1.length, d = t.length, p = Math.min(u, d);
        for(c = 0; c < p; c++){
            let r = t[c] = a ? $6f131a8b96a87ba3$var$lx(t[c]) : $6f131a8b96a87ba3$var$lS(t[c]);
            S(e1[c], r, n, null, i, l, s, o, a);
        }
        u > d ? ee(e1, i, l, !0, !1, p) : I(t, n, r, i, l, s, o, a, p);
    }, J = (e1, t, n, r, i, l, s, o, a)=>{
        let c = 0, u = t.length, d = e1.length - 1, p = u - 1;
        for(; c <= d && c <= p;){
            let r = e1[c], u = t[c] = a ? $6f131a8b96a87ba3$var$lx(t[c]) : $6f131a8b96a87ba3$var$lS(t[c]);
            if ($6f131a8b96a87ba3$var$lu(r, u)) S(r, u, n, null, i, l, s, o, a);
            else break;
            c++;
        }
        for(; c <= d && c <= p;){
            let r = e1[d], c = t[p] = a ? $6f131a8b96a87ba3$var$lx(t[p]) : $6f131a8b96a87ba3$var$lS(t[p]);
            if ($6f131a8b96a87ba3$var$lu(r, c)) S(r, c, n, null, i, l, s, o, a);
            else break;
            d--, p--;
        }
        if (c > d) {
            if (c <= p) {
                let e1 = p + 1, d = e1 < u ? t[e1].el : r;
                for(; c <= p;)S(null, t[c] = a ? $6f131a8b96a87ba3$var$lx(t[c]) : $6f131a8b96a87ba3$var$lS(t[c]), n, d, i, l, s, o, a), c++;
            }
        } else if (c > p) for(; c <= d;)X(e1[c], i, l, !0), c++;
        else {
            let h, f = c, m = c, y = new Map;
            for(c = m; c <= p; c++){
                let e1 = t[c] = a ? $6f131a8b96a87ba3$var$lx(t[c]) : $6f131a8b96a87ba3$var$lS(t[c]);
                null != e1.key && y.set(e1.key, c);
            }
            let v = 0, b = p - m + 1, _ = !1, x = 0, C = Array(b);
            for(c = 0; c < b; c++)C[c] = 0;
            for(c = f; c <= d; c++){
                let r, u = e1[c];
                if (v >= b) {
                    X(u, i, l, !0);
                    continue;
                }
                if (null != u.key) r = y.get(u.key);
                else for(h = m; h <= p; h++)if (0 === C[h - m] && $6f131a8b96a87ba3$var$lu(u, t[h])) {
                    r = h;
                    break;
                }
                void 0 === r ? X(u, i, l, !0) : (C[r - m] = c + 1, r >= x ? x = r : _ = !0, S(u, t[r], n, null, i, l, s, o, a), v++);
            }
            let k = _ ? function(e1) {
                let t, n, r, i, l, s = e1.slice(), o = [
                    0
                ], a = e1.length;
                for(t = 0; t < a; t++){
                    let a = e1[t];
                    if (0 !== a) {
                        if (e1[n = o[o.length - 1]] < a) {
                            s[t] = n, o.push(t);
                            continue;
                        }
                        for(r = 0, i = o.length - 1; r < i;)e1[o[l = r + i >> 1]] < a ? r = l + 1 : i = l;
                        a < e1[o[r]] && (r > 0 && (s[t] = o[r - 1]), o[r] = t);
                    }
                }
                for(r = o.length, i = o[r - 1]; r-- > 0;)o[r] = i, i = s[i];
                return o;
            }(C) : $6f131a8b96a87ba3$var$g;
            for(h = k.length - 1, c = b - 1; c >= 0; c--){
                let e1 = m + c, d = t[e1], p = t[e1 + 1], f = e1 + 1 < u ? p.el || $6f131a8b96a87ba3$var$iQ(p) : r;
                0 === C[c] ? S(null, d, n, f, i, l, s, o, a) : _ && (h < 0 || c !== k[h] ? G(d, n, f, 2) : h--);
            }
        }
    }, G = (e1, t, n, r, i = null)=>{
        let { el: o, type: a, transition: c, children: u, shapeFlag: d } = e1;
        if (6 & d) return void G(e1.component.subTree, t, n, r);
        if (128 & d) return void e1.suspense.move(t, n, r);
        if (64 & d) return void a.move(e1, t, n, er);
        if (a === $6f131a8b96a87ba3$export$ffb0004e005737fa) {
            l(o, t, n);
            for(let e1 = 0; e1 < u.length; e1++)G(u[e1], t, n, r);
            l(e1.anchor, t, n);
            return;
        }
        if (a === $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6) return void (({ el: e1, anchor: t }, n, r)=>{
            let i;
            for(; e1 && e1 !== t;)i = y(e1), l(e1, n, r), e1 = i;
            l(t, n, r);
        })(e1, t, n);
        if (2 !== r && 1 & d && c) {
            if (0 === r) c.persisted && !o[$6f131a8b96a87ba3$var$nV] ? l(o, t, n) : (c.beforeEnter(o), l(o, t, n), $6f131a8b96a87ba3$var$iU(()=>c.enter(o), i));
            else {
                let { leave: r, delayLeave: i, afterLeave: a } = c, u = ()=>{
                    e1.ctx.isUnmounted ? s(o) : l(o, t, n);
                }, d = ()=>{
                    let e1 = o._isLeaving || !!o[$6f131a8b96a87ba3$var$nV];
                    o._isLeaving && o[$6f131a8b96a87ba3$var$nV](!0), c.persisted && !e1 ? u() : r(o, ()=>{
                        u(), a && a();
                    });
                };
                i ? i(o, u, d) : d();
            }
        } else l(o, t, n);
    }, X = (e1, t, n, r = !1, i = !1)=>{
        let l, { type: s, props: o, ref: a, children: c, dynamicChildren: u, shapeFlag: d, patchFlag: p, dirs: h, cacheIndex: f, memo: g } = e1;
        if ((-2 === p || u && u.hasOnce) && (i = !1), null != a && ($6f131a8b96a87ba3$var$eP(), $6f131a8b96a87ba3$var$n6(a, null, n, e1, !0), $6f131a8b96a87ba3$var$eF()), null == f || e1.ctx && e1.ctx !== t || (t.renderCache[f] = void 0), 256 & d) return void t.ctx.deactivate(e1);
        let m = 1 & d && h, y = !$6f131a8b96a87ba3$var$rp(e1);
        if (y && (l = o && o.onVnodeBeforeUnmount) && $6f131a8b96a87ba3$var$lT(l, t, e1), 6 & d) Y(e1.component, n, r);
        else {
            if (128 & d) return void e1.suspense.unmount(n, r);
            m && $6f131a8b96a87ba3$var$ng(e1, null, t, "beforeUnmount"), 64 & d ? e1.type.remove(e1, t, n, er, r) : u && !u.hasOnce && (s !== $6f131a8b96a87ba3$export$ffb0004e005737fa || p > 0 && 64 & p) ? ee(u, t, n, !1, !0) : (s === $6f131a8b96a87ba3$export$ffb0004e005737fa && 384 & p || !i && 16 & d) && ee(c, t, n), r && Q(e1);
        }
        let v = null != g && null == f;
        (y && (l = o && o.onVnodeUnmounted) || m || v) && $6f131a8b96a87ba3$var$iU(()=>{
            l && $6f131a8b96a87ba3$var$lT(l, t, e1), m && $6f131a8b96a87ba3$var$ng(e1, null, t, "unmounted"), v && (e1.el = null);
        }, n);
    }, Q = (e1)=>{
        let { type: t, el: n, anchor: r, transition: i } = e1, l = t === $6f131a8b96a87ba3$export$ffb0004e005737fa;
        if (l && !i) return void Z(n, r);
        if (t === $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6) {
            (({ el: e1, anchor: t })=>{
                let n;
                for(; e1 && e1 !== t;)n = y(e1), s(e1), e1 = n;
                s(t);
            })(e1), i && !i.persisted && i.afterLeave && i.afterLeave();
            return;
        }
        let o = l ? $6f131a8b96a87ba3$var$nQ(e1) : e1, a = ()=>{
            l ? h(n) && Z(n, r) : s(n), i && !i.persisted && i.afterLeave && i.afterLeave();
        };
        if (o && 1 & o.shapeFlag && i && !i.persisted) {
            let { leave: e1, delayLeave: t } = i, n = o.el, r = ()=>e1(n, a);
            t ? t(n, a, r) : r();
        } else a();
    }, Z = (e1, t)=>{
        let n;
        for(; e1 !== t;)n = y(e1), s(e1), e1 = n;
        s(t);
    }, Y = (e1, t, n)=>{
        let { bum: r, scope: i, job: l, subTree: s, um: o, m: a, a: c } = e1;
        $6f131a8b96a87ba3$var$iX(a), $6f131a8b96a87ba3$var$iX(c), r && $6f131a8b96a87ba3$var$U(r), i.stop(), l ? (l.flags |= 8, X(s, e1, t, n)) : e1.vnode.el && s && (s.transition = e1.vnode.transition, X(s, e1, t, n)), o && $6f131a8b96a87ba3$var$iU(o, t), $6f131a8b96a87ba3$var$iU(()=>{
            e1.isUnmounted = !0;
        }, t);
    }, ee = (e1, t, n, r = !1, i = !1, l = 0)=>{
        for(let s = l; s < e1.length; s++)X(e1[s], t, n, r, i);
    }, et = (e1)=>{
        if (6 & e1.shapeFlag) return et(e1.component.subTree);
        if (128 & e1.shapeFlag) return e1.suspense.next();
        let t = y(e1.anchor || e1.el), n = t && t[$6f131a8b96a87ba3$var$nE];
        return n ? y(n) : t;
    }, en = (e1, t, n)=>{
        !function(e1, t) {
            if ($6f131a8b96a87ba3$var$nl) return e1();
            let n = void 0 === t ? void 0 : new Set($6f131a8b96a87ba3$var$t6);
            e1(), $6f131a8b96a87ba3$var$nl = !0;
            try {
                $6f131a8b96a87ba3$var$nr(void 0, t), $6f131a8b96a87ba3$var$ni(void 0, n, t);
            } finally{
                $6f131a8b96a87ba3$var$nl = !1;
            }
        }(()=>{
            null == e1 ? t._vnode && X(t._vnode, null, null, !0) : S(t._vnode || null, e1, t, null, null, null, n), t._vnode = e1;
        }, e1 && t._vnode ? void 0 : e1 && e1.component ? e1.component.uid : $6f131a8b96a87ba3$var$lN);
    }, er = {
        p: S,
        um: X,
        m: G,
        r: Q,
        mt: B,
        mc: I,
        pc: W,
        pbc: P,
        n: et,
        o: e1
    };
    return t && ([r, i] = t(er)), {
        render: en,
        hydrate: r,
        createApp: (n = r, function(e1, t = null) {
            $6f131a8b96a87ba3$var$T(e1) || (e1 = $6f131a8b96a87ba3$var$_({}, e1)), null == t || $6f131a8b96a87ba3$var$A(t) || (t = null);
            let r = $6f131a8b96a87ba3$var$ig(), i = new WeakSet, l = [], s = !1, o = r.app = {
                _uid: $6f131a8b96a87ba3$var$im++,
                _component: e1,
                _props: t,
                _container: null,
                _context: r,
                _instance: null,
                version: $6f131a8b96a87ba3$export$83d89fbfd8236492,
                get config () {
                    return r.config;
                },
                set config (e){},
                use: (e1, ...t)=>(i.has(e1) || (e1 && $6f131a8b96a87ba3$var$T(e1.install) ? (i.add(e1), e1.install(o, ...t)) : $6f131a8b96a87ba3$var$T(e1) && (i.add(e1), e1(o, ...t))), o),
                mixin: (e1)=>(r.mixins.includes(e1) || r.mixins.push(e1), o),
                component: (e1, t)=>t ? (r.components[e1] = t, o) : r.components[e1],
                directive: (e1, t)=>t ? (r.directives[e1] = t, o) : r.directives[e1],
                mount (i, l, a) {
                    if (!s) {
                        let c = o._ceVNode || $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, t);
                        return c.appContext = r, !0 === a ? a = "svg" : !1 === a && (a = void 0), l && n ? n(c, i) : en(c, i, a), s = !0, o._container = i, i.__vue_app__ = o, $6f131a8b96a87ba3$var$lU(c.component);
                    }
                },
                onUnmount (e1) {
                    l.push(e1);
                },
                unmount () {
                    s && ($6f131a8b96a87ba3$export$dae85862a8d94378(l, o._instance, 16), en(null, o._container), delete o._container.__vue_app__);
                },
                provide: (e1, t)=>(r.provides[e1] = t, o),
                runWithContext (e1) {
                    let t = $6f131a8b96a87ba3$var$iy;
                    $6f131a8b96a87ba3$var$iy = o;
                    try {
                        return e1();
                    } finally{
                        $6f131a8b96a87ba3$var$iy = t;
                    }
                }
            };
            return o;
        })
    };
}
function $6f131a8b96a87ba3$var$iK({ type: e1, props: t }, n) {
    return "svg" === n && "foreignObject" === e1 || "mathml" === n && "annotation-xml" === e1 && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function $6f131a8b96a87ba3$var$iz({ effect: e1, job: t }, n) {
    n ? (e1.flags |= 32, t.flags |= 4) : (e1.flags &= -33, t.flags &= -5);
}
function $6f131a8b96a87ba3$var$iJ(e1, t) {
    return (!e1 || e1 && !e1.pendingBranch) && t && !t.persisted;
}
function $6f131a8b96a87ba3$var$iG(e1, t, n = !1) {
    let r = e1.children, i = t.children;
    if ($6f131a8b96a87ba3$var$k(r) && $6f131a8b96a87ba3$var$k(i)) for(let e1 = 0; e1 < r.length; e1++){
        let t = r[e1], l = i[e1];
        1 & l.shapeFlag && !l.dynamicChildren && ((l.patchFlag <= 0 || 32 === l.patchFlag) && ((l = i[e1] = $6f131a8b96a87ba3$var$lx(i[e1])).el = t.el), n || -2 === l.patchFlag || $6f131a8b96a87ba3$var$iG(t, l)), l.type === $6f131a8b96a87ba3$export$5f1af8db9871e1d6 && (-1 === l.patchFlag && (l = i[e1] = $6f131a8b96a87ba3$var$lx(l)), l.el = t.el), l.type !== $6f131a8b96a87ba3$export$4d299b491347818a || l.el || (l.el = t.el);
    }
}
function $6f131a8b96a87ba3$var$iX(e1) {
    if (e1) for(let t = 0; t < e1.length; t++)e1[t].flags |= 8;
}
function $6f131a8b96a87ba3$var$iQ(e1) {
    if (e1.placeholder) return e1.placeholder;
    let t = e1.component;
    return t ? $6f131a8b96a87ba3$var$iQ(t.subTree) : null;
}
let $6f131a8b96a87ba3$var$iZ = (e1)=>e1.__isSuspense, $6f131a8b96a87ba3$var$iY = 0, $6f131a8b96a87ba3$export$74bf444e3cd11ea5 = {
    name: "Suspense",
    __isSuspense: !0,
    process (e1, t, n, r, i, l, s, o, a, c) {
        if (null == e1) !function(e1, t, n, r, i, l, s, o, a) {
            let { p: c, o: { createElement: u } } = a, d = u("div"), p = e1.suspense = $6f131a8b96a87ba3$var$i2(e1, i, r, t, d, n, l, s, o, a);
            c(null, p.pendingBranch = e1.ssContent, d, null, r, p, l, s), p.deps > 0 ? ($6f131a8b96a87ba3$var$i1(e1, "onPending"), $6f131a8b96a87ba3$var$i1(e1, "onFallback"), c(null, e1.ssFallback, t, n, r, null, l, s), $6f131a8b96a87ba3$var$i4(p, e1.ssFallback)) : p.resolve(!1, !0);
        }(t, n, r, i, l, s, o, a, c);
        else {
            if (l && l.deps > 0 && !e1.suspense.isInFallback && !l.isHydrating) {
                t.suspense = e1.suspense, t.suspense.vnode = t, t.el = e1.el;
                return;
            }
            !function(e1, t, n, r, i, l, s, o, { p: a, um: c, o: { createElement: u } }) {
                let d = t.suspense = e1.suspense;
                d.vnode = t, t.el = e1.el;
                let p = t.ssContent, h = t.ssFallback, { activeBranch: f, pendingBranch: g, isInFallback: m, isHydrating: y } = d;
                if (g) d.pendingBranch = p, $6f131a8b96a87ba3$var$lu(g, p) ? (d.deps++, a(g, p, y ? n : d.hiddenContainer, null, i, d, l, s, o), d.deps--, d.deps <= 0 ? d.resolve() : !m || y || d.isFallbackMountPending || (a(f, h, n, r, i, null, l, s, o), $6f131a8b96a87ba3$var$i4(d, h))) : (d.pendingId = $6f131a8b96a87ba3$var$iY++, y ? (d.isHydrating = !1, d.activeBranch = g) : c(g, i, d), d.deps = 0, d.effects.length = 0, d.hiddenContainer = u("div"), m ? (a(null, p, d.hiddenContainer, null, i, d, l, s, o), d.deps <= 0 ? d.resolve() : d.isFallbackMountPending || (a(f, h, n, r, i, null, l, s, o), $6f131a8b96a87ba3$var$i4(d, h))) : f && $6f131a8b96a87ba3$var$lu(f, p) ? (a(f, p, n, r, i, d, l, s, o), d.resolve(!0)) : (a(null, p, d.hiddenContainer, null, i, d, l, s, o), d.deps <= 0 && d.resolve()));
                else if (f && $6f131a8b96a87ba3$var$lu(f, p)) a(f, p, n, r, i, d, l, s, o), $6f131a8b96a87ba3$var$i4(d, p);
                else if ($6f131a8b96a87ba3$var$i1(t, "onPending"), d.pendingBranch = p, 512 & p.shapeFlag ? d.pendingId = p.component.suspenseId : d.pendingId = $6f131a8b96a87ba3$var$iY++, a(null, p, d.hiddenContainer, null, i, d, l, s, o), d.deps <= 0) d.resolve();
                else {
                    let { timeout: e1, pendingId: t } = d;
                    e1 > 0 ? setTimeout(()=>{
                        d.pendingId === t && d.fallback(h);
                    }, e1) : 0 === e1 && d.fallback(h);
                }
            }(e1, t, n, r, i, s, o, a, c);
        }
    },
    hydrate: function(e1, t, n, r, i, l, s, o, a) {
        let c = t.suspense = $6f131a8b96a87ba3$var$i2(t, r, n, e1.parentNode, document.createElement("div"), null, i, l, s, o, !0), u = a(e1, c.pendingBranch = t.ssContent, n, c, l, s);
        return 0 === c.deps && c.resolve(!1, !0), u;
    },
    normalize: function(e1) {
        let { shapeFlag: t, children: n } = e1, r = 32 & t;
        e1.ssContent = $6f131a8b96a87ba3$var$i3(r ? n.default : n), e1.ssFallback = r ? $6f131a8b96a87ba3$var$i3(n.fallback) : $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$4d299b491347818a);
    }
};
function $6f131a8b96a87ba3$var$i1(e1, t) {
    let n = e1.props && e1.props[t];
    $6f131a8b96a87ba3$var$T(n) && n();
}
function $6f131a8b96a87ba3$var$i2(e1, t, n, r, i, l, s, o, a, c, u = !1) {
    var d;
    let p, h, { p: f, m: g, um: m, n: y, o: { parentNode: v, remove: b } } = c, _ = null != (p = (d = e1).props && d.props.suspensible) && !1 !== p;
    _ && t && t.pendingBranch && (h = t.pendingId, t.deps++);
    let S = e1.props ? $6f131a8b96a87ba3$var$W(e1.props.timeout) : void 0, x = l, C = {
        vnode: e1,
        parent: t,
        parentComponent: n,
        namespace: s,
        container: r,
        hiddenContainer: i,
        deps: 0,
        pendingId: $6f131a8b96a87ba3$var$iY++,
        timeout: "number" == typeof S ? S : -1,
        activeBranch: null,
        isFallbackMountPending: !1,
        pendingBranch: null,
        isInFallback: !u,
        isHydrating: u,
        isUnmounted: !1,
        effects: [],
        resolve (e1 = !1, n = !1) {
            let { vnode: r, activeBranch: i, pendingBranch: s, pendingId: o, effects: a, parentComponent: c, container: u, isInFallback: d } = C, p = !1;
            if (C.isHydrating) C.isHydrating = !1;
            else if (!e1) {
                p = i && s.transition && "out-in" === s.transition.mode;
                let e1 = !1;
                p && (i.transition.afterLeave = ()=>{
                    o === C.pendingId && (g(s, u, l !== x || e1 ? l : y(i), 0), $6f131a8b96a87ba3$export$59536a0199721cab(a), d && r.ssFallback && (r.ssFallback.el = null));
                }), i && !C.isFallbackMountPending && (v(i.el) === u && (l = y(i), e1 = !0), m(i, c, C, !0), !p && d && r.ssFallback && $6f131a8b96a87ba3$var$iU(()=>r.ssFallback.el = null, C)), p || g(s, u, l, 0);
            }
            C.isFallbackMountPending = !1, $6f131a8b96a87ba3$var$i4(C, s), C.pendingBranch = null, C.isInFallback = !1;
            let f = C.parent, b = !1;
            for(; f;){
                if (f.pendingBranch) {
                    for(let e1 = 0; e1 < a.length; e1++)f.effects.push(a[e1]);
                    b = !0;
                    break;
                }
                f = f.parent;
            }
            b || p || $6f131a8b96a87ba3$export$59536a0199721cab(a), C.effects = [], _ && t && t.pendingBranch && h === t.pendingId && (h = void 0, t.deps--, 0 !== t.deps || n || t.resolve()), $6f131a8b96a87ba3$var$i1(r, "onResolve");
        },
        fallback (e1) {
            if (!C.pendingBranch) return;
            let { vnode: t, activeBranch: n, parentComponent: r, container: i, namespace: l } = C;
            $6f131a8b96a87ba3$var$i1(t, "onFallback");
            let s = y(n), c = ()=>{
                if (C.isFallbackMountPending = !1, !C.isInFallback) return;
                let e1 = C.vnode.ssFallback;
                f(null, e1, i, s, r, null, l, o, a), $6f131a8b96a87ba3$var$i4(C, e1);
            }, u = e1.transition && "out-in" === e1.transition.mode;
            u && (C.isFallbackMountPending = !0, n.transition.afterLeave = c), C.isInFallback = !0, m(n, r, null, !0), u || c();
        },
        move (e1, t, n) {
            C.activeBranch && g(C.activeBranch, e1, t, n), C.container = e1;
        },
        next: ()=>C.activeBranch && y(C.activeBranch),
        registerDep (e1, t, n, r) {
            let i = !!C.pendingBranch;
            i && C.deps++;
            let l = e1.vnode.el;
            e1.asyncDep.catch((t)=>{
                $6f131a8b96a87ba3$export$d3da1ecaf1206c58(t, e1, 0);
            }).then((s)=>{
                if (e1.isUnmounted || C.isUnmounted || C.pendingId !== e1.suspenseId) return;
                if ($6f131a8b96a87ba3$var$lO(), !e1.scope.active) {
                    i && 0 == --C.deps && C.resolve();
                    return;
                }
                e1.asyncResolved = !0;
                let { vnode: o } = e1;
                $6f131a8b96a87ba3$var$lD(e1, s, !1), l && (o.el = l);
                let a = !l && e1.subTree.el;
                t(e1, o, v(l || e1.subTree.el), l ? null : y(e1.subTree), C, r, n), a && (o.placeholder = null, b(a)), $6f131a8b96a87ba3$var$iE(e1, o.el), i && 0 == --C.deps && C.resolve();
            });
        },
        unmount (e1, t) {
            C.isUnmounted = !0, C.activeBranch && m(C.activeBranch, n, e1, t), C.pendingBranch && m(C.pendingBranch, n, e1, t);
        }
    };
    return C;
}
function $6f131a8b96a87ba3$var$i3(e1) {
    let t;
    if ($6f131a8b96a87ba3$var$T(e1)) {
        let n = $6f131a8b96a87ba3$var$li && e1._c;
        n && (e1._d = !1, $6f131a8b96a87ba3$export$e7eaa45e502fe5cc()), e1 = e1(), n && (e1._d = !0, t = $6f131a8b96a87ba3$var$lt, $6f131a8b96a87ba3$var$lr());
    }
    return $6f131a8b96a87ba3$var$k(e1) && (e1 = $6f131a8b96a87ba3$var$ik(e1)), e1 = $6f131a8b96a87ba3$var$lS(e1), t && !e1.dynamicChildren && (e1.dynamicChildren = t.filter((t)=>t !== e1)), e1;
}
function $6f131a8b96a87ba3$var$i6(e1, t) {
    t && t.pendingBranch ? $6f131a8b96a87ba3$var$k(e1) ? t.effects.push(...e1) : t.effects.push(e1) : $6f131a8b96a87ba3$export$59536a0199721cab(e1);
}
function $6f131a8b96a87ba3$var$i4(e1, t) {
    e1.activeBranch = t;
    let { vnode: n, parentComponent: r } = e1, i = t.el;
    for(; !i && t.component;)i = (t = t.component.subTree).el;
    n.el = i, r && r.subTree === n && (r.vnode.el = i, $6f131a8b96a87ba3$var$iE(r, i));
}
let $6f131a8b96a87ba3$export$ffb0004e005737fa = Symbol.for("v-fgt"), $6f131a8b96a87ba3$export$5f1af8db9871e1d6 = Symbol.for("v-txt"), $6f131a8b96a87ba3$export$4d299b491347818a = Symbol.for("v-cmt"), $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc"), $6f131a8b96a87ba3$var$le = [], $6f131a8b96a87ba3$var$lt = null;
function $6f131a8b96a87ba3$export$e7eaa45e502fe5cc(e1 = !1) {
    $6f131a8b96a87ba3$var$le.push($6f131a8b96a87ba3$var$lt = e1 ? null : []);
}
function $6f131a8b96a87ba3$var$lr() {
    $6f131a8b96a87ba3$var$le.pop(), $6f131a8b96a87ba3$var$lt = $6f131a8b96a87ba3$var$le[$6f131a8b96a87ba3$var$le.length - 1] || null;
}
let $6f131a8b96a87ba3$var$li = 1;
function $6f131a8b96a87ba3$export$c20bee82f26f1e27(e1, t = !1) {
    $6f131a8b96a87ba3$var$li += e1, e1 < 0 && $6f131a8b96a87ba3$var$lt && t && ($6f131a8b96a87ba3$var$lt.hasOnce = !0);
}
function $6f131a8b96a87ba3$var$ls(e1) {
    return e1.dynamicChildren = $6f131a8b96a87ba3$var$li > 0 ? $6f131a8b96a87ba3$var$lt || $6f131a8b96a87ba3$var$g : null, $6f131a8b96a87ba3$var$lr(), $6f131a8b96a87ba3$var$li > 0 && $6f131a8b96a87ba3$var$lt && $6f131a8b96a87ba3$var$lt.push(e1), e1;
}
function $6f131a8b96a87ba3$export$167055419fc69ec1(e1, t, n, r, i, l) {
    return $6f131a8b96a87ba3$var$ls($6f131a8b96a87ba3$export$42098e0eaa15c48e(e1, t, n, r, i, l, !0));
}
function $6f131a8b96a87ba3$export$9f2dfe8048dfb22b(e1, t, n, r, i) {
    return $6f131a8b96a87ba3$var$ls($6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, t, n, r, i, !0));
}
function $6f131a8b96a87ba3$export$3868d13f8734ae81(e1) {
    return !!e1 && !0 === e1.__v_isVNode;
}
function $6f131a8b96a87ba3$var$lu(e1, t) {
    return e1.type === t.type && e1.key === t.key;
}
function $6f131a8b96a87ba3$export$83beccd3afeeb809(e1) {}
let $6f131a8b96a87ba3$var$lp = ({ key: e1 })=>null != e1 ? e1 : null, $6f131a8b96a87ba3$var$lh = ({ ref: e1, ref_key: t, ref_for: n })=>("number" == typeof e1 && (e1 = "" + e1), null != e1 ? $6f131a8b96a87ba3$var$w(e1) || $6f131a8b96a87ba3$export$4f9f5282de18fc69(e1) || $6f131a8b96a87ba3$var$T(e1) ? {
        i: $6f131a8b96a87ba3$var$no,
        r: e1,
        k: t,
        f: !!n
    } : e1 : null);
function $6f131a8b96a87ba3$export$42098e0eaa15c48e(e1, t = null, n = null, r = 0, i = null, l = +(e1 !== $6f131a8b96a87ba3$export$ffb0004e005737fa), s = !1, o = !1) {
    let a = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e1,
        props: t,
        key: t && $6f131a8b96a87ba3$var$lp(t),
        ref: t && $6f131a8b96a87ba3$var$lh(t),
        scopeId: $6f131a8b96a87ba3$var$na,
        slotScopeIds: null,
        children: n,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: l,
        patchFlag: r,
        dynamicProps: i,
        dynamicChildren: null,
        appContext: null,
        ctx: $6f131a8b96a87ba3$var$no
    };
    return o ? ($6f131a8b96a87ba3$var$lC(a, n), 128 & l && e1.normalize(a)) : n && (a.shapeFlag |= $6f131a8b96a87ba3$var$w(n) ? 8 : 16), $6f131a8b96a87ba3$var$li > 0 && !s && $6f131a8b96a87ba3$var$lt && (a.patchFlag > 0 || 6 & l) && 32 !== a.patchFlag && $6f131a8b96a87ba3$var$lt.push(a), a;
}
let $6f131a8b96a87ba3$export$bf5c4cf060303d58 = function(e1, t = null, n = null, r = 0, i = null, l = !1) {
    var s;
    if (e1 && e1 !== $6f131a8b96a87ba3$var$rL || (e1 = $6f131a8b96a87ba3$export$4d299b491347818a), $6f131a8b96a87ba3$export$3868d13f8734ae81(e1)) {
        let r = $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1, t, !0);
        return n && $6f131a8b96a87ba3$var$lC(r, n), $6f131a8b96a87ba3$var$li > 0 && !l && $6f131a8b96a87ba3$var$lt && (6 & r.shapeFlag ? $6f131a8b96a87ba3$var$lt[$6f131a8b96a87ba3$var$lt.indexOf(e1)] = r : $6f131a8b96a87ba3$var$lt.push(r)), r.patchFlag = -2, r;
    }
    if ($6f131a8b96a87ba3$var$T(s = e1) && "__vccOpts" in s && (e1 = e1.__vccOpts), t) {
        let { class: e1, style: n } = t = $6f131a8b96a87ba3$export$1f1be0e0e384d7d2(t);
        e1 && !$6f131a8b96a87ba3$var$w(e1) && (t.class = $6f131a8b96a87ba3$export$4f7022d2d68e2c5a(e1)), $6f131a8b96a87ba3$var$A(n) && ($6f131a8b96a87ba3$export$5f3ca29d057519b3(n) && !$6f131a8b96a87ba3$var$k(n) && (n = $6f131a8b96a87ba3$var$_({}, n)), t.style = $6f131a8b96a87ba3$export$8756898546458274(n));
    }
    let o = $6f131a8b96a87ba3$var$w(e1) ? 1 : $6f131a8b96a87ba3$var$iZ(e1) ? 128 : e1.__isTeleport ? 64 : $6f131a8b96a87ba3$var$A(e1) ? 4 : 2 * !!$6f131a8b96a87ba3$var$T(e1);
    return $6f131a8b96a87ba3$export$42098e0eaa15c48e(e1, t, n, r, i, o, l, !0);
};
function $6f131a8b96a87ba3$export$1f1be0e0e384d7d2(e1) {
    return e1 ? $6f131a8b96a87ba3$export$5f3ca29d057519b3(e1) || $6f131a8b96a87ba3$var$iI(e1) ? $6f131a8b96a87ba3$var$_({}, e1) : e1 : null;
}
function $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1, t, n = !1, r = !1) {
    let { props: i, ref: l, patchFlag: s, children: o, transition: a } = e1, c = t ? $6f131a8b96a87ba3$export$9d1611c77c2fe928(i || {}, t) : i, u = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e1.type,
        props: c,
        key: c && $6f131a8b96a87ba3$var$lp(c),
        ref: t && t.ref ? n && l ? $6f131a8b96a87ba3$var$k(l) ? l.concat($6f131a8b96a87ba3$var$lh(t)) : [
            l,
            $6f131a8b96a87ba3$var$lh(t)
        ] : $6f131a8b96a87ba3$var$lh(t) : l,
        scopeId: e1.scopeId,
        slotScopeIds: e1.slotScopeIds,
        children: o,
        target: e1.target,
        targetStart: e1.targetStart,
        targetAnchor: e1.targetAnchor,
        staticCount: e1.staticCount,
        shapeFlag: e1.shapeFlag,
        patchFlag: t && e1.type !== $6f131a8b96a87ba3$export$ffb0004e005737fa ? -1 === s ? 16 : 16 | s : s,
        dynamicProps: e1.dynamicProps,
        dynamicChildren: e1.dynamicChildren,
        appContext: e1.appContext,
        dirs: e1.dirs,
        transition: a,
        component: e1.component,
        suspense: e1.suspense,
        ssContent: e1.ssContent && $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1.ssContent),
        ssFallback: e1.ssFallback && $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1.ssFallback),
        placeholder: e1.placeholder,
        el: e1.el,
        anchor: e1.anchor,
        ctx: e1.ctx,
        ce: e1.ce,
        cacheIndex: e1.cacheIndex
    };
    return a && r && $6f131a8b96a87ba3$export$7770a22486565649(u, a.clone(u)), u;
}
function $6f131a8b96a87ba3$export$22f9b5ffd89dac9(e1 = " ", t = 0) {
    return $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$5f1af8db9871e1d6, null, e1, t);
}
function $6f131a8b96a87ba3$export$33a9f6dd2840e6bb(e1, t) {
    let n = $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$c1b9a1d3af45b7b6, null, e1);
    return n.staticCount = t, n;
}
function $6f131a8b96a87ba3$export$49553837c7236d3c(e1 = "", t = !1) {
    return t ? ($6f131a8b96a87ba3$export$e7eaa45e502fe5cc(), $6f131a8b96a87ba3$export$9f2dfe8048dfb22b($6f131a8b96a87ba3$export$4d299b491347818a, null, e1)) : $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$4d299b491347818a, null, e1);
}
function $6f131a8b96a87ba3$var$lS(e1) {
    return null == e1 || "boolean" == typeof e1 ? $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$4d299b491347818a) : $6f131a8b96a87ba3$var$k(e1) ? $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$ffb0004e005737fa, null, e1.slice()) : $6f131a8b96a87ba3$export$3868d13f8734ae81(e1) ? $6f131a8b96a87ba3$var$lx(e1) : $6f131a8b96a87ba3$export$bf5c4cf060303d58($6f131a8b96a87ba3$export$5f1af8db9871e1d6, null, String(e1));
}
function $6f131a8b96a87ba3$var$lx(e1) {
    return null === e1.el && -1 !== e1.patchFlag || e1.memo ? e1 : $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a(e1);
}
function $6f131a8b96a87ba3$var$lC(e1, t) {
    let n = 0, { shapeFlag: r } = e1;
    if (null == t) t = null;
    else if ($6f131a8b96a87ba3$var$k(t)) n = 16;
    else if ("object" == typeof t) {
        if (65 & r) {
            let n = t.default;
            n && (n._c && (n._d = !1), $6f131a8b96a87ba3$var$lC(e1, n()), n._c && (n._d = !0));
            return;
        } else {
            n = 32;
            let r = t._;
            r || $6f131a8b96a87ba3$var$iI(t) ? 3 === r && $6f131a8b96a87ba3$var$no && (1 === $6f131a8b96a87ba3$var$no.slots._ ? t._ = 1 : (t._ = 2, e1.patchFlag |= 1024)) : t._ctx = $6f131a8b96a87ba3$var$no;
        }
    } else if ($6f131a8b96a87ba3$var$T(t)) {
        if (65 & r) return void $6f131a8b96a87ba3$var$lC(e1, {
            default: t
        });
        t = {
            default: t,
            _ctx: $6f131a8b96a87ba3$var$no
        }, n = 32;
    } else t = String(t), 64 & r ? (n = 16, t = [
        $6f131a8b96a87ba3$export$22f9b5ffd89dac9(t)
    ]) : n = 8;
    e1.children = t, e1.shapeFlag |= n;
}
function $6f131a8b96a87ba3$export$9d1611c77c2fe928(...e1) {
    let t = {};
    for(let n = 0; n < e1.length; n++){
        let r = e1[n];
        for(let e1 in r)if ("class" === e1) t.class !== r.class && (t.class = $6f131a8b96a87ba3$export$4f7022d2d68e2c5a([
            t.class,
            r.class
        ]));
        else if ("style" === e1) t.style = $6f131a8b96a87ba3$export$8756898546458274([
            t.style,
            r.style
        ]);
        else if ($6f131a8b96a87ba3$var$v(e1)) {
            let n = t[e1], i = r[e1];
            i && n !== i && !($6f131a8b96a87ba3$var$k(n) && n.includes(i)) ? t[e1] = n ? [].concat(n, i) : i : null != i || null != n || $6f131a8b96a87ba3$var$b(e1) || (t[e1] = i);
        } else "" !== e1 && (t[e1] = r[e1]);
    }
    return t;
}
function $6f131a8b96a87ba3$var$lT(e1, t, n, r = null) {
    $6f131a8b96a87ba3$export$dae85862a8d94378(e1, t, 7, [
        n,
        r
    ]);
}
let $6f131a8b96a87ba3$var$lw = $6f131a8b96a87ba3$var$ig(), $6f131a8b96a87ba3$var$lN = 0;
function $6f131a8b96a87ba3$var$lA(e1, t, n) {
    let r = e1.type, i = (t ? t.appContext : e1.appContext) || $6f131a8b96a87ba3$var$lw, l = {
        uid: $6f131a8b96a87ba3$var$lN++,
        vnode: e1,
        type: r,
        parent: t,
        appContext: i,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new $6f131a8b96a87ba3$export$1168ed9dbc71ddbd(!0),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: t ? t.provides : Object.create(i.provides),
        ids: t ? t.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: function e1(t, n, r = !1) {
            let i = r ? $6f131a8b96a87ba3$var$iP : n.propsCache, l = i.get(t);
            if (l) return l;
            let s = t.props, o = {}, a = [], c = !1;
            if (!$6f131a8b96a87ba3$var$T(t)) {
                let i = (t)=>{
                    c = !0;
                    let [r, i] = e1(t, n, !0);
                    $6f131a8b96a87ba3$var$_(o, r), i && a.push(...i);
                };
                !r && n.mixins.length && n.mixins.forEach(i), t.extends && i(t.extends), t.mixins && t.mixins.forEach(i);
            }
            if (!s && !c) return $6f131a8b96a87ba3$var$A(t) && i.set(t, $6f131a8b96a87ba3$var$g), $6f131a8b96a87ba3$var$g;
            if ($6f131a8b96a87ba3$var$k(s)) for(let e1 = 0; e1 < s.length; e1++){
                let t = $6f131a8b96a87ba3$export$161d051f5dd25de7(s[e1]);
                $6f131a8b96a87ba3$var$iF(t) && (o[t] = $6f131a8b96a87ba3$var$f);
            }
            else if (s) for(let e1 in s){
                let t = $6f131a8b96a87ba3$export$161d051f5dd25de7(e1);
                if ($6f131a8b96a87ba3$var$iF(t)) {
                    let n = s[e1], r = o[t] = $6f131a8b96a87ba3$var$k(n) || $6f131a8b96a87ba3$var$T(n) ? {
                        type: n
                    } : $6f131a8b96a87ba3$var$_({}, n), i = r.type, l = !1, c = !0;
                    if ($6f131a8b96a87ba3$var$k(i)) for(let e1 = 0; e1 < i.length; ++e1){
                        let t = i[e1], n = $6f131a8b96a87ba3$var$T(t) && t.name;
                        if ("Boolean" === n) {
                            l = !0;
                            break;
                        }
                        "String" === n && (c = !1);
                    }
                    else l = $6f131a8b96a87ba3$var$T(i) && "Boolean" === i.name;
                    r[0] = l, r[1] = c, (l || $6f131a8b96a87ba3$var$C(r, "default")) && a.push(t);
                }
            }
            let u = [
                o,
                a
            ];
            return $6f131a8b96a87ba3$var$A(t) && i.set(t, u), u;
        }(r, i),
        emitsOptions: function e1(t, n, r = !1) {
            let i = r ? $6f131a8b96a87ba3$var$iS : n.emitsCache, l = i.get(t);
            if (void 0 !== l) return l;
            let s = t.emits, o = {}, a = !1;
            if (!$6f131a8b96a87ba3$var$T(t)) {
                let i = (t)=>{
                    let r = e1(t, n, !0);
                    r && (a = !0, $6f131a8b96a87ba3$var$_(o, r));
                };
                !r && n.mixins.length && n.mixins.forEach(i), t.extends && i(t.extends), t.mixins && t.mixins.forEach(i);
            }
            return s || a ? ($6f131a8b96a87ba3$var$k(s) ? s.forEach((e1)=>o[e1] = null) : $6f131a8b96a87ba3$var$_(o, s), $6f131a8b96a87ba3$var$A(t) && i.set(t, o), o) : ($6f131a8b96a87ba3$var$A(t) && i.set(t, null), null);
        }(r, i),
        emit: null,
        emitted: null,
        propsDefaults: $6f131a8b96a87ba3$var$f,
        inheritAttrs: r.inheritAttrs,
        ctx: $6f131a8b96a87ba3$var$f,
        data: $6f131a8b96a87ba3$var$f,
        props: $6f131a8b96a87ba3$var$f,
        attrs: $6f131a8b96a87ba3$var$f,
        slots: $6f131a8b96a87ba3$var$f,
        refs: $6f131a8b96a87ba3$var$f,
        setupState: $6f131a8b96a87ba3$var$f,
        setupContext: null,
        suspense: n,
        suspenseId: n ? n.pendingId : 0,
        asyncDep: null,
        asyncResolved: !1,
        isMounted: !1,
        isUnmounted: !1,
        isDeactivated: !1,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    return l.ctx = {
        _: l
    }, l.root = t ? t.root : l, l.emit = $6f131a8b96a87ba3$var$i_.bind(null, l), e1.ce && e1.ce(l), l;
}
let $6f131a8b96a87ba3$var$lE = null, $6f131a8b96a87ba3$export$f13e630aa3915748 = ()=>$6f131a8b96a87ba3$var$lE || $6f131a8b96a87ba3$var$no;
{
    let e1 = $6f131a8b96a87ba3$var$K(), t = (t, n)=>{
        let r;
        return (r = e1[t]) || (r = e1[t] = []), r.push(n), (e1)=>{
            r.length > 1 ? r.forEach((t)=>t(e1)) : r[0](e1);
        };
    };
    $6f131a8b96a87ba3$var$l = t("__VUE_INSTANCE_SETTERS__", (e1)=>$6f131a8b96a87ba3$var$lE = e1), $6f131a8b96a87ba3$var$s = t("__VUE_SSR_SETTERS__", (e1)=>$6f131a8b96a87ba3$var$lP = e1);
}let $6f131a8b96a87ba3$var$lI = (e1)=>{
    let t = $6f131a8b96a87ba3$var$lE;
    return $6f131a8b96a87ba3$var$l(e1), e1.scope.on(), ()=>{
        e1.scope.off(), $6f131a8b96a87ba3$var$l(t);
    };
}, $6f131a8b96a87ba3$var$lO = ()=>{
    $6f131a8b96a87ba3$var$lE && $6f131a8b96a87ba3$var$lE.scope.off(), $6f131a8b96a87ba3$var$l(null);
};
function $6f131a8b96a87ba3$var$lM(e1) {
    return 4 & e1.vnode.shapeFlag;
}
let $6f131a8b96a87ba3$var$lP = !1;
function $6f131a8b96a87ba3$var$lF(e1, t = !1, n = !1) {
    t && $6f131a8b96a87ba3$var$s(t);
    let { props: r, children: i } = e1.vnode, l = $6f131a8b96a87ba3$var$lM(e1);
    !function(e1, t, n, r = !1) {
        let i = {}, l = Object.create($6f131a8b96a87ba3$var$iR);
        for(let n in e1.propsDefaults = Object.create(null), $6f131a8b96a87ba3$var$iO(e1, t, i, l), e1.propsOptions[0])n in i || (i[n] = void 0);
        n ? e1.props = r ? i : $6f131a8b96a87ba3$export$8d81cefd22d22260(i) : e1.type.props ? e1.props = i : e1.props = l, e1.attrs = l;
    }(e1, r, l, t);
    var o = n || t;
    let a = e1.slots = Object.create($6f131a8b96a87ba3$var$iR);
    if (32 & e1.vnode.shapeFlag) {
        let e1 = i._;
        e1 ? ($6f131a8b96a87ba3$var$ij(a, i, o), o && $6f131a8b96a87ba3$var$H(a, "_", e1, !0)) : $6f131a8b96a87ba3$var$i$(i, a);
    } else i && $6f131a8b96a87ba3$var$iB(e1, i);
    let c = l ? function(e1, t) {
        let n = e1.type;
        e1.accessCache = Object.create(null), e1.proxy = new Proxy(e1.ctx, $6f131a8b96a87ba3$var$rX);
        let { setup: r } = n;
        if (r) {
            $6f131a8b96a87ba3$var$eP();
            let n = e1.setupContext = r.length > 1 ? $6f131a8b96a87ba3$var$lj(e1) : null, i = $6f131a8b96a87ba3$var$lI(e1), l = $6f131a8b96a87ba3$export$b22fcaf88446e9bf(r, e1, 0, [
                e1.props,
                n
            ]), o = $6f131a8b96a87ba3$var$E(l);
            if ($6f131a8b96a87ba3$var$eF(), i(), (o || e1.sp) && !$6f131a8b96a87ba3$var$rp(e1) && $6f131a8b96a87ba3$var$n0(e1), o) {
                if (l.then($6f131a8b96a87ba3$var$lO, $6f131a8b96a87ba3$var$lO), t) return l.then((n)=>{
                    $6f131a8b96a87ba3$var$s(!0);
                    try {
                        $6f131a8b96a87ba3$var$lD(e1, n, t);
                    } finally{
                        $6f131a8b96a87ba3$var$s(!1);
                    }
                }).catch((t)=>{
                    $6f131a8b96a87ba3$export$d3da1ecaf1206c58(t, e1, 0);
                });
                e1.asyncDep = l;
            } else $6f131a8b96a87ba3$var$lD(e1, l, t);
        } else $6f131a8b96a87ba3$var$l$(e1, t);
    }(e1, t) : void 0;
    return t && $6f131a8b96a87ba3$var$s(!1), c;
}
function $6f131a8b96a87ba3$var$lD(e1, t, n) {
    $6f131a8b96a87ba3$var$T(t) ? e1.type.__ssrInlineRender ? e1.ssrRender = t : e1.render = t : $6f131a8b96a87ba3$var$A(t) && (e1.setupState = $6f131a8b96a87ba3$export$f353fd1b97db3fa0(t)), $6f131a8b96a87ba3$var$l$(e1, n);
}
function $6f131a8b96a87ba3$export$667bb5a67822b941(e1) {
    $6f131a8b96a87ba3$var$o = e1, $6f131a8b96a87ba3$var$a = (e1)=>{
        e1.render._rc && (e1.withProxy = new Proxy(e1.ctx, $6f131a8b96a87ba3$var$rQ));
    };
}
let $6f131a8b96a87ba3$export$c93a9c496c5211fa = ()=>!$6f131a8b96a87ba3$var$o;
function $6f131a8b96a87ba3$var$l$(e1, t, n) {
    let r = e1.type;
    if (!e1.render) {
        if (!t && $6f131a8b96a87ba3$var$o && !r.render) {
            let t = r.template || $6f131a8b96a87ba3$var$is(e1).template;
            if (t) {
                let { isCustomElement: n, compilerOptions: i } = e1.appContext.config, { delimiters: l, compilerOptions: s } = r, a = $6f131a8b96a87ba3$var$_($6f131a8b96a87ba3$var$_({
                    isCustomElement: n,
                    delimiters: l
                }, i), s);
                r.render = $6f131a8b96a87ba3$var$o(t, a);
            }
        }
        e1.render = r.render || $6f131a8b96a87ba3$var$m, $6f131a8b96a87ba3$var$a && $6f131a8b96a87ba3$var$a(e1);
    }
    {
        let t = $6f131a8b96a87ba3$var$lI(e1);
        $6f131a8b96a87ba3$var$eP();
        try {
            !function(e1) {
                let t = $6f131a8b96a87ba3$var$is(e1), n = e1.proxy, r = e1.ctx;
                $6f131a8b96a87ba3$var$ii = !1, t.beforeCreate && $6f131a8b96a87ba3$var$il(t.beforeCreate, e1, "bc");
                let { data: i, computed: l, methods: s, watch: o, provide: a, inject: c, created: u, beforeMount: d, mounted: p, beforeUpdate: h, updated: f, activated: g, deactivated: y, beforeUnmount: v, unmounted: b, render: _, renderTracked: S, renderTriggered: x, errorCaptured: C, serverPrefetch: N, expose: E, inheritAttrs: R, components: I, directives: O } = t;
                if (c && function(e1, t) {
                    for(let n in $6f131a8b96a87ba3$var$k(e1) && (e1 = $6f131a8b96a87ba3$var$iu(e1)), e1){
                        let r, i = e1[n];
                        $6f131a8b96a87ba3$export$4f9f5282de18fc69(r = $6f131a8b96a87ba3$var$A(i) ? "default" in i ? $6f131a8b96a87ba3$export$a976684a0efeb93f(i.from || n, i.default, !0) : $6f131a8b96a87ba3$export$a976684a0efeb93f(i.from || n) : $6f131a8b96a87ba3$export$a976684a0efeb93f(i)) ? Object.defineProperty(t, n, {
                            enumerable: !0,
                            configurable: !0,
                            get: ()=>r.value,
                            set: (e1)=>r.value = e1
                        }) : t[n] = r;
                    }
                }(c, r), s) for(let e1 in s){
                    let t = s[e1];
                    $6f131a8b96a87ba3$var$T(t) && (r[e1] = t.bind(n));
                }
                if (i) {
                    let t = i.call(n, n);
                    $6f131a8b96a87ba3$var$A(t) && (e1.data = $6f131a8b96a87ba3$export$90a44edba14e47be(t));
                }
                if ($6f131a8b96a87ba3$var$ii = !0, l) for(let e1 in l){
                    let t = l[e1], i = $6f131a8b96a87ba3$var$T(t) ? t.bind(n, n) : $6f131a8b96a87ba3$var$T(t.get) ? t.get.bind(n, n) : $6f131a8b96a87ba3$var$m, s = $6f131a8b96a87ba3$export$2983e091f1a1e8e2({
                        get: i,
                        set: !$6f131a8b96a87ba3$var$T(t) && $6f131a8b96a87ba3$var$T(t.set) ? t.set.bind(n) : $6f131a8b96a87ba3$var$m
                    });
                    Object.defineProperty(r, e1, {
                        enumerable: !0,
                        configurable: !0,
                        get: ()=>s.value,
                        set: (e1)=>s.value = e1
                    });
                }
                if (o) for(let e1 in o)!function e1(t, n, r, i) {
                    let l = i.includes(".") ? $6f131a8b96a87ba3$var$nN(r, i) : ()=>r[i];
                    if ($6f131a8b96a87ba3$var$w(t)) {
                        let e1 = n[t];
                        $6f131a8b96a87ba3$var$T(e1) && $6f131a8b96a87ba3$export$3db5d71bdb2d5499(l, e1);
                    } else if ($6f131a8b96a87ba3$var$T(t)) $6f131a8b96a87ba3$export$3db5d71bdb2d5499(l, t.bind(r));
                    else if ($6f131a8b96a87ba3$var$A(t)) {
                        if ($6f131a8b96a87ba3$var$k(t)) t.forEach((t)=>e1(t, n, r, i));
                        else {
                            let e1 = $6f131a8b96a87ba3$var$T(t.handler) ? t.handler.bind(r) : n[t.handler];
                            $6f131a8b96a87ba3$var$T(e1) && $6f131a8b96a87ba3$export$3db5d71bdb2d5499(l, e1, t);
                        }
                    }
                }(o[e1], r, n, e1);
                if (a) {
                    let e1 = $6f131a8b96a87ba3$var$T(a) ? a.call(n) : a;
                    Reflect.ownKeys(e1).forEach((t)=>{
                        $6f131a8b96a87ba3$export$abe1e183e22e10ad(t, e1[t]);
                    });
                }
                function M(e1, t) {
                    $6f131a8b96a87ba3$var$k(t) ? t.forEach((t)=>e1(t.bind(n))) : t && e1(t.bind(n));
                }
                if (u && $6f131a8b96a87ba3$var$il(u, e1, "c"), M($6f131a8b96a87ba3$export$23b7aeb0d671f804, d), M($6f131a8b96a87ba3$export$6d1641039221b5cb, p), M($6f131a8b96a87ba3$export$ab91988a13872e4c, h), M($6f131a8b96a87ba3$export$5876c47052fb88b1, f), M($6f131a8b96a87ba3$export$ba52d824b95a2154, g), M($6f131a8b96a87ba3$export$bf1440eeaf5fa709, y), M($6f131a8b96a87ba3$export$6a3a15856e50ad19, C), M($6f131a8b96a87ba3$export$2b41f4235363e921, S), M($6f131a8b96a87ba3$export$898295a813d662eb, x), M($6f131a8b96a87ba3$export$40c420df62d2614, v), M($6f131a8b96a87ba3$export$13348a43ccacfe58, b), M($6f131a8b96a87ba3$export$ebf0c601f267bceb, N), $6f131a8b96a87ba3$var$k(E)) {
                    if (E.length) {
                        let t = e1.exposed || (e1.exposed = {});
                        E.forEach((e1)=>{
                            Object.defineProperty(t, e1, {
                                get: ()=>n[e1],
                                set: (t)=>n[e1] = t,
                                enumerable: !0
                            });
                        });
                    } else e1.exposed || (e1.exposed = {});
                }
                _ && e1.render === $6f131a8b96a87ba3$var$m && (e1.render = _), null != R && (e1.inheritAttrs = R), I && (e1.components = I), O && (e1.directives = O), N && $6f131a8b96a87ba3$var$n0(e1);
            }(e1);
        } finally{
            $6f131a8b96a87ba3$var$eF(), t();
        }
    }
}
let $6f131a8b96a87ba3$var$lB = {
    get: (e1, t)=>($6f131a8b96a87ba3$var$eq(e1, "get", ""), e1[t])
};
function $6f131a8b96a87ba3$var$lj(e1) {
    return {
        attrs: new Proxy(e1.attrs, $6f131a8b96a87ba3$var$lB),
        slots: e1.slots,
        emit: e1.emit,
        expose: (t)=>{
            e1.exposed = t || {};
        }
    };
}
function $6f131a8b96a87ba3$var$lU(e1) {
    return e1.exposed ? e1.exposeProxy || (e1.exposeProxy = new Proxy($6f131a8b96a87ba3$export$f353fd1b97db3fa0($6f131a8b96a87ba3$export$995ab8b13ad7a9d0(e1.exposed)), {
        get: (t, n)=>n in t ? t[n] : n in $6f131a8b96a87ba3$var$rJ ? $6f131a8b96a87ba3$var$rJ[n](e1) : void 0,
        has: (e1, t)=>t in e1 || t in $6f131a8b96a87ba3$var$rJ
    })) : e1.proxy;
}
function $6f131a8b96a87ba3$var$lH(e1, t = !0) {
    return $6f131a8b96a87ba3$var$T(e1) ? e1.displayName || e1.name : e1.name || t && e1.__name;
}
let $6f131a8b96a87ba3$export$2983e091f1a1e8e2 = (e1, t)=>(function(e1, t = !1) {
        let n, r;
        return $6f131a8b96a87ba3$var$T(e1) ? n = e1 : (n = e1.get, r = e1.set), new $6f131a8b96a87ba3$var$tH(n, r, t);
    })(e1, $6f131a8b96a87ba3$var$lP);
function $6f131a8b96a87ba3$export$dda1d9f60106f0e9(e1, t, n) {
    try {
        $6f131a8b96a87ba3$export$c20bee82f26f1e27(-1);
        let r = arguments.length;
        if (2 !== r) return r > 3 ? n = Array.prototype.slice.call(arguments, 2) : 3 === r && $6f131a8b96a87ba3$export$3868d13f8734ae81(n) && (n = [
            n
        ]), $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, t, n);
        if (!$6f131a8b96a87ba3$var$A(t) || $6f131a8b96a87ba3$var$k(t)) return $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, null, t);
        if ($6f131a8b96a87ba3$export$3868d13f8734ae81(t)) return $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, null, [
            t
        ]);
        return $6f131a8b96a87ba3$export$bf5c4cf060303d58(e1, t);
    } finally{
        $6f131a8b96a87ba3$export$c20bee82f26f1e27(1);
    }
}
function $6f131a8b96a87ba3$export$aed4979be6a60047() {}
function $6f131a8b96a87ba3$export$2a6d714a4d738ae(e1, t, n, r) {
    let i = n[r];
    if (i && $6f131a8b96a87ba3$export$bf525184d622787c(i, e1)) return i;
    let l = t();
    return l.memo = e1.slice(), l.cacheIndex = r, n[r] = l;
}
function $6f131a8b96a87ba3$export$bf525184d622787c(e1, t) {
    let n = e1.memo;
    if (n.length != t.length) return !1;
    for(let e1 = 0; e1 < n.length; e1++)if ($6f131a8b96a87ba3$var$j(n[e1], t[e1])) return !1;
    return $6f131a8b96a87ba3$var$li > 0 && $6f131a8b96a87ba3$var$lt && $6f131a8b96a87ba3$var$lt.push(e1), !0;
}
let $6f131a8b96a87ba3$export$83d89fbfd8236492 = "3.5.44", $6f131a8b96a87ba3$export$c106dd0671a0fc2d = $6f131a8b96a87ba3$var$m, $6f131a8b96a87ba3$export$795e0ad4a0e2ed30 = null, $6f131a8b96a87ba3$export$6922d3b3a607469e, $6f131a8b96a87ba3$export$b0c258b32c26c785 = $6f131a8b96a87ba3$var$m, $6f131a8b96a87ba3$export$a9679033567b336d = {
    createComponentInstance: $6f131a8b96a87ba3$var$lA,
    setupComponent: $6f131a8b96a87ba3$var$lF,
    renderComponentRoot: $6f131a8b96a87ba3$var$iC,
    setCurrentRenderingInstance: $6f131a8b96a87ba3$var$nc,
    isVNode: $6f131a8b96a87ba3$export$3868d13f8734ae81,
    normalizeVNode: $6f131a8b96a87ba3$var$lS,
    getComponentPublicInstance: $6f131a8b96a87ba3$var$lU,
    ensureValidVNode: $6f131a8b96a87ba3$var$rW,
    pushWarningContext: function(e1) {},
    popWarningContext: function() {}
}, $6f131a8b96a87ba3$export$83cf26e06ea620e1 = null, $6f131a8b96a87ba3$export$dc678eddf276286e = null, $6f131a8b96a87ba3$export$22072a82865312f6 = null, $6f131a8b96a87ba3$var$l6 = "u" > typeof window && window.trustedTypes;
if ($6f131a8b96a87ba3$var$l6) try {
    $6f131a8b96a87ba3$var$p = $6f131a8b96a87ba3$var$l6.createPolicy("vue", {
        createHTML: (e1)=>e1
    });
} catch (e1) {}
let $6f131a8b96a87ba3$var$l4 = $6f131a8b96a87ba3$var$p ? (e1)=>$6f131a8b96a87ba3$var$p.createHTML(e1) : (e1)=>e1, $6f131a8b96a87ba3$var$l8 = "u" > typeof document ? document : null, $6f131a8b96a87ba3$var$l5 = $6f131a8b96a87ba3$var$l8 && $6f131a8b96a87ba3$var$l8.createElement("template"), $6f131a8b96a87ba3$export$de4fb7f5030605d3 = {
    insert: (e1, t, n)=>{
        t.insertBefore(e1, n || null);
    },
    remove: (e1)=>{
        let t = e1.parentNode;
        t && t.removeChild(e1);
    },
    createElement: (e1, t, n, r)=>{
        let i = "svg" === t ? $6f131a8b96a87ba3$var$l8.createElementNS("http://www.w3.org/2000/svg", e1) : "mathml" === t ? $6f131a8b96a87ba3$var$l8.createElementNS("http://www.w3.org/1998/Math/MathML", e1) : n ? $6f131a8b96a87ba3$var$l8.createElement(e1, {
            is: n
        }) : $6f131a8b96a87ba3$var$l8.createElement(e1);
        return "select" === e1 && r && null != r.multiple && i.setAttribute("multiple", r.multiple), i;
    },
    createText: (e1)=>$6f131a8b96a87ba3$var$l8.createTextNode(e1),
    createComment: (e1)=>$6f131a8b96a87ba3$var$l8.createComment(e1),
    setText: (e1, t)=>{
        e1.nodeValue = t;
    },
    setElementText: (e1, t)=>{
        e1.textContent = t;
    },
    parentNode: (e1)=>e1.parentNode,
    nextSibling: (e1)=>e1.nextSibling,
    querySelector: (e1)=>$6f131a8b96a87ba3$var$l8.querySelector(e1),
    setScopeId (e1, t) {
        e1.setAttribute(t, "");
    },
    insertStaticContent (e1, t, n, r, i, l) {
        let s = n ? n.previousSibling : t.lastChild;
        if (i && (i === l || i.nextSibling)) for(; t.insertBefore(i.cloneNode(!0), n), i !== l && (i = i.nextSibling););
        else {
            $6f131a8b96a87ba3$var$l5.innerHTML = $6f131a8b96a87ba3$var$l4("svg" === r ? `<svg>${e1}</svg>` : "mathml" === r ? `<math>${e1}</math>` : e1);
            let i = $6f131a8b96a87ba3$var$l5.content;
            if ("svg" === r || "mathml" === r) {
                let e1 = i.firstChild;
                for(; e1.firstChild;)i.appendChild(e1.firstChild);
                i.removeChild(e1);
            }
            t.insertBefore(i, n);
        }
        return [
            s ? s.nextSibling : t.firstChild,
            n ? n.previousSibling : t.lastChild
        ];
    }
}, $6f131a8b96a87ba3$var$l7 = "transition", $6f131a8b96a87ba3$var$se = "animation", $6f131a8b96a87ba3$var$st = Symbol("_vtc"), $6f131a8b96a87ba3$var$sn = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: !0
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
}, $6f131a8b96a87ba3$var$sr = $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$export$b876c99684f8cf3b, $6f131a8b96a87ba3$var$sn), $6f131a8b96a87ba3$export$be58926105124dd4 = (($6f131a8b96a87ba3$var$oN = (e1, { slots: t })=>$6f131a8b96a87ba3$export$dda1d9f60106f0e9($6f131a8b96a87ba3$export$abd95b5f5e8a8837, $6f131a8b96a87ba3$var$so(e1), t)).displayName = "Transition", $6f131a8b96a87ba3$var$oN.props = $6f131a8b96a87ba3$var$sr, $6f131a8b96a87ba3$var$oN), $6f131a8b96a87ba3$var$sl = (e1, t = [])=>{
    $6f131a8b96a87ba3$var$k(e1) ? e1.forEach((e1)=>e1(...t)) : e1 && e1(...t);
}, $6f131a8b96a87ba3$var$ss = (e1)=>!!e1 && ($6f131a8b96a87ba3$var$k(e1) ? e1.some((e1)=>e1.length > 1) : e1.length > 1);
function $6f131a8b96a87ba3$var$so(e1) {
    let t = {};
    for(let n in e1)n in $6f131a8b96a87ba3$var$sn || (t[n] = e1[n]);
    if (!1 === e1.css) return t;
    let { name: n = "v", type: r, duration: i, enterFromClass: l = `${n}-enter-from`, enterActiveClass: s = `${n}-enter-active`, enterToClass: o = `${n}-enter-to`, appearFromClass: a = l, appearActiveClass: c = s, appearToClass: u = o, leaveFromClass: d = `${n}-leave-from`, leaveActiveClass: p = `${n}-leave-active`, leaveToClass: h = `${n}-leave-to` } = e1, f = function(e1) {
        if (null == e1) return null;
        {
            if ($6f131a8b96a87ba3$var$A(e1)) return [
                function(e1) {
                    return $6f131a8b96a87ba3$var$W(e1);
                }(e1.enter),
                function(e1) {
                    return $6f131a8b96a87ba3$var$W(e1);
                }(e1.leave)
            ];
            let t = function(e1) {
                return $6f131a8b96a87ba3$var$W(e1);
            }(e1);
            return [
                t,
                t
            ];
        }
    }(i), g = f && f[0], m = f && f[1], { onBeforeEnter: y, onEnter: v, onEnterCancelled: b, onLeave: S, onLeaveCancelled: x, onBeforeAppear: C = y, onAppear: k = v, onAppearCancelled: T = b } = t, w = (e1, t, n, r)=>{
        e1._enterCancelled = r, $6f131a8b96a87ba3$var$sc(e1, t ? u : o), $6f131a8b96a87ba3$var$sc(e1, t ? c : s), n && n();
    }, N = (e1, t)=>{
        e1._isLeaving = !1, $6f131a8b96a87ba3$var$sc(e1, d), $6f131a8b96a87ba3$var$sc(e1, h), $6f131a8b96a87ba3$var$sc(e1, p), t && t();
    }, E = (e1)=>(t, n)=>{
            let i = e1 ? k : v, s = ()=>w(t, e1, n);
            $6f131a8b96a87ba3$var$sl(i, [
                t,
                s
            ]), $6f131a8b96a87ba3$var$su(()=>{
                $6f131a8b96a87ba3$var$sc(t, e1 ? a : l), $6f131a8b96a87ba3$var$sa(t, e1 ? u : o), $6f131a8b96a87ba3$var$ss(i) || $6f131a8b96a87ba3$var$sp(t, r, g, s);
            });
        };
    return $6f131a8b96a87ba3$var$_(t, {
        onBeforeEnter (e1) {
            $6f131a8b96a87ba3$var$sl(y, [
                e1
            ]), $6f131a8b96a87ba3$var$sa(e1, l), $6f131a8b96a87ba3$var$sa(e1, s);
        },
        onBeforeAppear (e1) {
            $6f131a8b96a87ba3$var$sl(C, [
                e1
            ]), $6f131a8b96a87ba3$var$sa(e1, a), $6f131a8b96a87ba3$var$sa(e1, c);
        },
        onEnter: E(!1),
        onAppear: E(!0),
        onLeave (e1, t) {
            e1._isLeaving = !0;
            let n = ()=>N(e1, t);
            $6f131a8b96a87ba3$var$sa(e1, d), e1._enterCancelled ? ($6f131a8b96a87ba3$var$sa(e1, p), $6f131a8b96a87ba3$var$sm(e1)) : ($6f131a8b96a87ba3$var$sm(e1), $6f131a8b96a87ba3$var$sa(e1, p)), $6f131a8b96a87ba3$var$su(()=>{
                e1._isLeaving && ($6f131a8b96a87ba3$var$sc(e1, d), $6f131a8b96a87ba3$var$sa(e1, h), $6f131a8b96a87ba3$var$ss(S) || $6f131a8b96a87ba3$var$sp(e1, r, m, n));
            }), $6f131a8b96a87ba3$var$sl(S, [
                e1,
                n
            ]);
        },
        onEnterCancelled (e1) {
            w(e1, !1, void 0, !0), $6f131a8b96a87ba3$var$sl(b, [
                e1
            ]);
        },
        onAppearCancelled (e1) {
            w(e1, !0, void 0, !0), $6f131a8b96a87ba3$var$sl(T, [
                e1
            ]);
        },
        onLeaveCancelled (e1) {
            N(e1), $6f131a8b96a87ba3$var$sl(x, [
                e1
            ]);
        }
    });
}
function $6f131a8b96a87ba3$var$sa(e1, t) {
    t.split(/\s+/).forEach((t)=>t && e1.classList.add(t)), (e1[$6f131a8b96a87ba3$var$st] || (e1[$6f131a8b96a87ba3$var$st] = new Set)).add(t);
}
function $6f131a8b96a87ba3$var$sc(e1, t) {
    t.split(/\s+/).forEach((t)=>t && e1.classList.remove(t));
    let n = e1[$6f131a8b96a87ba3$var$st];
    n && (n.delete(t), n.size || (e1[$6f131a8b96a87ba3$var$st] = void 0));
}
function $6f131a8b96a87ba3$var$su(e1) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(e1);
    });
}
let $6f131a8b96a87ba3$var$sd = 0;
function $6f131a8b96a87ba3$var$sp(e1, t, n, r) {
    let i = e1._endId = ++$6f131a8b96a87ba3$var$sd, l = ()=>{
        i === e1._endId && r();
    };
    if (null != n) return setTimeout(l, n);
    let { type: s, timeout: o, propCount: a } = $6f131a8b96a87ba3$var$sh(e1, t);
    if (!s) return r();
    let c = s + "end", u = 0, d = ()=>{
        e1.removeEventListener(c, p), l();
    }, p = (t)=>{
        t.target === e1 && ++u >= a && d();
    };
    setTimeout(()=>{
        u < a && d();
    }, o + 1), e1.addEventListener(c, p);
}
function $6f131a8b96a87ba3$var$sh(e1, t) {
    let n = window.getComputedStyle(e1), r = (e1)=>(n[e1] || "").split(", "), i = r(`${$6f131a8b96a87ba3$var$l7}Delay`), l = r(`${$6f131a8b96a87ba3$var$l7}Duration`), s = $6f131a8b96a87ba3$var$sf(i, l), o = r(`${$6f131a8b96a87ba3$var$se}Delay`), a = r(`${$6f131a8b96a87ba3$var$se}Duration`), c = $6f131a8b96a87ba3$var$sf(o, a), u = null, d = 0, p = 0;
    t === $6f131a8b96a87ba3$var$l7 ? s > 0 && (u = $6f131a8b96a87ba3$var$l7, d = s, p = l.length) : t === $6f131a8b96a87ba3$var$se ? c > 0 && (u = $6f131a8b96a87ba3$var$se, d = c, p = a.length) : p = (u = (d = Math.max(s, c)) > 0 ? s > c ? $6f131a8b96a87ba3$var$l7 : $6f131a8b96a87ba3$var$se : null) ? u === $6f131a8b96a87ba3$var$l7 ? l.length : a.length : 0;
    let h = u === $6f131a8b96a87ba3$var$l7 && /\b(?:transform|all)(?:,|$)/.test(r(`${$6f131a8b96a87ba3$var$l7}Property`).toString());
    return {
        type: u,
        timeout: d,
        propCount: p,
        hasTransform: h
    };
}
function $6f131a8b96a87ba3$var$sf(e1, t) {
    for(; e1.length < t.length;)e1 = e1.concat(e1);
    return Math.max(...t.map((t, n)=>$6f131a8b96a87ba3$var$sg(t) + $6f131a8b96a87ba3$var$sg(e1[n])));
}
function $6f131a8b96a87ba3$var$sg(e1) {
    return "auto" === e1 ? 0 : 1e3 * Number(e1.slice(0, -1).replace(",", "."));
}
function $6f131a8b96a87ba3$var$sm(e1) {
    return (e1 ? e1.ownerDocument : document).body.offsetHeight;
}
let $6f131a8b96a87ba3$var$sy = Symbol("_vod"), $6f131a8b96a87ba3$var$sv = Symbol("_vsh"), $6f131a8b96a87ba3$export$5cb4fcdc6937d7e1 = {
    name: "show",
    beforeMount (e1, { value: t }, { transition: n }) {
        e1[$6f131a8b96a87ba3$var$sy] = "none" === e1.style.display ? "" : e1.style.display, n && t ? n.beforeEnter(e1) : $6f131a8b96a87ba3$var$s_(e1, t);
    },
    mounted (e1, { value: t }, { transition: n }) {
        n && t && n.enter(e1);
    },
    updated (e1, { value: t, oldValue: n }, { transition: r }) {
        !t != !n && (r ? t ? (r.beforeEnter(e1), $6f131a8b96a87ba3$var$s_(e1, !0), r.enter(e1)) : r.leave(e1, ()=>{
            $6f131a8b96a87ba3$var$s_(e1, !1);
        }) : $6f131a8b96a87ba3$var$s_(e1, t));
    },
    beforeUnmount (e1, { value: t }) {
        $6f131a8b96a87ba3$var$s_(e1, t);
    }
};
function $6f131a8b96a87ba3$var$s_(e1, t) {
    e1.style.display = t ? e1[$6f131a8b96a87ba3$var$sy] : "none", e1[$6f131a8b96a87ba3$var$sv] = !t;
}
let $6f131a8b96a87ba3$var$sS = Symbol("");
function $6f131a8b96a87ba3$export$ef28b76f07940108(e1) {
    let t = $6f131a8b96a87ba3$export$f13e630aa3915748();
    if (!t) return;
    let n = t.ut = (n = e1(t.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${t.uid}"]`)).forEach((e1)=>$6f131a8b96a87ba3$var$sC(e1, n));
    }, r = ()=>{
        let r = e1(t.proxy);
        t.ce ? $6f131a8b96a87ba3$var$sC(t.ce, r) : function e1(t, n) {
            if (128 & t.shapeFlag) {
                let r = t.suspense;
                t = r.activeBranch, r.pendingBranch && !r.isHydrating && r.effects.push(()=>{
                    e1(r.activeBranch, n);
                });
            }
            for(; t.component;)t = t.component.subTree;
            if (1 & t.shapeFlag && t.el) $6f131a8b96a87ba3$var$sC(t.el, n);
            else if (t.type === $6f131a8b96a87ba3$export$ffb0004e005737fa) t.children.forEach((t)=>e1(t, n));
            else if (t.type === $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6) {
                let { el: e1, anchor: r } = t;
                for(; e1 && ($6f131a8b96a87ba3$var$sC(e1, n), e1 !== r);)e1 = e1.nextSibling;
            }
        }(t.subTree, r), n(r);
    };
    $6f131a8b96a87ba3$export$ab91988a13872e4c(()=>{
        $6f131a8b96a87ba3$export$59536a0199721cab(r);
    }), $6f131a8b96a87ba3$export$6d1641039221b5cb(()=>{
        $6f131a8b96a87ba3$export$3db5d71bdb2d5499(r, $6f131a8b96a87ba3$var$m, {
            flush: "post"
        });
        let e1 = new MutationObserver(r);
        e1.observe(t.subTree.el.parentNode, {
            childList: !0
        }), $6f131a8b96a87ba3$export$13348a43ccacfe58(()=>e1.disconnect());
    });
}
function $6f131a8b96a87ba3$var$sC(e1, t) {
    if (1 === e1.nodeType) {
        let r = e1.style, i = "";
        for(let e1 in t){
            var n;
            let l = null == (n = t[e1]) ? "initial" : "string" == typeof n ? "" === n ? " " : n : String(n);
            r.setProperty(`--${e1}`, l), i += `--${e1}: ${l};`;
        }
        r[$6f131a8b96a87ba3$var$sS] = i;
    }
}
let $6f131a8b96a87ba3$var$sk = /(?:^|;)\s*display\s*:/, $6f131a8b96a87ba3$var$sT = /\s*!important$/;
function $6f131a8b96a87ba3$var$sw(e1, t, n) {
    if ($6f131a8b96a87ba3$var$k(n)) n.forEach((n)=>$6f131a8b96a87ba3$var$sw(e1, t, n));
    else if (null == n && (n = ""), t.startsWith("--")) $6f131a8b96a87ba3$var$sT.test(n) ? e1.setProperty(t, n.replace($6f131a8b96a87ba3$var$sT, ""), "important") : e1.setProperty(t, n);
    else {
        let r = function(e1, t) {
            let n = $6f131a8b96a87ba3$var$sA[t];
            if (n) return n;
            let r = $6f131a8b96a87ba3$export$161d051f5dd25de7(t);
            if ("filter" !== r && r in e1) return $6f131a8b96a87ba3$var$sA[t] = r;
            r = $6f131a8b96a87ba3$export$9a00dee1beb8f576(r);
            for(let n = 0; n < $6f131a8b96a87ba3$var$sN.length; n++){
                let i = $6f131a8b96a87ba3$var$sN[n] + r;
                if (i in e1) return $6f131a8b96a87ba3$var$sA[t] = i;
            }
            return t;
        }(e1, t);
        $6f131a8b96a87ba3$var$sT.test(n) ? e1.setProperty($6f131a8b96a87ba3$var$V(r), n.replace($6f131a8b96a87ba3$var$sT, ""), "important") : e1[r] = n;
    }
}
let $6f131a8b96a87ba3$var$sN = [
    "Webkit",
    "Moz",
    "ms"
], $6f131a8b96a87ba3$var$sA = {}, $6f131a8b96a87ba3$var$sE = "http://www.w3.org/1999/xlink";
function $6f131a8b96a87ba3$var$sR(e1, t, n, r, i, l = $6f131a8b96a87ba3$var$el(t)) {
    if (r && t.startsWith("xlink:")) null == n ? e1.removeAttributeNS($6f131a8b96a87ba3$var$sE, t.slice(6, t.length)) : e1.setAttributeNS($6f131a8b96a87ba3$var$sE, t, n);
    else null == n || l && !(n || "" === n) ? e1.removeAttribute(t) : e1.setAttribute(t, l ? "" : $6f131a8b96a87ba3$var$N(n) ? String(n) : n);
}
function $6f131a8b96a87ba3$var$sI(e1, t, n, r, i) {
    if ("innerHTML" === t || "textContent" === t) {
        null != n && (e1[t] = "innerHTML" === t ? $6f131a8b96a87ba3$var$l4(n) : n);
        return;
    }
    let l = e1.tagName;
    if ("value" === t && "PROGRESS" !== l && !l.includes("-")) {
        let r = "OPTION" === l ? e1.getAttribute("value") || "" : e1.value, i = null == n ? "checkbox" === e1.type ? "on" : "" : String(n);
        r === i && "_value" in e1 || (e1.value = i), null == n && e1.removeAttribute(t), e1._value = n;
        return;
    }
    let s = !1;
    if ("" === n || null == n) {
        let r = typeof e1[t];
        if ("boolean" === r) {
            var o;
            n = !!(o = n) || "" === o;
        } else null == n && "string" === r ? (n = "", s = !0) : "number" === r && (n = 0, s = !0);
    }
    try {
        e1[t] = n;
    } catch (e1) {}
    s && e1.removeAttribute(i || t);
}
function $6f131a8b96a87ba3$var$sO(e1, t, n, r) {
    e1.addEventListener(t, n, r);
}
let $6f131a8b96a87ba3$var$sM = Symbol("_vei"), $6f131a8b96a87ba3$var$sP = /(Once|Passive|Capture)$/, $6f131a8b96a87ba3$var$sF = /^on:?(?:Once|Passive|Capture)$/, $6f131a8b96a87ba3$var$sD = 0, $6f131a8b96a87ba3$var$sL = Promise.resolve(), $6f131a8b96a87ba3$var$sV = (e1)=>111 === e1.charCodeAt(0) && 110 === e1.charCodeAt(1) && e1.charCodeAt(2) > 96 && 123 > e1.charCodeAt(2), $6f131a8b96a87ba3$export$cd4aa0842d13df8b = (e1, t, n, r, i, l)=>{
    let s = "svg" === i;
    if ("class" === t) {
        var o;
        let t;
        o = r, (t = e1[$6f131a8b96a87ba3$var$st]) && (o = (o ? [
            o,
            ...t
        ] : [
            ...t
        ]).join(" ")), null == o ? e1.removeAttribute("class") : s ? e1.setAttribute("class", o) : e1.className = o;
    } else "style" === t ? function(e1, t, n) {
        let r = e1.style, i = $6f131a8b96a87ba3$var$w(n), l = !1;
        if (n && !i) {
            if (t) {
                if ($6f131a8b96a87ba3$var$w(t)) for (let e1 of t.split(";")){
                    let t = e1.slice(0, e1.indexOf(":")).trim();
                    null == n[t] && $6f131a8b96a87ba3$var$sw(r, t, "");
                }
                else for(let e1 in t)null == n[e1] && $6f131a8b96a87ba3$var$sw(r, e1, "");
            }
            for(let i in n){
                var s, o, a, c;
                "display" === i && (l = !0);
                let u = n[i];
                null != u ? (s = e1, o = i, a = !$6f131a8b96a87ba3$var$w(t) && t ? t[i] : void 0, c = u, "TEXTAREA" === s.tagName && ("width" === o || "height" === o) && $6f131a8b96a87ba3$var$w(c) && a === c || $6f131a8b96a87ba3$var$sw(r, i, u)) : $6f131a8b96a87ba3$var$sw(r, i, "");
            }
        } else if (i) {
            if (t !== n) {
                let e1 = r[$6f131a8b96a87ba3$var$sS];
                e1 && (n += ";" + e1), r.cssText = n, l = $6f131a8b96a87ba3$var$sk.test(n);
            }
        } else t && e1.removeAttribute("style");
        $6f131a8b96a87ba3$var$sy in e1 && (i && t === n || (e1[$6f131a8b96a87ba3$var$sy] = l ? r.display : ""), e1[$6f131a8b96a87ba3$var$sv] && (r.display = "none"));
    }(e1, n, r) : $6f131a8b96a87ba3$var$v(t) ? $6f131a8b96a87ba3$var$b(t) || function(e1, t, n, r = null) {
        let i = e1[$6f131a8b96a87ba3$var$sM] || (e1[$6f131a8b96a87ba3$var$sM] = {}), l = i[t];
        if (n && l) l.value = n;
        else {
            let [a, c] = function(e1) {
                let t, n;
                for(; (n = e1.match($6f131a8b96a87ba3$var$sP)) && !$6f131a8b96a87ba3$var$sF.test(e1);)t || (t = {}), e1 = e1.slice(0, e1.length - n[1].length), t[n[1].toLowerCase()] = !0;
                return [
                    ":" === e1[2] ? e1.slice(3) : $6f131a8b96a87ba3$var$V(e1.slice(2)),
                    t
                ];
            }(t);
            if (n) {
                var s, o;
                let l;
                $6f131a8b96a87ba3$var$sO(e1, a, i[t] = (s = n, o = r, (l = (e1)=>{
                    if (e1._vts) {
                        if (e1._vts <= l.attached) return;
                    } else e1._vts = Date.now();
                    let t = l.value;
                    if ($6f131a8b96a87ba3$var$k(t)) {
                        let n = e1.stopImmediatePropagation;
                        e1.stopImmediatePropagation = ()=>{
                            n.call(e1), e1._stopped = !0;
                        };
                        let r = t.slice(), i = [
                            e1
                        ];
                        for(let t = 0; t < r.length && !e1._stopped; t++){
                            let e1 = r[t];
                            e1 && $6f131a8b96a87ba3$export$dae85862a8d94378(e1, o, 5, i);
                        }
                    } else $6f131a8b96a87ba3$export$dae85862a8d94378(t, o, 5, [
                        e1
                    ]);
                }).value = s, l.attached = $6f131a8b96a87ba3$var$sD || ($6f131a8b96a87ba3$var$sL.then(()=>$6f131a8b96a87ba3$var$sD = 0), $6f131a8b96a87ba3$var$sD = Date.now()), l), c);
            } else l && (e1.removeEventListener(a, l, c), i[t] = void 0);
        }
    }(e1, t, r, l) : ("." === t[0] ? (t = t.slice(1), 0) : "^" === t[0] ? (t = t.slice(1), 1) : !function(e1, t, n, r) {
        if (r) return !!("innerHTML" === t || "textContent" === t || t in e1 && $6f131a8b96a87ba3$var$sV(t) && $6f131a8b96a87ba3$var$T(n));
        if ("spellcheck" === t || "draggable" === t || "translate" === t || "autocorrect" === t || "sandbox" === t && "IFRAME" === e1.tagName || "form" === t || "list" === t && "INPUT" === e1.tagName || "type" === t && "TEXTAREA" === e1.tagName) return !1;
        if ("width" === t || "height" === t) {
            let t = e1.tagName;
            if ("IMG" === t || "VIDEO" === t || "CANVAS" === t || "SOURCE" === t) return !1;
        }
        return !($6f131a8b96a87ba3$var$sV(t) && $6f131a8b96a87ba3$var$w(n)) && t in e1;
    }(e1, t, r, s)) ? e1._isVueCE && (function(e1, t) {
        let n = e1._def.props;
        if (!n) return !1;
        let r = $6f131a8b96a87ba3$export$161d051f5dd25de7(t);
        return Array.isArray(n) ? n.some((e1)=>$6f131a8b96a87ba3$export$161d051f5dd25de7(e1) === r) : Object.keys(n).some((e1)=>$6f131a8b96a87ba3$export$161d051f5dd25de7(e1) === r);
    }(e1, t) || e1._def.__asyncLoader && (/[A-Z]/.test(t) || !$6f131a8b96a87ba3$var$w(r))) ? $6f131a8b96a87ba3$var$sI(e1, $6f131a8b96a87ba3$export$161d051f5dd25de7(t), r, l, t) : ("true-value" === t ? e1._trueValue = r : "false-value" === t && (e1._falseValue = r), $6f131a8b96a87ba3$var$sR(e1, t, r, s)) : ($6f131a8b96a87ba3$var$sI(e1, t, r), e1.tagName.includes("-") || "value" !== t && "checked" !== t && "selected" !== t || $6f131a8b96a87ba3$var$sR(e1, t, r, s, l, "value" !== t));
}, $6f131a8b96a87ba3$var$sB = {};
function $6f131a8b96a87ba3$export$a00e2346eabbdbef(e1, t, n) {
    let r, i = $6f131a8b96a87ba3$export$afa64b67e5a01c3b(e1, t);
    "[object Object]" === (r = i, $6f131a8b96a87ba3$var$R.call(r)) && (i = $6f131a8b96a87ba3$var$_({}, i, t));
    class l extends $6f131a8b96a87ba3$export$b337c1a55163dbe3 {
        constructor(e1){
            super(i, e1, n);
        }
    }
    return l.def = i, l;
}
let $6f131a8b96a87ba3$export$6debb2e68f212638 = (e1, t)=>$6f131a8b96a87ba3$export$a00e2346eabbdbef(e1, t, $6f131a8b96a87ba3$export$35800275c0037383), $6f131a8b96a87ba3$var$sH = "u" > typeof HTMLElement ? HTMLElement : class {
};
class $6f131a8b96a87ba3$export$b337c1a55163dbe3 extends $6f131a8b96a87ba3$var$sH {
    constructor(e1, t = {}, n = $6f131a8b96a87ba3$export$4e373c34abfa8c68){
        super(), this._def = e1, this._props = t, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._patching = !1, this._dirty = !1, this._numberProps = null, this._styleChildren = new WeakSet, this._styleAnchors = new WeakMap, this._ob = null, this.shadowRoot && n !== $6f131a8b96a87ba3$export$4e373c34abfa8c68 ? this._root = this.shadowRoot : !1 !== e1.shadowRoot ? (this.attachShadow($6f131a8b96a87ba3$var$_({}, e1.shadowRootOptions, {
            mode: "open"
        })), this._root = this.shadowRoot) : this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        this.shadowRoot || this._resolved || this._parseSlots(), this._connected = !0;
        let e1 = this;
        for(; e1 = e1 && (e1.assignedSlot || e1.parentNode || e1.host);)if (e1 instanceof $6f131a8b96a87ba3$export$b337c1a55163dbe3) {
            this._parent = e1;
            break;
        }
        this._instance || (this._resolved ? this._mount(this._def) : e1 && e1._pendingResolve ? this._pendingResolve = e1._pendingResolve.then(()=>{
            if (this._pendingResolve = void 0, this.isConnected) return this._resolveDef();
        }) : this._resolveDef());
    }
    _setParent(e1 = this._parent) {
        e1 && (this._instance.parent = e1._instance, this._inheritParentContext(e1));
    }
    _inheritParentContext(e1 = this._parent) {
        e1 && this._app && Object.setPrototypeOf(this._app._context.provides, e1._instance.provides);
    }
    disconnectedCallback() {
        this._connected = !1, $6f131a8b96a87ba3$export$bdd553fddd433dcb(()=>{
            !this._connected && (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null, this._teleportTargets && (this._teleportTargets.clear(), this._teleportTargets = void 0));
        });
    }
    _processMutations(e1) {
        for (let t of e1)this._setAttr(t.attributeName);
    }
    _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let e1 = 0; e1 < this.attributes.length; e1++)this._setAttr(this.attributes[e1].name);
        this._ob = new MutationObserver(this._processMutations.bind(this)), this._ob.observe(this, {
            attributes: !0
        });
        let e1 = (e1, t = !1)=>{
            let n;
            this._resolved = !0, this._pendingResolve = void 0;
            let { props: r, styles: i } = e1;
            if (r && !$6f131a8b96a87ba3$var$k(r)) for(let e1 in r){
                let t = r[e1];
                (t === Number || t && t.type === Number) && (e1 in this._props && (this._props[e1] = $6f131a8b96a87ba3$var$W(this._props[e1])), (n || (n = Object.create(null)))[$6f131a8b96a87ba3$export$161d051f5dd25de7(e1)] = !0);
            }
            this._numberProps = n, this._resolveProps(e1), this.shadowRoot && this._applyStyles(i), this._connected && this._mount(e1);
        }, t = this._def.__asyncLoader;
        if (t) return this._pendingResolve = t().then((t)=>{
            t.configureApp = this._def.configureApp, e1(this._def = t, !0);
        }), this._pendingResolve;
        e1(this._def);
    }
    _mount(e1) {
        this._app = this._createApp(e1), this._inheritParentContext(), e1.configureApp && e1.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
        let t = this._instance && this._instance.exposed;
        if (t) for(let e1 in t)$6f131a8b96a87ba3$var$C(this, e1) || Object.defineProperty(this, e1, {
            get: ()=>$6f131a8b96a87ba3$export$a239a76781616204(t[e1])
        });
    }
    _resolveProps(e1) {
        let { props: t } = e1, n = $6f131a8b96a87ba3$var$k(t) ? t : Object.keys(t || {});
        for (let e1 of Object.keys(this))"_" !== e1[0] && n.includes(e1) && this._setProp(e1, this[e1]);
        for (let e1 of n.map($6f131a8b96a87ba3$export$161d051f5dd25de7))Object.defineProperty(this, e1, {
            get () {
                return this._getProp(e1);
            },
            set (t) {
                this._setProp(e1, t, !0, !this._patching);
            }
        });
    }
    _setAttr(e1) {
        if (e1.startsWith("data-v-")) return;
        let t = this.hasAttribute(e1), n = t ? this.getAttribute(e1) : $6f131a8b96a87ba3$var$sB, r = $6f131a8b96a87ba3$export$161d051f5dd25de7(e1);
        t && this._numberProps && this._numberProps[r] && (n = $6f131a8b96a87ba3$var$W(n)), this._setProp(r, n, !1, !0);
    }
    _getProp(e1) {
        return this._props[e1];
    }
    _setProp(e1, t, n = !0, r = !1) {
        if (t !== this._props[e1] && (this._dirty = !0, t === $6f131a8b96a87ba3$var$sB ? delete this._props[e1] : (this._props[e1] = t, "key" === e1 && this._app && (this._app._ceVNode.key = t)), r && this._instance && this._update(), n)) {
            let n = this._ob;
            n && (this._processMutations(n.takeRecords()), n.disconnect()), !0 === t ? this.setAttribute($6f131a8b96a87ba3$var$V(e1), "") : "string" == typeof t || "number" == typeof t ? this.setAttribute($6f131a8b96a87ba3$var$V(e1), t + "") : t || this.removeAttribute($6f131a8b96a87ba3$var$V(e1)), n && n.observe(this, {
                attributes: !0
            });
        }
    }
    _update() {
        let e1 = this._createVNode();
        this._app && (e1.appContext = this._app._context), $6f131a8b96a87ba3$export$b3890eb0ae9dca99(e1, this._root);
    }
    _createVNode() {
        let e1 = {};
        this.shadowRoot || (e1.onVnodeMounted = e1.onVnodeUpdated = this._renderSlots.bind(this));
        let t = $6f131a8b96a87ba3$export$bf5c4cf060303d58(this._def, $6f131a8b96a87ba3$var$_(e1, this._props));
        return this._instance || (t.ce = (e1)=>{
            this._instance = e1, e1.ce = this, e1.isCE = !0;
            let t = (e1, t)=>{
                let n;
                this.dispatchEvent(new CustomEvent(e1, "[object Object]" === (n = t[0], $6f131a8b96a87ba3$var$R.call(n)) ? $6f131a8b96a87ba3$var$_({
                    detail: t
                }, t[0]) : {
                    detail: t
                }));
            };
            e1.emit = (e1, ...n)=>{
                t(e1, n), $6f131a8b96a87ba3$var$V(e1) !== e1 && t($6f131a8b96a87ba3$var$V(e1), n);
            }, this._setParent();
        }), t;
    }
    _applyStyles(e1, t, n) {
        if (!e1) return;
        if (t) {
            if (t === this._def || this._styleChildren.has(t)) return;
            this._styleChildren.add(t);
        }
        let r = this._nonce, i = this.shadowRoot, l = n ? this._getStyleAnchor(n) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(i), s = null;
        for(let o = e1.length - 1; o >= 0; o--){
            let a = document.createElement("style");
            r && a.setAttribute("nonce", r), a.textContent = e1[o], i.insertBefore(a, s || l), s = a, 0 === o && (n || this._styleAnchors.set(this._def, a), t && this._styleAnchors.set(t, a));
        }
    }
    _getStyleAnchor(e1) {
        if (!e1) return null;
        let t = this._styleAnchors.get(e1);
        return t && t.parentNode === this.shadowRoot ? t : (t && this._styleAnchors.delete(e1), null);
    }
    _getRootStyleInsertionAnchor(e1) {
        for(let t = 0; t < e1.childNodes.length; t++){
            let n = e1.childNodes[t];
            if (!(n instanceof HTMLStyleElement)) return n;
        }
        return null;
    }
    _parseSlots() {
        let e1, t = this._slots = {};
        for(; e1 = this.firstChild;){
            let n = 1 === e1.nodeType && e1.getAttribute("slot") || "default";
            (t[n] || (t[n] = [])).push(e1), this.removeChild(e1);
        }
    }
    _renderSlots() {
        let e1 = this._getSlots(), t = this._instance.type.__scopeId;
        for(let n = 0; n < e1.length; n++){
            let r = e1[n], i = r.getAttribute("name") || "default", l = this._slots[i], s = r.parentNode;
            if (l) for (let e1 of l){
                if (t && 1 === e1.nodeType) {
                    let n, r = t + "-s", i = document.createTreeWalker(e1, 1);
                    for(e1.setAttribute(r, ""); n = i.nextNode();)n.setAttribute(r, "");
                }
                s.insertBefore(e1, r);
            }
            else for(; r.firstChild;)s.insertBefore(r.firstChild, r);
            s.removeChild(r);
        }
    }
    _getSlots() {
        let e1 = [
            this
        ];
        this._teleportTargets && e1.push(...this._teleportTargets);
        let t = new Set;
        for (let n of e1){
            let e1 = n.querySelectorAll("slot");
            for(let n = 0; n < e1.length; n++)t.add(e1[n]);
        }
        return Array.from(t);
    }
    _injectChildStyle(e1, t) {
        this._applyStyles(e1.styles, e1, t);
    }
    _beginPatch() {
        this._patching = !0, this._dirty = !1;
    }
    _endPatch() {
        this._patching = !1, this._dirty && this._instance && this._update();
    }
    _hasShadowRoot() {
        return !1 !== this._def.shadowRoot;
    }
    _removeChildStyle(e1) {}
}
function $6f131a8b96a87ba3$export$da5acfe93a94e37d(e1) {
    let t = $6f131a8b96a87ba3$export$f13e630aa3915748(), n = t && t.ce;
    return n || null;
}
function $6f131a8b96a87ba3$export$64d45095031fa749() {
    let e1 = $6f131a8b96a87ba3$export$da5acfe93a94e37d();
    return e1 && e1.shadowRoot;
}
function $6f131a8b96a87ba3$export$9300d5b90d56e3d1(e1 = "$style") {
    {
        let t = $6f131a8b96a87ba3$export$f13e630aa3915748();
        if (!t) return $6f131a8b96a87ba3$var$f;
        let n = t.type.__cssModules;
        if (!n) return $6f131a8b96a87ba3$var$f;
        let r = n[e1];
        return r || $6f131a8b96a87ba3$var$f;
    }
}
let $6f131a8b96a87ba3$var$sJ = new WeakMap, $6f131a8b96a87ba3$var$sG = new WeakMap, $6f131a8b96a87ba3$var$sX = Symbol("_moveCb"), $6f131a8b96a87ba3$var$sQ = Symbol("_enterCb"), $6f131a8b96a87ba3$var$sZ = new WeakMap, $6f131a8b96a87ba3$export$19ffa8f511f7bc2e = ($6f131a8b96a87ba3$var$oA = {
    name: "TransitionGroup",
    props: $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$sr, {
        tag: String,
        moveClass: String
    }),
    setup (e1, { slots: t }) {
        let n, r, i, l, s = $6f131a8b96a87ba3$export$f13e630aa3915748(), o = $6f131a8b96a87ba3$export$d2a0a1bc267c90f6(), a = ()=>(void 0 === l && (l = n.length > 0 && function(e1, t, n) {
                let r = e1.cloneNode(), i = e1[$6f131a8b96a87ba3$var$st];
                i && i.forEach((e1)=>{
                    e1.split(/\s+/).forEach((e1)=>e1 && r.classList.remove(e1));
                }), n.split(/\s+/).forEach((e1)=>e1 && r.classList.add(e1)), r.style.display = "none";
                let l = 1 === t.nodeType ? t : t.parentNode;
                l.appendChild(r);
                let { hasTransform: s } = $6f131a8b96a87ba3$var$sh(r);
                return l.removeChild(r), s;
            }(n[0].el, s.vnode.el, $6f131a8b96a87ba3$var$s1(e1))), l);
        return $6f131a8b96a87ba3$export$5876c47052fb88b1(()=>{
            var t, r;
            let l;
            if ($6f131a8b96a87ba3$var$sZ.delete(s), !a()) {
                n = [], i = void 0;
                return;
            }
            let o = $6f131a8b96a87ba3$var$s1(e1);
            n.forEach($6f131a8b96a87ba3$var$s0);
            let c = i && (t = i, r = s.vnode.el, (l = t.find((e1)=>e1.willMove() && e1.item.contains(r))) && $6f131a8b96a87ba3$var$s3(l.item, l));
            i = void 0, n.forEach((e1)=>{
                var t, n;
                return t = e1, n = c, void $6f131a8b96a87ba3$var$sG.set(t, $6f131a8b96a87ba3$var$s3(t.el, n));
            });
            let u = n.filter($6f131a8b96a87ba3$var$s2);
            $6f131a8b96a87ba3$var$sm(s.vnode.el), u.forEach((e1)=>{
                let t = e1.el, n = t.style;
                $6f131a8b96a87ba3$var$sa(t, o), n.transform = n.webkitTransform = n.transitionDuration = "";
                let r = t[$6f131a8b96a87ba3$var$sX] = (e1)=>{
                    (!e1 || e1.target === t) && (!e1 || e1.propertyName.endsWith("transform")) && (t.removeEventListener("transitionend", r), t[$6f131a8b96a87ba3$var$sX] = null, $6f131a8b96a87ba3$var$sc(t, o));
                };
                t.addEventListener("transitionend", r);
            }), n = [];
        }), ()=>{
            let c = $6f131a8b96a87ba3$export$ab18938b9fc5f28e(e1), u = $6f131a8b96a87ba3$var$so(c), d = c.tag || $6f131a8b96a87ba3$export$ffb0004e005737fa;
            if (n = [], l = void 0, r) for(let e1 = 0; e1 < r.length; e1++){
                let t = r[e1];
                t.el && t.el instanceof Element && !t.el[$6f131a8b96a87ba3$var$sv] && (n.push(t), $6f131a8b96a87ba3$export$7770a22486565649(t, $6f131a8b96a87ba3$export$76ac1779589cd824(t, u, o, s)), $6f131a8b96a87ba3$var$sJ.set(t, $6f131a8b96a87ba3$var$s3(t.el)));
            }
            r = t.default ? $6f131a8b96a87ba3$export$a67f9b1229c7c97a(t.default()) : [];
            for(let e1 = 0; e1 < r.length; e1++){
                let t = r[e1];
                null != t.key && $6f131a8b96a87ba3$export$7770a22486565649(t, $6f131a8b96a87ba3$export$76ac1779589cd824(t, u, o, s));
            }
            return n.length && (i = function(e1) {
                let t;
                for(let n = e1.parent; n; n = n.parent){
                    let r = $6f131a8b96a87ba3$var$sZ.get(n);
                    if (r) {
                        let i = function(e1, t) {
                            let n = 1 === e1.nodeType ? e1 : e1.parentNode;
                            for(; t && t.parentNode !== n;)t = t.parentNode;
                            if (t && 1 === t.nodeType) return t;
                        }(n.vnode.el, e1.vnode.el);
                        i && (t || (t = [])).push($6f131a8b96a87ba3$var$_($6f131a8b96a87ba3$var$s3(i), {
                            item: i,
                            willMove: r
                        }));
                    }
                }
                return t;
            }(s), $6f131a8b96a87ba3$var$sZ.set(s, a)), $6f131a8b96a87ba3$export$bf5c4cf060303d58(d, null, r);
        };
    }
}, delete $6f131a8b96a87ba3$var$oA.props.mode, $6f131a8b96a87ba3$var$oA);
function $6f131a8b96a87ba3$var$s0(e1) {
    let t = e1.el;
    t[$6f131a8b96a87ba3$var$sX] && t[$6f131a8b96a87ba3$var$sX](), t[$6f131a8b96a87ba3$var$sQ] && t[$6f131a8b96a87ba3$var$sQ]();
}
function $6f131a8b96a87ba3$var$s1(e1) {
    return e1.moveClass || `${e1.name || "v"}-move`;
}
function $6f131a8b96a87ba3$var$s2(e1) {
    let t = $6f131a8b96a87ba3$var$sJ.get(e1), n = $6f131a8b96a87ba3$var$sG.get(e1), r = t.left - n.left, i = t.top - n.top;
    if (r || i) {
        let t = e1.el, n = t.style, l = t.getBoundingClientRect(), s = 1, o = 1;
        return t.offsetWidth && (s = l.width / t.offsetWidth), t.offsetHeight && (o = l.height / t.offsetHeight), Number.isFinite(s) && 0 !== s || (s = 1), Number.isFinite(o) && 0 !== o || (o = 1), .01 > Math.abs(s - 1) && (s = 1), .01 > Math.abs(o - 1) && (o = 1), n.transform = n.webkitTransform = `translate(${r / s}px,${i / o}px)`, n.transitionDuration = "0s", e1;
    }
}
function $6f131a8b96a87ba3$var$s3(e1, t) {
    let n = e1.getBoundingClientRect();
    return {
        left: n.left - (t ? t.left : 0),
        top: n.top - (t ? t.top : 0)
    };
}
let $6f131a8b96a87ba3$var$s6 = (e1)=>{
    let t = e1.props["onUpdate:modelValue"] || !1;
    return $6f131a8b96a87ba3$var$k(t) ? (e1)=>$6f131a8b96a87ba3$var$U(t, e1) : t;
};
function $6f131a8b96a87ba3$var$s4(e1) {
    e1.target.composing = !0;
}
function $6f131a8b96a87ba3$var$s8(e1) {
    let t = e1.target;
    t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
let $6f131a8b96a87ba3$var$s5 = Symbol("_assign"), $6f131a8b96a87ba3$var$s9 = Symbol("_initialValue");
function $6f131a8b96a87ba3$var$s7(e1, t, n) {
    return t && (e1 = e1.trim()), n && (e1 = $6f131a8b96a87ba3$var$q(e1)), e1;
}
let $6f131a8b96a87ba3$export$f1f88689f5728478 = {
    created (e1, { modifiers: { lazy: t, trim: n, number: r } }, i) {
        e1.parentNode && ("text" === e1.type ? e1[$6f131a8b96a87ba3$var$s9] = e1.defaultValue.replace(/[\r\n]/g, "") : "textarea" === e1.type && (e1[$6f131a8b96a87ba3$var$s9] = e1.defaultValue.replace(/\r\n?/g, `
`))), e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(i);
        let l = r || i.props && "number" === i.props.type;
        $6f131a8b96a87ba3$var$sO(e1, t ? "change" : "input", (t)=>{
            t.target.composing || e1[$6f131a8b96a87ba3$var$s5]($6f131a8b96a87ba3$var$s7(e1.value, n, l));
        }), (n || l) && $6f131a8b96a87ba3$var$sO(e1, "change", ()=>{
            e1.value = $6f131a8b96a87ba3$var$s7(e1.value, n, l);
        }), t || ($6f131a8b96a87ba3$var$sO(e1, "compositionstart", $6f131a8b96a87ba3$var$s4), $6f131a8b96a87ba3$var$sO(e1, "compositionend", $6f131a8b96a87ba3$var$s8), $6f131a8b96a87ba3$var$sO(e1, "change", $6f131a8b96a87ba3$var$s8));
    },
    mounted (e1, { value: t, modifiers: { trim: n, number: r } }) {
        let i = e1[$6f131a8b96a87ba3$var$s9];
        delete e1[$6f131a8b96a87ba3$var$s9], void 0 !== i && ("text" === e1.type || "textarea" === e1.type) && e1.value !== i ? e1[$6f131a8b96a87ba3$var$s5]($6f131a8b96a87ba3$var$s7(e1.value, n, r)) : e1.value = null == t ? "" : t;
    },
    beforeUpdate (e1, { value: t, oldValue: n, modifiers: { lazy: r, trim: i, number: l } }, s) {
        if (e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(s), e1.composing) return;
        let o = (l || "number" === e1.type) && !/^0\d/.test(e1.value) ? $6f131a8b96a87ba3$var$q(e1.value) : e1.value, a = null == t ? "" : t;
        if (o === a) return;
        let c = e1.getRootNode();
        (c instanceof Document || c instanceof ShadowRoot) && c.activeElement === e1 && "range" !== e1.type && (r && t === n || i && e1.value.trim() === a) || (e1.value = a);
    }
}, $6f131a8b96a87ba3$export$8847c2e532b35714 = {
    deep: !0,
    created (e1, t, n) {
        e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(n), $6f131a8b96a87ba3$var$sO(e1, "change", ()=>{
            let t = e1._modelValue, n = $6f131a8b96a87ba3$var$os(e1), r = e1.checked, i = e1[$6f131a8b96a87ba3$var$s5];
            if ($6f131a8b96a87ba3$var$k(t)) {
                let e1 = $6f131a8b96a87ba3$var$ed(t, n), l = -1 !== e1;
                if (r && !l) i(t.concat(n));
                else if (!r && l) {
                    let n = [
                        ...t
                    ];
                    n.splice(e1, 1), i(n);
                }
            } else {
                let l;
                if ("[object Set]" === (l = t, $6f131a8b96a87ba3$var$R.call(l))) {
                    let e1 = new Set(t);
                    r ? e1.add(n) : e1.delete(n), i(e1);
                } else i($6f131a8b96a87ba3$var$oo(e1, r));
            }
        });
    },
    mounted: $6f131a8b96a87ba3$var$on,
    beforeUpdate (e1, t, n) {
        e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(n), $6f131a8b96a87ba3$var$on(e1, t, n);
    }
};
function $6f131a8b96a87ba3$var$on(e1, { value: t, oldValue: n }, r) {
    let i;
    if (e1._modelValue = t, $6f131a8b96a87ba3$var$k(t)) i = $6f131a8b96a87ba3$var$ed(t, r.props.value) > -1;
    else {
        let l;
        if ("[object Set]" === (l = t, $6f131a8b96a87ba3$var$R.call(l))) i = t.has(r.props.value);
        else {
            if (t === n) return;
            i = $6f131a8b96a87ba3$var$eu(t, $6f131a8b96a87ba3$var$oo(e1, !0));
        }
    }
    e1.checked !== i && (e1.checked = i);
}
let $6f131a8b96a87ba3$export$b4356c59b38b7aa9 = {
    created (e1, { value: t }, n) {
        e1.checked = $6f131a8b96a87ba3$var$eu(t, n.props.value), e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(n), $6f131a8b96a87ba3$var$sO(e1, "change", ()=>{
            e1[$6f131a8b96a87ba3$var$s5]($6f131a8b96a87ba3$var$os(e1));
        });
    },
    beforeUpdate (e1, { value: t, oldValue: n }, r) {
        e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(r), t !== n && (e1.checked = $6f131a8b96a87ba3$var$eu(t, r.props.value));
    }
}, $6f131a8b96a87ba3$export$87d227567b51ca39 = {
    deep: !0,
    created (e1, { value: t, modifiers: { number: n } }, r) {
        e1._modelValue = t, $6f131a8b96a87ba3$var$sO(e1, "change", ()=>{
            let t, r = Array.prototype.filter.call(e1.options, (e1)=>e1.selected).map((e1)=>n ? $6f131a8b96a87ba3$var$q($6f131a8b96a87ba3$var$os(e1)) : $6f131a8b96a87ba3$var$os(e1)), i = e1.multiple, l = i ? "[object Set]" === (t = e1._modelValue, $6f131a8b96a87ba3$var$R.call(t)) ? new Set(r) : r : r[0], s = e1._pendingValue = [
                i,
                i ? $6f131a8b96a87ba3$var$k(l) ? r.slice() : r : l
            ];
            try {
                e1[$6f131a8b96a87ba3$var$s5](l);
            } finally{
                $6f131a8b96a87ba3$export$bdd553fddd433dcb(()=>{
                    e1._pendingValue === s && (e1._pendingValue = void 0);
                });
            }
        }), e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(r);
    },
    mounted (e1, { value: t }) {
        $6f131a8b96a87ba3$var$ol(e1, t);
    },
    beforeUpdate (e1, { value: t }, n) {
        e1._modelValue = t, e1[$6f131a8b96a87ba3$var$s5] = $6f131a8b96a87ba3$var$s6(n);
    },
    updated (e1, { value: t }) {
        let n = e1._pendingValue;
        e1._pendingValue = void 0, n && n[0] === e1.multiple && function(e1, t, n) {
            let r;
            if (!n || $6f131a8b96a87ba3$var$k(e1)) return $6f131a8b96a87ba3$var$eu(e1, t);
            if ("[object Set]" === (r = e1, $6f131a8b96a87ba3$var$R.call(r))) {
                if (e1.size !== t.length) return !1;
                for (let n of t)if (!e1.has(n)) return !1;
                return !0;
            }
            return !1;
        }(t, n[1], n[0]) || $6f131a8b96a87ba3$var$ol(e1, t);
    }
};
function $6f131a8b96a87ba3$var$ol(e1, t) {
    let n, r = e1.multiple, i = $6f131a8b96a87ba3$var$k(t);
    if (!r || i || "[object Set]" === (n = t, $6f131a8b96a87ba3$var$R.call(n))) {
        for(let n = 0, l = e1.options.length; n < l; n++){
            let l = e1.options[n], s = $6f131a8b96a87ba3$var$os(l);
            if (r) {
                if (i) {
                    let e1 = typeof s;
                    "string" === e1 || "number" === e1 ? l.selected = t.some((e1)=>String(e1) === String(s)) : l.selected = $6f131a8b96a87ba3$var$ed(t, s) > -1;
                } else l.selected = t.has(s);
            } else if ($6f131a8b96a87ba3$var$eu($6f131a8b96a87ba3$var$os(l), t)) {
                e1.selectedIndex !== n && (e1.selectedIndex = n);
                return;
            }
        }
        r || -1 === e1.selectedIndex || (e1.selectedIndex = -1);
    }
}
function $6f131a8b96a87ba3$var$os(e1) {
    return "_value" in e1 ? e1._value : e1.value;
}
function $6f131a8b96a87ba3$var$oo(e1, t) {
    let n = t ? "_trueValue" : "_falseValue";
    return n in e1 ? e1[n] : t;
}
let $6f131a8b96a87ba3$export$5ad5c0e01ff62c5 = {
    created (e1, t, n) {
        $6f131a8b96a87ba3$var$ou(e1, t, n, null, "created");
    },
    mounted (e1, t, n) {
        $6f131a8b96a87ba3$var$ou(e1, t, n, null, "mounted");
    },
    beforeUpdate (e1, t, n, r) {
        $6f131a8b96a87ba3$var$ou(e1, t, n, r, "beforeUpdate");
    },
    updated (e1, t, n, r) {
        $6f131a8b96a87ba3$var$ou(e1, t, n, r, "updated");
    }
};
function $6f131a8b96a87ba3$var$oc(e1, t) {
    switch(e1){
        case "SELECT":
            return $6f131a8b96a87ba3$export$87d227567b51ca39;
        case "TEXTAREA":
            return $6f131a8b96a87ba3$export$f1f88689f5728478;
        default:
            switch(t){
                case "checkbox":
                    return $6f131a8b96a87ba3$export$8847c2e532b35714;
                case "radio":
                    return $6f131a8b96a87ba3$export$b4356c59b38b7aa9;
                default:
                    return $6f131a8b96a87ba3$export$f1f88689f5728478;
            }
    }
}
function $6f131a8b96a87ba3$var$ou(e1, t, n, r, i) {
    let l = $6f131a8b96a87ba3$var$oc(e1.tagName, n.props && n.props.type)[i];
    l && l(e1, t, n, r);
}
let $6f131a8b96a87ba3$var$od = [
    "ctrl",
    "shift",
    "alt",
    "meta"
], $6f131a8b96a87ba3$var$op = {
    stop: (e1)=>e1.stopPropagation(),
    prevent: (e1)=>e1.preventDefault(),
    self: (e1)=>e1.target !== e1.currentTarget,
    ctrl: (e1)=>!e1.ctrlKey,
    shift: (e1)=>!e1.shiftKey,
    alt: (e1)=>!e1.altKey,
    meta: (e1)=>!e1.metaKey,
    left: (e1)=>"button" in e1 && 0 !== e1.button,
    middle: (e1)=>"button" in e1 && 1 !== e1.button,
    right: (e1)=>"button" in e1 && 2 !== e1.button,
    exact: (e1, t)=>$6f131a8b96a87ba3$var$od.some((n)=>e1[`${n}Key`] && !t.includes(n))
}, $6f131a8b96a87ba3$export$26bd3b8e29e6f273 = (e1, t)=>{
    if (!e1) return e1;
    let n = e1._withMods || (e1._withMods = {}), r = t.join(".");
    return n[r] || (n[r] = (n, ...r)=>{
        for(let e1 = 0; e1 < t.length; e1++){
            let r = $6f131a8b96a87ba3$var$op[t[e1]];
            if (r && r(n, t)) return;
        }
        return e1(n, ...r);
    });
}, $6f131a8b96a87ba3$var$of = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
}, $6f131a8b96a87ba3$export$f691a8759658f782 = (e1, t)=>{
    let n = e1._withKeys || (e1._withKeys = {}), r = t.join(".");
    return n[r] || (n[r] = (n)=>{
        if (!("key" in n)) return;
        let r = $6f131a8b96a87ba3$var$V(n.key);
        if (t.some((e1)=>e1 === r || $6f131a8b96a87ba3$var$of[e1] === r)) return e1(n);
    });
}, $6f131a8b96a87ba3$var$om = $6f131a8b96a87ba3$var$_({
    patchProp: $6f131a8b96a87ba3$export$cd4aa0842d13df8b
}, $6f131a8b96a87ba3$export$de4fb7f5030605d3), $6f131a8b96a87ba3$var$oy = !1;
function $6f131a8b96a87ba3$var$ov() {
    return $6f131a8b96a87ba3$var$c = $6f131a8b96a87ba3$var$oy ? $6f131a8b96a87ba3$var$c : $6f131a8b96a87ba3$export$200524cf0d997ff0($6f131a8b96a87ba3$var$om), $6f131a8b96a87ba3$var$oy = !0, $6f131a8b96a87ba3$var$c;
}
let $6f131a8b96a87ba3$export$b3890eb0ae9dca99 = (...e1)=>{
    ($6f131a8b96a87ba3$var$c || ($6f131a8b96a87ba3$var$c = $6f131a8b96a87ba3$export$53ae2f996c64e9a($6f131a8b96a87ba3$var$om))).render(...e1);
}, $6f131a8b96a87ba3$export$fa8d919ba61d84db = (...e1)=>{
    $6f131a8b96a87ba3$var$ov().hydrate(...e1);
}, $6f131a8b96a87ba3$export$4e373c34abfa8c68 = (...e1)=>{
    let t = ($6f131a8b96a87ba3$var$c || ($6f131a8b96a87ba3$var$c = $6f131a8b96a87ba3$export$53ae2f996c64e9a($6f131a8b96a87ba3$var$om))).createApp(...e1), { mount: n } = t;
    return t.mount = (e1)=>{
        let r = $6f131a8b96a87ba3$var$ok(e1);
        if (!r) return;
        let i = t._component;
        $6f131a8b96a87ba3$var$T(i) || i.render || i.template || (i.template = r.innerHTML), 1 === r.nodeType && (r.textContent = "");
        let l = n(r, !1, $6f131a8b96a87ba3$var$oC(r));
        return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), l;
    }, t;
}, $6f131a8b96a87ba3$export$35800275c0037383 = (...e1)=>{
    let t = $6f131a8b96a87ba3$var$ov().createApp(...e1), { mount: n } = t;
    return t.mount = (e1)=>{
        let t = $6f131a8b96a87ba3$var$ok(e1);
        if (t) return n(t, !0, $6f131a8b96a87ba3$var$oC(t));
    }, t;
};
function $6f131a8b96a87ba3$var$oC(e1) {
    return e1 instanceof SVGElement ? "svg" : "function" == typeof MathMLElement && e1 instanceof MathMLElement ? "mathml" : void 0;
}
function $6f131a8b96a87ba3$var$ok(e1) {
    return $6f131a8b96a87ba3$var$w(e1) ? document.querySelector(e1) : e1;
}
let $6f131a8b96a87ba3$var$oT = !1, $6f131a8b96a87ba3$export$800b28255aa678d9 = ()=>{
    $6f131a8b96a87ba3$var$oT || ($6f131a8b96a87ba3$var$oT = !0, $6f131a8b96a87ba3$export$f1f88689f5728478.getSSRProps = ({ value: e1 })=>({
            value: e1
        }), $6f131a8b96a87ba3$export$b4356c59b38b7aa9.getSSRProps = ({ value: e1 }, t)=>{
        if (t.props && $6f131a8b96a87ba3$var$eu(t.props.value, e1)) return {
            checked: !0
        };
    }, $6f131a8b96a87ba3$export$8847c2e532b35714.getSSRProps = ({ value: e1 }, t)=>{
        if ($6f131a8b96a87ba3$var$k(e1)) {
            if (t.props && $6f131a8b96a87ba3$var$ed(e1, t.props.value) > -1) return {
                checked: !0
            };
        } else {
            let n;
            if ("[object Set]" === (n = e1, $6f131a8b96a87ba3$var$R.call(n))) {
                if (t.props && e1.has(t.props.value)) return {
                    checked: !0
                };
            } else if (e1) return {
                checked: !0
            };
        }
    }, $6f131a8b96a87ba3$export$5ad5c0e01ff62c5.getSSRProps = (e1, t)=>{
        if ("string" != typeof t.type) return;
        let n = $6f131a8b96a87ba3$var$oc(t.type.toUpperCase(), t.props && t.props.type);
        if (n.getSSRProps) return n.getSSRProps(e1, t);
    }, $6f131a8b96a87ba3$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: e1 })=>{
        if (!e1) return {
            style: {
                display: "none"
            }
        };
    });
};
var $6f131a8b96a87ba3$var$oN, $6f131a8b96a87ba3$var$oA, $6f131a8b96a87ba3$var$oE, $6f131a8b96a87ba3$var$oR = Object.freeze({
    __proto__: null,
    BaseTransition: $6f131a8b96a87ba3$export$abd95b5f5e8a8837,
    BaseTransitionPropsValidators: $6f131a8b96a87ba3$export$b876c99684f8cf3b,
    Comment: $6f131a8b96a87ba3$export$4d299b491347818a,
    DeprecationTypes: $6f131a8b96a87ba3$export$22072a82865312f6,
    EffectScope: $6f131a8b96a87ba3$export$1168ed9dbc71ddbd,
    ErrorCodes: $6f131a8b96a87ba3$export$10e8e1cf990558d7,
    ErrorTypeStrings: $6f131a8b96a87ba3$export$795e0ad4a0e2ed30,
    Fragment: $6f131a8b96a87ba3$export$ffb0004e005737fa,
    KeepAlive: $6f131a8b96a87ba3$export$70eb8a58709972df,
    ReactiveEffect: $6f131a8b96a87ba3$export$28352bb4dd362521,
    Static: $6f131a8b96a87ba3$export$c1b9a1d3af45b7b6,
    Suspense: $6f131a8b96a87ba3$export$74bf444e3cd11ea5,
    Teleport: $6f131a8b96a87ba3$export$76d55a0304a371f4,
    Text: $6f131a8b96a87ba3$export$5f1af8db9871e1d6,
    TrackOpTypes: $6f131a8b96a87ba3$export$2ac2bd0a56e04551,
    Transition: $6f131a8b96a87ba3$export$be58926105124dd4,
    TransitionGroup: $6f131a8b96a87ba3$export$19ffa8f511f7bc2e,
    TriggerOpTypes: $6f131a8b96a87ba3$export$1e8941c92696a26,
    VueElement: $6f131a8b96a87ba3$export$b337c1a55163dbe3,
    assertNumber: $6f131a8b96a87ba3$export$dfbcecb440255e4a,
    callWithAsyncErrorHandling: $6f131a8b96a87ba3$export$dae85862a8d94378,
    callWithErrorHandling: $6f131a8b96a87ba3$export$b22fcaf88446e9bf,
    camelize: $6f131a8b96a87ba3$export$161d051f5dd25de7,
    capitalize: $6f131a8b96a87ba3$export$9a00dee1beb8f576,
    cloneVNode: $6f131a8b96a87ba3$export$ee4f9e12c0a92a1a,
    compatUtils: $6f131a8b96a87ba3$export$dc678eddf276286e,
    computed: $6f131a8b96a87ba3$export$2983e091f1a1e8e2,
    createApp: $6f131a8b96a87ba3$export$4e373c34abfa8c68,
    createBlock: $6f131a8b96a87ba3$export$9f2dfe8048dfb22b,
    createCommentVNode: $6f131a8b96a87ba3$export$49553837c7236d3c,
    createElementBlock: $6f131a8b96a87ba3$export$167055419fc69ec1,
    createElementVNode: $6f131a8b96a87ba3$export$42098e0eaa15c48e,
    createHydrationRenderer: $6f131a8b96a87ba3$export$200524cf0d997ff0,
    createPropsRestProxy: $6f131a8b96a87ba3$export$7c343e855c563faa,
    createRenderer: $6f131a8b96a87ba3$export$53ae2f996c64e9a,
    createSSRApp: $6f131a8b96a87ba3$export$35800275c0037383,
    createSlots: $6f131a8b96a87ba3$export$85738f8fcd0a5430,
    createStaticVNode: $6f131a8b96a87ba3$export$33a9f6dd2840e6bb,
    createTextVNode: $6f131a8b96a87ba3$export$22f9b5ffd89dac9,
    createVNode: $6f131a8b96a87ba3$export$bf5c4cf060303d58,
    customRef: $6f131a8b96a87ba3$export$a20c2dd6199824cb,
    defineAsyncComponent: $6f131a8b96a87ba3$export$d75d499b4c16cf21,
    defineComponent: $6f131a8b96a87ba3$export$afa64b67e5a01c3b,
    defineCustomElement: $6f131a8b96a87ba3$export$a00e2346eabbdbef,
    defineEmits: $6f131a8b96a87ba3$export$51ecece22fc17ddc,
    defineExpose: $6f131a8b96a87ba3$export$da25b65ca24b518a,
    defineModel: $6f131a8b96a87ba3$export$acd55aa037e791bb,
    defineOptions: $6f131a8b96a87ba3$export$77e79129327f3d0d,
    defineProps: $6f131a8b96a87ba3$export$80b33eababae110e,
    defineSSRCustomElement: $6f131a8b96a87ba3$export$6debb2e68f212638,
    defineSlots: $6f131a8b96a87ba3$export$1b3acd4bb805b712,
    devtools: $6f131a8b96a87ba3$export$6922d3b3a607469e,
    effect: $6f131a8b96a87ba3$export$dc573d8a6576cdb3,
    effectScope: $6f131a8b96a87ba3$export$7056603ea81600be,
    getCurrentInstance: $6f131a8b96a87ba3$export$f13e630aa3915748,
    getCurrentScope: $6f131a8b96a87ba3$export$c7be4b0125a10cba,
    getCurrentWatcher: $6f131a8b96a87ba3$export$2532f7acfca7c82d,
    getTransitionRawChildren: $6f131a8b96a87ba3$export$a67f9b1229c7c97a,
    guardReactiveProps: $6f131a8b96a87ba3$export$1f1be0e0e384d7d2,
    h: $6f131a8b96a87ba3$export$dda1d9f60106f0e9,
    handleError: $6f131a8b96a87ba3$export$d3da1ecaf1206c58,
    hasInjectionContext: $6f131a8b96a87ba3$export$caf6761f24fc571a,
    hydrate: $6f131a8b96a87ba3$export$fa8d919ba61d84db,
    hydrateOnIdle: $6f131a8b96a87ba3$export$8bfca283fd254627,
    hydrateOnInteraction: $6f131a8b96a87ba3$export$288f5a9b4248e114,
    hydrateOnMediaQuery: $6f131a8b96a87ba3$export$804dbb6002787b74,
    hydrateOnVisible: $6f131a8b96a87ba3$export$2b04cd335e660930,
    initCustomFormatter: $6f131a8b96a87ba3$export$aed4979be6a60047,
    initDirectivesForSSR: $6f131a8b96a87ba3$export$800b28255aa678d9,
    inject: $6f131a8b96a87ba3$export$a976684a0efeb93f,
    isMemoSame: $6f131a8b96a87ba3$export$bf525184d622787c,
    isProxy: $6f131a8b96a87ba3$export$5f3ca29d057519b3,
    isReactive: $6f131a8b96a87ba3$export$352205f445242f02,
    isReadonly: $6f131a8b96a87ba3$export$92d09b48637741e7,
    isRef: $6f131a8b96a87ba3$export$4f9f5282de18fc69,
    isRuntimeOnly: $6f131a8b96a87ba3$export$c93a9c496c5211fa,
    isShallow: $6f131a8b96a87ba3$export$7f3fe6025abfa26e,
    isVNode: $6f131a8b96a87ba3$export$3868d13f8734ae81,
    markRaw: $6f131a8b96a87ba3$export$995ab8b13ad7a9d0,
    mergeDefaults: $6f131a8b96a87ba3$export$ec60f47d4a8a2e7f,
    mergeModels: $6f131a8b96a87ba3$export$ad4f724f587e6828,
    mergeProps: $6f131a8b96a87ba3$export$9d1611c77c2fe928,
    nextTick: $6f131a8b96a87ba3$export$bdd553fddd433dcb,
    nodeOps: $6f131a8b96a87ba3$export$de4fb7f5030605d3,
    normalizeClass: $6f131a8b96a87ba3$export$4f7022d2d68e2c5a,
    normalizeProps: $6f131a8b96a87ba3$export$601abcd8103db5e4,
    normalizeStyle: $6f131a8b96a87ba3$export$8756898546458274,
    onActivated: $6f131a8b96a87ba3$export$ba52d824b95a2154,
    onBeforeMount: $6f131a8b96a87ba3$export$23b7aeb0d671f804,
    onBeforeUnmount: $6f131a8b96a87ba3$export$40c420df62d2614,
    onBeforeUpdate: $6f131a8b96a87ba3$export$ab91988a13872e4c,
    onDeactivated: $6f131a8b96a87ba3$export$bf1440eeaf5fa709,
    onErrorCaptured: $6f131a8b96a87ba3$export$6a3a15856e50ad19,
    onMounted: $6f131a8b96a87ba3$export$6d1641039221b5cb,
    onRenderTracked: $6f131a8b96a87ba3$export$2b41f4235363e921,
    onRenderTriggered: $6f131a8b96a87ba3$export$898295a813d662eb,
    onScopeDispose: $6f131a8b96a87ba3$export$a780418acd4762da,
    onServerPrefetch: $6f131a8b96a87ba3$export$ebf0c601f267bceb,
    onUnmounted: $6f131a8b96a87ba3$export$13348a43ccacfe58,
    onUpdated: $6f131a8b96a87ba3$export$5876c47052fb88b1,
    onWatcherCleanup: $6f131a8b96a87ba3$export$8ddeeb083684a9d0,
    openBlock: $6f131a8b96a87ba3$export$e7eaa45e502fe5cc,
    patchProp: $6f131a8b96a87ba3$export$cd4aa0842d13df8b,
    popScopeId: $6f131a8b96a87ba3$export$f2dc6805dc11834e,
    provide: $6f131a8b96a87ba3$export$abe1e183e22e10ad,
    proxyRefs: $6f131a8b96a87ba3$export$f353fd1b97db3fa0,
    pushScopeId: $6f131a8b96a87ba3$export$ac020265ca2cc4cd,
    queuePostFlushCb: $6f131a8b96a87ba3$export$59536a0199721cab,
    reactive: $6f131a8b96a87ba3$export$90a44edba14e47be,
    readonly: $6f131a8b96a87ba3$export$6ec456bd5b7b3c51,
    ref: $6f131a8b96a87ba3$export$eff4d24c3ff7876e,
    registerRuntimeCompiler: $6f131a8b96a87ba3$export$667bb5a67822b941,
    render: $6f131a8b96a87ba3$export$b3890eb0ae9dca99,
    renderList: $6f131a8b96a87ba3$export$4bf387f59bfc6d67,
    renderSlot: $6f131a8b96a87ba3$export$4abee4c34694ada1,
    resolveComponent: $6f131a8b96a87ba3$export$681d65eec9d1d1e8,
    resolveDirective: $6f131a8b96a87ba3$export$a1989e995cd481be,
    resolveDynamicComponent: $6f131a8b96a87ba3$export$b44c564a05ca975,
    resolveFilter: $6f131a8b96a87ba3$export$83cf26e06ea620e1,
    resolveTransitionHooks: $6f131a8b96a87ba3$export$76ac1779589cd824,
    setBlockTracking: $6f131a8b96a87ba3$export$c20bee82f26f1e27,
    setDevtoolsHook: $6f131a8b96a87ba3$export$b0c258b32c26c785,
    setTransitionHooks: $6f131a8b96a87ba3$export$7770a22486565649,
    shallowReactive: $6f131a8b96a87ba3$export$8d81cefd22d22260,
    shallowReadonly: $6f131a8b96a87ba3$export$7c4b5f2b50f09f6b,
    shallowRef: $6f131a8b96a87ba3$export$9b7bc5fe3b17c8b3,
    ssrContextKey: $6f131a8b96a87ba3$export$f2549a27e18acf2d,
    ssrUtils: $6f131a8b96a87ba3$export$a9679033567b336d,
    stop: $6f131a8b96a87ba3$export$fa6813432f753b0d,
    toDisplayString: $6f131a8b96a87ba3$export$b5b1545233b45293,
    toHandlerKey: $6f131a8b96a87ba3$export$8c022799eeaaefcd,
    toHandlers: $6f131a8b96a87ba3$export$2fb94ff667a6a1a,
    toRaw: $6f131a8b96a87ba3$export$ab18938b9fc5f28e,
    toRef: $6f131a8b96a87ba3$export$1f60508e4f47b4b7,
    toRefs: $6f131a8b96a87ba3$export$2e9533675e5e70e0,
    toValue: $6f131a8b96a87ba3$export$30bdcc2218aa9458,
    transformVNodeArgs: $6f131a8b96a87ba3$export$83beccd3afeeb809,
    triggerRef: $6f131a8b96a87ba3$export$f402f86588575ccc,
    unref: $6f131a8b96a87ba3$export$a239a76781616204,
    useAttrs: $6f131a8b96a87ba3$export$75e29435042cd2ea,
    useCssModule: $6f131a8b96a87ba3$export$9300d5b90d56e3d1,
    useCssVars: $6f131a8b96a87ba3$export$ef28b76f07940108,
    useHost: $6f131a8b96a87ba3$export$da5acfe93a94e37d,
    useId: $6f131a8b96a87ba3$export$f680877a34711e37,
    useModel: $6f131a8b96a87ba3$export$fb78bd113157f1a1,
    useSSRContext: $6f131a8b96a87ba3$export$6b1c54dc4befcda,
    useShadowRoot: $6f131a8b96a87ba3$export$64d45095031fa749,
    useSlots: $6f131a8b96a87ba3$export$9203a8e84125433c,
    useTemplateRef: $6f131a8b96a87ba3$export$83a5dbc1f35517ca,
    useTransitionState: $6f131a8b96a87ba3$export$d2a0a1bc267c90f6,
    vModelCheckbox: $6f131a8b96a87ba3$export$8847c2e532b35714,
    vModelDynamic: $6f131a8b96a87ba3$export$5ad5c0e01ff62c5,
    vModelRadio: $6f131a8b96a87ba3$export$b4356c59b38b7aa9,
    vModelSelect: $6f131a8b96a87ba3$export$87d227567b51ca39,
    vModelText: $6f131a8b96a87ba3$export$f1f88689f5728478,
    vShow: $6f131a8b96a87ba3$export$5cb4fcdc6937d7e1,
    version: $6f131a8b96a87ba3$export$83d89fbfd8236492,
    warn: $6f131a8b96a87ba3$export$c106dd0671a0fc2d,
    watch: $6f131a8b96a87ba3$export$3db5d71bdb2d5499,
    watchEffect: $6f131a8b96a87ba3$export$ede35fc0e5500309,
    watchPostEffect: $6f131a8b96a87ba3$export$b7f27ea67102d543,
    watchSyncEffect: $6f131a8b96a87ba3$export$2035654f31b0e555,
    withAsyncContext: $6f131a8b96a87ba3$export$d6d6f7369f1fb104,
    withCtx: $6f131a8b96a87ba3$export$694b237e827a3d23,
    withDefaults: $6f131a8b96a87ba3$export$4df9c0969a9e0160,
    withDirectives: $6f131a8b96a87ba3$export$49729353e7c1e6c5,
    withKeys: $6f131a8b96a87ba3$export$f691a8759658f782,
    withMemo: $6f131a8b96a87ba3$export$2a6d714a4d738ae,
    withModifiers: $6f131a8b96a87ba3$export$26bd3b8e29e6f273,
    withScopeId: $6f131a8b96a87ba3$export$15ba313e13f3dd04
});
let $6f131a8b96a87ba3$var$oI = Symbol(""), $6f131a8b96a87ba3$var$oO = Symbol(""), $6f131a8b96a87ba3$var$oM = Symbol(""), $6f131a8b96a87ba3$var$oP = Symbol(""), $6f131a8b96a87ba3$var$oF = Symbol(""), $6f131a8b96a87ba3$var$oD = Symbol(""), $6f131a8b96a87ba3$var$oL = Symbol(""), $6f131a8b96a87ba3$var$oV = Symbol(""), $6f131a8b96a87ba3$var$o$ = Symbol(""), $6f131a8b96a87ba3$var$oB = Symbol(""), $6f131a8b96a87ba3$var$oj = Symbol(""), $6f131a8b96a87ba3$var$oU = Symbol(""), $6f131a8b96a87ba3$var$oH = Symbol(""), $6f131a8b96a87ba3$var$oq = Symbol(""), $6f131a8b96a87ba3$var$oW = Symbol(""), $6f131a8b96a87ba3$var$oK = Symbol(""), $6f131a8b96a87ba3$var$oz = Symbol(""), $6f131a8b96a87ba3$var$oJ = Symbol(""), $6f131a8b96a87ba3$var$oG = Symbol(""), $6f131a8b96a87ba3$var$oX = Symbol(""), $6f131a8b96a87ba3$var$oQ = Symbol(""), $6f131a8b96a87ba3$var$oZ = Symbol(""), $6f131a8b96a87ba3$var$oY = Symbol(""), $6f131a8b96a87ba3$var$o0 = Symbol(""), $6f131a8b96a87ba3$var$o1 = Symbol(""), $6f131a8b96a87ba3$var$o2 = Symbol(""), $6f131a8b96a87ba3$var$o3 = Symbol(""), $6f131a8b96a87ba3$var$o6 = Symbol(""), $6f131a8b96a87ba3$var$o4 = Symbol(""), $6f131a8b96a87ba3$var$o8 = Symbol(""), $6f131a8b96a87ba3$var$o5 = Symbol(""), $6f131a8b96a87ba3$var$o9 = Symbol(""), $6f131a8b96a87ba3$var$o7 = Symbol(""), $6f131a8b96a87ba3$var$ae = Symbol(""), $6f131a8b96a87ba3$var$at = Symbol(""), $6f131a8b96a87ba3$var$an = Symbol(""), $6f131a8b96a87ba3$var$ar = Symbol(""), $6f131a8b96a87ba3$var$ai = Symbol(""), $6f131a8b96a87ba3$var$al = Symbol(""), $6f131a8b96a87ba3$var$as = {
    [$6f131a8b96a87ba3$var$oI]: "Fragment",
    [$6f131a8b96a87ba3$var$oO]: "Teleport",
    [$6f131a8b96a87ba3$var$oM]: "Suspense",
    [$6f131a8b96a87ba3$var$oP]: "KeepAlive",
    [$6f131a8b96a87ba3$var$oF]: "BaseTransition",
    [$6f131a8b96a87ba3$var$oD]: "openBlock",
    [$6f131a8b96a87ba3$var$oL]: "createBlock",
    [$6f131a8b96a87ba3$var$oV]: "createElementBlock",
    [$6f131a8b96a87ba3$var$o$]: "createVNode",
    [$6f131a8b96a87ba3$var$oB]: "createElementVNode",
    [$6f131a8b96a87ba3$var$oj]: "createCommentVNode",
    [$6f131a8b96a87ba3$var$oU]: "createTextVNode",
    [$6f131a8b96a87ba3$var$oH]: "createStaticVNode",
    [$6f131a8b96a87ba3$var$oq]: "resolveComponent",
    [$6f131a8b96a87ba3$var$oW]: "resolveDynamicComponent",
    [$6f131a8b96a87ba3$var$oK]: "resolveDirective",
    [$6f131a8b96a87ba3$var$oz]: "resolveFilter",
    [$6f131a8b96a87ba3$var$oJ]: "withDirectives",
    [$6f131a8b96a87ba3$var$oG]: "renderList",
    [$6f131a8b96a87ba3$var$oX]: "renderSlot",
    [$6f131a8b96a87ba3$var$oQ]: "createSlots",
    [$6f131a8b96a87ba3$var$oZ]: "toDisplayString",
    [$6f131a8b96a87ba3$var$oY]: "mergeProps",
    [$6f131a8b96a87ba3$var$o0]: "normalizeClass",
    [$6f131a8b96a87ba3$var$o1]: "normalizeStyle",
    [$6f131a8b96a87ba3$var$o2]: "normalizeProps",
    [$6f131a8b96a87ba3$var$o3]: "guardReactiveProps",
    [$6f131a8b96a87ba3$var$o6]: "toHandlers",
    [$6f131a8b96a87ba3$var$o4]: "camelize",
    [$6f131a8b96a87ba3$var$o8]: "capitalize",
    [$6f131a8b96a87ba3$var$o5]: "toHandlerKey",
    [$6f131a8b96a87ba3$var$o9]: "setBlockTracking",
    [$6f131a8b96a87ba3$var$o7]: "pushScopeId",
    [$6f131a8b96a87ba3$var$ae]: "popScopeId",
    [$6f131a8b96a87ba3$var$at]: "withCtx",
    [$6f131a8b96a87ba3$var$an]: "unref",
    [$6f131a8b96a87ba3$var$ar]: "isRef",
    [$6f131a8b96a87ba3$var$ai]: "withMemo",
    [$6f131a8b96a87ba3$var$al]: "isMemoSame"
}, $6f131a8b96a87ba3$var$ao = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function $6f131a8b96a87ba3$var$aa(e1, t, n, r, i, l, s, o = !1, a = !1, c = !1, u = $6f131a8b96a87ba3$var$ao) {
    var d, p, h, f;
    return e1 && (o ? (e1.helper($6f131a8b96a87ba3$var$oD), e1.helper((d = e1.inSSR, p = c, d || p ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV))) : e1.helper((h = e1.inSSR, f = c, h || f ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB)), s && e1.helper($6f131a8b96a87ba3$var$oJ)), {
        type: 13,
        tag: t,
        props: n,
        children: r,
        patchFlag: i,
        dynamicProps: l,
        directives: s,
        isBlock: o,
        disableTracking: a,
        isComponent: c,
        loc: u
    };
}
function $6f131a8b96a87ba3$var$ac(e1, t = $6f131a8b96a87ba3$var$ao) {
    return {
        type: 17,
        loc: t,
        elements: e1
    };
}
function $6f131a8b96a87ba3$var$au(e1, t = $6f131a8b96a87ba3$var$ao) {
    return {
        type: 15,
        loc: t,
        properties: e1
    };
}
function $6f131a8b96a87ba3$var$ad(e1, t) {
    return {
        type: 16,
        loc: $6f131a8b96a87ba3$var$ao,
        key: $6f131a8b96a87ba3$var$w(e1) ? $6f131a8b96a87ba3$var$ap(e1, !0) : e1,
        value: t
    };
}
function $6f131a8b96a87ba3$var$ap(e1, t = !1, n = $6f131a8b96a87ba3$var$ao, r = 0) {
    return {
        type: 4,
        loc: n,
        content: e1,
        isStatic: t,
        constType: t ? 3 : r
    };
}
function $6f131a8b96a87ba3$var$ah(e1, t = $6f131a8b96a87ba3$var$ao) {
    return {
        type: 8,
        loc: t,
        children: e1
    };
}
function $6f131a8b96a87ba3$var$af(e1, t = [], n = $6f131a8b96a87ba3$var$ao) {
    return {
        type: 14,
        loc: n,
        callee: e1,
        arguments: t
    };
}
function $6f131a8b96a87ba3$var$ag(e1, t, n = !1, r = !1, i = $6f131a8b96a87ba3$var$ao) {
    return {
        type: 18,
        params: e1,
        returns: t,
        newline: n,
        isSlot: r,
        loc: i
    };
}
function $6f131a8b96a87ba3$var$am(e1, t, n, r = !0) {
    return {
        type: 19,
        test: e1,
        consequent: t,
        alternate: n,
        newline: r,
        loc: $6f131a8b96a87ba3$var$ao
    };
}
function $6f131a8b96a87ba3$var$ay(e1, { helper: t, removeHelper: n, inSSR: r }) {
    if (!e1.isBlock) {
        var i, l;
        e1.isBlock = !0, n((i = e1.isComponent, r || i ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB)), t($6f131a8b96a87ba3$var$oD), t((l = e1.isComponent, r || l ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV));
    }
}
let $6f131a8b96a87ba3$var$av = new Uint8Array([
    123,
    123
]), $6f131a8b96a87ba3$var$ab = new Uint8Array([
    125,
    125
]);
function $6f131a8b96a87ba3$var$a_(e1) {
    return e1 >= 97 && e1 <= 122 || e1 >= 65 && e1 <= 90;
}
function $6f131a8b96a87ba3$var$aS(e1) {
    return 32 === e1 || 10 === e1 || 9 === e1 || 12 === e1 || 13 === e1;
}
function $6f131a8b96a87ba3$var$ax(e1) {
    return 47 === e1 || 62 === e1 || $6f131a8b96a87ba3$var$aS(e1);
}
function $6f131a8b96a87ba3$var$aC(e1) {
    let t = new Uint8Array(e1.length);
    for(let n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
    return t;
}
let $6f131a8b96a87ba3$var$ak = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
function $6f131a8b96a87ba3$var$aT(e1) {
    throw e1;
}
function $6f131a8b96a87ba3$var$aw(e1) {}
function $6f131a8b96a87ba3$var$aN(e1, t, n, r) {
    let i = SyntaxError(String(`https://vuejs.org/error-reference/#compiler-${e1}`));
    return i.code = e1, i.loc = t, i;
}
let $6f131a8b96a87ba3$var$aA = (e1)=>4 === e1.type && e1.isStatic;
function $6f131a8b96a87ba3$var$aE(e1) {
    switch(e1){
        case "Teleport":
        case "teleport":
            return $6f131a8b96a87ba3$var$oO;
        case "Suspense":
        case "suspense":
            return $6f131a8b96a87ba3$var$oM;
        case "KeepAlive":
        case "keep-alive":
            return $6f131a8b96a87ba3$var$oP;
        case "BaseTransition":
        case "base-transition":
            return $6f131a8b96a87ba3$var$oF;
    }
}
let $6f131a8b96a87ba3$var$aR = /^$|^\d|[^\$\w\xA0-\uFFFF]/, $6f131a8b96a87ba3$var$aI = /[A-Za-z_$\xA0-\uFFFF]/, $6f131a8b96a87ba3$var$aO = /[\.\?\w$\xA0-\uFFFF]/, $6f131a8b96a87ba3$var$aM = /\s+[.[]\s*|\s*[.[]\s+/g, $6f131a8b96a87ba3$var$aP = (e1)=>4 === e1.type ? e1.content : e1.loc.source, $6f131a8b96a87ba3$var$aF = (e1)=>{
    let t = $6f131a8b96a87ba3$var$aP(e1).trim().replace($6f131a8b96a87ba3$var$aM, (e1)=>e1.trim()), n = 0, r = [], i = 0, l = 0, s = null;
    for(let e1 = 0; e1 < t.length; e1++){
        let o = t.charAt(e1);
        switch(n){
            case 0:
                if ("[" === o) r.push(n), n = 1, i++;
                else if ("(" === o) r.push(n), n = 2, l++;
                else if (!(0 === e1 ? $6f131a8b96a87ba3$var$aI : $6f131a8b96a87ba3$var$aO).test(o)) return !1;
                break;
            case 1:
                "'" === o || '"' === o || "`" === o ? (r.push(n), n = 3, s = o) : "[" === o ? i++ : "]" !== o || --i || (n = r.pop());
                break;
            case 2:
                if ("'" === o || '"' === o || "`" === o) r.push(n), n = 3, s = o;
                else if ("(" === o) l++;
                else if (")" === o) {
                    if (e1 === t.length - 1) return !1;
                    --l || (n = r.pop());
                }
                break;
            case 3:
                o === s && (n = r.pop(), s = null);
        }
    }
    return !i && !l;
}, $6f131a8b96a87ba3$var$aD = /^\s*(?:async\s*)?(?:\([^)]*?\)|[\w$_]+)\s*(?::[^=]+)?=>|^\s*(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/;
function $6f131a8b96a87ba3$var$aL(e1, t, n = !1) {
    for(let r = 0; r < e1.props.length; r++){
        let i = e1.props[r];
        if (7 === i.type && (n || i.exp) && ($6f131a8b96a87ba3$var$w(t) ? i.name === t : t.test(i.name))) return i;
    }
}
function $6f131a8b96a87ba3$var$aV(e1, t, n = !1, r = !1) {
    for(let i = 0; i < e1.props.length; i++){
        let l = e1.props[i];
        if (6 === l.type) {
            if (n) continue;
            if (l.name === t && (l.value || r)) return l;
        } else if ("bind" === l.name && (l.exp || r) && $6f131a8b96a87ba3$var$a$(l.arg, t)) return l;
    }
}
function $6f131a8b96a87ba3$var$a$(e1, t) {
    return !!(e1 && $6f131a8b96a87ba3$var$aA(e1) && e1.content === t);
}
function $6f131a8b96a87ba3$var$aB(e1) {
    return 5 === e1.type || 2 === e1.type;
}
function $6f131a8b96a87ba3$var$aj(e1) {
    return 7 === e1.type && "pre" === e1.name;
}
function $6f131a8b96a87ba3$var$aU(e1) {
    return 7 === e1.type && "slot" === e1.name;
}
function $6f131a8b96a87ba3$var$aH(e1) {
    return 1 === e1.type && 3 === e1.tagType;
}
function $6f131a8b96a87ba3$var$aq(e1) {
    return 1 === e1.type && 2 === e1.tagType;
}
let $6f131a8b96a87ba3$var$aW = new Set([
    $6f131a8b96a87ba3$var$o2,
    $6f131a8b96a87ba3$var$o3
]);
function $6f131a8b96a87ba3$var$aK(e1, t = []) {
    if (e1 && !$6f131a8b96a87ba3$var$w(e1) && 14 === e1.type) {
        let n = e1.callee;
        if (!$6f131a8b96a87ba3$var$w(n) && $6f131a8b96a87ba3$var$aW.has(n)) return $6f131a8b96a87ba3$var$aK(e1.arguments[0], t.concat(e1));
    }
    return [
        e1,
        t
    ];
}
function $6f131a8b96a87ba3$var$az(e1, t, n) {
    let r, i;
    if (13 !== e1.type && function(e1, t) {
        var n, r, i;
        if (4 !== t.key.type || "key" !== t.key.content) return !1;
        let l = e1.arguments[2];
        if (l && !$6f131a8b96a87ba3$var$w(l)) {
            let [e1] = $6f131a8b96a87ba3$var$aK(l);
            if (e1 && !$6f131a8b96a87ba3$var$w(e1) && 15 === e1.type && $6f131a8b96a87ba3$var$aJ(t, e1)) return !0;
        }
        return (n = e1.arguments)[2] || (n[2] = "{}"), (r = e1.arguments)[3] || (r[3] = "undefined"), (i = e1.arguments)[4] || (i[4] = "undefined"), e1.arguments[5] = t.value, !0;
    }(e1, t)) return;
    let l = 13 === e1.type ? e1.props : e1.arguments[2], s = [];
    if (l && !$6f131a8b96a87ba3$var$w(l) && 14 === l.type) {
        let e1 = $6f131a8b96a87ba3$var$aK(l);
        l = e1[0], i = (s = e1[1])[s.length - 1];
    }
    if (null == l || $6f131a8b96a87ba3$var$w(l)) r = $6f131a8b96a87ba3$var$au([
        t
    ]);
    else if (14 === l.type) {
        let e1 = l.arguments[0];
        $6f131a8b96a87ba3$var$w(e1) || 15 !== e1.type ? l.callee === $6f131a8b96a87ba3$var$o6 ? r = $6f131a8b96a87ba3$var$af(n.helper($6f131a8b96a87ba3$var$oY), [
            $6f131a8b96a87ba3$var$au([
                t
            ]),
            l
        ]) : l.arguments.unshift($6f131a8b96a87ba3$var$au([
            t
        ])) : $6f131a8b96a87ba3$var$aJ(t, e1) || e1.properties.unshift(t), r || (r = l);
    } else 15 === l.type ? ($6f131a8b96a87ba3$var$aJ(t, l) || l.properties.unshift(t), r = l) : (r = $6f131a8b96a87ba3$var$af(n.helper($6f131a8b96a87ba3$var$oY), [
        $6f131a8b96a87ba3$var$au([
            t
        ]),
        l
    ]), i && i.callee === $6f131a8b96a87ba3$var$o3 && (i = s[s.length - 2]));
    13 === e1.type ? i ? i.arguments[0] = r : e1.props = r : i ? i.arguments[0] = r : e1.arguments[2] = r;
}
function $6f131a8b96a87ba3$var$aJ(e1, t) {
    let n = !1;
    if (4 === e1.key.type) {
        let r = e1.key.content;
        n = t.properties.some((e1)=>4 === e1.key.type && e1.key.content === r);
    }
    return n;
}
function $6f131a8b96a87ba3$var$aG(e1, t) {
    return `_${t}_${e1.replace(/[^\w]/g, (t, n)=>"-" === t ? "_" : e1.charCodeAt(n).toString())}`;
}
let $6f131a8b96a87ba3$var$aX = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
function $6f131a8b96a87ba3$var$aQ(e1) {
    for(let t = 0; t < e1.length; t++)if (!$6f131a8b96a87ba3$var$aS(e1.charCodeAt(t))) return !1;
    return !0;
}
function $6f131a8b96a87ba3$var$aZ(e1) {
    return 2 === e1.type && $6f131a8b96a87ba3$var$aQ(e1.content) || 12 === e1.type && $6f131a8b96a87ba3$var$aZ(e1.content);
}
function $6f131a8b96a87ba3$var$aY(e1) {
    return 3 === e1.type || $6f131a8b96a87ba3$var$aZ(e1);
}
let $6f131a8b96a87ba3$var$a0 = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        "{{",
        "}}"
    ],
    getNamespace: ()=>0,
    isVoidTag: $6f131a8b96a87ba3$var$y,
    isPreTag: $6f131a8b96a87ba3$var$y,
    isIgnoreNewlineTag: $6f131a8b96a87ba3$var$y,
    isCustomElement: $6f131a8b96a87ba3$var$y,
    onError: $6f131a8b96a87ba3$var$aT,
    onWarn: $6f131a8b96a87ba3$var$aw,
    comments: !1,
    prefixIdentifiers: !1
}, $6f131a8b96a87ba3$var$a1 = $6f131a8b96a87ba3$var$a0, $6f131a8b96a87ba3$var$a2 = null, $6f131a8b96a87ba3$var$a3 = "", $6f131a8b96a87ba3$var$a6 = null, $6f131a8b96a87ba3$var$a4 = null, $6f131a8b96a87ba3$var$a8 = "", $6f131a8b96a87ba3$var$a5 = -1, $6f131a8b96a87ba3$var$a9 = -1, $6f131a8b96a87ba3$var$a7 = 0, $6f131a8b96a87ba3$var$ce = !1, $6f131a8b96a87ba3$var$ct = null, $6f131a8b96a87ba3$var$cn = [], $6f131a8b96a87ba3$var$cr = new class {
    constructor(e1, t){
        this.stack = e1, this.cbs = t, this.state = 1, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = 1, this.inRCDATA = !1, this.inXML = !1, this.inVPre = !1, this.newlines = [], this.mode = 0, this.delimiterOpen = $6f131a8b96a87ba3$var$av, this.delimiterClose = $6f131a8b96a87ba3$var$ab, this.delimiterIndex = -1, this.currentSequence = void 0, this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return 2 === this.mode && 0 === this.stack.length;
    }
    reset() {
        this.state = 1, this.mode = 0, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = 1, this.inRCDATA = !1, this.currentSequence = void 0, this.newlines.length = 0, this.delimiterOpen = $6f131a8b96a87ba3$var$av, this.delimiterClose = $6f131a8b96a87ba3$var$ab;
    }
    getPos(e1) {
        let t = 1, n = e1 + 1, r = this.newlines.length, i = -1;
        if (r > 100) {
            let t = -1, n = r;
            for(; t + 1 < n;){
                let r = t + n >>> 1;
                this.newlines[r] < e1 ? t = r : n = r;
            }
            i = t;
        } else for(let t = r - 1; t >= 0; t--)if (e1 > this.newlines[t]) {
            i = t;
            break;
        }
        return i >= 0 && (t = i + 2, n = e1 - this.newlines[i]), {
            column: n,
            line: t,
            offset: e1
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(e1) {
        60 === e1 ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = 5, this.sectionStart = this.index) : this.inVPre || e1 !== this.delimiterOpen[0] || (this.state = 2, this.delimiterIndex = 0, this.stateInterpolationOpen(e1));
    }
    stateInterpolationOpen(e1) {
        if (e1 === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                let e1 = this.index + 1 - this.delimiterOpen.length;
                e1 > this.sectionStart && this.cbs.ontext(this.sectionStart, e1), this.state = 3, this.sectionStart = e1;
            } else this.delimiterIndex++;
        } else this.inRCDATA ? (this.state = 32, this.stateInRCDATA(e1)) : (this.state = 1, this.stateText(e1));
    }
    stateInterpolation(e1) {
        e1 === this.delimiterClose[0] && (this.state = 4, this.delimiterIndex = 0, this.stateInterpolationClose(e1));
    }
    stateInterpolationClose(e1) {
        e1 === this.delimiterClose[this.delimiterIndex] ? this.delimiterIndex === this.delimiterClose.length - 1 ? (this.cbs.oninterpolation(this.sectionStart, this.index + 1), this.inRCDATA ? this.state = 32 : this.state = 1, this.sectionStart = this.index + 1) : this.delimiterIndex++ : (this.state = 3, this.stateInterpolation(e1));
    }
    stateSpecialStartSequence(e1) {
        let t = this.sequenceIndex === this.currentSequence.length;
        if (t ? $6f131a8b96a87ba3$var$ax(e1) : (32 | e1) === this.currentSequence[this.sequenceIndex]) {
            if (!t) return void this.sequenceIndex++;
        } else this.inRCDATA = !1;
        this.sequenceIndex = 0, this.state = 6, this.stateInTagName(e1);
    }
    stateInRCDATA(e1) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (62 === e1 || $6f131a8b96a87ba3$var$aS(e1)) {
                let t = this.index - this.currentSequence.length;
                if (this.sectionStart < t) {
                    let e1 = this.index;
                    this.index = t, this.cbs.ontext(this.sectionStart, t), this.index = e1;
                }
                this.sectionStart = t + 2, this.stateInClosingTagName(e1), this.inRCDATA = !1;
                return;
            }
            this.sequenceIndex = 0;
        }
        (32 | e1) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : 0 === this.sequenceIndex ? this.currentSequence !== $6f131a8b96a87ba3$var$ak.TitleEnd && (this.currentSequence !== $6f131a8b96a87ba3$var$ak.TextareaEnd || this.inSFCRoot) ? this.fastForwardTo(60) && (this.sequenceIndex = 1) : this.inVPre || e1 !== this.delimiterOpen[0] || (this.state = 2, this.delimiterIndex = 0, this.stateInterpolationOpen(e1)) : this.sequenceIndex = Number(60 === e1);
    }
    stateCDATASequence(e1) {
        e1 === $6f131a8b96a87ba3$var$ak.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === $6f131a8b96a87ba3$var$ak.Cdata.length && (this.state = 28, this.currentSequence = $6f131a8b96a87ba3$var$ak.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = 23, this.stateInDeclaration(e1));
    }
    fastForwardTo(e1) {
        for(; ++this.index < this.buffer.length;){
            let t = this.buffer.charCodeAt(this.index);
            if (10 === t && this.newlines.push(this.index), t === e1) return !0;
        }
        return this.index = this.buffer.length - 1, !1;
    }
    stateInCommentLike(e1) {
        e1 === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === $6f131a8b96a87ba3$var$ak.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index - 2) : this.cbs.oncomment(this.sectionStart, this.index - 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = 1) : 0 === this.sequenceIndex ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e1 !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
    }
    startSpecial(e1, t) {
        this.enterRCDATA(e1, t), this.state = 31;
    }
    enterRCDATA(e1, t) {
        this.inRCDATA = !0, this.currentSequence = e1, this.sequenceIndex = t;
    }
    stateBeforeTagName(e1) {
        33 === e1 ? (this.state = 22, this.sectionStart = this.index + 1) : 63 === e1 ? (this.state = 24, this.sectionStart = this.index + 1) : $6f131a8b96a87ba3$var$a_(e1) ? (this.sectionStart = this.index, 0 === this.mode ? this.state = 6 : this.inSFCRoot ? this.state = 34 : this.inXML ? this.state = 6 : 116 === e1 ? this.state = 30 : this.state = 115 === e1 ? 29 : 6) : 47 === e1 ? this.state = 8 : (this.state = 1, this.stateText(e1));
    }
    stateInTagName(e1) {
        $6f131a8b96a87ba3$var$ax(e1) && this.handleTagName(e1);
    }
    stateInSFCRootTagName(e1) {
        if ($6f131a8b96a87ba3$var$ax(e1)) {
            let t = this.buffer.slice(this.sectionStart, this.index);
            "template" !== t && this.enterRCDATA($6f131a8b96a87ba3$var$aC("</" + t), 0), this.handleTagName(e1);
        }
    }
    handleTagName(e1) {
        this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = 11, this.stateBeforeAttrName(e1);
    }
    stateBeforeClosingTagName(e1) {
        $6f131a8b96a87ba3$var$aS(e1) || (62 === e1 ? (this.state = 1, this.sectionStart = this.index + 1) : (this.state = $6f131a8b96a87ba3$var$a_(e1) ? 9 : 27, this.sectionStart = this.index));
    }
    stateInClosingTagName(e1) {
        (62 === e1 || $6f131a8b96a87ba3$var$aS(e1)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = 10, this.stateAfterClosingTagName(e1));
    }
    stateAfterClosingTagName(e1) {
        62 === e1 && (this.state = 1, this.sectionStart = this.index + 1);
    }
    stateBeforeAttrName(e1) {
        62 === e1 ? (this.cbs.onopentagend(this.index), this.inRCDATA ? this.state = 32 : this.state = 1, this.sectionStart = this.index + 1) : 47 === e1 ? this.state = 7 : 60 === e1 && 47 === this.peek() ? (this.cbs.onopentagend(this.index), this.state = 5, this.sectionStart = this.index) : $6f131a8b96a87ba3$var$aS(e1) || this.handleAttrStart(e1);
    }
    handleAttrStart(e1) {
        118 === e1 && 45 === this.peek() ? (this.state = 13, this.sectionStart = this.index) : 46 === e1 || 58 === e1 || 64 === e1 || 35 === e1 ? (this.cbs.ondirname(this.index, this.index + 1), this.state = 14, this.sectionStart = this.index + 1) : (this.state = 12, this.sectionStart = this.index);
    }
    stateInSelfClosingTag(e1) {
        62 === e1 ? (this.cbs.onselfclosingtag(this.index), this.state = 1, this.sectionStart = this.index + 1, this.inRCDATA = !1) : $6f131a8b96a87ba3$var$aS(e1) || (this.state = 11, this.stateBeforeAttrName(e1));
    }
    stateInAttrName(e1) {
        (61 === e1 || $6f131a8b96a87ba3$var$ax(e1)) && (this.cbs.onattribname(this.sectionStart, this.index), this.handleAttrNameEnd(e1));
    }
    stateInDirName(e1) {
        61 === e1 || $6f131a8b96a87ba3$var$ax(e1) ? (this.cbs.ondirname(this.sectionStart, this.index), this.handleAttrNameEnd(e1)) : 58 === e1 ? (this.cbs.ondirname(this.sectionStart, this.index), this.state = 14, this.sectionStart = this.index + 1) : 46 === e1 && (this.cbs.ondirname(this.sectionStart, this.index), this.state = 16, this.sectionStart = this.index + 1);
    }
    stateInDirArg(e1) {
        61 === e1 || $6f131a8b96a87ba3$var$ax(e1) ? (this.cbs.ondirarg(this.sectionStart, this.index), this.handleAttrNameEnd(e1)) : 91 === e1 ? this.state = 15 : 46 === e1 && (this.cbs.ondirarg(this.sectionStart, this.index), this.state = 16, this.sectionStart = this.index + 1);
    }
    stateInDynamicDirArg(e1) {
        93 === e1 ? this.state = 14 : (61 === e1 || $6f131a8b96a87ba3$var$ax(e1)) && (this.cbs.ondirarg(this.sectionStart, this.index + 1), this.handleAttrNameEnd(e1));
    }
    stateInDirModifier(e1) {
        61 === e1 || $6f131a8b96a87ba3$var$ax(e1) ? (this.cbs.ondirmodifier(this.sectionStart, this.index), this.handleAttrNameEnd(e1)) : 46 === e1 && (this.cbs.ondirmodifier(this.sectionStart, this.index), this.sectionStart = this.index + 1);
    }
    handleAttrNameEnd(e1) {
        this.sectionStart = this.index, this.state = 17, this.cbs.onattribnameend(this.index), this.stateAfterAttrName(e1);
    }
    stateAfterAttrName(e1) {
        61 === e1 ? this.state = 18 : 47 === e1 || 62 === e1 ? (this.cbs.onattribend(0, this.sectionStart), this.sectionStart = -1, this.state = 11, this.stateBeforeAttrName(e1)) : $6f131a8b96a87ba3$var$aS(e1) || (this.cbs.onattribend(0, this.sectionStart), this.handleAttrStart(e1));
    }
    stateBeforeAttrValue(e1) {
        34 === e1 ? (this.state = 19, this.sectionStart = this.index + 1) : 39 === e1 ? (this.state = 20, this.sectionStart = this.index + 1) : $6f131a8b96a87ba3$var$aS(e1) || (this.sectionStart = this.index, this.state = 21, this.stateInAttrValueNoQuotes(e1));
    }
    handleInAttrValue(e1, t) {
        (e1 === t || this.fastForwardTo(t)) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(34 === t ? 3 : 2, this.index + 1), this.state = 11);
    }
    stateInAttrValueDoubleQuotes(e1) {
        this.handleInAttrValue(e1, 34);
    }
    stateInAttrValueSingleQuotes(e1) {
        this.handleInAttrValue(e1, 39);
    }
    stateInAttrValueNoQuotes(e1) {
        $6f131a8b96a87ba3$var$aS(e1) || 62 === e1 ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(1, this.index), this.state = 11, this.stateBeforeAttrName(e1)) : (39 === e1 || 60 === e1 || 61 === e1 || 96 === e1) && this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(e1) {
        91 === e1 ? (this.state = 26, this.sequenceIndex = 0) : this.state = 45 === e1 ? 25 : 23;
    }
    stateInDeclaration(e1) {
        (62 === e1 || this.fastForwardTo(62)) && (this.state = 1, this.sectionStart = this.index + 1);
    }
    stateInProcessingInstruction(e1) {
        (62 === e1 || this.fastForwardTo(62)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = 1, this.sectionStart = this.index + 1);
    }
    stateBeforeComment(e1) {
        45 === e1 ? (this.state = 28, this.currentSequence = $6f131a8b96a87ba3$var$ak.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = 23;
    }
    stateInSpecialComment(e1) {
        (62 === e1 || this.fastForwardTo(62)) && (this.cbs.oncomment(this.sectionStart, this.index), this.state = 1, this.sectionStart = this.index + 1);
    }
    stateBeforeSpecialS(e1) {
        e1 === $6f131a8b96a87ba3$var$ak.ScriptEnd[3] ? this.startSpecial($6f131a8b96a87ba3$var$ak.ScriptEnd, 4) : e1 === $6f131a8b96a87ba3$var$ak.StyleEnd[3] ? this.startSpecial($6f131a8b96a87ba3$var$ak.StyleEnd, 4) : (this.state = 6, this.stateInTagName(e1));
    }
    stateBeforeSpecialT(e1) {
        e1 === $6f131a8b96a87ba3$var$ak.TitleEnd[3] ? this.startSpecial($6f131a8b96a87ba3$var$ak.TitleEnd, 4) : e1 === $6f131a8b96a87ba3$var$ak.TextareaEnd[3] ? this.startSpecial($6f131a8b96a87ba3$var$ak.TextareaEnd, 4) : (this.state = 6, this.stateInTagName(e1));
    }
    startEntity() {}
    stateInEntity() {}
    parse(e1) {
        for(this.buffer = e1; this.index < this.buffer.length;){
            let e1 = this.buffer.charCodeAt(this.index);
            switch(10 === e1 && 33 !== this.state && this.newlines.push(this.index), this.state){
                case 1:
                    this.stateText(e1);
                    break;
                case 2:
                    this.stateInterpolationOpen(e1);
                    break;
                case 3:
                    this.stateInterpolation(e1);
                    break;
                case 4:
                    this.stateInterpolationClose(e1);
                    break;
                case 31:
                    this.stateSpecialStartSequence(e1);
                    break;
                case 32:
                    this.stateInRCDATA(e1);
                    break;
                case 26:
                    this.stateCDATASequence(e1);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(e1);
                    break;
                case 12:
                    this.stateInAttrName(e1);
                    break;
                case 13:
                    this.stateInDirName(e1);
                    break;
                case 14:
                    this.stateInDirArg(e1);
                    break;
                case 15:
                    this.stateInDynamicDirArg(e1);
                    break;
                case 16:
                    this.stateInDirModifier(e1);
                    break;
                case 28:
                    this.stateInCommentLike(e1);
                    break;
                case 27:
                    this.stateInSpecialComment(e1);
                    break;
                case 11:
                    this.stateBeforeAttrName(e1);
                    break;
                case 6:
                    this.stateInTagName(e1);
                    break;
                case 34:
                    this.stateInSFCRootTagName(e1);
                    break;
                case 9:
                    this.stateInClosingTagName(e1);
                    break;
                case 5:
                    this.stateBeforeTagName(e1);
                    break;
                case 17:
                    this.stateAfterAttrName(e1);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(e1);
                    break;
                case 18:
                    this.stateBeforeAttrValue(e1);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(e1);
                    break;
                case 10:
                    this.stateAfterClosingTagName(e1);
                    break;
                case 29:
                    this.stateBeforeSpecialS(e1);
                    break;
                case 30:
                    this.stateBeforeSpecialT(e1);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(e1);
                    break;
                case 7:
                    this.stateInSelfClosingTag(e1);
                    break;
                case 23:
                    this.stateInDeclaration(e1);
                    break;
                case 22:
                    this.stateBeforeDeclaration(e1);
                    break;
                case 25:
                    this.stateBeforeComment(e1);
                    break;
                case 24:
                    this.stateInProcessingInstruction(e1);
                    break;
                case 33:
                    this.stateInEntity();
            }
            this.index++;
        }
        this.cleanup(), this.finish();
    }
    cleanup() {
        this.sectionStart !== this.index && (1 === this.state || 32 === this.state && 0 === this.sequenceIndex ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (19 === this.state || 20 === this.state || 21 === this.state) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
    }
    finish() {
        this.handleTrailingData(), this.cbs.onend();
    }
    handleTrailingData() {
        let e1 = this.buffer.length;
        this.sectionStart >= e1 || (28 === this.state ? this.currentSequence === $6f131a8b96a87ba3$var$ak.CdataEnd ? this.cbs.oncdata(this.sectionStart, e1) : this.cbs.oncomment(this.sectionStart, e1) : 6 === this.state || 11 === this.state || 18 === this.state || 17 === this.state || 12 === this.state || 13 === this.state || 14 === this.state || 15 === this.state || 16 === this.state || 20 === this.state || 19 === this.state || 21 === this.state || 9 === this.state || this.cbs.ontext(this.sectionStart, e1));
    }
    emitCodePoint(e1, t) {}
}($6f131a8b96a87ba3$var$cn, {
    onerr: $6f131a8b96a87ba3$var$cb,
    ontext (e1, t) {
        $6f131a8b96a87ba3$var$ca($6f131a8b96a87ba3$var$cs(e1, t), e1, t);
    },
    ontextentity (e1, t, n) {
        $6f131a8b96a87ba3$var$ca(e1, t, n);
    },
    oninterpolation (e1, t) {
        if ($6f131a8b96a87ba3$var$ce) return $6f131a8b96a87ba3$var$ca($6f131a8b96a87ba3$var$cs(e1, t), e1, t);
        let n = e1 + $6f131a8b96a87ba3$var$cr.delimiterOpen.length, r = t - $6f131a8b96a87ba3$var$cr.delimiterClose.length;
        for(; $6f131a8b96a87ba3$var$aS($6f131a8b96a87ba3$var$a3.charCodeAt(n));)n++;
        for(; $6f131a8b96a87ba3$var$aS($6f131a8b96a87ba3$var$a3.charCodeAt(r - 1));)r--;
        let i = $6f131a8b96a87ba3$var$cs(n, r);
        i.includes("&") && (i = $6f131a8b96a87ba3$var$a1.decodeEntities(i, !1)), $6f131a8b96a87ba3$var$cg({
            type: 5,
            content: $6f131a8b96a87ba3$var$cv(i, !1, $6f131a8b96a87ba3$var$cm(n, r)),
            loc: $6f131a8b96a87ba3$var$cm(e1, t)
        });
    },
    onopentagname (e1, t) {
        let n = $6f131a8b96a87ba3$var$cs(e1, t);
        $6f131a8b96a87ba3$var$a6 = {
            type: 1,
            tag: n,
            ns: $6f131a8b96a87ba3$var$a1.getNamespace(n, $6f131a8b96a87ba3$var$cn[0], $6f131a8b96a87ba3$var$a1.ns),
            tagType: 0,
            props: [],
            children: [],
            loc: $6f131a8b96a87ba3$var$cm(e1 - 1, t),
            codegenNode: void 0
        };
    },
    onopentagend (e1) {
        $6f131a8b96a87ba3$var$co(e1);
    },
    onclosetag (e1, t) {
        let n = $6f131a8b96a87ba3$var$cs(e1, t);
        if (!$6f131a8b96a87ba3$var$a1.isVoidTag(n)) {
            let r = !1;
            for(let e1 = 0; e1 < $6f131a8b96a87ba3$var$cn.length; e1++)if ($6f131a8b96a87ba3$var$cn[e1].tag.toLowerCase() === n.toLowerCase()) {
                r = !0, e1 > 0 && $6f131a8b96a87ba3$var$cn[0].loc.start.offset;
                for(let n = 0; n <= e1; n++)$6f131a8b96a87ba3$var$cc($6f131a8b96a87ba3$var$cn.shift(), t, n < e1);
                break;
            }
            r || $6f131a8b96a87ba3$var$cu(e1, 60);
        }
    },
    onselfclosingtag (e1) {
        let t = $6f131a8b96a87ba3$var$a6.tag;
        $6f131a8b96a87ba3$var$a6.isSelfClosing = !0, $6f131a8b96a87ba3$var$co(e1), $6f131a8b96a87ba3$var$cn[0] && $6f131a8b96a87ba3$var$cn[0].tag === t && $6f131a8b96a87ba3$var$cc($6f131a8b96a87ba3$var$cn.shift(), e1);
    },
    onattribname (e1, t) {
        $6f131a8b96a87ba3$var$a4 = {
            type: 6,
            name: $6f131a8b96a87ba3$var$cs(e1, t),
            nameLoc: $6f131a8b96a87ba3$var$cm(e1, t),
            value: void 0,
            loc: $6f131a8b96a87ba3$var$cm(e1)
        };
    },
    ondirname (e1, t) {
        let n = $6f131a8b96a87ba3$var$cs(e1, t), r = "." === n || ":" === n ? "bind" : "@" === n ? "on" : "#" === n ? "slot" : n.slice(2);
        if ($6f131a8b96a87ba3$var$ce || "" === r) $6f131a8b96a87ba3$var$a4 = {
            type: 6,
            name: n,
            nameLoc: $6f131a8b96a87ba3$var$cm(e1, t),
            value: void 0,
            loc: $6f131a8b96a87ba3$var$cm(e1)
        };
        else if ($6f131a8b96a87ba3$var$a4 = {
            type: 7,
            name: r,
            rawName: n,
            exp: void 0,
            arg: void 0,
            modifiers: "." === n ? [
                $6f131a8b96a87ba3$var$ap("prop")
            ] : [],
            loc: $6f131a8b96a87ba3$var$cm(e1)
        }, "pre" === r) {
            $6f131a8b96a87ba3$var$ce = $6f131a8b96a87ba3$var$cr.inVPre = !0, $6f131a8b96a87ba3$var$ct = $6f131a8b96a87ba3$var$a6;
            let e1 = $6f131a8b96a87ba3$var$a6.props;
            for(let t = 0; t < e1.length; t++)7 === e1[t].type && (e1[t] = function(e1) {
                let t = {
                    type: 6,
                    name: e1.rawName,
                    nameLoc: $6f131a8b96a87ba3$var$cm(e1.loc.start.offset, e1.loc.start.offset + e1.rawName.length),
                    value: void 0,
                    loc: e1.loc
                };
                if (e1.exp) {
                    let n = e1.exp.loc;
                    n.end.offset < e1.loc.end.offset && (n.start.offset--, n.start.column--, n.end.offset++, n.end.column++), t.value = {
                        type: 2,
                        content: e1.exp.content,
                        loc: n
                    };
                }
                return t;
            }(e1[t]));
        }
    },
    ondirarg (e1, t) {
        if (e1 === t) return;
        let n = $6f131a8b96a87ba3$var$cs(e1, t);
        if ($6f131a8b96a87ba3$var$ce && !$6f131a8b96a87ba3$var$aj($6f131a8b96a87ba3$var$a4)) $6f131a8b96a87ba3$var$a4.name += n, $6f131a8b96a87ba3$var$cy($6f131a8b96a87ba3$var$a4.nameLoc, t);
        else {
            let r = "[" !== n[0];
            $6f131a8b96a87ba3$var$a4.arg = $6f131a8b96a87ba3$var$cv(r ? n : n.slice(1, -1), r, $6f131a8b96a87ba3$var$cm(e1, t), 3 * !!r);
        }
    },
    ondirmodifier (e1, t) {
        let n = $6f131a8b96a87ba3$var$cs(e1, t);
        if ($6f131a8b96a87ba3$var$ce && !$6f131a8b96a87ba3$var$aj($6f131a8b96a87ba3$var$a4)) $6f131a8b96a87ba3$var$a4.name += "." + n, $6f131a8b96a87ba3$var$cy($6f131a8b96a87ba3$var$a4.nameLoc, t);
        else if ("slot" === $6f131a8b96a87ba3$var$a4.name) {
            let e1 = $6f131a8b96a87ba3$var$a4.arg;
            e1 && (e1.content += "." + n, $6f131a8b96a87ba3$var$cy(e1.loc, t));
        } else {
            let r = $6f131a8b96a87ba3$var$ap(n, !0, $6f131a8b96a87ba3$var$cm(e1, t));
            $6f131a8b96a87ba3$var$a4.modifiers.push(r);
        }
    },
    onattribdata (e1, t) {
        $6f131a8b96a87ba3$var$a8 += $6f131a8b96a87ba3$var$cs(e1, t), $6f131a8b96a87ba3$var$a5 < 0 && ($6f131a8b96a87ba3$var$a5 = e1), $6f131a8b96a87ba3$var$a9 = t;
    },
    onattribentity (e1, t, n) {
        $6f131a8b96a87ba3$var$a8 += e1, $6f131a8b96a87ba3$var$a5 < 0 && ($6f131a8b96a87ba3$var$a5 = t), $6f131a8b96a87ba3$var$a9 = n;
    },
    onattribnameend (e1) {
        let t = $6f131a8b96a87ba3$var$cs($6f131a8b96a87ba3$var$a4.loc.start.offset, e1);
        7 === $6f131a8b96a87ba3$var$a4.type && ($6f131a8b96a87ba3$var$a4.rawName = t), $6f131a8b96a87ba3$var$a6.props.some((e1)=>(7 === e1.type ? e1.rawName : e1.name) === t);
    },
    onattribend (e1, t) {
        $6f131a8b96a87ba3$var$a6 && $6f131a8b96a87ba3$var$a4 && ($6f131a8b96a87ba3$var$cy($6f131a8b96a87ba3$var$a4.loc, t), 0 !== e1 && ($6f131a8b96a87ba3$var$a8.includes("&") && ($6f131a8b96a87ba3$var$a8 = $6f131a8b96a87ba3$var$a1.decodeEntities($6f131a8b96a87ba3$var$a8, !0)), 6 === $6f131a8b96a87ba3$var$a4.type ? ("class" === $6f131a8b96a87ba3$var$a4.name && ($6f131a8b96a87ba3$var$a8 = $6f131a8b96a87ba3$var$cf($6f131a8b96a87ba3$var$a8).trim()), $6f131a8b96a87ba3$var$a4.value = {
            type: 2,
            content: $6f131a8b96a87ba3$var$a8,
            loc: 1 === e1 ? $6f131a8b96a87ba3$var$cm($6f131a8b96a87ba3$var$a5, $6f131a8b96a87ba3$var$a9) : $6f131a8b96a87ba3$var$cm($6f131a8b96a87ba3$var$a5 - 1, $6f131a8b96a87ba3$var$a9 + 1)
        }, $6f131a8b96a87ba3$var$cr.inSFCRoot && "template" === $6f131a8b96a87ba3$var$a6.tag && "lang" === $6f131a8b96a87ba3$var$a4.name && $6f131a8b96a87ba3$var$a8 && "html" !== $6f131a8b96a87ba3$var$a8 && $6f131a8b96a87ba3$var$cr.enterRCDATA($6f131a8b96a87ba3$var$aC("</template"), 0)) : ($6f131a8b96a87ba3$var$a4.exp = $6f131a8b96a87ba3$var$cv($6f131a8b96a87ba3$var$a8, !1, $6f131a8b96a87ba3$var$cm($6f131a8b96a87ba3$var$a5, $6f131a8b96a87ba3$var$a9), 0, 0), "for" === $6f131a8b96a87ba3$var$a4.name && ($6f131a8b96a87ba3$var$a4.forParseResult = function(e1) {
            let t = e1.loc, n = e1.content, r = n.match($6f131a8b96a87ba3$var$aX);
            if (!r) return;
            let [, i, l] = r, s = (e1, n, r = !1)=>{
                let i = t.start.offset + n, l = i + e1.length;
                return $6f131a8b96a87ba3$var$cv(e1, !1, $6f131a8b96a87ba3$var$cm(i, l), 0, +!!r);
            }, o = {
                source: s(l.trim(), n.indexOf(l, i.length)),
                value: void 0,
                key: void 0,
                index: void 0,
                finalized: !1
            }, a = i.trim().replace($6f131a8b96a87ba3$var$cl, "").trim(), c = i.indexOf(a), u = a.match($6f131a8b96a87ba3$var$ci);
            if (u) {
                let e1;
                a = a.replace($6f131a8b96a87ba3$var$ci, "").trim();
                let t = u[1].trim();
                if (t && (e1 = n.indexOf(t, c + a.length), o.key = s(t, e1, !0)), u[2]) {
                    let r = u[2].trim();
                    r && (o.index = s(r, n.indexOf(r, o.key ? e1 + t.length : c + a.length), !0));
                }
            }
            return a && (o.value = s(a, c, !0)), o;
        }($6f131a8b96a87ba3$var$a4.exp)))), (7 !== $6f131a8b96a87ba3$var$a4.type || "pre" !== $6f131a8b96a87ba3$var$a4.name) && $6f131a8b96a87ba3$var$a6.props.push($6f131a8b96a87ba3$var$a4)), $6f131a8b96a87ba3$var$a8 = "", $6f131a8b96a87ba3$var$a5 = $6f131a8b96a87ba3$var$a9 = -1;
    },
    oncomment (e1, t) {
        $6f131a8b96a87ba3$var$a1.comments && $6f131a8b96a87ba3$var$cg({
            type: 3,
            content: $6f131a8b96a87ba3$var$cs(e1, t),
            loc: $6f131a8b96a87ba3$var$cm(e1 - 4, t + 3)
        });
    },
    onend () {
        let e1 = $6f131a8b96a87ba3$var$a3.length;
        for(let t = 0; t < $6f131a8b96a87ba3$var$cn.length; t++)$6f131a8b96a87ba3$var$cc($6f131a8b96a87ba3$var$cn[t], e1 - 1), $6f131a8b96a87ba3$var$cn[t].loc.start.offset;
    },
    oncdata (e1, t) {
        ($6f131a8b96a87ba3$var$cn[0] ? $6f131a8b96a87ba3$var$cn[0].ns : $6f131a8b96a87ba3$var$a1.ns) !== 0 && $6f131a8b96a87ba3$var$ca($6f131a8b96a87ba3$var$cs(e1, t), e1, t);
    },
    onprocessinginstruction (e1) {
        ($6f131a8b96a87ba3$var$cn[0] ? $6f131a8b96a87ba3$var$cn[0].ns : $6f131a8b96a87ba3$var$a1.ns) === 0 && $6f131a8b96a87ba3$var$cb(21, e1 - 1);
    }
}), $6f131a8b96a87ba3$var$ci = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/, $6f131a8b96a87ba3$var$cl = /^\(|\)$/g;
function $6f131a8b96a87ba3$var$cs(e1, t) {
    return $6f131a8b96a87ba3$var$a3.slice(e1, t);
}
function $6f131a8b96a87ba3$var$co(e1) {
    $6f131a8b96a87ba3$var$cr.inSFCRoot && ($6f131a8b96a87ba3$var$a6.innerLoc = $6f131a8b96a87ba3$var$cm(e1 + 1, e1 + 1)), $6f131a8b96a87ba3$var$cg($6f131a8b96a87ba3$var$a6);
    let { tag: t, ns: n } = $6f131a8b96a87ba3$var$a6;
    0 === n && $6f131a8b96a87ba3$var$a1.isPreTag(t) && $6f131a8b96a87ba3$var$a7++, $6f131a8b96a87ba3$var$a1.isVoidTag(t) ? $6f131a8b96a87ba3$var$cc($6f131a8b96a87ba3$var$a6, e1) : ($6f131a8b96a87ba3$var$cn.unshift($6f131a8b96a87ba3$var$a6), (1 === n || 2 === n) && ($6f131a8b96a87ba3$var$cr.inXML = !0)), $6f131a8b96a87ba3$var$a6 = null;
}
function $6f131a8b96a87ba3$var$ca(e1, t, n) {
    {
        let t = $6f131a8b96a87ba3$var$cn[0] && $6f131a8b96a87ba3$var$cn[0].tag;
        "script" !== t && "style" !== t && e1.includes("&") && (e1 = $6f131a8b96a87ba3$var$a1.decodeEntities(e1, !1));
    }
    let r = $6f131a8b96a87ba3$var$cn[0] || $6f131a8b96a87ba3$var$a2, i = r.children[r.children.length - 1];
    i && 2 === i.type ? (i.content += e1, $6f131a8b96a87ba3$var$cy(i.loc, n)) : r.children.push({
        type: 2,
        content: e1,
        loc: $6f131a8b96a87ba3$var$cm(t, n)
    });
}
function $6f131a8b96a87ba3$var$cc(e1, t, n = !1) {
    n ? $6f131a8b96a87ba3$var$cy(e1.loc, $6f131a8b96a87ba3$var$cu(t, 60)) : $6f131a8b96a87ba3$var$cy(e1.loc, function(e1) {
        let t = e1;
        for(; 62 !== $6f131a8b96a87ba3$var$a3.charCodeAt(t) && t < $6f131a8b96a87ba3$var$a3.length - 1;)t++;
        return t;
    }(t) + 1), $6f131a8b96a87ba3$var$cr.inSFCRoot && (e1.children.length ? e1.innerLoc.end = $6f131a8b96a87ba3$var$_({}, e1.children[e1.children.length - 1].loc.end) : e1.innerLoc.end = $6f131a8b96a87ba3$var$_({}, e1.innerLoc.start), e1.innerLoc.source = $6f131a8b96a87ba3$var$cs(e1.innerLoc.start.offset, e1.innerLoc.end.offset));
    let { tag: r, ns: i, children: l } = e1;
    if (!$6f131a8b96a87ba3$var$ce && ("slot" === r ? e1.tagType = 2 : !function({ tag: e1, props: t }) {
        if ("template" === e1) {
            for(let e1 = 0; e1 < t.length; e1++)if (7 === t[e1].type && $6f131a8b96a87ba3$var$cd.has(t[e1].name)) return !0;
        }
        return !1;
    }(e1) ? function({ tag: e1, props: t }) {
        var n;
        if ($6f131a8b96a87ba3$var$a1.isCustomElement(e1)) return !1;
        if ("component" === e1 || (n = e1.charCodeAt(0)) > 64 && n < 91 || $6f131a8b96a87ba3$var$aE(e1) || $6f131a8b96a87ba3$var$a1.isBuiltInComponent && $6f131a8b96a87ba3$var$a1.isBuiltInComponent(e1) || $6f131a8b96a87ba3$var$a1.isNativeTag && !$6f131a8b96a87ba3$var$a1.isNativeTag(e1)) return !0;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t[e1];
            if (6 === n.type && "is" === n.name && n.value && n.value.content.startsWith("vue:")) return !0;
        }
        return !1;
    }(e1) && (e1.tagType = 1) : e1.tagType = 3), $6f131a8b96a87ba3$var$cr.inRCDATA || (e1.children = $6f131a8b96a87ba3$var$ch(l)), 0 === i && $6f131a8b96a87ba3$var$a1.isIgnoreNewlineTag(r)) {
        let e1 = l[0];
        e1 && 2 === e1.type && (e1.content = e1.content.replace(/^\r?\n/, ""));
    }
    0 === i && $6f131a8b96a87ba3$var$a1.isPreTag(r) && $6f131a8b96a87ba3$var$a7--, $6f131a8b96a87ba3$var$ct === e1 && ($6f131a8b96a87ba3$var$ce = $6f131a8b96a87ba3$var$cr.inVPre = !1, $6f131a8b96a87ba3$var$ct = null), $6f131a8b96a87ba3$var$cr.inXML && ($6f131a8b96a87ba3$var$cn[0] ? $6f131a8b96a87ba3$var$cn[0].ns : $6f131a8b96a87ba3$var$a1.ns) === 0 && ($6f131a8b96a87ba3$var$cr.inXML = !1);
}
function $6f131a8b96a87ba3$var$cu(e1, t) {
    let n = e1;
    for(; $6f131a8b96a87ba3$var$a3.charCodeAt(n) !== t && n >= 0;)n--;
    return n;
}
let $6f131a8b96a87ba3$var$cd = new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]), $6f131a8b96a87ba3$var$cp = /\r\n/g;
function $6f131a8b96a87ba3$var$ch(e1) {
    let t = "preserve" !== $6f131a8b96a87ba3$var$a1.whitespace, n = !1;
    for(let r = 0; r < e1.length; r++){
        let i = e1[r];
        if (2 === i.type) {
            if ($6f131a8b96a87ba3$var$a7) i.content = i.content.replace($6f131a8b96a87ba3$var$cp, `
`);
            else if ($6f131a8b96a87ba3$var$aQ(i.content)) {
                let l = e1[r - 1] && e1[r - 1].type, s = e1[r + 1] && e1[r + 1].type;
                !l || !s || t && (3 === l && (3 === s || 1 === s) || 1 === l && (3 === s || 1 === s && function(e1) {
                    for(let t = 0; t < e1.length; t++){
                        let n = e1.charCodeAt(t);
                        if (10 === n || 13 === n) return !0;
                    }
                    return !1;
                }(i.content))) ? (n = !0, e1[r] = null) : i.content = " ";
            } else t && (i.content = $6f131a8b96a87ba3$var$cf(i.content));
        }
    }
    return n ? e1.filter(Boolean) : e1;
}
function $6f131a8b96a87ba3$var$cf(e1) {
    let t = "", n = !1;
    for(let r = 0; r < e1.length; r++)$6f131a8b96a87ba3$var$aS(e1.charCodeAt(r)) ? n || (t += " ", n = !0) : (t += e1[r], n = !1);
    return t;
}
function $6f131a8b96a87ba3$var$cg(e1) {
    ($6f131a8b96a87ba3$var$cn[0] || $6f131a8b96a87ba3$var$a2).children.push(e1);
}
function $6f131a8b96a87ba3$var$cm(e1, t) {
    return {
        start: $6f131a8b96a87ba3$var$cr.getPos(e1),
        end: null == t ? t : $6f131a8b96a87ba3$var$cr.getPos(t),
        source: null == t ? t : $6f131a8b96a87ba3$var$cs(e1, t)
    };
}
function $6f131a8b96a87ba3$var$cy(e1, t) {
    e1.end = $6f131a8b96a87ba3$var$cr.getPos(t), e1.source = $6f131a8b96a87ba3$var$cs(e1.start.offset, t);
}
function $6f131a8b96a87ba3$var$cv(e1, t = !1, n, r = 0, i = 0) {
    return $6f131a8b96a87ba3$var$ap(e1, t, n, r);
}
function $6f131a8b96a87ba3$var$cb(e1, t, n) {
    $6f131a8b96a87ba3$var$a1.onError($6f131a8b96a87ba3$var$aN(e1, $6f131a8b96a87ba3$var$cm(t, t)));
}
function $6f131a8b96a87ba3$var$c_(e1) {
    let t = e1.children.filter((e1)=>3 !== e1.type);
    return 1 !== t.length || 1 !== t[0].type || $6f131a8b96a87ba3$var$aq(t[0]) ? null : t[0];
}
function $6f131a8b96a87ba3$var$cS(e1, t) {
    let { constantCache: n } = t;
    switch(e1.type){
        case 1:
            if (0 !== e1.tagType) return 0;
            let r = n.get(e1);
            if (void 0 !== r) return r;
            let i = e1.codegenNode;
            if (13 !== i.type || i.isBlock && "svg" !== e1.tag && "foreignObject" !== e1.tag && "math" !== e1.tag) return 0;
            if (void 0 !== i.patchFlag) return n.set(e1, 0), 0;
            {
                let r = 3, c = $6f131a8b96a87ba3$var$cC(e1, t);
                if (0 === c) return n.set(e1, 0), 0;
                c < r && (r = c);
                for(let i = 0; i < e1.children.length; i++){
                    let l = $6f131a8b96a87ba3$var$cS(e1.children[i], t);
                    if (0 === l) return n.set(e1, 0), 0;
                    l < r && (r = l);
                }
                if (r > 1) for(let i = 0; i < e1.props.length; i++){
                    let l = e1.props[i];
                    if (7 === l.type && "bind" === l.name && l.exp) {
                        let i = $6f131a8b96a87ba3$var$cS(l.exp, t);
                        if (0 === i) return n.set(e1, 0), 0;
                        i < r && (r = i);
                    }
                }
                if (i.isBlock) {
                    var l, s, o, a;
                    for(let t = 0; t < e1.props.length; t++)if (7 === e1.props[t].type) return n.set(e1, 0), 0;
                    t.removeHelper($6f131a8b96a87ba3$var$oD), t.removeHelper((l = t.inSSR, s = i.isComponent, l || s ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV)), i.isBlock = !1, t.helper((o = t.inSSR, a = i.isComponent, o || a ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB));
                }
                return n.set(e1, r), r;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
        default:
            return 0;
        case 5:
        case 12:
            return $6f131a8b96a87ba3$var$cS(e1.content, t);
        case 4:
            return e1.constType;
        case 8:
            let c = 3;
            for(let n = 0; n < e1.children.length; n++){
                let r = e1.children[n];
                if ($6f131a8b96a87ba3$var$w(r) || $6f131a8b96a87ba3$var$N(r)) continue;
                let i = $6f131a8b96a87ba3$var$cS(r, t);
                if (0 === i) return 0;
                i < c && (c = i);
            }
            return c;
        case 20:
            return 2;
    }
}
let $6f131a8b96a87ba3$var$cx = new Set([
    $6f131a8b96a87ba3$var$o0,
    $6f131a8b96a87ba3$var$o1,
    $6f131a8b96a87ba3$var$o2,
    $6f131a8b96a87ba3$var$o3
]);
function $6f131a8b96a87ba3$var$cC(e1, t) {
    let n = 3, r = $6f131a8b96a87ba3$var$ck(e1);
    if (r && 15 === r.type) {
        let { properties: e1 } = r;
        for(let r = 0; r < e1.length; r++){
            let i, { key: l, value: s } = e1[r], o = $6f131a8b96a87ba3$var$cS(l, t);
            if (0 === o) return o;
            if (o < n && (n = o), 0 === (i = 4 === s.type ? $6f131a8b96a87ba3$var$cS(s, t) : 14 === s.type ? function e1(t, n) {
                if (14 === t.type && !$6f131a8b96a87ba3$var$w(t.callee) && $6f131a8b96a87ba3$var$cx.has(t.callee)) {
                    let r = t.arguments[0];
                    if (4 === r.type) return $6f131a8b96a87ba3$var$cS(r, n);
                    if (14 === r.type) return e1(r, n);
                }
                return 0;
            }(s, t) : 0)) return i;
            i < n && (n = i);
        }
    }
    return n;
}
function $6f131a8b96a87ba3$var$ck(e1) {
    let t = e1.codegenNode;
    if (13 === t.type) return t.props;
}
function $6f131a8b96a87ba3$var$cT(e1, t) {
    t.currentNode = e1;
    let { nodeTransforms: n } = t, r = [];
    for(let i = 0; i < n.length; i++){
        let l = n[i](e1, t);
        if (l && ($6f131a8b96a87ba3$var$k(l) ? r.push(...l) : r.push(l)), !t.currentNode) return;
        e1 = t.currentNode;
    }
    switch(e1.type){
        case 3:
            t.ssr || t.helper($6f131a8b96a87ba3$var$oj);
            break;
        case 5:
            t.ssr || t.helper($6f131a8b96a87ba3$var$oZ);
            break;
        case 9:
            for(let n = 0; n < e1.branches.length; n++)$6f131a8b96a87ba3$var$cT(e1.branches[n], t);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            var i = e1;
            let l = 0, s = ()=>{
                l--;
            };
            for(; l < i.children.length; l++){
                let e1 = i.children[l];
                $6f131a8b96a87ba3$var$w(e1) || (t.grandParent = t.parent, t.parent = i, t.childIndex = l, t.onNodeRemoved = s, $6f131a8b96a87ba3$var$cT(e1, t));
            }
    }
    t.currentNode = e1;
    let o = r.length;
    for(; o--;)r[o]();
}
function $6f131a8b96a87ba3$var$cw(e1, t) {
    let n = $6f131a8b96a87ba3$var$w(e1) ? (t)=>t === e1 : (t)=>e1.test(t);
    return (e1, r)=>{
        if (1 === e1.type) {
            let { props: i } = e1;
            if (3 === e1.tagType && i.some($6f131a8b96a87ba3$var$aU)) return;
            let l = [];
            for(let s = 0; s < i.length; s++){
                let o = i[s];
                if (7 === o.type && n(o.name)) {
                    i.splice(s, 1), s--;
                    let n = t(e1, o, r);
                    n && l.push(n);
                }
            }
            return l;
        }
    };
}
let $6f131a8b96a87ba3$var$cN = "/*@__PURE__*/", $6f131a8b96a87ba3$var$cA = (e1)=>`${$6f131a8b96a87ba3$var$as[e1]}: _${$6f131a8b96a87ba3$var$as[e1]}`;
function $6f131a8b96a87ba3$var$cE(e1, t, { helper: n, push: r, newline: i, isTS: l }) {
    let s = n("component" === t ? $6f131a8b96a87ba3$var$oq : $6f131a8b96a87ba3$var$oK);
    for(let n = 0; n < e1.length; n++){
        let o = e1[n], a = o.endsWith("__self");
        a && (o = o.slice(0, -6)), r(`const ${$6f131a8b96a87ba3$var$aG(o, t)} = ${s}(${JSON.stringify(o)}${a ? ", true" : ""})${l ? "!" : ""}`), n < e1.length - 1 && i();
    }
}
function $6f131a8b96a87ba3$var$cR(e1, t) {
    let n = e1.length > 3;
    t.push("["), n && t.indent(), $6f131a8b96a87ba3$var$cI(e1, t, n), n && t.deindent(), t.push("]");
}
function $6f131a8b96a87ba3$var$cI(e1, t, n = !1, r = !0) {
    let { push: i, newline: l } = t;
    for(let s = 0; s < e1.length; s++){
        let o = e1[s];
        $6f131a8b96a87ba3$var$w(o) ? i(o, -3) : $6f131a8b96a87ba3$var$k(o) ? $6f131a8b96a87ba3$var$cR(o, t) : $6f131a8b96a87ba3$var$cO(o, t), s < e1.length - 1 && (n ? (r && i(","), l()) : r && i(", "));
    }
}
function $6f131a8b96a87ba3$var$cO(e1, t) {
    var n, r, i;
    if ($6f131a8b96a87ba3$var$w(e1)) return void t.push(e1, -3);
    if ($6f131a8b96a87ba3$var$N(e1)) return void t.push(t.helper(e1));
    switch(e1.type){
        case 1:
        case 9:
        case 11:
        case 12:
            $6f131a8b96a87ba3$var$cO(e1.codegenNode, t);
            break;
        case 2:
            n = e1, t.push(JSON.stringify(n.content), -3, n);
            break;
        case 4:
            $6f131a8b96a87ba3$var$cM(e1, t);
            break;
        case 5:
            !function(e1, t) {
                let { push: n, helper: r, pure: i } = t;
                i && n($6f131a8b96a87ba3$var$cN), n(`${r($6f131a8b96a87ba3$var$oZ)}(`), $6f131a8b96a87ba3$var$cO(e1.content, t), n(")");
            }(e1, t);
            break;
        case 8:
            $6f131a8b96a87ba3$var$cP(e1, t);
            break;
        case 3:
            !function(e1, t) {
                let { push: n, helper: r, pure: i } = t;
                i && n($6f131a8b96a87ba3$var$cN), n(`${r($6f131a8b96a87ba3$var$oj)}(${JSON.stringify(e1.content)})`, -3, e1);
            }(e1, t);
            break;
        case 13:
            !function(e1, t) {
                var n, r;
                let i, { push: l, helper: s, pure: o } = t, { tag: a, props: c, children: u, patchFlag: d, dynamicProps: p, directives: h, isBlock: f, disableTracking: g, isComponent: m } = e1;
                d && (i = String(d)), h && l(s($6f131a8b96a87ba3$var$oJ) + "("), f && l(`(${s($6f131a8b96a87ba3$var$oD)}(${g ? "true" : ""}), `), o && l($6f131a8b96a87ba3$var$cN), l(s(f ? (n = t.inSSR, n || m ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV) : (r = t.inSSR, r || m ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB)) + "(", -2, e1), $6f131a8b96a87ba3$var$cI(function(e1) {
                    let t = e1.length;
                    for(; t-- && null == e1[t];);
                    return e1.slice(0, t + 1).map((e1)=>e1 || "null");
                }([
                    a,
                    c,
                    u,
                    i,
                    p
                ]), t), l(")"), f && l(")"), h && (l(", "), $6f131a8b96a87ba3$var$cO(h, t), l(")"));
            }(e1, t);
            break;
        case 14:
            !function(e1, t) {
                let { push: n, helper: r, pure: i } = t, l = $6f131a8b96a87ba3$var$w(e1.callee) ? e1.callee : r(e1.callee);
                i && n($6f131a8b96a87ba3$var$cN), n(l + "(", -2, e1), $6f131a8b96a87ba3$var$cI(e1.arguments, t), n(")");
            }(e1, t);
            break;
        case 15:
            !function(e1, t) {
                let { push: n, indent: r, deindent: i, newline: l } = t, { properties: s } = e1;
                if (!s.length) return n("{}", -2, e1);
                let o = s.length > 1;
                n(o ? "{" : "{ "), o && r();
                for(let e1 = 0; e1 < s.length; e1++){
                    let { key: r, value: i } = s[e1];
                    !function(e1, t) {
                        let { push: n } = t;
                        if (8 === e1.type) n("["), $6f131a8b96a87ba3$var$cP(e1, t), n("]");
                        else if (e1.isStatic) {
                            let t;
                            n((t = e1.content, $6f131a8b96a87ba3$var$aR.test(t)) ? JSON.stringify(e1.content) : e1.content, -2, e1);
                        } else n(`[${e1.content}]`, -3, e1);
                    }(r, t), n(": "), $6f131a8b96a87ba3$var$cO(i, t), e1 < s.length - 1 && (n(","), l());
                }
                o && i(), n(o ? "}" : " }");
            }(e1, t);
            break;
        case 17:
            r = e1, i = t, $6f131a8b96a87ba3$var$cR(r.elements, i);
            break;
        case 18:
            !function(e1, t) {
                let { push: n, indent: r, deindent: i } = t, { params: l, returns: s, body: o, newline: a, isSlot: c } = e1;
                c && n(`_${$6f131a8b96a87ba3$var$as[$6f131a8b96a87ba3$var$at]}(`), n("(", -2, e1), $6f131a8b96a87ba3$var$k(l) ? $6f131a8b96a87ba3$var$cI(l, t) : l && $6f131a8b96a87ba3$var$cO(l, t), n(") => "), (a || o) && (n("{"), r()), s ? (a && n("return "), $6f131a8b96a87ba3$var$k(s) ? $6f131a8b96a87ba3$var$cR(s, t) : $6f131a8b96a87ba3$var$cO(s, t)) : o && $6f131a8b96a87ba3$var$cO(o, t), (a || o) && (i(), n("}")), c && n(")");
            }(e1, t);
            break;
        case 19:
            !function(e1, t) {
                let { test: n, consequent: r, alternate: i, newline: l } = e1, { push: s, indent: o, deindent: a, newline: c } = t;
                if (4 === n.type) {
                    let e1, r = (e1 = n.content, !!$6f131a8b96a87ba3$var$aR.test(e1));
                    r && s("("), $6f131a8b96a87ba3$var$cM(n, t), r && s(")");
                } else s("("), $6f131a8b96a87ba3$var$cO(n, t), s(")");
                l && o(), t.indentLevel++, l || s(" "), s("? "), $6f131a8b96a87ba3$var$cO(r, t), t.indentLevel--, l && c(), l || s(" "), s(": ");
                let u = 19 === i.type;
                !u && t.indentLevel++, $6f131a8b96a87ba3$var$cO(i, t), !u && t.indentLevel--, l && a(!0);
            }(e1, t);
            break;
        case 20:
            !function(e1, t) {
                let { push: n, helper: r, indent: i, deindent: l, newline: s } = t, { needPauseTracking: o, needArraySpread: a } = e1;
                a && n("[...("), n(`_cache[${e1.index}] || (`), o && (i(), n(`${r($6f131a8b96a87ba3$var$o9)}(-1`), e1.inVOnce && n(", true"), n("),"), s(), n("(")), n(`_cache[${e1.index}] = `), $6f131a8b96a87ba3$var$cO(e1.value, t), o && (n(`).cacheIndex = ${e1.index},`), s(), n(`${r($6f131a8b96a87ba3$var$o9)}(1),`), s(), n(`_cache[${e1.index}]`), l()), n(")"), a && n(")]");
            }(e1, t);
            break;
        case 21:
            $6f131a8b96a87ba3$var$cI(e1.body, t, !0, !1);
    }
}
function $6f131a8b96a87ba3$var$cM(e1, t) {
    let { content: n, isStatic: r } = e1;
    t.push(r ? JSON.stringify(n) : n, -3, e1);
}
function $6f131a8b96a87ba3$var$cP(e1, t) {
    for(let n = 0; n < e1.children.length; n++){
        let r = e1.children[n];
        $6f131a8b96a87ba3$var$w(r) ? t.push(r, -3) : $6f131a8b96a87ba3$var$cO(r, t);
    }
}
let $6f131a8b96a87ba3$var$cF = $6f131a8b96a87ba3$var$cw(/^(?:if|else|else-if)$/, (e1, t, n)=>(function(e1, t, n, r) {
        if ("else" !== t.name && (!t.exp || !t.exp.content.trim())) {
            let r = t.exp ? t.exp.loc : e1.loc;
            n.onError($6f131a8b96a87ba3$var$aN(28, t.loc)), t.exp = $6f131a8b96a87ba3$var$ap("true", !1, r);
        }
        if ("if" === t.name) {
            var i;
            let l = $6f131a8b96a87ba3$var$cD(e1, t), s = {
                type: 9,
                loc: $6f131a8b96a87ba3$var$cm((i = e1.loc).start.offset, i.end.offset),
                branches: [
                    l
                ]
            };
            if (n.replaceNode(s), r) return r(s, l, !0);
        } else {
            let i = n.parent.children, l = i.indexOf(e1);
            for(; l-- >= -1;){
                let s = i[l];
                if (s && $6f131a8b96a87ba3$var$aY(s)) {
                    n.removeNode(s);
                    continue;
                }
                if (s && 9 === s.type) {
                    ("else-if" === t.name || "else" === t.name) && void 0 === s.branches[s.branches.length - 1].condition && n.onError($6f131a8b96a87ba3$var$aN(30, e1.loc)), n.removeNode();
                    let i = $6f131a8b96a87ba3$var$cD(e1, t);
                    s.branches.push(i);
                    let l = r && r(s, i, !1);
                    $6f131a8b96a87ba3$var$cT(i, n), l && l(), n.currentNode = null;
                } else n.onError($6f131a8b96a87ba3$var$aN(30, e1.loc));
                break;
            }
        }
    })(e1, t, n, (e1, t, r)=>{
        let i = n.parent.children, l = i.indexOf(e1), s = 0;
        for(; l-- >= 0;){
            let e1 = i[l];
            e1 && 9 === e1.type && (s += e1.branches.length);
        }
        return ()=>{
            r ? e1.codegenNode = $6f131a8b96a87ba3$var$cL(t, s, n) : function(e1) {
                for(;;)if (19 === e1.type) {
                    if (19 !== e1.alternate.type) return e1;
                    else e1 = e1.alternate;
                } else 20 === e1.type && (e1 = e1.value);
            }(e1.codegenNode).alternate = $6f131a8b96a87ba3$var$cL(t, s + e1.branches.length - 1, n);
        };
    }));
function $6f131a8b96a87ba3$var$cD(e1, t) {
    let n = 3 === e1.tagType;
    return {
        type: 10,
        loc: e1.loc,
        condition: "else" === t.name ? void 0 : t.exp,
        children: n && !$6f131a8b96a87ba3$var$aL(e1, "for") ? e1.children : [
            e1
        ],
        userKey: $6f131a8b96a87ba3$var$aV(e1, "key"),
        isTemplateIf: n
    };
}
function $6f131a8b96a87ba3$var$cL(e1, t, n) {
    return e1.condition ? $6f131a8b96a87ba3$var$am(e1.condition, $6f131a8b96a87ba3$var$cV(e1, t, n), $6f131a8b96a87ba3$var$af(n.helper($6f131a8b96a87ba3$var$oj), [
        '""',
        "true"
    ])) : $6f131a8b96a87ba3$var$cV(e1, t, n);
}
function $6f131a8b96a87ba3$var$cV(e1, t, n) {
    let { helper: r } = n, i = $6f131a8b96a87ba3$var$ad("key", $6f131a8b96a87ba3$var$ap(`${t}`, !1, $6f131a8b96a87ba3$var$ao, 2)), { children: l } = e1, s = l[0];
    if (1 !== l.length || 1 !== s.type) {
        if (1 !== l.length || 11 !== s.type) return $6f131a8b96a87ba3$var$aa(n, r($6f131a8b96a87ba3$var$oI), $6f131a8b96a87ba3$var$au([
            i
        ]), l, 64, void 0, void 0, !0, !1, !1, e1.loc);
        else {
            let e1 = s.codegenNode;
            return $6f131a8b96a87ba3$var$az(e1, i, n), e1;
        }
    }
    {
        let e1 = s.codegenNode, t = 14 === e1.type && e1.callee === $6f131a8b96a87ba3$var$ai ? e1.arguments[1].returns : e1;
        return 13 === t.type && $6f131a8b96a87ba3$var$ay(t, n), $6f131a8b96a87ba3$var$az(t, i, n), e1;
    }
}
let $6f131a8b96a87ba3$var$c$ = $6f131a8b96a87ba3$var$cw("for", (e1, t, n)=>{
    let { helper: r, removeHelper: i } = n;
    return function(e1, t, n, r) {
        if (!t.exp) return void n.onError($6f131a8b96a87ba3$var$aN(31, t.loc));
        let i = t.forParseResult;
        if (!i) return void n.onError($6f131a8b96a87ba3$var$aN(32, t.loc));
        $6f131a8b96a87ba3$var$cB(i);
        let { scopes: l } = n, { source: s, value: o, key: a, index: c } = i, u = {
            type: 11,
            loc: t.loc,
            source: s,
            valueAlias: o,
            keyAlias: a,
            objectIndexAlias: c,
            parseResult: i,
            children: $6f131a8b96a87ba3$var$aH(e1) ? e1.children : [
                e1
            ]
        };
        n.replaceNode(u), l.vFor++;
        let d = r && r(u);
        return ()=>{
            l.vFor--, d && d();
        };
    }(e1, t, n, (t)=>{
        let l = $6f131a8b96a87ba3$var$af(r($6f131a8b96a87ba3$var$oG), [
            t.source
        ]), s = $6f131a8b96a87ba3$var$aH(e1), o = $6f131a8b96a87ba3$var$aL(e1, "memo"), a = $6f131a8b96a87ba3$var$aV(e1, "key", !1, !0);
        a && a.type;
        let c = a && (6 === a.type ? a.value ? $6f131a8b96a87ba3$var$ap(a.value.content, !0) : void 0 : a.exp), u = c ? $6f131a8b96a87ba3$var$ad("key", c) : null, d = 4 === t.source.type && t.source.constType > 0, p = d ? 64 : a ? 128 : 256;
        return t.codegenNode = $6f131a8b96a87ba3$var$aa(n, r($6f131a8b96a87ba3$var$oI), void 0, l, p, void 0, void 0, !0, !d, !1, e1.loc), ()=>{
            var a, p, h, f, g, m, y, v, b;
            let _, { children: S } = t, x = 1 !== S.length || 1 !== S[0].type, C = $6f131a8b96a87ba3$var$aq(e1) ? e1 : s && 1 === e1.children.length && $6f131a8b96a87ba3$var$aq(e1.children[0]) ? e1.children[0] : null;
            if (C) _ = C.codegenNode, s && u && $6f131a8b96a87ba3$var$az(_, u, n);
            else if (x) _ = $6f131a8b96a87ba3$var$aa(n, r($6f131a8b96a87ba3$var$oI), u ? $6f131a8b96a87ba3$var$au([
                u
            ]) : void 0, e1.children, 64, void 0, void 0, !0, void 0, !1);
            else {
                _ = S[0].codegenNode, s && u && $6f131a8b96a87ba3$var$az(_, u, n);
                let e1 = !d || !0 === _.isBlockRequired;
                _.isBlock !== e1 && (_.isBlock ? (i($6f131a8b96a87ba3$var$oD), i((p = n.inSSR, h = _.isComponent, p || h ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV))) : i((f = n.inSSR, g = _.isComponent, f || g ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB))), (_.isBlock = e1, _.isBlock) ? (r($6f131a8b96a87ba3$var$oD), r((m = n.inSSR, y = _.isComponent, m || y ? $6f131a8b96a87ba3$var$oL : $6f131a8b96a87ba3$var$oV))) : (r((v = n.inSSR, b = _.isComponent, v || b ? $6f131a8b96a87ba3$var$o$ : $6f131a8b96a87ba3$var$oB)), _.needsPatch && (_.patchFlag = (null != (a = _.patchFlag) ? a : 0) | 512));
            }
            if (o) {
                let e1 = $6f131a8b96a87ba3$var$ag($6f131a8b96a87ba3$var$cj(t.parseResult, [
                    $6f131a8b96a87ba3$var$ap("_cached")
                ]));
                e1.body = {
                    type: 21,
                    body: [
                        $6f131a8b96a87ba3$var$ah([
                            "const _memo = (",
                            o.exp,
                            ")"
                        ]),
                        $6f131a8b96a87ba3$var$ah([
                            "if (_cached && _cached.el",
                            ...c ? [
                                " && _cached.key === (",
                                c,
                                ")"
                            ] : [],
                            ` && ${n.helperString($6f131a8b96a87ba3$var$al)}(_cached, _memo)) return _cached`
                        ]),
                        $6f131a8b96a87ba3$var$ah([
                            "const _item = ",
                            _
                        ]),
                        $6f131a8b96a87ba3$var$ap("_item.memo = _memo"),
                        $6f131a8b96a87ba3$var$ap("return _item")
                    ],
                    loc: $6f131a8b96a87ba3$var$ao
                }, l.arguments.push(e1, $6f131a8b96a87ba3$var$ap("_cache"), $6f131a8b96a87ba3$var$ap(String(n.cached.length))), n.cached.push(null);
            } else l.arguments.push($6f131a8b96a87ba3$var$ag($6f131a8b96a87ba3$var$cj(t.parseResult), _, !0));
        };
    });
});
function $6f131a8b96a87ba3$var$cB(e1, t) {
    e1.finalized || (e1.finalized = !0);
}
function $6f131a8b96a87ba3$var$cj({ value: e1, key: t, index: n }, r = []) {
    var i = [
        e1,
        t,
        n,
        ...r
    ];
    let l = i.length;
    for(; l-- && !i[l];);
    return i.slice(0, l + 1).map((e1, t)=>e1 || $6f131a8b96a87ba3$var$ap("_".repeat(t + 1), !1));
}
let $6f131a8b96a87ba3$var$cU = $6f131a8b96a87ba3$var$ap("undefined", !1), $6f131a8b96a87ba3$var$cH = (e1, t)=>{
    if (1 === e1.type && (1 === e1.tagType || 3 === e1.tagType)) {
        let n = $6f131a8b96a87ba3$var$aL(e1, "slot");
        if (n) return n.exp, t.scopes.vSlot++, ()=>{
            t.scopes.vSlot--;
        };
    }
};
function $6f131a8b96a87ba3$var$cq(e1, t, n) {
    let r = [
        $6f131a8b96a87ba3$var$ad("name", e1),
        $6f131a8b96a87ba3$var$ad("fn", t)
    ];
    return null != n && r.push($6f131a8b96a87ba3$var$ad("key", $6f131a8b96a87ba3$var$ap(String(n), !0))), $6f131a8b96a87ba3$var$au(r);
}
let $6f131a8b96a87ba3$var$cW = new WeakMap, $6f131a8b96a87ba3$var$cK = (e1, t)=>function() {
        let n, r, i, l, s;
        if (1 !== (e1 = t.currentNode).type || 0 !== e1.tagType && 1 !== e1.tagType) return;
        let { tag: o, props: a } = e1, c = 1 === e1.tagType, u = c ? function(e1, t, n = !1) {
            let { tag: r } = e1, i = $6f131a8b96a87ba3$var$cG(r), l = $6f131a8b96a87ba3$var$aV(e1, "is", !1, !0);
            if (l) {
                if (i) {
                    let e1;
                    if (6 === l.type ? e1 = l.value && $6f131a8b96a87ba3$var$ap(l.value.content, !0) : (e1 = l.exp) || (e1 = $6f131a8b96a87ba3$var$ap("is", !1, l.arg.loc)), e1) return $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oW), [
                        e1
                    ]);
                } else 6 === l.type && l.value.content.startsWith("vue:") && (r = l.value.content.slice(4));
            }
            let s = $6f131a8b96a87ba3$var$aE(r) || t.isBuiltInComponent(r);
            return s ? (n || t.helper(s), s) : (t.helper($6f131a8b96a87ba3$var$oq), t.components.add(r), $6f131a8b96a87ba3$var$aG(r, "component"));
        }(e1, t) : `"${o}"`, d = $6f131a8b96a87ba3$var$A(u) && u.callee === $6f131a8b96a87ba3$var$oW, p = 0, h = !1, f = !1, g = d || u === $6f131a8b96a87ba3$var$oO || u === $6f131a8b96a87ba3$var$oM || !c && ("svg" === o || "foreignObject" === o || "math" === o);
        if (a.length > 0) {
            let r = $6f131a8b96a87ba3$var$cz(e1, t, void 0, c, d);
            n = r.props, p = r.patchFlag, l = r.dynamicPropNames, h = r.needsPatch, f = r.isBlockRequired;
            let i = r.directives;
            s = i && i.length ? $6f131a8b96a87ba3$var$ac(i.map((e1)=>(function(e1, t) {
                    let n = [], r = $6f131a8b96a87ba3$var$cW.get(e1);
                    r ? n.push(t.helperString(r)) : (t.helper($6f131a8b96a87ba3$var$oK), t.directives.add(e1.name), n.push($6f131a8b96a87ba3$var$aG(e1.name, "directive")));
                    let { loc: i } = e1;
                    if (e1.exp && n.push(e1.exp), e1.arg && (e1.exp || n.push("void 0"), n.push(e1.arg)), Object.keys(e1.modifiers).length) {
                        e1.arg || (e1.exp || n.push("void 0"), n.push("void 0"));
                        let t = $6f131a8b96a87ba3$var$ap("true", !1, i);
                        n.push($6f131a8b96a87ba3$var$au(e1.modifiers.map((e1)=>$6f131a8b96a87ba3$var$ad(e1, t)), i));
                    }
                    return $6f131a8b96a87ba3$var$ac(n, e1.loc);
                })(e1, t))) : void 0, r.shouldUseBlock && (g = !0);
        }
        if (e1.children.length > 0) {
            if (u === $6f131a8b96a87ba3$var$oP && (g = !0, p |= 1024), c && u !== $6f131a8b96a87ba3$var$oO && u !== $6f131a8b96a87ba3$var$oP) {
                let { slots: n, hasDynamicSlots: i } = function(e1, t, n = (e1, t, n, r)=>$6f131a8b96a87ba3$var$ag(e1, n, !1, !0, n.length ? n[0].loc : r)) {
                    t.helper($6f131a8b96a87ba3$var$at);
                    let { children: r, loc: i } = e1, l = [], s = [], o = t.scopes.vSlot > 0 || t.scopes.vFor > 0, a = $6f131a8b96a87ba3$var$aL(e1, "slot", !0);
                    if (a) {
                        let { arg: e1, exp: t } = a;
                        e1 && !$6f131a8b96a87ba3$var$aA(e1) && (o = !0), l.push($6f131a8b96a87ba3$var$ad(e1 || $6f131a8b96a87ba3$var$ap("default", !0), n(t, void 0, r, i)));
                    }
                    let c = !1, u = !1, d = [], p = new Set, h = 0;
                    for(let e1 = 0; e1 < r.length; e1++){
                        let i, f, g, m, y = r[e1];
                        if (!$6f131a8b96a87ba3$var$aH(y) || !(i = $6f131a8b96a87ba3$var$aL(y, "slot", !0))) {
                            3 !== y.type && d.push(y);
                            continue;
                        }
                        if (a) {
                            t.onError($6f131a8b96a87ba3$var$aN(37, i.loc));
                            break;
                        }
                        c = !0;
                        let { children: v, loc: b } = y, { arg: _ = $6f131a8b96a87ba3$var$ap("default", !0), exp: S, loc: x } = i;
                        $6f131a8b96a87ba3$var$aA(_) ? f = _ ? _.content : "default" : o = !0;
                        let C = $6f131a8b96a87ba3$var$aL(y, "for"), k = n(S, C, v, b);
                        if (g = $6f131a8b96a87ba3$var$aL(y, "if")) o = !0, s.push($6f131a8b96a87ba3$var$am(g.exp, $6f131a8b96a87ba3$var$cq(_, k, h++), $6f131a8b96a87ba3$var$cU));
                        else if (m = $6f131a8b96a87ba3$var$aL(y, /^else(?:-if)?$/, !0)) {
                            let n, i = e1;
                            for(; i-- && $6f131a8b96a87ba3$var$aY(n = r[i]););
                            if (n && $6f131a8b96a87ba3$var$aH(n) && $6f131a8b96a87ba3$var$aL(n, /^(?:else-)?if$/)) {
                                let e1 = s[s.length - 1];
                                for(; 19 === e1.alternate.type;)e1 = e1.alternate;
                                e1.alternate = m.exp ? $6f131a8b96a87ba3$var$am(m.exp, $6f131a8b96a87ba3$var$cq(_, k, h++), $6f131a8b96a87ba3$var$cU) : $6f131a8b96a87ba3$var$cq(_, k, h++);
                            } else t.onError($6f131a8b96a87ba3$var$aN(30, m.loc));
                        } else if (C) {
                            o = !0;
                            let e1 = C.forParseResult;
                            e1 ? ($6f131a8b96a87ba3$var$cB(e1), s.push($6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oG), [
                                e1.source,
                                $6f131a8b96a87ba3$var$ag($6f131a8b96a87ba3$var$cj(e1), $6f131a8b96a87ba3$var$cq(_, k), !0)
                            ]))) : t.onError($6f131a8b96a87ba3$var$aN(32, C.loc));
                        } else {
                            if (f) {
                                if (p.has(f)) {
                                    t.onError($6f131a8b96a87ba3$var$aN(38, x));
                                    continue;
                                }
                                p.add(f), "default" === f && (u = !0);
                            }
                            l.push($6f131a8b96a87ba3$var$ad(_, k));
                        }
                    }
                    if (!a) {
                        let e1 = (e1, t)=>$6f131a8b96a87ba3$var$ad("default", n(e1, void 0, t, i));
                        c ? d.length && !d.every($6f131a8b96a87ba3$var$aZ) && (u ? t.onError($6f131a8b96a87ba3$var$aN(39, d[0].loc)) : l.push(e1(void 0, d))) : l.push(e1(void 0, r));
                    }
                    let f = o ? 2 : !function e1(t) {
                        for(let n = 0; n < t.length; n++){
                            let r = t[n];
                            switch(r.type){
                                case 1:
                                    if (2 === r.tagType || e1(r.children)) return !0;
                                    break;
                                case 9:
                                    if (e1(r.branches)) return !0;
                                    break;
                                case 10:
                                case 11:
                                    if (e1(r.children)) return !0;
                            }
                        }
                        return !1;
                    }(e1.children) ? 1 : 3, g = $6f131a8b96a87ba3$var$au(l.concat($6f131a8b96a87ba3$var$ad("_", $6f131a8b96a87ba3$var$ap(f + "", !1))), i);
                    return s.length && (g = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oQ), [
                        g,
                        $6f131a8b96a87ba3$var$ac(s)
                    ])), {
                        slots: g,
                        hasDynamicSlots: o
                    };
                }(e1, t);
                r = n, i && (p |= 1024);
            } else if (1 === e1.children.length && u !== $6f131a8b96a87ba3$var$oO) {
                let n = e1.children[0], i = n.type, l = 5 === i || 8 === i;
                l && 0 === $6f131a8b96a87ba3$var$cS(n, t) && (p |= 1), r = l || 2 === i ? n : e1.children;
            } else r = e1.children;
        }
        l && l.length && (i = function(e1) {
            let t = "[";
            for(let n = 0, r = e1.length; n < r; n++)t += JSON.stringify(e1[n]), n < r - 1 && (t += ", ");
            return t + "]";
        }(l));
        let m = e1.codegenNode = $6f131a8b96a87ba3$var$aa(t, u, n, r, 0 === p ? void 0 : p, i, s, !!g, !1, c, e1.loc);
        (h = h && (0 === p || 32 === p)) && (m.needsPatch = !0), f && (m.isBlockRequired = !0);
    };
function $6f131a8b96a87ba3$var$cz(e1, t, n = e1.props, r, i, l = !1) {
    let s, { tag: o, loc: a, children: c } = e1, u = [], d = [], p = [], h = c.length > 0, f = !1, g = !1, m = 0, y = !1, b = !1, _ = !1, S = !1, x = !1, C = !1, k = [], T = (e1)=>{
        u.length && (d.push($6f131a8b96a87ba3$var$au($6f131a8b96a87ba3$var$cJ(u), a)), u = []), e1 && d.push(e1);
    }, w = ()=>{
        t.scopes.vFor > 0 && u.push($6f131a8b96a87ba3$var$ad($6f131a8b96a87ba3$var$ap("ref_for", !0), $6f131a8b96a87ba3$var$ap("true")));
    }, A = ({ key: e1, value: n })=>{
        if ($6f131a8b96a87ba3$var$aA(e1)) {
            let l = e1.content, s = $6f131a8b96a87ba3$var$v(l);
            s && (!r || i) && "onclick" !== l.toLowerCase() && "onUpdate:modelValue" !== l && !$6f131a8b96a87ba3$var$O(l) && (S = !0), s && $6f131a8b96a87ba3$var$O(l) && (C = !0), "ref" === l && (y = !0), s && 14 === n.type && (n = n.arguments[0]), 20 === n.type || (4 === n.type || 8 === n.type) && $6f131a8b96a87ba3$var$cS(n, t) > 0 || ("class" === l ? b = !0 : "style" === l ? _ = !0 : "ref" === l || "key" === l || k.includes(l) || k.push(l), r && ("class" === l || "style" === l) && !k.includes(l) && k.push(l));
        } else x = !0;
    };
    for(let i = 0; i < n.length; i++){
        let s = n[i];
        if (6 === s.type) {
            let { loc: e1, name: t, nameLoc: n, value: r } = s;
            if ("ref" === t && (y = !0, w()), "is" === t && ($6f131a8b96a87ba3$var$cG(o) || r && r.content.startsWith("vue:"))) continue;
            u.push($6f131a8b96a87ba3$var$ad($6f131a8b96a87ba3$var$ap(t, !0, n), $6f131a8b96a87ba3$var$ap(r ? r.content : "", !0, r ? r.loc : e1)));
        } else {
            let { name: n, arg: i, exp: c, loc: y, modifiers: v } = s, b = "bind" === n, _ = "on" === n;
            if ("slot" === n) {
                r || t.onError($6f131a8b96a87ba3$var$aN(40, y));
                continue;
            }
            if ("once" === n || "memo" === n || "is" === n || b && $6f131a8b96a87ba3$var$a$(i, "is") && $6f131a8b96a87ba3$var$cG(o) || _ && l) continue;
            if (b && $6f131a8b96a87ba3$var$a$(i, "key") && (f = !0), _ && h && i && $6f131a8b96a87ba3$var$aA(i) && "vue:beforeUpdate" === $6f131a8b96a87ba3$export$161d051f5dd25de7(i.content) && (f = !0, g = !0), b && $6f131a8b96a87ba3$var$a$(i, "ref") && w(), !i && (b || _)) {
                x = !0, c ? b ? (w(), T(), d.push(c)) : T({
                    type: 14,
                    loc: y,
                    callee: t.helper($6f131a8b96a87ba3$var$o6),
                    arguments: r ? [
                        c
                    ] : [
                        c,
                        "true"
                    ]
                }) : t.onError($6f131a8b96a87ba3$var$aN(b ? 34 : 35, y));
                continue;
            }
            b && v.some((e1)=>"prop" === e1.content) && (m |= 32);
            let S = t.directiveTransforms[n];
            if (S) {
                let { props: n, needRuntime: r } = S(s, e1, t);
                l || n.forEach(A), _ && i && !$6f131a8b96a87ba3$var$aA(i) ? T($6f131a8b96a87ba3$var$au(n, a)) : u.push(...n), r && (p.push(s), $6f131a8b96a87ba3$var$N(r) && $6f131a8b96a87ba3$var$cW.set(s, r));
            } else !$6f131a8b96a87ba3$var$M(n) && (p.push(s), h && (f = !0, g = !0));
        }
    }
    d.length ? (T(), s = d.length > 1 ? $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oY), d, a) : d[0]) : u.length && (s = $6f131a8b96a87ba3$var$au($6f131a8b96a87ba3$var$cJ(u), a)), x ? m |= 16 : (b && !r && (m |= 2), _ && !r && (m |= 4), k.length && (m |= 8), S && (m |= 32));
    let E = (0 === m || 32 === m) && (y || C || p.length > 0);
    if (!f && E && (m |= 512), !t.inSSR && s) switch(s.type){
        case 15:
            let R = -1, I = -1, P = !1;
            for(let e1 = 0; e1 < s.properties.length; e1++){
                let t = s.properties[e1].key;
                $6f131a8b96a87ba3$var$aA(t) ? "class" === t.content ? R = e1 : "style" === t.content && (I = e1) : t.isHandlerKey || (P = !0);
            }
            let F = s.properties[R], L = s.properties[I];
            P ? s = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$o2), [
                s
            ]) : (F && !$6f131a8b96a87ba3$var$aA(F.value) && (F.value = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$o0), [
                F.value
            ])), L && (_ || 4 === L.value.type && "[" === L.value.content.trim()[0] || 17 === L.value.type) && (L.value = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$o1), [
                L.value
            ])));
            break;
        case 14:
            break;
        default:
            s = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$o2), [
                $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$o3), [
                    s
                ])
            ]);
    }
    return {
        props: s,
        directives: p,
        patchFlag: m,
        dynamicPropNames: k,
        shouldUseBlock: f,
        needsPatch: E,
        isBlockRequired: g
    };
}
function $6f131a8b96a87ba3$var$cJ(e1) {
    let t = new Map, n = [];
    for(let l = 0; l < e1.length; l++){
        var r, i;
        let s = e1[l];
        if (8 === s.key.type || !s.key.isStatic) {
            n.push(s);
            continue;
        }
        let o = s.key.content, a = t.get(o);
        a ? ("style" === o || "class" === o || $6f131a8b96a87ba3$var$v(o)) && (r = a, i = s, 17 === r.value.type ? r.value.elements.push(i.value) : r.value = $6f131a8b96a87ba3$var$ac([
            r.value,
            i.value
        ], r.loc)) : (t.set(o, s), n.push(s));
    }
    return n;
}
function $6f131a8b96a87ba3$var$cG(e1) {
    return "component" === e1 || "Component" === e1;
}
let $6f131a8b96a87ba3$var$cX = (e1, t)=>{
    if ($6f131a8b96a87ba3$var$aq(e1)) {
        let { children: n, loc: r } = e1, { slotName: i, slotProps: l } = function(e1, t) {
            let n, r = '"default"', i = [];
            for(let t = 0; t < e1.props.length; t++){
                let n = e1.props[t];
                if (6 === n.type) n.value && ("name" === n.name ? r = JSON.stringify(n.value.content) : (n.name = $6f131a8b96a87ba3$export$161d051f5dd25de7(n.name), i.push(n)));
                else if ("bind" === n.name && $6f131a8b96a87ba3$var$a$(n.arg, "name")) {
                    if (n.exp) r = n.exp;
                    else if (n.arg && 4 === n.arg.type) {
                        let e1 = $6f131a8b96a87ba3$export$161d051f5dd25de7(n.arg.content);
                        r = n.exp = $6f131a8b96a87ba3$var$ap(e1, !1, n.arg.loc);
                    }
                } else "bind" === n.name && n.arg && $6f131a8b96a87ba3$var$aA(n.arg) && (n.arg.content = $6f131a8b96a87ba3$export$161d051f5dd25de7(n.arg.content)), i.push(n);
            }
            if (i.length > 0) {
                let { props: r, directives: l } = $6f131a8b96a87ba3$var$cz(e1, t, i, !1, !1);
                n = r, l.length && t.onError($6f131a8b96a87ba3$var$aN(36, l[0].loc));
            }
            return {
                slotName: r,
                slotProps: n
            };
        }(e1, t), s = [
            t.prefixIdentifiers ? "_ctx.$slots" : "$slots",
            i,
            "{}",
            "undefined",
            "true"
        ], o = 2;
        l && (s[2] = l, o = 3), n.length && (s[3] = $6f131a8b96a87ba3$var$ag([], n, !1, !1, r), o = 4), t.scopeId && !t.slotted && (o = 5), s.splice(o), e1.codegenNode = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oX), s, r);
    }
}, $6f131a8b96a87ba3$var$cQ = (e1, t, n, r)=>{
    let i, { loc: l, modifiers: s, arg: o } = e1;
    if (!e1.exp && s.length, 4 === o.type) {
        if (o.isStatic) {
            let e1 = o.content;
            e1.startsWith("vue:") && (e1 = `vnode-${e1.slice(4)}`), i = $6f131a8b96a87ba3$var$ap(0 !== t.tagType || e1.startsWith("vnode") || !/[A-Z]/.test(e1) ? $6f131a8b96a87ba3$export$8c022799eeaaefcd($6f131a8b96a87ba3$export$161d051f5dd25de7(e1)) : `on:${e1}`, !0, o.loc);
        } else i = $6f131a8b96a87ba3$var$ah([
            `${n.helperString($6f131a8b96a87ba3$var$o5)}(`,
            o,
            ")"
        ]);
    } else (i = o).children.unshift(`${n.helperString($6f131a8b96a87ba3$var$o5)}(`), i.children.push(")");
    let a = e1.exp;
    a && !a.content.trim() && (a = void 0);
    let c = n.cacheHandlers && !a && !n.inVOnce;
    if (a) {
        let e1, t = $6f131a8b96a87ba3$var$aF(a), n = !(t || (e1 = a, $6f131a8b96a87ba3$var$aD.test($6f131a8b96a87ba3$var$aP(e1)))), r = a.content.includes(";");
        (n || c && t) && (a = $6f131a8b96a87ba3$var$ah([
            `${n ? "$event" : "(...args)"} => ${r ? "{" : "("}`,
            a,
            r ? "}" : ")"
        ]));
    }
    let u = {
        props: [
            $6f131a8b96a87ba3$var$ad(i, a || $6f131a8b96a87ba3$var$ap("() => {}", !1, l))
        ]
    };
    return r && (u = r(u)), c && (u.props[0].value = n.cache(u.props[0].value)), u.props.forEach((e1)=>e1.key.isHandlerKey = !0), u;
}, $6f131a8b96a87ba3$var$cZ = (e1, t, n)=>{
    let { modifiers: r } = e1, i = e1.arg, { exp: l } = e1;
    return l && 4 === l.type && !l.content.trim() && (l = void 0), 4 !== i.type ? (i.children.unshift("("), i.children.push(') || ""')) : i.isStatic || (i.content = i.content ? `${i.content} || ""` : '""'), r.some((e1)=>"camel" === e1.content) && (4 === i.type ? i.isStatic ? i.content = $6f131a8b96a87ba3$export$161d051f5dd25de7(i.content) : i.content = `${n.helperString($6f131a8b96a87ba3$var$o4)}(${i.content})` : (i.children.unshift(`${n.helperString($6f131a8b96a87ba3$var$o4)}(`), i.children.push(")"))), !n.inSSR && (r.some((e1)=>"prop" === e1.content) && $6f131a8b96a87ba3$var$cY(i, "."), r.some((e1)=>"attr" === e1.content) && $6f131a8b96a87ba3$var$cY(i, "^")), {
        props: [
            $6f131a8b96a87ba3$var$ad(i, l)
        ]
    };
}, $6f131a8b96a87ba3$var$cY = (e1, t)=>{
    4 === e1.type ? e1.isStatic ? e1.content = t + e1.content : e1.content = `\`${t}$\{${e1.content}}\`` : (e1.children.unshift(`'${t}' + (`), e1.children.push(")"));
}, $6f131a8b96a87ba3$var$c0 = (e1, t)=>{
    if (0 === e1.type || 1 === e1.type || 11 === e1.type || 10 === e1.type) return ()=>{
        let n, r = e1.children, i = !1;
        for(let e1 = 0; e1 < r.length; e1++){
            let t = r[e1];
            if ($6f131a8b96a87ba3$var$aB(t)) {
                i = !0;
                for(let i = e1 + 1; i < r.length; i++){
                    let l = r[i];
                    if ($6f131a8b96a87ba3$var$aB(l)) n || (n = r[e1] = $6f131a8b96a87ba3$var$ah([
                        t
                    ], t.loc)), n.children.push(" + ", l), r.splice(i, 1), i--;
                    else {
                        n = void 0;
                        break;
                    }
                }
            }
        }
        if (i && (1 !== r.length || 0 !== e1.type && (1 !== e1.type || 0 !== e1.tagType || e1.props.find((e1)=>7 === e1.type && !t.directiveTransforms[e1.name])))) for(let e1 = 0; e1 < r.length; e1++){
            let n = r[e1];
            if ($6f131a8b96a87ba3$var$aB(n) || 8 === n.type) {
                let i = [];
                (2 !== n.type || " " !== n.content) && i.push(n), t.ssr || 0 !== $6f131a8b96a87ba3$var$cS(n, t) || i.push("1"), r[e1] = {
                    type: 12,
                    content: n,
                    loc: n.loc,
                    codegenNode: $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$oU), i)
                };
            }
        }
    };
}, $6f131a8b96a87ba3$var$c1 = new WeakSet, $6f131a8b96a87ba3$var$c2 = (e1, t)=>{
    if (1 === e1.type && $6f131a8b96a87ba3$var$aL(e1, "once", !0) && !$6f131a8b96a87ba3$var$c1.has(e1) && !t.inVOnce && !t.inSSR) return $6f131a8b96a87ba3$var$c1.add(e1), t.inVOnce = !0, t.helper($6f131a8b96a87ba3$var$o9), ()=>{
        t.inVOnce = !1;
        let e1 = t.currentNode;
        e1.codegenNode && (e1.codegenNode = t.cache(e1.codegenNode, !0, !0));
    };
}, $6f131a8b96a87ba3$var$c3 = (e1, t, n)=>{
    let r, { exp: i, arg: l } = e1;
    if (!i) return n.onError($6f131a8b96a87ba3$var$aN(41, e1.loc)), $6f131a8b96a87ba3$var$c6();
    let s = i.loc.source.trim(), o = 4 === i.type ? i.content : s, a = n.bindingMetadata[s];
    if ("props" === a || "props-aliased" === a || "literal-const" === a || "setup-const" === a) return i.loc, $6f131a8b96a87ba3$var$c6();
    if (!o.trim() || !$6f131a8b96a87ba3$var$aF(i)) return n.onError($6f131a8b96a87ba3$var$aN(42, i.loc)), $6f131a8b96a87ba3$var$c6();
    let c = l || $6f131a8b96a87ba3$var$ap("modelValue", !0), u = l ? $6f131a8b96a87ba3$var$aA(l) ? `onUpdate:${$6f131a8b96a87ba3$export$161d051f5dd25de7(l.content)}` : $6f131a8b96a87ba3$var$ah([
        '"onUpdate:" + ',
        l
    ]) : "onUpdate:modelValue", d = n.isTS ? "($event: any)" : "$event";
    r = $6f131a8b96a87ba3$var$ah([
        `${d} => ((`,
        i,
        ") = $event)"
    ]);
    let p = [
        $6f131a8b96a87ba3$var$ad(c, e1.exp),
        $6f131a8b96a87ba3$var$ad(u, r)
    ];
    if (e1.modifiers.length && 1 === t.tagType) {
        let t = e1.modifiers.map((e1)=>e1.content).map((e1)=>($6f131a8b96a87ba3$var$aR.test(e1) ? JSON.stringify(e1) : e1) + ": true").join(", "), n = l ? $6f131a8b96a87ba3$var$aA(l) ? `${l.content}Modifiers` : $6f131a8b96a87ba3$var$ah([
            l,
            ' + "Modifiers"'
        ]) : "modelModifiers";
        p.push($6f131a8b96a87ba3$var$ad(n, $6f131a8b96a87ba3$var$ap(`{ ${t} }`, !1, e1.loc, 2)));
    }
    return $6f131a8b96a87ba3$var$c6(p);
};
function $6f131a8b96a87ba3$var$c6(e1 = []) {
    return {
        props: e1
    };
}
let $6f131a8b96a87ba3$var$c4 = new WeakSet, $6f131a8b96a87ba3$var$c8 = (e1, t)=>{
    if (1 === e1.type) {
        let n = $6f131a8b96a87ba3$var$aL(e1, "memo");
        if (!(!n || $6f131a8b96a87ba3$var$c4.has(e1)) && !t.inSSR) return $6f131a8b96a87ba3$var$c4.add(e1), ()=>{
            let r = e1.codegenNode || t.currentNode.codegenNode;
            r && 13 === r.type && (1 !== e1.tagType && $6f131a8b96a87ba3$var$ay(r, t), e1.codegenNode = $6f131a8b96a87ba3$var$af(t.helper($6f131a8b96a87ba3$var$ai), [
                n.exp,
                $6f131a8b96a87ba3$var$ag(void 0, r),
                "_cache",
                String(t.cached.length)
            ]), t.cached.push(null));
        };
    }
}, $6f131a8b96a87ba3$var$c5 = (e1, t)=>{
    if (1 === e1.type) {
        for (let n of e1.props)if (7 === n.type && "bind" === n.name && (!n.exp || 4 === n.exp.type && !n.exp.content.trim()) && n.arg) {
            let e1 = n.arg;
            if (4 === e1.type && e1.isStatic) {
                let t = $6f131a8b96a87ba3$export$161d051f5dd25de7(e1.content);
                ($6f131a8b96a87ba3$var$aI.test(t[0]) || "-" === t[0]) && (n.exp = $6f131a8b96a87ba3$var$ap(t, !1, e1.loc));
            } else t.onError($6f131a8b96a87ba3$var$aN(53, e1.loc)), n.exp = $6f131a8b96a87ba3$var$ap("", !0, e1.loc);
        }
    }
}, $6f131a8b96a87ba3$var$c9 = Symbol(""), $6f131a8b96a87ba3$var$c7 = Symbol(""), $6f131a8b96a87ba3$var$ue = Symbol(""), $6f131a8b96a87ba3$var$ut = Symbol(""), $6f131a8b96a87ba3$var$un = Symbol(""), $6f131a8b96a87ba3$var$ur = Symbol(""), $6f131a8b96a87ba3$var$ui = Symbol(""), $6f131a8b96a87ba3$var$ul = Symbol(""), $6f131a8b96a87ba3$var$us = Symbol(""), $6f131a8b96a87ba3$var$uo = Symbol("");
Object.getOwnPropertySymbols($6f131a8b96a87ba3$var$oE = {
    [$6f131a8b96a87ba3$var$c9]: "vModelRadio",
    [$6f131a8b96a87ba3$var$c7]: "vModelCheckbox",
    [$6f131a8b96a87ba3$var$ue]: "vModelText",
    [$6f131a8b96a87ba3$var$ut]: "vModelSelect",
    [$6f131a8b96a87ba3$var$un]: "vModelDynamic",
    [$6f131a8b96a87ba3$var$ur]: "withModifiers",
    [$6f131a8b96a87ba3$var$ui]: "withKeys",
    [$6f131a8b96a87ba3$var$ul]: "vShow",
    [$6f131a8b96a87ba3$var$us]: "Transition",
    [$6f131a8b96a87ba3$var$uo]: "TransitionGroup"
}).forEach((e1)=>{
    $6f131a8b96a87ba3$var$as[e1] = $6f131a8b96a87ba3$var$oE[e1];
});
let $6f131a8b96a87ba3$var$ua = {
    parseMode: "html",
    isVoidTag: $6f131a8b96a87ba3$var$ei,
    isNativeTag: (e1)=>$6f131a8b96a87ba3$var$et(e1) || $6f131a8b96a87ba3$var$en(e1) || $6f131a8b96a87ba3$var$er(e1),
    isPreTag: (e1)=>"pre" === e1,
    isIgnoreNewlineTag: (e1)=>"pre" === e1 || "textarea" === e1,
    decodeEntities: function(e1, t = !1) {
        return ($6f131a8b96a87ba3$var$u || ($6f131a8b96a87ba3$var$u = document.createElement("div")), t) ? ($6f131a8b96a87ba3$var$u.innerHTML = `<div foo="${e1.replace(/"/g, "&quot;")}">`, $6f131a8b96a87ba3$var$u.children[0].getAttribute("foo")) : ($6f131a8b96a87ba3$var$u.innerHTML = e1, $6f131a8b96a87ba3$var$u.textContent);
    },
    isBuiltInComponent: (e1)=>"Transition" === e1 || "transition" === e1 ? $6f131a8b96a87ba3$var$us : "TransitionGroup" === e1 || "transition-group" === e1 ? $6f131a8b96a87ba3$var$uo : void 0,
    getNamespace (e1, t, n) {
        let r = t ? t.ns : n;
        if (t && 2 === r) {
            if ("annotation-xml" === t.tag) {
                if ("svg" === e1) return 1;
                t.props.some((e1)=>6 === e1.type && "encoding" === e1.name && null != e1.value && ("text/html" === e1.value.content || "application/xhtml+xml" === e1.value.content)) && (r = 0);
            } else /^m(?:[ions]|text)$/.test(t.tag) && "mglyph" !== e1 && "malignmark" !== e1 && (r = 0);
        } else t && 1 === r && ("foreignObject" === t.tag || "desc" === t.tag || "title" === t.tag) && (r = 0);
        if (0 === r) {
            if ("svg" === e1) return 1;
            if ("math" === e1) return 2;
        }
        return r;
    }
}, $6f131a8b96a87ba3$var$uc = $6f131a8b96a87ba3$var$h("passive,once,capture"), $6f131a8b96a87ba3$var$uu = $6f131a8b96a87ba3$var$h("stop,prevent,self,ctrl,shift,alt,meta,exact,middle"), $6f131a8b96a87ba3$var$ud = $6f131a8b96a87ba3$var$h("left,right"), $6f131a8b96a87ba3$var$up = $6f131a8b96a87ba3$var$h("onkeyup,onkeydown,onkeypress"), $6f131a8b96a87ba3$var$uh = (e1, t)=>$6f131a8b96a87ba3$var$aA(e1) && "onclick" === e1.content.toLowerCase() ? $6f131a8b96a87ba3$var$ap(t, !0) : 4 !== e1.type ? $6f131a8b96a87ba3$var$ah([
        "(",
        e1,
        `) === "onClick" ? "${t}" : (`,
        e1,
        ")"
    ]) : e1, $6f131a8b96a87ba3$var$uf = (e1, t)=>{
    1 === e1.type && 0 === e1.tagType && ("script" === e1.tag || "style" === e1.tag) && t.removeNode();
}, $6f131a8b96a87ba3$var$ug = [
    (e1)=>{
        1 === e1.type && e1.props.forEach((t, n)=>{
            let r, i;
            6 === t.type && "style" === t.name && t.value && (e1.props[n] = {
                type: 7,
                name: "bind",
                arg: $6f131a8b96a87ba3$var$ap("style", !0, t.loc),
                exp: (r = t.value.content, i = t.loc, $6f131a8b96a87ba3$var$ap(JSON.stringify($6f131a8b96a87ba3$var$Z(r)), !1, i, 3)),
                modifiers: [],
                loc: t.loc
            });
        });
    },
    (e1, t)=>{
        if (1 === e1.type && 1 === e1.tagType && t.isBuiltInComponent(e1.tag) === $6f131a8b96a87ba3$var$us) return ()=>{
            if (!e1.children.length) return;
            !function e1(t) {
                let n = t.children = t.children.filter((e1)=>!$6f131a8b96a87ba3$var$aY(e1)), r = n[0];
                return 1 !== n.length || 11 === r.type || 9 === r.type && r.branches.some(e1);
            }(e1);
            let t = e1.children[0];
            if (1 === t.type) for (let n of t.props)7 === n.type && "show" === n.name && e1.props.push({
                type: 6,
                name: "persisted",
                nameLoc: e1.loc,
                value: void 0,
                loc: e1.loc
            });
        };
    }
], $6f131a8b96a87ba3$var$um = {
    cloak: ()=>({
            props: []
        }),
    html: (e1, t, n)=>{
        let { exp: r, loc: i } = e1;
        return r || n.onError($6f131a8b96a87ba3$var$aN(54, i)), t.children.length && (n.onError($6f131a8b96a87ba3$var$aN(55, i)), t.children.length = 0), {
            props: [
                $6f131a8b96a87ba3$var$ad($6f131a8b96a87ba3$var$ap("innerHTML", !0, i), r || $6f131a8b96a87ba3$var$ap("", !0))
            ]
        };
    },
    text: (e1, t, n)=>{
        let { exp: r, loc: i } = e1;
        return r || n.onError($6f131a8b96a87ba3$var$aN(56, i)), t.children.length && (n.onError($6f131a8b96a87ba3$var$aN(57, i)), t.children.length = 0), {
            props: [
                $6f131a8b96a87ba3$var$ad($6f131a8b96a87ba3$var$ap("textContent", !0), r ? $6f131a8b96a87ba3$var$cS(r, n) > 0 ? r : $6f131a8b96a87ba3$var$af(n.helperString($6f131a8b96a87ba3$var$oZ), [
                    r
                ], i) : $6f131a8b96a87ba3$var$ap("", !0))
            ]
        };
    },
    model: (e1, t, n)=>{
        let r = $6f131a8b96a87ba3$var$c3(e1, t, n);
        if (!r.props.length || 1 === t.tagType) return r;
        e1.arg && n.onError($6f131a8b96a87ba3$var$aN(59, e1.arg.loc));
        let { tag: i } = t, l = n.isCustomElement(i);
        if ("input" === i || "textarea" === i || "select" === i || l) {
            let s = $6f131a8b96a87ba3$var$ue, o = !1;
            if ("input" === i || l) {
                let r = $6f131a8b96a87ba3$var$aV(t, "type");
                if (r) {
                    if (7 === r.type) s = $6f131a8b96a87ba3$var$un;
                    else if (r.value) switch(r.value.content){
                        case "radio":
                            s = $6f131a8b96a87ba3$var$c9;
                            break;
                        case "checkbox":
                            s = $6f131a8b96a87ba3$var$c7;
                            break;
                        case "file":
                            o = !0, n.onError($6f131a8b96a87ba3$var$aN(60, e1.loc));
                    }
                } else t.props.some((e1)=>7 === e1.type && "bind" === e1.name && (!e1.arg || 4 !== e1.arg.type || !e1.arg.isStatic)) && (s = $6f131a8b96a87ba3$var$un);
            } else "select" === i && (s = $6f131a8b96a87ba3$var$ut);
            o || (r.needRuntime = n.helper(s));
        } else n.onError($6f131a8b96a87ba3$var$aN(58, e1.loc));
        return r.props = r.props.filter((e1)=>4 !== e1.key.type || "modelValue" !== e1.key.content), r;
    },
    on: (e1, t, n)=>$6f131a8b96a87ba3$var$cQ(e1, t, n, (t)=>{
            let { modifiers: r } = e1;
            if (!r.length) return t;
            let { key: i, value: l } = t.props[0], { keyModifiers: s, nonKeyModifiers: o, eventOptionModifiers: a } = ((e1, t, n)=>{
                let r = [], i = [], l = [];
                for(let n = 0; n < t.length; n++){
                    let s = t[n].content;
                    $6f131a8b96a87ba3$var$uc(s) ? l.push(s) : $6f131a8b96a87ba3$var$ud(s) ? $6f131a8b96a87ba3$var$aA(e1) ? $6f131a8b96a87ba3$var$up(e1.content.toLowerCase()) ? r.push(s) : i.push(s) : (r.push(s), i.push(s)) : $6f131a8b96a87ba3$var$uu(s) ? i.push(s) : r.push(s);
                }
                return {
                    keyModifiers: r,
                    nonKeyModifiers: i,
                    eventOptionModifiers: l
                };
            })(i, r, e1.loc);
            if (o.includes("right") && (i = $6f131a8b96a87ba3$var$uh(i, "onContextmenu")), o.includes("middle") && (i = $6f131a8b96a87ba3$var$uh(i, "onMouseup")), o.length && (l = $6f131a8b96a87ba3$var$af(n.helper($6f131a8b96a87ba3$var$ur), [
                l,
                JSON.stringify(o)
            ])), s.length && (!$6f131a8b96a87ba3$var$aA(i) || $6f131a8b96a87ba3$var$up(i.content.toLowerCase())) && (l = $6f131a8b96a87ba3$var$af(n.helper($6f131a8b96a87ba3$var$ui), [
                l,
                JSON.stringify(s)
            ])), a.length) {
                let e1 = a.map($6f131a8b96a87ba3$export$9a00dee1beb8f576).join("");
                i = $6f131a8b96a87ba3$var$aA(i) ? $6f131a8b96a87ba3$var$ap(`${i.content}${e1}`, !0) : $6f131a8b96a87ba3$var$ah([
                    "(",
                    i,
                    `) + "${e1}"`
                ]);
            }
            return {
                props: [
                    $6f131a8b96a87ba3$var$ad(i, l)
                ]
            };
        }),
    show: (e1, t, n)=>{
        let { exp: r, loc: i } = e1;
        return r || n.onError($6f131a8b96a87ba3$var$aN(62, i)), {
            props: [],
            needRuntime: n.helper($6f131a8b96a87ba3$var$ul)
        };
    }
}, $6f131a8b96a87ba3$var$uy = Object.create(null);
function $6f131a8b96a87ba3$export$ef7acd7185315e22(e1, t) {
    if (!$6f131a8b96a87ba3$var$w(e1)) {
        if (!e1.nodeType) return $6f131a8b96a87ba3$var$m;
        else e1 = e1.innerHTML;
    }
    let n = e1 + JSON.stringify(t, (e1, t)=>"function" == typeof t ? t.toString() : t), r = $6f131a8b96a87ba3$var$uy[n];
    if (r) return r;
    if ("#" === e1[0]) {
        let t = document.querySelector(e1);
        e1 = t ? t.innerHTML : "";
    }
    let i = $6f131a8b96a87ba3$var$_({
        hoistStatic: !0,
        onError: void 0,
        onWarn: $6f131a8b96a87ba3$var$m
    }, t);
    !i.isCustomElement && "u" > typeof customElements && (i.isCustomElement = (e1)=>!!customElements.get(e1));
    let { code: l } = function(e1, t = {}) {
        return function(e1, t = {}) {
            var n;
            let r, i = t.onError || $6f131a8b96a87ba3$var$aT, l = "module" === t.mode;
            !0 === t.prefixIdentifiers ? i($6f131a8b96a87ba3$var$aN(48)) : l && i($6f131a8b96a87ba3$var$aN(49)), t.cacheHandlers && i($6f131a8b96a87ba3$var$aN(50)), t.scopeId && !l && i($6f131a8b96a87ba3$var$aN(51));
            let s = $6f131a8b96a87ba3$var$_({}, t, {
                prefixIdentifiers: !1
            }), o = $6f131a8b96a87ba3$var$w(e1) ? function(e1, t) {
                if ($6f131a8b96a87ba3$var$cr.reset(), $6f131a8b96a87ba3$var$a6 = null, $6f131a8b96a87ba3$var$a4 = null, $6f131a8b96a87ba3$var$a8 = "", $6f131a8b96a87ba3$var$a5 = -1, $6f131a8b96a87ba3$var$a9 = -1, $6f131a8b96a87ba3$var$cn.length = 0, $6f131a8b96a87ba3$var$a3 = e1, $6f131a8b96a87ba3$var$a1 = $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$a0), t) {
                    let e1;
                    for(e1 in t)null != t[e1] && ($6f131a8b96a87ba3$var$a1[e1] = t[e1]);
                }
                $6f131a8b96a87ba3$var$cr.mode = "html" === $6f131a8b96a87ba3$var$a1.parseMode ? 1 : 2 * ("sfc" === $6f131a8b96a87ba3$var$a1.parseMode), $6f131a8b96a87ba3$var$cr.inXML = 1 === $6f131a8b96a87ba3$var$a1.ns || 2 === $6f131a8b96a87ba3$var$a1.ns;
                let n = t && t.delimiters;
                n && ($6f131a8b96a87ba3$var$cr.delimiterOpen = $6f131a8b96a87ba3$var$aC(n[0]), $6f131a8b96a87ba3$var$cr.delimiterClose = $6f131a8b96a87ba3$var$aC(n[1]));
                let r = $6f131a8b96a87ba3$var$a2 = function(e1, t = "") {
                    return {
                        type: 0,
                        source: t,
                        children: e1,
                        helpers: new Set,
                        components: [],
                        directives: [],
                        hoists: [],
                        imports: [],
                        cached: [],
                        temps: 0,
                        codegenNode: void 0,
                        loc: $6f131a8b96a87ba3$var$ao
                    };
                }([], e1);
                return $6f131a8b96a87ba3$var$cr.parse($6f131a8b96a87ba3$var$a3), r.loc = $6f131a8b96a87ba3$var$cm(0, e1.length), r.children = $6f131a8b96a87ba3$var$ch(r.children), $6f131a8b96a87ba3$var$a2 = null, r;
            }(e1, s) : e1, [a, c] = [
                [
                    $6f131a8b96a87ba3$var$c5,
                    $6f131a8b96a87ba3$var$c2,
                    $6f131a8b96a87ba3$var$cF,
                    $6f131a8b96a87ba3$var$c8,
                    $6f131a8b96a87ba3$var$c$,
                    $6f131a8b96a87ba3$var$cX,
                    $6f131a8b96a87ba3$var$cK,
                    $6f131a8b96a87ba3$var$cH,
                    $6f131a8b96a87ba3$var$c0
                ],
                {
                    on: $6f131a8b96a87ba3$var$cQ,
                    bind: $6f131a8b96a87ba3$var$cZ,
                    model: $6f131a8b96a87ba3$var$c3
                }
            ];
            return r = function(e1, { filename: t = "", prefixIdentifiers: n = !1, hoistStatic: r = !1, hmr: i = !1, cacheHandlers: l = !1, nodeTransforms: s = [], directiveTransforms: o = {}, transformHoist: a = null, isBuiltInComponent: c = $6f131a8b96a87ba3$var$m, isCustomElement: u = $6f131a8b96a87ba3$var$m, expressionPlugins: d = [], scopeId: p = null, slotted: h = !0, ssr: g = !1, inSSR: y = !1, ssrCssVars: v = "", bindingMetadata: b = $6f131a8b96a87ba3$var$f, inline: _ = !1, isTS: S = !1, onError: x = $6f131a8b96a87ba3$var$aT, onWarn: C = $6f131a8b96a87ba3$var$aw, compatConfig: k }) {
                let T = t.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/), N = {
                    filename: t,
                    selfName: T && $6f131a8b96a87ba3$export$9a00dee1beb8f576($6f131a8b96a87ba3$export$161d051f5dd25de7(T[1])),
                    prefixIdentifiers: n,
                    hoistStatic: r,
                    hmr: i,
                    cacheHandlers: l,
                    nodeTransforms: s,
                    directiveTransforms: o,
                    transformHoist: a,
                    isBuiltInComponent: c,
                    isCustomElement: u,
                    expressionPlugins: d,
                    scopeId: p,
                    slotted: h,
                    ssr: g,
                    inSSR: y,
                    ssrCssVars: v,
                    bindingMetadata: b,
                    inline: _,
                    isTS: S,
                    onError: x,
                    onWarn: C,
                    compatConfig: k,
                    root: e1,
                    helpers: new Map,
                    components: new Set,
                    directives: new Set,
                    hoists: [],
                    imports: [],
                    cached: [],
                    constantCache: new WeakMap,
                    vForMemoKeyedNodes: new WeakSet,
                    temps: 0,
                    identifiers: Object.create(null),
                    scopes: {
                        vFor: 0,
                        vSlot: 0,
                        vPre: 0,
                        vOnce: 0
                    },
                    parent: null,
                    grandParent: null,
                    currentNode: e1,
                    childIndex: 0,
                    inVOnce: !1,
                    helper (e1) {
                        let t = N.helpers.get(e1) || 0;
                        return N.helpers.set(e1, t + 1), e1;
                    },
                    removeHelper (e1) {
                        let t = N.helpers.get(e1);
                        if (t) {
                            let n = t - 1;
                            n ? N.helpers.set(e1, n) : N.helpers.delete(e1);
                        }
                    },
                    helperString: (e1)=>`_${$6f131a8b96a87ba3$var$as[N.helper(e1)]}`,
                    replaceNode (e1) {
                        N.parent.children[N.childIndex] = N.currentNode = e1;
                    },
                    removeNode (e1) {
                        let t = N.parent.children, n = e1 ? t.indexOf(e1) : N.currentNode ? N.childIndex : -1;
                        e1 && e1 !== N.currentNode ? N.childIndex > n && (N.childIndex--, N.onNodeRemoved()) : (N.currentNode = null, N.onNodeRemoved()), N.parent.children.splice(n, 1);
                    },
                    onNodeRemoved: $6f131a8b96a87ba3$var$m,
                    addIdentifiers (e1) {},
                    removeIdentifiers (e1) {},
                    hoist (e1) {
                        $6f131a8b96a87ba3$var$w(e1) && (e1 = $6f131a8b96a87ba3$var$ap(e1)), N.hoists.push(e1);
                        let t = $6f131a8b96a87ba3$var$ap(`_hoisted_${N.hoists.length}`, !1, e1.loc, 2);
                        return t.hoisted = e1, t;
                    },
                    cache (e1, t = !1, n = !1) {
                        let r = function(e1, t, n = !1, r = !1) {
                            return {
                                type: 20,
                                index: e1,
                                value: t,
                                needPauseTracking: n,
                                inVOnce: r,
                                needArraySpread: !1,
                                loc: $6f131a8b96a87ba3$var$ao
                            };
                        }(N.cached.length, e1, t, n);
                        return N.cached.push(r), r;
                    }
                };
                return N;
            }(o, n = $6f131a8b96a87ba3$var$_({}, s, {
                nodeTransforms: [
                    ...a,
                    ...t.nodeTransforms || []
                ],
                directiveTransforms: $6f131a8b96a87ba3$var$_({}, c, t.directiveTransforms || {})
            })), $6f131a8b96a87ba3$var$cT(o, r), n.hoistStatic && function e1(t, n, r, i = !1, l = !1) {
                let { children: s } = t, o = [];
                for(let n = 0; n < s.length; n++){
                    let a = s[n];
                    if (1 === a.type && 0 === a.tagType) {
                        let e1 = i ? 0 : $6f131a8b96a87ba3$var$cS(a, r);
                        if (e1 > 0) {
                            if (e1 >= 2) {
                                a.codegenNode.patchFlag = -1, o.push(a);
                                continue;
                            }
                        } else {
                            let e1 = a.codegenNode;
                            if (13 === e1.type) {
                                let t = e1.patchFlag;
                                if ((void 0 === t || 512 === t || 1 === t) && $6f131a8b96a87ba3$var$cC(a, r) >= 2) {
                                    let t = $6f131a8b96a87ba3$var$ck(a);
                                    t && (e1.props = r.hoist(t));
                                }
                                e1.dynamicProps && (e1.dynamicProps = r.hoist(e1.dynamicProps));
                            }
                        }
                    } else if (12 === a.type && (i ? 0 : $6f131a8b96a87ba3$var$cS(a, r)) >= 2) {
                        14 === a.codegenNode.type && a.codegenNode.arguments.length > 0 && a.codegenNode.arguments.push("-1"), o.push(a);
                        continue;
                    }
                    if (1 === a.type) {
                        let n = 1 === a.tagType;
                        n && r.scopes.vSlot++, e1(a, t, r, !1, l), n && r.scopes.vSlot--;
                    } else if (11 === a.type) e1(a, t, r, 1 === a.children.length, !0);
                    else if (9 === a.type) for(let n = 0; n < a.branches.length; n++)e1(a.branches[n], t, r, 1 === a.branches[n].children.length, l);
                }
                let a = !1;
                if (o.length === s.length && 1 === t.type) {
                    if (0 === t.tagType && t.codegenNode && 13 === t.codegenNode.type && $6f131a8b96a87ba3$var$k(t.codegenNode.children)) t.codegenNode.children = c($6f131a8b96a87ba3$var$ac(t.codegenNode.children)), a = !0;
                    else if (1 === t.tagType && t.codegenNode && 13 === t.codegenNode.type && t.codegenNode.children && !$6f131a8b96a87ba3$var$k(t.codegenNode.children) && 15 === t.codegenNode.children.type) {
                        let e1 = u(t.codegenNode, "default");
                        e1 && (e1.returns = c($6f131a8b96a87ba3$var$ac(e1.returns)), a = !0);
                    } else if (3 === t.tagType && n && 1 === n.type && 1 === n.tagType && n.codegenNode && 13 === n.codegenNode.type && n.codegenNode.children && !$6f131a8b96a87ba3$var$k(n.codegenNode.children) && 15 === n.codegenNode.children.type) {
                        let e1 = $6f131a8b96a87ba3$var$aL(t, "slot", !0), r = e1 && e1.arg && u(n.codegenNode, e1.arg);
                        r && (r.returns = c($6f131a8b96a87ba3$var$ac(r.returns)), a = !0);
                    }
                }
                if (!a) for (let e1 of o)e1.codegenNode = r.cache(e1.codegenNode);
                function c(e1) {
                    let t = r.cache(e1);
                    return t.needArraySpread = !0, t;
                }
                function u(e1, t) {
                    if (e1.children && !$6f131a8b96a87ba3$var$k(e1.children) && 15 === e1.children.type) {
                        let n = e1.children.properties.find((e1)=>e1.key === t || e1.key.content === t);
                        return n && n.value;
                    }
                }
                o.length && r.transformHoist && r.transformHoist(s, r, t);
            }(o, void 0, r, !!$6f131a8b96a87ba3$var$c_(o)), n.ssr || function(e1, t) {
                let { helper: n } = t, { children: r } = e1;
                if (1 === r.length) {
                    let n = $6f131a8b96a87ba3$var$c_(e1);
                    if (n && n.codegenNode) {
                        let r = n.codegenNode;
                        13 === r.type && $6f131a8b96a87ba3$var$ay(r, t), e1.codegenNode = r;
                    } else e1.codegenNode = r[0];
                } else r.length > 1 && (e1.codegenNode = $6f131a8b96a87ba3$var$aa(t, n($6f131a8b96a87ba3$var$oI), void 0, e1.children, 64, void 0, void 0, !0, void 0, !1));
            }(o, r), o.helpers = new Set([
                ...r.helpers.keys()
            ]), o.components = [
                ...r.components
            ], o.directives = [
                ...r.directives
            ], o.imports = r.imports, o.hoists = r.hoists, o.temps = r.temps, o.cached = r.cached, o.transformed = !0, function(e1, t = {}) {
                let n = function(e1, { mode: t = "function", prefixIdentifiers: n = "module" === t, sourceMap: r = !1, filename: i = "template.vue.html", scopeId: l = null, optimizeImports: s = !1, runtimeGlobalName: o = "Vue", runtimeModuleName: a = "vue", ssrRuntimeModuleName: c = "vue/server-renderer", ssr: u = !1, isTS: d = !1, inSSR: p = !1 }) {
                    let h = {
                        mode: t,
                        prefixIdentifiers: n,
                        sourceMap: r,
                        filename: i,
                        scopeId: l,
                        optimizeImports: s,
                        runtimeGlobalName: o,
                        runtimeModuleName: a,
                        ssrRuntimeModuleName: c,
                        ssr: u,
                        isTS: d,
                        inSSR: p,
                        source: e1.source,
                        code: "",
                        column: 1,
                        line: 1,
                        offset: 0,
                        indentLevel: 0,
                        pure: !1,
                        map: void 0,
                        helper: (e1)=>`_${$6f131a8b96a87ba3$var$as[e1]}`,
                        push (e1, t = -2, n) {
                            h.code += e1;
                        },
                        indent () {
                            f(++h.indentLevel);
                        },
                        deindent (e1 = !1) {
                            e1 ? --h.indentLevel : f(--h.indentLevel);
                        },
                        newline () {
                            f(h.indentLevel);
                        }
                    };
                    function f(e1) {
                        h.push(`
` + "  ".repeat(e1), 0);
                    }
                    return h;
                }(e1, t);
                t.onContextCreated && t.onContextCreated(n);
                let { mode: r, push: i, prefixIdentifiers: l, indent: s, deindent: o, newline: a, ssr: c } = n, u = Array.from(e1.helpers), d = u.length > 0, p = !l && "module" !== r;
                !function(e1, t) {
                    let { push: n, newline: r, runtimeGlobalName: i } = t, l = Array.from(e1.helpers);
                    if (l.length > 0 && (n(`const _Vue = ${i}
`, -1), e1.hoists.length)) {
                        let e1 = [
                            $6f131a8b96a87ba3$var$o$,
                            $6f131a8b96a87ba3$var$oB,
                            $6f131a8b96a87ba3$var$oj,
                            $6f131a8b96a87ba3$var$oU,
                            $6f131a8b96a87ba3$var$oH
                        ].filter((e1)=>l.includes(e1)).map($6f131a8b96a87ba3$var$cA).join(", ");
                        n(`const { ${e1} } = _Vue
`, -1);
                    }
                    (function(e1, t) {
                        if (!e1.length) return;
                        t.pure = !0;
                        let { push: n, newline: r } = t;
                        r();
                        for(let i = 0; i < e1.length; i++){
                            let l = e1[i];
                            l && (n(`const _hoisted_${i + 1} = `), $6f131a8b96a87ba3$var$cO(l, t), r());
                        }
                        t.pure = !1;
                    })(e1.hoists, t), r(), n("return ");
                }(e1, n);
                let h = (c ? [
                    "_ctx",
                    "_push",
                    "_parent",
                    "_attrs"
                ] : [
                    "_ctx",
                    "_cache"
                ]).join(", ");
                if (i(`function ${c ? "ssrRender" : "render"}(${h}) {`), s(), p && (i("with (_ctx) {"), s(), d && (i(`const { ${u.map($6f131a8b96a87ba3$var$cA).join(", ")} } = _Vue
`, -1), a())), e1.components.length && ($6f131a8b96a87ba3$var$cE(e1.components, "component", n), (e1.directives.length || e1.temps > 0) && a()), e1.directives.length && ($6f131a8b96a87ba3$var$cE(e1.directives, "directive", n), e1.temps > 0 && a()), e1.temps > 0) {
                    i("let ");
                    for(let t = 0; t < e1.temps; t++)i(`${t > 0 ? ", " : ""}_temp${t}`);
                }
                return (e1.components.length || e1.directives.length || e1.temps) && (i(`
`, 0), a()), c || i("return "), e1.codegenNode ? $6f131a8b96a87ba3$var$cO(e1.codegenNode, n) : i("null"), p && (o(), i("}")), o(), i("}"), {
                    ast: e1,
                    code: n.code,
                    preamble: "",
                    map: n.map ? n.map.toJSON() : void 0
                };
            }(o, s);
        }(e1, $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$ua, t, {
            nodeTransforms: [
                $6f131a8b96a87ba3$var$uf,
                ...$6f131a8b96a87ba3$var$ug,
                ...t.nodeTransforms || []
            ],
            directiveTransforms: $6f131a8b96a87ba3$var$_({}, $6f131a8b96a87ba3$var$um, t.directiveTransforms || {}),
            transformHoist: null
        }));
    }(e1, i), s = Function("Vue", l)($6f131a8b96a87ba3$var$oR);
    return s._rc = !0, $6f131a8b96a87ba3$var$uy[n] = s;
}
$6f131a8b96a87ba3$export$667bb5a67822b941($6f131a8b96a87ba3$export$ef7acd7185315e22);

});

parcelRegister("hkrtv", function(module, exports) {

module.exports = (parcelRequire("7KQRm"));

});
parcelRegister("7KQRm", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");

var $f9RLk = parcelRequire("f9RLk");

var $9fVgj = parcelRequire("9fVgj");

var $6Ozi4 = parcelRequire("6Ozi4");

var $eyroE = parcelRequire("eyroE");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5a55d51f5112df3c$var$createInstance(defaultConfig) {
    var context = new $9fVgj(defaultConfig);
    var instance = $f9RLk($9fVgj.prototype.request, context);
    // Copy axios.prototype to instance
    $cfXJ3.extend(instance, $9fVgj.prototype, context);
    // Copy context to instance
    $cfXJ3.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5a55d51f5112df3c$var$axios = $5a55d51f5112df3c$var$createInstance($eyroE);
// Expose Axios class to allow class inheritance
$5a55d51f5112df3c$var$axios.Axios = $9fVgj;
// Factory for creating new instances
$5a55d51f5112df3c$var$axios.create = function create(instanceConfig) {
    return $5a55d51f5112df3c$var$createInstance($6Ozi4($5a55d51f5112df3c$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$5a55d51f5112df3c$var$axios.Cancel = (parcelRequire("6otJi"));

$5a55d51f5112df3c$var$axios.CancelToken = (parcelRequire("emRt6"));

$5a55d51f5112df3c$var$axios.isCancel = (parcelRequire("9zOBF"));
// Expose all/spread
$5a55d51f5112df3c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5a55d51f5112df3c$var$axios.spread = (parcelRequire("6FgZm"));
module.exports = $5a55d51f5112df3c$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5a55d51f5112df3c$var$axios;

});
parcelRegister("cfXJ3", function(module, exports) {
'use strict';

var $f9RLk = parcelRequire("f9RLk");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $8ec53706316d8141$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $8ec53706316d8141$var$isArray(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $8ec53706316d8141$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ec53706316d8141$var$isBuffer(val) {
    return val !== null && !$8ec53706316d8141$var$isUndefined(val) && val.constructor !== null && !$8ec53706316d8141$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $8ec53706316d8141$var$isArrayBuffer(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $8ec53706316d8141$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ec53706316d8141$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $8ec53706316d8141$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $8ec53706316d8141$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $8ec53706316d8141$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $8ec53706316d8141$var$isDate(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $8ec53706316d8141$var$isFile(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $8ec53706316d8141$var$isBlob(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $8ec53706316d8141$var$isFunction(val) {
    return $8ec53706316d8141$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $8ec53706316d8141$var$isStream(val) {
    return $8ec53706316d8141$var$isObject(val) && $8ec53706316d8141$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $8ec53706316d8141$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $8ec53706316d8141$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $8ec53706316d8141$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $8ec53706316d8141$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ec53706316d8141$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $8ec53706316d8141$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $8ec53706316d8141$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$8ec53706316d8141$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $8ec53706316d8141$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $8ec53706316d8141$var$deepMerge(result[key], val);
        else if (typeof val === 'object') result[key] = $8ec53706316d8141$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$8ec53706316d8141$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $8ec53706316d8141$var$extend(a, b, thisArg) {
    $8ec53706316d8141$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $f9RLk(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $8ec53706316d8141$var$isArray,
    isArrayBuffer: $8ec53706316d8141$var$isArrayBuffer,
    isBuffer: $8ec53706316d8141$var$isBuffer,
    isFormData: $8ec53706316d8141$var$isFormData,
    isArrayBufferView: $8ec53706316d8141$var$isArrayBufferView,
    isString: $8ec53706316d8141$var$isString,
    isNumber: $8ec53706316d8141$var$isNumber,
    isObject: $8ec53706316d8141$var$isObject,
    isUndefined: $8ec53706316d8141$var$isUndefined,
    isDate: $8ec53706316d8141$var$isDate,
    isFile: $8ec53706316d8141$var$isFile,
    isBlob: $8ec53706316d8141$var$isBlob,
    isFunction: $8ec53706316d8141$var$isFunction,
    isStream: $8ec53706316d8141$var$isStream,
    isURLSearchParams: $8ec53706316d8141$var$isURLSearchParams,
    isStandardBrowserEnv: $8ec53706316d8141$var$isStandardBrowserEnv,
    forEach: $8ec53706316d8141$var$forEach,
    merge: $8ec53706316d8141$var$merge,
    deepMerge: $8ec53706316d8141$var$deepMerge,
    extend: $8ec53706316d8141$var$extend,
    trim: $8ec53706316d8141$var$trim
};

});
parcelRegister("f9RLk", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("9fVgj", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");

var $kh5iz = parcelRequire("kh5iz");

var $hbpe2 = parcelRequire("hbpe2");

var $bjupl = parcelRequire("bjupl");

var $6Ozi4 = parcelRequire("6Ozi4");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $6bd1eed68c530ceb$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $hbpe2(),
        response: new $hbpe2()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $6bd1eed68c530ceb$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $6Ozi4(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $bjupl,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$6bd1eed68c530ceb$var$Axios.prototype.getUri = function getUri(config) {
    config = $6Ozi4(this.defaults, config);
    return $kh5iz(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$cfXJ3.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6bd1eed68c530ceb$var$Axios.prototype[method] = function(url, config) {
        return this.request($cfXJ3.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$cfXJ3.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $6bd1eed68c530ceb$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($cfXJ3.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $6bd1eed68c530ceb$var$Axios;

});
parcelRegister("kh5iz", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
function $ec298157471185b6$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($cfXJ3.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $cfXJ3.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($cfXJ3.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $cfXJ3.forEach(val, function parseValue(v) {
                if ($cfXJ3.isDate(v)) v = v.toISOString();
                else if ($cfXJ3.isObject(v)) v = JSON.stringify(v);
                parts.push($ec298157471185b6$var$encode(key) + '=' + $ec298157471185b6$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("hbpe2", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
function $c827080148be903b$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $c827080148be903b$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $c827080148be903b$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $c827080148be903b$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $cfXJ3.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $c827080148be903b$var$InterceptorManager;

});

parcelRegister("bjupl", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");

var $fr8i3 = parcelRequire("fr8i3");

var $9zOBF = parcelRequire("9zOBF");

var $eyroE = parcelRequire("eyroE");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $83c90e6e57aa4df7$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $fr8i3(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $cfXJ3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $cfXJ3.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $eyroE.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $fr8i3(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$9zOBF(reason)) {
            $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $fr8i3(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("fr8i3", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $cfXJ3.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("9zOBF", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("eyroE", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");

var $9KfEp = parcelRequire("9KfEp");
var $a9897e12be8d83bc$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, value) {
    if (!$cfXJ3.isUndefined(headers) && $cfXJ3.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $a9897e12be8d83bc$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("cl3tj"));
    return adapter;
}
var $a9897e12be8d83bc$var$defaults = {
    adapter: $a9897e12be8d83bc$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9KfEp(headers, 'Accept');
            $9KfEp(headers, 'Content-Type');
            if ($cfXJ3.isFormData(data) || $cfXJ3.isArrayBuffer(data) || $cfXJ3.isBuffer(data) || $cfXJ3.isStream(data) || $cfXJ3.isFile(data) || $cfXJ3.isBlob(data)) return data;
            if ($cfXJ3.isArrayBufferView(data)) return data.buffer;
            if ($cfXJ3.isURLSearchParams(data)) {
                $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($cfXJ3.isObject(data)) {
                $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$a9897e12be8d83bc$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$cfXJ3.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $a9897e12be8d83bc$var$defaults.headers[method] = {};
});
$cfXJ3.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $a9897e12be8d83bc$var$defaults.headers[method] = $cfXJ3.merge($a9897e12be8d83bc$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $a9897e12be8d83bc$var$defaults;

});
parcelRegister("9KfEp", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $cfXJ3.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("cl3tj", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");

var $1iZhD = parcelRequire("1iZhD");

var $kh5iz = parcelRequire("kh5iz");

var $cDv4o = parcelRequire("cDv4o");

var $fNAMV = parcelRequire("fNAMV");

var $8Ri5J = parcelRequire("8Ri5J");

var $a47WW = parcelRequire("a47WW");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($cfXJ3.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $cDv4o(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $kh5iz(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $fNAMV(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1iZhD(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($a47WW('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($a47WW('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($a47WW(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($cfXJ3.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("777Uo"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $8Ri5J(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $cfXJ3.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$cfXJ3.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("1iZhD", function(module, exports) {
'use strict';

var $a47WW = parcelRequire("a47WW");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($a47WW('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("a47WW", function(module, exports) {
'use strict';

var $53Eo5 = parcelRequire("53Eo5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $53Eo5(error, config, code, request, response);
};

});
parcelRegister("53Eo5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("cDv4o", function(module, exports) {
'use strict';

var $fWd87 = parcelRequire("fWd87");

var $dLRtT = parcelRequire("dLRtT");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$fWd87(requestedURL)) return $dLRtT(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("fWd87", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("dLRtT", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("fNAMV", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $b807f7f7b4b7c70f$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $cfXJ3.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $cfXJ3.trim(line.substr(0, i)).toLowerCase();
        val = $cfXJ3.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $b807f7f7b4b7c70f$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("8Ri5J", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = $cfXJ3.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $cfXJ3.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("777Uo", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = $cfXJ3.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($cfXJ3.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($cfXJ3.isString(path)) cookie.push('path=' + path);
            if ($cfXJ3.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("6Ozi4", function(module, exports) {
'use strict';

var $cfXJ3 = parcelRequire("cfXJ3");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'params',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'url',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'maxContentLength',
        'validateStatus',
        'maxRedirects',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath'
    ];
    $cfXJ3.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
    });
    $cfXJ3.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($cfXJ3.isObject(config2[prop])) config[prop] = $cfXJ3.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if ($cfXJ3.isObject(config1[prop])) config[prop] = $cfXJ3.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    $cfXJ3.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $cfXJ3.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("6otJi", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $4a7c0ba89fe1b16d$var$Cancel(message) {
    this.message = message;
}
$4a7c0ba89fe1b16d$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$4a7c0ba89fe1b16d$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $4a7c0ba89fe1b16d$var$Cancel;

});

parcelRegister("emRt6", function(module, exports) {
'use strict';

var $6otJi = parcelRequire("6otJi");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $a75c987db5a96b51$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $6otJi(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $a75c987db5a96b51$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $a75c987db5a96b51$var$CancelToken.source = function source() {
    var cancel;
    var token = new $a75c987db5a96b51$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $a75c987db5a96b51$var$CancelToken;

});

parcelRegister("6FgZm", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});



parcelRegister("3rLfV", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("fDLKI"))($parcel$resolve("2CqEm")),
    (parcelRequire("3WFuy"))($parcel$resolve("cIVpX"))
]).then(()=>parcelRequire('a2LqC'));

});
parcelRegister("fDLKI", function(module, exports) {
"use strict";

var $667pM = parcelRequire("667pM");
module.exports = $667pM(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("667pM", function(module, exports) {
"use strict";
var $47090e09928e24bd$var$cachedBundles = {};
var $47090e09928e24bd$var$cachedPreloads = {};
var $47090e09928e24bd$var$cachedPrefetches = {};
function $47090e09928e24bd$var$getCache(type) {
    switch(type){
        case 'preload':
            return $47090e09928e24bd$var$cachedPreloads;
        case 'prefetch':
            return $47090e09928e24bd$var$cachedPrefetches;
        default:
            return $47090e09928e24bd$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $47090e09928e24bd$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("3WFuy", function(module, exports) {
"use strict";

var $667pM = parcelRequire("667pM");
module.exports = $667pM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("hSYxp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d056705ebc042568$export$2e2bcd8739ae039; });

var $kWBQl = parcelRequire("kWBQl");
function $d056705ebc042568$var$shuffle(o) {
    for(let j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
}
var $d056705ebc042568$export$2e2bcd8739ae039 = {
    components: {
        ImageView: $kWBQl.default
    },
    props: {
        images: {
            type: Array
        }
    },
    data () {
        return {
            currentSlideId: 0,
            currentSlideHandle: void 0
        };
    },
    computed: {
        slides () {
            if (this.images.length) return $d056705ebc042568$var$shuffle(this.images);
            return [];
        }
    },
    methods: {
        showNextSlide () {
            this.currentSlideId = (this.currentSlideId + 1) % this.slides.length;
        },
        showPrevSlide () {
            this.currentSlideId = (this.currentSlideId - 1 + this.slides.length) % this.slides.length;
        },
        createSlideHandle () {
            this.currentSlideHandle = this.currentSlideHandle || setInterval(this.showNextSlide, 5000);
        },
        removeSlideHandle () {
            clearInterval(this.currentSlideHandle);
            this.currentSlideHandle = void 0;
        }
    },
    mounted () {
        this.createSlideHandle();
    },
    beforeDestroy () {
        this.removeSlideHandle();
    }
};

});
parcelRegister("kWBQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3f6944c9bc1d578$export$2e2bcd8739ae039; });
let $f3f6944c9bc1d578$var$script;



let $f3f6944c9bc1d578$var$initialize = ()=>{
    $f3f6944c9bc1d578$var$script = (parcelRequire("akq03"));
    if ($f3f6944c9bc1d578$var$script.__esModule) $f3f6944c9bc1d578$var$script = $f3f6944c9bc1d578$var$script.default;
    $f3f6944c9bc1d578$var$script.render = (parcelRequire("5j0vS")).render;
    (parcelRequire("j1mNt")).default($f3f6944c9bc1d578$var$script);
    $f3f6944c9bc1d578$var$script.__scopeId = 'data-v-e7ce9f';
    $f3f6944c9bc1d578$var$script.__file = "ImageView.vue";
};
$f3f6944c9bc1d578$var$initialize();
var $f3f6944c9bc1d578$export$2e2bcd8739ae039 = $f3f6944c9bc1d578$var$script;

});
parcelRegister("akq03", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0b4e1e9313dc5df2$export$2e2bcd8739ae039; });

var $ls5jG = parcelRequire("ls5jG");
var $0b4e1e9313dc5df2$export$2e2bcd8739ae039 = {
    name: 'ImageView',
    components: {
        Image: $ls5jG.Image
    },
    props: {
        file: Object,
        width: Number,
        height: Number
    },
    computed: {
        imageKitEndpoint () {
            return window.systemConfig.imageKitEndpoint;
        }
    }
};

});
parcelRegister("ls5jG", function(module, exports) {

$parcel$export(module.exports, "Image", function () { return $f9e0563c1f454c21$export$3e431a229df88919; });

var $9xflP = parcelRequire("9xflP");

var $jtAZT = parcelRequire("jtAZT");
var $f9e0563c1f454c21$require$Buffer = $jtAZT.Buffer;
var $f9e0563c1f454c21$var$I = {
    MISSING_UPLOAD_FILE_PARAMETER: {
        message: "Missing file parameter for upload"
    },
    MISSING_UPLOAD_FILENAME_PARAMETER: {
        message: "Missing fileName parameter for upload"
    },
    MISSING_PUBLIC_KEY: {
        message: "Missing public key for upload"
    },
    UPLOAD_ENDPOINT_NETWORK_ERROR: {
        message: "Request to ImageKit upload endpoint failed due to network error"
    },
    MISSING_SIGNATURE: {
        message: "Missing signature for upload. The SDK expects token, signature and expire for authentication."
    },
    MISSING_TOKEN: {
        message: "Missing token for upload. The SDK expects token, signature and expire for authentication."
    },
    MISSING_EXPIRE: {
        message: "Missing expire for upload. The SDK expects token, signature and expire for authentication."
    },
    INVALID_TRANSFORMATION: {
        message: "Invalid transformation parameter. Please include at least pre, post, or both."
    },
    INVALID_PRE_TRANSFORMATION: {
        message: "Invalid pre transformation parameter."
    },
    INVALID_POST_TRANSFORMATION: {
        message: "Invalid post transformation parameter."
    }
};
class $f9e0563c1f454c21$export$46d819725f7d5e47 extends Error {
    constructor(t, r){
        super(t), this.$ResponseMetadata = void 0, this.name = "ImageKitInvalidRequestError", this.$ResponseMetadata = r;
    }
}
class $f9e0563c1f454c21$export$bf35435bbfc8b4ea extends Error {
    constructor(t, r){
        super(t), this.reason = void 0, this.name = "ImageKitAbortError", this.reason = r;
    }
}
class $f9e0563c1f454c21$export$c3937bfcf970c5ac extends Error {
    constructor(t){
        super(t), this.name = "ImageKitUploadNetworkError";
    }
}
class $f9e0563c1f454c21$export$d378fe5073e4883f extends Error {
    constructor(t, r){
        super(t), this.$ResponseMetadata = void 0, this.name = "ImageKitServerError", this.$ResponseMetadata = r;
    }
}
const $f9e0563c1f454c21$export$a3c8e1472dc2ed84 = (e)=>e ? new Promise((t, r)=>{
        const { xhr: l } = e || {};
        delete e.xhr;
        const s = l || new XMLHttpRequest();
        if (!e.file) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_UPLOAD_FILE_PARAMETER.message));
        if (!e.fileName) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_UPLOAD_FILENAME_PARAMETER.message));
        if (!e.publicKey || e.publicKey.length === 0) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_PUBLIC_KEY.message));
        if (!e.token) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_TOKEN.message));
        if (!e.signature) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_SIGNATURE.message));
        if (!e.expire) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.MISSING_EXPIRE.message));
        if (e.transformation) {
            if (!(Object.keys(e.transformation).includes("pre") || Object.keys(e.transformation).includes("post"))) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.INVALID_TRANSFORMATION.message));
            if (Object.keys(e.transformation).includes("pre") && !e.transformation.pre) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.INVALID_PRE_TRANSFORMATION.message));
            if (Object.keys(e.transformation).includes("post")) {
                if (Array.isArray(e.transformation.post)) for (let a of e.transformation.post){
                    if (a.type === "abs" && !(a.protocol || a.value)) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.INVALID_POST_TRANSFORMATION.message));
                    if (a.type === "transformation" && !a.value) return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.INVALID_POST_TRANSFORMATION.message));
                }
                else return r(new $f9e0563c1f454c21$export$46d819725f7d5e47($f9e0563c1f454c21$var$I.INVALID_POST_TRANSFORMATION.message));
            }
        }
        var u = new FormData();
        let n;
        for(n in e)if (n) {
            if (n === "file" && typeof e.file != "string") u.set("file", e.file, String(e.fileName));
            else if (n === "tags" && Array.isArray(e.tags)) u.set("tags", e.tags.join(","));
            else if (n === "signature") u.set("signature", e.signature);
            else if (n === "expire") u.set("expire", String(e.expire));
            else if (n === "token") u.set("token", e.token);
            else if (n === "responseFields" && Array.isArray(e.responseFields)) u.set("responseFields", e.responseFields.join(","));
            else if (n === "extensions" && Array.isArray(e.extensions)) u.set("extensions", JSON.stringify(e.extensions));
            else if (n === "customMetadata" && typeof e.customMetadata == "object" && !Array.isArray(e.customMetadata) && e.customMetadata !== null) u.set("customMetadata", JSON.stringify(e.customMetadata));
            else if (n === "transformation" && typeof e.transformation == "object" && e.transformation !== null) u.set(n, JSON.stringify(e.transformation));
            else if (n === "checks" && e.checks) u.set("checks", e.checks);
            else if (e[n] !== void 0) {
                if ([
                    "onProgress",
                    "abortSignal"
                ].includes(n)) continue;
                u.set(n, String(e[n]));
            }
        }
        e.onProgress && (s.upload.onprogress = function(a) {
            e.onProgress && e.onProgress(a);
        });
        function f() {
            var a;
            return s.abort(), r(new $f9e0563c1f454c21$export$bf35435bbfc8b4ea("Upload aborted", (a = e.abortSignal) === null || a === void 0 ? void 0 : a.reason));
        }
        if (e.abortSignal) {
            if (e.abortSignal.aborted) {
                var i;
                return r(new $f9e0563c1f454c21$export$bf35435bbfc8b4ea("Upload aborted", (i = e.abortSignal) === null || i === void 0 ? void 0 : i.reason));
            }
            e.abortSignal.addEventListener("abort", f), s.addEventListener("loadend", ()=>{
                e.abortSignal && e.abortSignal.removeEventListener("abort", f);
            });
        }
        s.open("POST", "https://upload.imagekit.io/api/v1/files/upload"), s.onerror = function(a) {
            return r(new $f9e0563c1f454c21$export$c3937bfcf970c5ac($f9e0563c1f454c21$var$I.UPLOAD_ENDPOINT_NETWORK_ERROR.message));
        }, s.onload = function() {
            if (s.status >= 200 && s.status < 300) try {
                var a = JSON.parse(s.responseText), o = $f9e0563c1f454c21$var$X(a, s);
                return t(o);
            } catch (d) {
                return r(d);
            }
            else if (s.status >= 400 && s.status < 500) try {
                var a = JSON.parse(s.responseText);
                return r(new $f9e0563c1f454c21$export$46d819725f7d5e47(a.message ?? "Invalid request. Please check the parameters.", $f9e0563c1f454c21$var$P(s)));
            } catch (d) {
                return r(d);
            }
            else try {
                var a = JSON.parse(s.responseText);
                return r(new $f9e0563c1f454c21$export$d378fe5073e4883f(a.message ?? "Server error occurred while uploading the file. This is rare and usually temporary.", $f9e0563c1f454c21$var$P(s)));
            } catch  {
                return r(new $f9e0563c1f454c21$export$d378fe5073e4883f("Server error occurred while uploading the file. This is rare and usually temporary.", $f9e0563c1f454c21$var$P(s)));
            }
        }, s.send(u);
    }) : Promise.reject(new $f9e0563c1f454c21$export$46d819725f7d5e47("Invalid options provided for upload")), $f9e0563c1f454c21$var$X = (e, t)=>{
    let r = {
        ...e
    };
    const l = $f9e0563c1f454c21$var$P(t);
    return Object.defineProperty(r, "$ResponseMetadata", {
        value: l,
        enumerable: !1,
        writable: !1
    }), r;
}, $f9e0563c1f454c21$var$P = (e)=>{
    const t = $f9e0563c1f454c21$var$Q(e);
    return {
        statusCode: e.status,
        headers: t,
        requestId: t["x-request-id"]
    };
};
function $f9e0563c1f454c21$var$Q(e) {
    const t = {}, r = e.getAllResponseHeaders();
    return Object.keys(r).length && r.trim().split(/[\r\n]+/).map((l)=>l.split(/: /)).forEach((l)=>{
        t[l[0].trim().toLowerCase()] = l[1].trim();
    }), t;
}
const $f9e0563c1f454c21$var$$ = {
    width: "w",
    height: "h",
    aspectRatio: "ar",
    background: "bg",
    border: "b",
    crop: "c",
    cropMode: "cm",
    dpr: "dpr",
    focus: "fo",
    quality: "q",
    x: "x",
    xCenter: "xc",
    y: "y",
    yCenter: "yc",
    format: "f",
    videoCodec: "vc",
    audioCodec: "ac",
    radius: "r",
    rotation: "rt",
    blur: "bl",
    named: "n",
    defaultImage: "di",
    flip: "fl",
    original: "orig",
    startOffset: "so",
    endOffset: "eo",
    duration: "du",
    streamingResolutions: "sr",
    grayscale: "e-grayscale",
    aiUpscale: "e-upscale",
    aiRetouch: "e-retouch",
    aiVariation: "e-genvar",
    aiDropShadow: "e-dropshadow",
    aiChangeBackground: "e-changebg",
    aiRemoveBackground: "e-bgremove",
    aiRemoveBackgroundExternal: "e-removedotbg",
    contrastStretch: "e-contrast",
    shadow: "e-shadow",
    sharpen: "e-sharpen",
    unsharpMask: "e-usm",
    gradient: "e-gradient",
    progressive: "pr",
    lossless: "lo",
    colorProfile: "cp",
    metadata: "md",
    opacity: "o",
    trim: "t",
    zoom: "z",
    page: "pg",
    fontSize: "fs",
    fontFamily: "ff",
    fontColor: "co",
    innerAlignment: "ia",
    padding: "pa",
    alpha: "al",
    typography: "tg",
    lineHeight: "lh",
    fontOutline: "fol",
    fontShadow: "fsh",
    raw: "raw"
}, $f9e0563c1f454c21$var$Z = "query", $f9e0563c1f454c21$var$ee = ":", $f9e0563c1f454c21$var$re = ",", $f9e0563c1f454c21$var$te = "-";
var $f9e0563c1f454c21$var$E = {
    addAsQueryParameter: (e)=>e.transformationPosition === $f9e0563c1f454c21$var$Z,
    getTransformKey: function(e) {
        return e && ($f9e0563c1f454c21$var$$[e] || $f9e0563c1f454c21$var$$[e.toLowerCase()]) || "";
    },
    getChainTransformDelimiter: function() {
        return $f9e0563c1f454c21$var$ee;
    },
    getTransformDelimiter: function() {
        return $f9e0563c1f454c21$var$re;
    },
    getTransformKeyValueDelimiter: function() {
        return $f9e0563c1f454c21$var$te;
    }
};
const $f9e0563c1f454c21$var$b = function(e) {
    return typeof window < "u" ? btoa(e) : $f9e0563c1f454c21$require$Buffer.from(e, "utf8").toString("base64");
}, $f9e0563c1f454c21$var$T = "tr", $f9e0563c1f454c21$var$ne = new RegExp("^[a-zA-Z0-9-._/ ]*$"), $f9e0563c1f454c21$var$se = new RegExp("^[a-zA-Z0-9-._ ]*$");
function $f9e0563c1f454c21$var$O(e) {
    return typeof e == "string" && e[e.length - 1] == "/" && (e = e.substring(0, e.length - 1)), e;
}
function $f9e0563c1f454c21$var$z(e) {
    return typeof e == "string" && e[0] == "/" && (e = e.slice(1)), e;
}
function $f9e0563c1f454c21$var$N(e, t) {
    var r = "/", l = new RegExp(r + "{1,}", "g");
    return e.join(r).replace(l, r);
}
const $f9e0563c1f454c21$export$9782811e37b4b14c = (e)=>{
    if (e.urlEndpoint = e.urlEndpoint || "", e.src = e.src || "", e.transformationPosition = e.transformationPosition || "query", !e.src) return "";
    const t = e.src.startsWith("http://") || e.src.startsWith("https://");
    var r, l, s;
    try {
        t ? (r = new URL(e.src), l = !0) : (s = new URL(e.urlEndpoint).pathname, r = new URL($f9e0563c1f454c21$var$N([
            e.urlEndpoint.replace(s, ""),
            e.src
        ])));
    } catch (f) {
        return console.error(f), "";
    }
    for(var u in e.queryParameters)r.searchParams.append(u, String(e.queryParameters[u]));
    var n = $f9e0563c1f454c21$export$51f55cf08641e356(e.transformation);
    return n && n.length && !$f9e0563c1f454c21$var$E.addAsQueryParameter(e) && !l && (r.pathname = $f9e0563c1f454c21$var$N([
        $f9e0563c1f454c21$var$T + $f9e0563c1f454c21$var$E.getChainTransformDelimiter() + n,
        r.pathname
    ])), s ? r.pathname = $f9e0563c1f454c21$var$N([
        s,
        r.pathname
    ]) : r.pathname = $f9e0563c1f454c21$var$N([
        r.pathname
    ]), n && n.length && ($f9e0563c1f454c21$var$E.addAsQueryParameter(e) || l) ? r.searchParams.toString() !== "" ? `${r.href}&${$f9e0563c1f454c21$var$T}=${n}` : `${r.href}?${$f9e0563c1f454c21$var$T}=${n}` : r.href;
};
function $f9e0563c1f454c21$var$w(e, t) {
    return e = $f9e0563c1f454c21$var$O($f9e0563c1f454c21$var$z(e)), t === "plain" ? `i-${e.replace(/\//g, "@@")}` : t === "base64" ? `ie-${encodeURIComponent($f9e0563c1f454c21$var$b(e))}` : $f9e0563c1f454c21$var$ne.test(e) ? `i-${e.replace(/\//g, "@@")}` : `ie-${encodeURIComponent($f9e0563c1f454c21$var$b(e))}`;
}
function $f9e0563c1f454c21$var$ie(e, t) {
    return t === "plain" ? `i-${encodeURIComponent(e)}` : t === "base64" ? `ie-${encodeURIComponent($f9e0563c1f454c21$var$b(e))}` : $f9e0563c1f454c21$var$se.test(e) ? `i-${encodeURIComponent(e)}` : `ie-${encodeURIComponent($f9e0563c1f454c21$var$b(e))}`;
}
function $f9e0563c1f454c21$var$ae(e) {
    const t = [], { type: r, position: l = {}, timing: s = {}, transformation: u = [] } = e || {};
    if (!r) return;
    switch(r){
        case "text":
            {
                const c = e;
                if (!c.text) return;
                const g = c.encoding || "auto";
                t.push("l-text"), t.push($f9e0563c1f454c21$var$ie(c.text, g));
            }
            break;
        case "image":
            t.push("l-image");
            {
                const c = e, g = c.encoding || "auto";
                if (c.input) t.push($f9e0563c1f454c21$var$w(c.input, g));
                else return;
            }
            break;
        case "video":
            t.push("l-video");
            {
                const c = e, g = c.encoding || "auto";
                if (c.input) t.push($f9e0563c1f454c21$var$w(c.input, g));
                else return;
            }
            break;
        case "subtitle":
            t.push("l-subtitle");
            {
                const c = e, g = c.encoding || "auto";
                if (c.input) t.push($f9e0563c1f454c21$var$w(c.input, g));
                else return;
            }
            break;
        case "solidColor":
            t.push("l-image"), t.push("i-ik_canvas");
            {
                const c = e;
                if (c.color) t.push(`bg-${c.color}`);
                else return;
            }
            break;
    }
    const { x: n, y: f, focus: i } = l;
    n && t.push(`lx-${n}`), f && t.push(`ly-${f}`), i && t.push(`lfo-${i}`);
    const { start: a, end: o, duration: d } = s;
    a && t.push(`lso-${a}`), o && t.push(`leo-${o}`), d && t.push(`ldu-${d}`);
    const m = $f9e0563c1f454c21$export$51f55cf08641e356(u);
    return m && m.trim() !== "" && t.push(m), t.push("l-end"), t.join($f9e0563c1f454c21$var$E.getTransformDelimiter());
}
const $f9e0563c1f454c21$export$51f55cf08641e356 = function(e) {
    if (!Array.isArray(e)) return "";
    for(var t = [], r = 0, l = e.length; r < l; r++){
        var s = [];
        for(var u in e[r]){
            let i = e[r][u];
            if (i != null) {
                if (u === "overlay" && typeof i == "object") {
                    var n = $f9e0563c1f454c21$var$ae(i);
                    n && n.trim() !== "" && s.push(n);
                    continue;
                }
                var f = $f9e0563c1f454c21$var$E.getTransformKey(u);
                if (f || (f = u), f !== "") {
                    if ([
                        "e-grayscale",
                        "e-contrast",
                        "e-removedotbg",
                        "e-bgremove",
                        "e-upscale",
                        "e-retouch",
                        "e-genvar"
                    ].includes(f)) {
                        if (i === !0 || i === "-" || i === "true") s.push(f);
                        else continue;
                    } else [
                        "e-sharpen",
                        "e-shadow",
                        "e-gradient",
                        "e-usm",
                        "e-dropshadow"
                    ].includes(f) && (i.toString().trim() === "" || i === !0 || i === "true") ? s.push(f) : u === "raw" ? s.push(e[r][u]) : (f === "di" && (i = $f9e0563c1f454c21$var$O($f9e0563c1f454c21$var$z(i || "")), i = i.replace(/\//g, "@@")), f === "sr" && Array.isArray(i) && (i = i.join("_")), f === "t" && i.toString().trim() === "" && (i = "true"), s.push([
                        f,
                        i
                    ].join($f9e0563c1f454c21$var$E.getTransformKeyValueDelimiter())));
                }
            }
        }
        s.length && t.push(s.join($f9e0563c1f454c21$var$E.getTransformDelimiter()));
    }
    return t.join($f9e0563c1f454c21$var$E.getChainTransformDelimiter());
}, $f9e0563c1f454c21$var$oe = [
    640,
    750,
    828,
    1080,
    1200,
    1920,
    2048,
    3840
], $f9e0563c1f454c21$var$ce = [
    16,
    32,
    48,
    64,
    96,
    128,
    256,
    384
];
function $f9e0563c1f454c21$export$52da33f84d8f0248(e) {
    const { src: t, urlEndpoint: r, transformation: l = [], queryParameters: s, transformationPosition: u, sizes: n, width: f, deviceBreakpoints: i = $f9e0563c1f454c21$var$oe, imageBreakpoints: a = $f9e0563c1f454c21$var$ce } = e, o = [
        ...i
    ].sort((p, v)=>p - v), m = [
        ...[
            ...a
        ].sort((p, v)=>p - v),
        ...o
    ].sort((p, v)=>p - v), { candidates: c, descriptorKind: g } = $f9e0563c1f454c21$var$fe({
        allBreakpoints: m,
        deviceBreakpoints: o,
        explicitWidth: f,
        sizesAttr: n
    }), A = (p)=>$f9e0563c1f454c21$export$9782811e37b4b14c({
            src: t,
            urlEndpoint: r,
            queryParameters: s,
            transformationPosition: u,
            transformation: [
                ...l,
                {
                    width: p,
                    crop: "at_max"
                }
            ]
        }), S = c.map((p, v)=>`${A(p)} ${g === "w" ? p : v + 1}${g}`).join(", ") || void 0, _ = n ?? (g === "w" ? "100vw" : void 0);
    return {
        src: A(c[c.length - 1]),
        srcSet: S,
        ..._ ? {
            sizes: _
        } : {},
        ...f !== void 0 ? {
            width: f
        } : {}
    };
}
function $f9e0563c1f454c21$var$fe(e) {
    const { allBreakpoints: t, deviceBreakpoints: r, explicitWidth: l, sizesAttr: s } = e;
    if (s) {
        const i = (s.match(/(^|\s)(1?\d{1,2})vw/g) || []).map((a)=>parseInt(a, 10));
        if (i.length) {
            const a = Math.min(...i) / 100, o = r[0] * a;
            return {
                candidates: t.filter((d)=>d >= o),
                descriptorKind: "w"
            };
        }
        return {
            candidates: t,
            descriptorKind: "w"
        };
    }
    if (typeof l != "number") return {
        candidates: r,
        descriptorKind: "w"
    };
    const u = (f)=>t.find((i)=>i >= f) || t[t.length - 1];
    return {
        candidates: Array.from(/* @__PURE__ */ new Set([
            u(l),
            u(l * 2)
        ])),
        descriptorKind: "x"
    };
}
const $f9e0563c1f454c21$export$ccb701a2e9db6194 = Symbol("ImageKitContext"), $f9e0563c1f454c21$var$le = [
    "width",
    "loading",
    "sizes",
    "srcset",
    "src"
], $f9e0563c1f454c21$export$3e431a229df88919 = /* @__PURE__ */ (0, $9xflP.defineComponent)({
    inheritAttrs: !1,
    __name: "Image",
    props: {
        deviceBreakpoints: {},
        imageBreakpoints: {},
        src: {},
        urlEndpoint: {},
        queryParameters: {},
        transformation: {},
        transformationPosition: {},
        responsive: {},
        width: {},
        sizes: {},
        loading: {}
    },
    setup (e) {
        const t = e, r = (0, $9xflP.inject)($f9e0563c1f454c21$export$ccb701a2e9db6194, {});
        function l(o, d) {
            const m = {
                ...o
            };
            for (const [c, g] of Object.entries(d))g !== void 0 && (m[c] = g);
            return m;
        }
        function s(o) {
            return typeof o == "number" ? Number.isFinite(o) ? o : NaN : typeof o == "string" && /^[0-9]+$/.test(o) ? parseInt(o, 10) : NaN;
        }
        const u = (0, $9xflP.computed)(()=>l(r, t)), n = (0, $9xflP.computed)(()=>{
            const { src: o = "", transformation: d = [], queryParameters: m, urlEndpoint: c, transformationPosition: g, sizes: A, responsive: S = !0, deviceBreakpoints: _, imageBreakpoints: p, width: v, loading: y = "lazy" } = u.value;
            if (!c || c.trim() === "") return console.error("urlEndpoint is neither provided in this component nor in any parent ImageKitProvider."), {
                src: o,
                loading: y
            };
            if (S === !1) return {
                src: $f9e0563c1f454c21$export$9782811e37b4b14c({
                    src: o,
                    transformation: [
                        ...d
                    ],
                    queryParameters: m,
                    urlEndpoint: c,
                    transformationPosition: g
                }),
                loading: y,
                width: v
            };
            const L = s(v), { src: V, srcSet: H } = $f9e0563c1f454c21$export$52da33f84d8f0248({
                src: o,
                transformation: [
                    ...d
                ],
                width: isNaN(L) ? void 0 : L,
                sizes: A,
                queryParameters: m,
                urlEndpoint: c,
                transformationPosition: g,
                deviceBreakpoints: _,
                imageBreakpoints: p
            });
            return {
                responsive: S,
                src: V,
                loading: y,
                srcSet: H,
                sizes: A,
                width: v
            };
        }), f = [
            "src",
            "transformation",
            "queryParameters",
            "urlEndpoint",
            "transformationPosition",
            "sizes",
            "responsive",
            "deviceBreakpoints",
            "imageBreakpoints",
            "srcSet"
        ], i = (0, $9xflP.useAttrs)(), a = (0, $9xflP.computed)(()=>{
            const o = {};
            for (const [d, m] of Object.entries(i))f.includes(d) || (o[d] = m);
            return o;
        });
        return (o, d)=>((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("img", (0, $9xflP.mergeProps)(a.value, {
                width: o.width,
                loading: n.value.loading,
                sizes: n.value.responsive ? n.value.sizes : void 0,
                srcset: n.value.responsive ? n.value.srcSet : void 0,
                src: n.value.src
            }), null, 16, $f9e0563c1f454c21$var$le));
    }
}), $f9e0563c1f454c21$var$de = [
    "src"
], $f9e0563c1f454c21$export$ae01dedf5c052bb = /* @__PURE__ */ (0, $9xflP.defineComponent)({
    __name: "Video",
    props: {
        src: {},
        urlEndpoint: {},
        queryParameters: {},
        transformation: {},
        transformationPosition: {}
    },
    setup (e) {
        const t = e, r = (0, $9xflP.inject)($f9e0563c1f454c21$export$ccb701a2e9db6194, {});
        function l(a, o) {
            const d = {
                ...a
            };
            for (const [m, c] of Object.entries(o))c !== void 0 && (d[m] = c);
            return d;
        }
        const s = (0, $9xflP.computed)(()=>l(r, t)), u = (0, $9xflP.computed)(()=>{
            const { src: a = "", transformation: o = [], queryParameters: d, urlEndpoint: m, transformationPosition: c } = s.value;
            return !m || m.trim() === "" ? (console.error("urlEndpoint is neither provided in this component nor in any parent ImageKitProvider."), {
                src: a
            }) : {
                src: $f9e0563c1f454c21$export$9782811e37b4b14c({
                    urlEndpoint: m,
                    src: a,
                    transformation: [
                        ...o
                    ],
                    queryParameters: d,
                    transformationPosition: c
                })
            };
        }), n = [
            "src",
            "transformation",
            "queryParameters",
            "urlEndpoint",
            "transformationPosition"
        ], f = (0, $9xflP.useAttrs)(), i = (0, $9xflP.computed)(()=>{
            const a = {};
            for (const [o, d] of Object.entries(f))n.includes(o) || (a[o] = d);
            return a;
        });
        return (a, o)=>((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("video", (0, $9xflP.mergeProps)(i.value, {
                src: u.value.src
            }), null, 16, $f9e0563c1f454c21$var$de));
    }
}), $f9e0563c1f454c21$export$b21e262ca94a8654 = /* @__PURE__ */ (0, $9xflP.defineComponent)({
    __name: "ImageKitProvider",
    props: {
        urlEndpoint: {},
        transformationPosition: {}
    },
    setup (e) {
        return (0, $9xflP.provide)($f9e0563c1f454c21$export$ccb701a2e9db6194, (0, $9xflP.reactive)(e)), (r, l)=>(0, $9xflP.renderSlot)(r.$slots, "default");
    }
});

});
parcelRegister("jtAZT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e2dd6ca73773b9a6$export$a143d493d941bafc; }, function (v) { return $e2dd6ca73773b9a6$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e2dd6ca73773b9a6$export$f99ded8fe4b79145; }, function (v) { return $e2dd6ca73773b9a6$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e2dd6ca73773b9a6$export$a143d493d941bafc;
var $e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a;
var $e2dd6ca73773b9a6$export$f99ded8fe4b79145;
var $e2dd6ca73773b9a6$export$599f31c3813fae4d;
'use strict';

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $e2dd6ca73773b9a6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e2dd6ca73773b9a6$export$a143d493d941bafc = $e2dd6ca73773b9a6$var$Buffer;
$e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a = $e2dd6ca73773b9a6$var$SlowBuffer;
$e2dd6ca73773b9a6$export$f99ded8fe4b79145 = 50;
const $e2dd6ca73773b9a6$var$K_MAX_LENGTH = 0x7fffffff;
$e2dd6ca73773b9a6$export$599f31c3813fae4d = $e2dd6ca73773b9a6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e2dd6ca73773b9a6$var$Buffer.TYPED_ARRAY_SUPPORT = $e2dd6ca73773b9a6$var$typedArraySupport();
if (!$e2dd6ca73773b9a6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e2dd6ca73773b9a6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e2dd6ca73773b9a6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e2dd6ca73773b9a6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e2dd6ca73773b9a6$var$createBuffer(length) {
    if (length > $e2dd6ca73773b9a6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e2dd6ca73773b9a6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e2dd6ca73773b9a6$var$allocUnsafe(arg);
    }
    return $e2dd6ca73773b9a6$var$from(arg, encodingOrOffset, length);
}
$e2dd6ca73773b9a6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e2dd6ca73773b9a6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e2dd6ca73773b9a6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e2dd6ca73773b9a6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e2dd6ca73773b9a6$var$isInstance(value, ArrayBuffer) || value && $e2dd6ca73773b9a6$var$isInstance(value.buffer, ArrayBuffer)) return $e2dd6ca73773b9a6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e2dd6ca73773b9a6$var$isInstance(value, SharedArrayBuffer) || value && $e2dd6ca73773b9a6$var$isInstance(value.buffer, SharedArrayBuffer))) return $e2dd6ca73773b9a6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e2dd6ca73773b9a6$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e2dd6ca73773b9a6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e2dd6ca73773b9a6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e2dd6ca73773b9a6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e2dd6ca73773b9a6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e2dd6ca73773b9a6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e2dd6ca73773b9a6$var$Buffer, Uint8Array);
function $e2dd6ca73773b9a6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e2dd6ca73773b9a6$var$alloc(size, fill, encoding) {
    $e2dd6ca73773b9a6$var$assertSize(size);
    if (size <= 0) return $e2dd6ca73773b9a6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e2dd6ca73773b9a6$var$createBuffer(size).fill(fill, encoding) : $e2dd6ca73773b9a6$var$createBuffer(size).fill(fill);
    return $e2dd6ca73773b9a6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e2dd6ca73773b9a6$var$Buffer.alloc = function(size, fill, encoding) {
    return $e2dd6ca73773b9a6$var$alloc(size, fill, encoding);
};
function $e2dd6ca73773b9a6$var$allocUnsafe(size) {
    $e2dd6ca73773b9a6$var$assertSize(size);
    return $e2dd6ca73773b9a6$var$createBuffer(size < 0 ? 0 : $e2dd6ca73773b9a6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e2dd6ca73773b9a6$var$Buffer.allocUnsafe = function(size) {
    return $e2dd6ca73773b9a6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e2dd6ca73773b9a6$var$Buffer.allocUnsafeSlow = function(size) {
    return $e2dd6ca73773b9a6$var$allocUnsafe(size);
};
function $e2dd6ca73773b9a6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e2dd6ca73773b9a6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $e2dd6ca73773b9a6$var$byteLength(string, encoding) | 0;
    let buf = $e2dd6ca73773b9a6$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e2dd6ca73773b9a6$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e2dd6ca73773b9a6$var$checked(array.length) | 0;
    const buf = $e2dd6ca73773b9a6$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e2dd6ca73773b9a6$var$fromArrayView(arrayView) {
    if ($e2dd6ca73773b9a6$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e2dd6ca73773b9a6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e2dd6ca73773b9a6$var$fromArrayLike(arrayView);
}
function $e2dd6ca73773b9a6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return buf;
}
function $e2dd6ca73773b9a6$var$fromObject(obj) {
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(obj)) {
        const len = $e2dd6ca73773b9a6$var$checked(obj.length) | 0;
        const buf = $e2dd6ca73773b9a6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e2dd6ca73773b9a6$var$numberIsNaN(obj.length)) return $e2dd6ca73773b9a6$var$createBuffer(0);
        return $e2dd6ca73773b9a6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e2dd6ca73773b9a6$var$fromArrayLike(obj.data);
}
function $e2dd6ca73773b9a6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e2dd6ca73773b9a6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e2dd6ca73773b9a6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e2dd6ca73773b9a6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e2dd6ca73773b9a6$var$Buffer.alloc(+length);
}
$e2dd6ca73773b9a6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e2dd6ca73773b9a6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e2dd6ca73773b9a6$var$Buffer.compare = function compare(a, b) {
    if ($e2dd6ca73773b9a6$var$isInstance(a, Uint8Array)) a = $e2dd6ca73773b9a6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e2dd6ca73773b9a6$var$isInstance(b, Uint8Array)) b = $e2dd6ca73773b9a6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(a) || !$e2dd6ca73773b9a6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e2dd6ca73773b9a6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e2dd6ca73773b9a6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e2dd6ca73773b9a6$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e2dd6ca73773b9a6$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e2dd6ca73773b9a6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(buf)) buf = $e2dd6ca73773b9a6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e2dd6ca73773b9a6$var$byteLength(string, encoding) {
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e2dd6ca73773b9a6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e2dd6ca73773b9a6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e2dd6ca73773b9a6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e2dd6ca73773b9a6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e2dd6ca73773b9a6$var$Buffer.byteLength = $e2dd6ca73773b9a6$var$byteLength;
function $e2dd6ca73773b9a6$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e2dd6ca73773b9a6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e2dd6ca73773b9a6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e2dd6ca73773b9a6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e2dd6ca73773b9a6$var$latin1Slice(this, start, end);
        case 'base64':
            return $e2dd6ca73773b9a6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e2dd6ca73773b9a6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e2dd6ca73773b9a6$var$Buffer.prototype._isBuffer = true;
function $e2dd6ca73773b9a6$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$e2dd6ca73773b9a6$var$swap(this, i, i + 1);
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $e2dd6ca73773b9a6$var$swap(this, i, i + 3);
        $e2dd6ca73773b9a6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $e2dd6ca73773b9a6$var$swap(this, i, i + 7);
        $e2dd6ca73773b9a6$var$swap(this, i + 1, i + 6);
        $e2dd6ca73773b9a6$var$swap(this, i + 2, i + 5);
        $e2dd6ca73773b9a6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e2dd6ca73773b9a6$var$utf8Slice(this, 0, length);
    return $e2dd6ca73773b9a6$var$slowToString.apply(this, arguments);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toLocaleString = $e2dd6ca73773b9a6$var$Buffer.prototype.toString;
$e2dd6ca73773b9a6$var$Buffer.prototype.equals = function equals(b) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e2dd6ca73773b9a6$var$Buffer.compare(this, b) === 0;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $e2dd6ca73773b9a6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e2dd6ca73773b9a6$var$customInspectSymbol) $e2dd6ca73773b9a6$var$Buffer.prototype[$e2dd6ca73773b9a6$var$customInspectSymbol] = $e2dd6ca73773b9a6$var$Buffer.prototype.inspect;
$e2dd6ca73773b9a6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e2dd6ca73773b9a6$var$isInstance(target, Uint8Array)) target = $e2dd6ca73773b9a6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e2dd6ca73773b9a6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e2dd6ca73773b9a6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e2dd6ca73773b9a6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e2dd6ca73773b9a6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e2dd6ca73773b9a6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e2dd6ca73773b9a6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e2dd6ca73773b9a6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e2dd6ca73773b9a6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e2dd6ca73773b9a6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e2dd6ca73773b9a6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e2dd6ca73773b9a6$var$utf8Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$asciiWrite(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$asciiToBytes(string), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$base64Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$base64ToBytes(string), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$ucs2Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e2dd6ca73773b9a6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e2dd6ca73773b9a6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e2dd6ca73773b9a6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e2dd6ca73773b9a6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e2dd6ca73773b9a6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e2dd6ca73773b9a6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e2dd6ca73773b9a6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $e2dd6ca73773b9a6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e2dd6ca73773b9a6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e2dd6ca73773b9a6$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e2dd6ca73773b9a6$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e2dd6ca73773b9a6$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e2dd6ca73773b9a6$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $e2dd6ca73773b9a6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e2dd6ca73773b9a6$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e2dd6ca73773b9a6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e2dd6ca73773b9a6$var$Buffer.prototype.readUintLE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUintBE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint8 = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint16LE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint16BE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint32LE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint32BE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readBigUInt64LE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e2dd6ca73773b9a6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e2dd6ca73773b9a6$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e2dd6ca73773b9a6$var$Buffer.prototype.readBigUInt64BE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e2dd6ca73773b9a6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e2dd6ca73773b9a6$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e2dd6ca73773b9a6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readBigInt64LE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e2dd6ca73773b9a6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e2dd6ca73773b9a6$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e2dd6ca73773b9a6$var$Buffer.prototype.readBigInt64BE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e2dd6ca73773b9a6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e2dd6ca73773b9a6$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e2dd6ca73773b9a6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $e2dd6ca73773b9a6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUintLE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUintBE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint8 = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint16LE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint16BE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint32LE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint32BE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e2dd6ca73773b9a6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e2dd6ca73773b9a6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e2dd6ca73773b9a6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e2dd6ca73773b9a6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeBigUInt64LE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e2dd6ca73773b9a6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e2dd6ca73773b9a6$var$Buffer.prototype.writeBigUInt64BE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e2dd6ca73773b9a6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e2dd6ca73773b9a6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeBigInt64LE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e2dd6ca73773b9a6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e2dd6ca73773b9a6$var$Buffer.prototype.writeBigInt64BE = $e2dd6ca73773b9a6$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e2dd6ca73773b9a6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e2dd6ca73773b9a6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeFloat(this, value, offset, true, noAssert);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeFloat(this, value, offset, false, noAssert);
};
function $e2dd6ca73773b9a6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeDouble(this, value, offset, true, noAssert);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e2dd6ca73773b9a6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e2dd6ca73773b9a6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e2dd6ca73773b9a6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e2dd6ca73773b9a6$var$Buffer.isBuffer(val) ? val : $e2dd6ca73773b9a6$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e2dd6ca73773b9a6$var$errors = {};
function $e2dd6ca73773b9a6$var$E(sym, getMessage, Base) {
    $e2dd6ca73773b9a6$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$e2dd6ca73773b9a6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e2dd6ca73773b9a6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e2dd6ca73773b9a6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e2dd6ca73773b9a6$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e2dd6ca73773b9a6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e2dd6ca73773b9a6$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e2dd6ca73773b9a6$var$checkBounds(buf, offset, byteLength) {
    $e2dd6ca73773b9a6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e2dd6ca73773b9a6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e2dd6ca73773b9a6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e2dd6ca73773b9a6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e2dd6ca73773b9a6$var$checkBounds(buf, offset, byteLength);
}
function $e2dd6ca73773b9a6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e2dd6ca73773b9a6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e2dd6ca73773b9a6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e2dd6ca73773b9a6$var$validateNumber(value, type);
        throw new $e2dd6ca73773b9a6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e2dd6ca73773b9a6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e2dd6ca73773b9a6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e2dd6ca73773b9a6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e2dd6ca73773b9a6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e2dd6ca73773b9a6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e2dd6ca73773b9a6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e2dd6ca73773b9a6$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e2dd6ca73773b9a6$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e2dd6ca73773b9a6$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($e2dd6ca73773b9a6$var$base64clean(str));
}
function $e2dd6ca73773b9a6$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e2dd6ca73773b9a6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e2dd6ca73773b9a6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e2dd6ca73773b9a6$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e2dd6ca73773b9a6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e2dd6ca73773b9a6$var$BufferBigIntNotDefined : fn;
}
function $e2dd6ca73773b9a6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("gxC2H", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $c0ad3cdf54feed88$export$d622b2ad8d90c771; }, function (v) { return $c0ad3cdf54feed88$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $c0ad3cdf54feed88$export$6100ba28696e12de; }, function (v) { return $c0ad3cdf54feed88$export$6100ba28696e12de = v; });
var $c0ad3cdf54feed88$export$a48f0734ac7c2329;
var $c0ad3cdf54feed88$export$d622b2ad8d90c771;
var $c0ad3cdf54feed88$export$6100ba28696e12de;
'use strict';
$c0ad3cdf54feed88$export$a48f0734ac7c2329 = $c0ad3cdf54feed88$var$byteLength;
$c0ad3cdf54feed88$export$d622b2ad8d90c771 = $c0ad3cdf54feed88$var$toByteArray;
$c0ad3cdf54feed88$export$6100ba28696e12de = $c0ad3cdf54feed88$var$fromByteArray;
var $c0ad3cdf54feed88$var$lookup = [];
var $c0ad3cdf54feed88$var$revLookup = [];
var $c0ad3cdf54feed88$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $c0ad3cdf54feed88$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $c0ad3cdf54feed88$var$i = 0, $c0ad3cdf54feed88$var$len = $c0ad3cdf54feed88$var$code.length; $c0ad3cdf54feed88$var$i < $c0ad3cdf54feed88$var$len; ++$c0ad3cdf54feed88$var$i){
    $c0ad3cdf54feed88$var$lookup[$c0ad3cdf54feed88$var$i] = $c0ad3cdf54feed88$var$code[$c0ad3cdf54feed88$var$i];
    $c0ad3cdf54feed88$var$revLookup[$c0ad3cdf54feed88$var$code.charCodeAt($c0ad3cdf54feed88$var$i)] = $c0ad3cdf54feed88$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c0ad3cdf54feed88$var$revLookup['-'.charCodeAt(0)] = 62;
$c0ad3cdf54feed88$var$revLookup['_'.charCodeAt(0)] = 63;
function $c0ad3cdf54feed88$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c0ad3cdf54feed88$var$byteLength(b64) {
    var lens = $c0ad3cdf54feed88$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c0ad3cdf54feed88$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c0ad3cdf54feed88$var$toByteArray(b64) {
    var tmp;
    var lens = $c0ad3cdf54feed88$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c0ad3cdf54feed88$var$Arr($c0ad3cdf54feed88$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 18 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 2 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 10 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c0ad3cdf54feed88$var$tripletToBase64(num) {
    return $c0ad3cdf54feed88$var$lookup[num >> 18 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num >> 12 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num >> 6 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num & 0x3F];
}
function $c0ad3cdf54feed88$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c0ad3cdf54feed88$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $c0ad3cdf54feed88$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c0ad3cdf54feed88$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c0ad3cdf54feed88$var$lookup[tmp >> 2] + $c0ad3cdf54feed88$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c0ad3cdf54feed88$var$lookup[tmp >> 10] + $c0ad3cdf54feed88$var$lookup[tmp >> 4 & 0x3F] + $c0ad3cdf54feed88$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8YfQz", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $68803832b4b2ccb4$export$aafa59e2e03f2942; }, function (v) { return $68803832b4b2ccb4$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $68803832b4b2ccb4$export$68d8715fc104d294; }, function (v) { return $68803832b4b2ccb4$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $68803832b4b2ccb4$export$aafa59e2e03f2942;
var $68803832b4b2ccb4$export$68d8715fc104d294;
$68803832b4b2ccb4$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$68803832b4b2ccb4$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("5j0vS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3dcf1ffa8c60e180$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
function $3dcf1ffa8c60e180$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Image = (0, $9xflP.resolveComponent)("Image");
    return (0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_Image, {
        "url-endpoint": $options.imageKitEndpoint,
        src: $props.file.url || $props.file.smallUrl,
        width: $props.width,
        transformation: [
            {
                width: $props.width,
                height: $props.file.fitIntoFrame ? undefined : $props.height
            }
        ],
        queryParameters: {
            v: $props.file.updatedAt
        },
        alt: $props.file.title
    }, null, 8, [
        "url-endpoint",
        "src",
        "width",
        "transformation",
        "queryParameters",
        "alt"
    ]);
}

});

parcelRegister("j1mNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd8fcb4d04f6423b$export$2e2bcd8739ae039; });
let $dd8fcb4d04f6423b$var$NOOP = ()=>{};
var $dd8fcb4d04f6423b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("dcxto", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $99c65c6e4014eb76$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $99c65c6e4014eb76$var$_hoisted_1 = {
    key: 0
};
const $99c65c6e4014eb76$var$_hoisted_2 = [
    "innerHTML"
];
function $99c65c6e4014eb76$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageView = (0, $9xflP.resolveComponent)("ImageView");
    return $props.images && $props.images.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $99c65c6e4014eb76$var$_hoisted_1, [
        (0, $9xflP.createElementVNode)("div", {
            class: "full-picture",
            onMouseenter: _cache[2] || (_cache[2] = (...args)=>$options.removeSlideHandle && $options.removeSlideHandle(...args)),
            onMouseleave: _cache[3] || (_cache[3] = (...args)=>$options.createSlideHandle && $options.createSlideHandle(...args))
        }, [
            $props.images.length > 1 ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("i", {
                key: 0,
                class: "fa fa-chevron-left",
                style: {
                    "left": "10px"
                },
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.showPrevSlide && $options.showPrevSlide(...args))
            })) : (0, $9xflP.createCommentVNode)("", true),
            $props.images.length > 1 ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("i", {
                key: 1,
                class: "fa fa-chevron-right",
                style: {
                    "right": "10px"
                },
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.showNextSlide && $options.showNextSlide(...args))
            })) : (0, $9xflP.createCommentVNode)("", true),
            (0, $9xflP.createVNode)((0, $9xflP.TransitionGroup), {
                name: "fade"
            }, {
                default: (0, $9xflP.withCtx)(()=>[
                        ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.slides, (slide, idx)=>{
                            return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                                key: 'full-picture-' + idx,
                                class: (0, $9xflP.normalizeClass)([
                                    {
                                        active: idx === $data.currentSlideId
                                    },
                                    "slide"
                                ])
                            }, [
                                (0, $9xflP.createVNode)(_component_ImageView, {
                                    file: slide,
                                    width: 360,
                                    height: 440
                                }, null, 8, [
                                    "file"
                                ]),
                                slide.title && slide.description ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                                    key: 0,
                                    innerHTML: slide.description,
                                    class: "description"
                                }, null, 8, $99c65c6e4014eb76$var$_hoisted_2)) : (0, $9xflP.createCommentVNode)("", true)
                            ], 2);
                        }), 128))
                    ]),
                _: 1
            })
        ], 32)
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("a6UOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75c68869dfd6b22b$export$2e2bcd8739ae039; });
let $75c68869dfd6b22b$var$NOOP = ()=>{};
var $75c68869dfd6b22b$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("9V2sX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $738b59a8cebc6e83$export$2e2bcd8739ae039; });
var $738b59a8cebc6e83$export$2e2bcd8739ae039 = {
    props: {},
    data () {
        return {};
    }
};

});

parcelRegister("1leoA", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $0fa2eb44cc9376e2$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $0fa2eb44cc9376e2$var$_hoisted_1 = {
    class: "benefits"
};
function $0fa2eb44cc9376e2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $0fa2eb44cc9376e2$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $9xflP.createElementVNode)("div", null, [
                (0, $9xflP.createElementVNode)("div", {
                    class: "icon-wrapper"
                }, [
                    (0, $9xflP.createElementVNode)("i", {
                        class: "coin-in-hand"
                    })
                ]),
                (0, $9xflP.createElementVNode)("span", null, "bis zu 80% bezuschusst")
            ], -1),
            (0, $9xflP.createElementVNode)("div", null, [
                (0, $9xflP.createElementVNode)("div", {
                    class: "icon-wrapper"
                }, [
                    (0, $9xflP.createElementVNode)("i", {
                        class: "certificate"
                    })
                ]),
                (0, $9xflP.createElementVNode)("span", null, " von gesetzlichen Krankenkassen gepr\xfcft & zertifiziert ")
            ], -1)
        ])
    ]);
}

});

parcelRegister("ib9j0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c078f8273fd107$export$2e2bcd8739ae039; });
let $d3c078f8273fd107$var$NOOP = ()=>{};
var $d3c078f8273fd107$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("9j7JG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6c6be38e9c51c5b2$export$2e2bcd8739ae039; });
var $6c6be38e9c51c5b2$export$2e2bcd8739ae039 = {
    props: {
        mapUrl: {
            type: String
        },
        previewUrl: {
            type: String
        }
    },
    data () {
        return {
            enabled: false
        };
    },
    methods: {
        enableMap () {
            this.enabled = true;
        }
    }
};

});

parcelRegister("iKBar", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $da695a872e6af853$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $da695a872e6af853$var$_hoisted_1 = {
    key: 0
};
const $da695a872e6af853$var$_hoisted_2 = {
    key: 0
};
const $da695a872e6af853$var$_hoisted_3 = [
    "src"
];
const $da695a872e6af853$var$_hoisted_4 = {
    key: 1
};
const $da695a872e6af853$var$_hoisted_5 = {
    key: 0,
    class: "map-image"
};
const $da695a872e6af853$var$_hoisted_6 = [
    "src"
];
const $da695a872e6af853$var$_hoisted_7 = {
    key: 1
};
function $da695a872e6af853$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.mapUrl ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $da695a872e6af853$var$_hoisted_1, [
        $data.enabled ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $da695a872e6af853$var$_hoisted_2, [
            (0, $9xflP.createElementVNode)("iframe", {
                src: $props.mapUrl,
                class: "map-iframe",
                width: "360",
                height: "360",
                style: {
                    "border": "0"
                },
                allowfullscreen: ""
            }, null, 8, $da695a872e6af853$var$_hoisted_3)
        ])) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $da695a872e6af853$var$_hoisted_4, [
            $props.previewUrl ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $da695a872e6af853$var$_hoisted_5, [
                (0, $9xflP.createElementVNode)("button", {
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.enableMap && $options.enableMap(...args))
                }, "Klicken, um Navigation zu aktivieren"),
                (0, $9xflP.createElementVNode)("img", {
                    alt: "Karte anzeigen",
                    src: $props.previewUrl
                }, null, 8, $da695a872e6af853$var$_hoisted_6)
            ])) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $da695a872e6af853$var$_hoisted_7, [
                (0, $9xflP.createElementVNode)("button", {
                    class: "btn btn-warning",
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.enableMap && $options.enableMap(...args))
                }, " Klicken, um Kartennavigation zu aktivieren ")
            ]))
        ]))
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("hA3cl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccc8478956657f6e$export$2e2bcd8739ae039; });
let $ccc8478956657f6e$var$NOOP = ()=>{};
var $ccc8478956657f6e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a95Vi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3ab3d64f67a3d485$export$2e2bcd8739ae039; });

var $9xflP = parcelRequire("9xflP");
let $3ab3d64f67a3d485$var$googleMapsPromise = null;
function $3ab3d64f67a3d485$var$loadGoogleMaps() {
    if (typeof window === 'undefined') return Promise.resolve();
    if (window.google?.maps?.places) return Promise.resolve();
    if ($3ab3d64f67a3d485$var$googleMapsPromise) return $3ab3d64f67a3d485$var$googleMapsPromise;
    const apiKey = window.appConfig?.mapsApiKey;
    if (!apiKey) return Promise.resolve();
    $3ab3d64f67a3d485$var$googleMapsPromise = new Promise((resolve, reject)=>{
        const existing = document.querySelector('script[data-gmaps]');
        if (existing) {
            existing.addEventListener('load', ()=>resolve());
            existing.addEventListener('error', reject);
            return;
        }
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=places`;
        script.async = true;
        script.setAttribute('data-gmaps', 'true');
        script.onload = ()=>resolve();
        script.onerror = (err)=>reject(err);
        document.head.appendChild(script);
    });
    return $3ab3d64f67a3d485$var$googleMapsPromise;
}
var $3ab3d64f67a3d485$export$2e2bcd8739ae039 = (0, $9xflP.defineComponent)({
    props: {
        placeId: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            isMapsLoaded: false
        };
    },
    computed: {
        isValidPlaceId () {
            return !!this.placeId && this.placeId !== 'null' && this.placeId.trim().length > 0;
        }
    },
    mounted () {
        if (!this.isValidPlaceId) return;
        if (this.$el instanceof HTMLElement && this.$el.offsetParent === null) return;
        if (typeof IntersectionObserver !== 'undefined' && this.$el instanceof HTMLElement) {
            const observer = new IntersectionObserver((entries)=>{
                if (entries.some((entry)=>entry.isIntersecting)) {
                    observer.disconnect();
                    this.initMaps();
                }
            }, {
                rootMargin: '200px'
            });
            observer.observe(this.$el);
        } else this.initMaps();
    },
    methods: {
        async initMaps () {
            try {
                await $3ab3d64f67a3d485$var$loadGoogleMaps();
                this.isMapsLoaded = true;
            } catch (err) {
                console.warn('Google Maps could not be loaded', err);
            }
        }
    }
});

});

parcelRegister("87HJt", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5ea0e6827e76c8ea$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $5ea0e6827e76c8ea$var$_hoisted_1 = {
    key: 0,
    class: "map-place-wrapper"
};
function $5ea0e6827e76c8ea$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_gmp_place_details_place_request = (0, $9xflP.resolveComponent)("gmp-place-details-place-request");
    const _component_gmp_place_rating = (0, $9xflP.resolveComponent)("gmp-place-rating");
    const _component_gmp_place_type = (0, $9xflP.resolveComponent)("gmp-place-type");
    const _component_gmp_place_attribution = (0, $9xflP.resolveComponent)("gmp-place-attribution");
    const _component_gmp_place_content_config = (0, $9xflP.resolveComponent)("gmp-place-content-config");
    const _component_gmp_place_details_compact = (0, $9xflP.resolveComponent)("gmp-place-details-compact");
    return _ctx.isValidPlaceId ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $5ea0e6827e76c8ea$var$_hoisted_1, [
        _ctx.isMapsLoaded ? ((0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_gmp_place_details_compact, {
            key: 0,
            orientation: "horizontal"
        }, {
            default: (0, $9xflP.withCtx)(()=>[
                    (0, $9xflP.createVNode)(_component_gmp_place_details_place_request, {
                        place: _ctx.placeId
                    }, null, 8, [
                        "place"
                    ]),
                    (0, $9xflP.createVNode)(_component_gmp_place_content_config, null, {
                        default: (0, $9xflP.withCtx)(()=>[
                                (0, $9xflP.createVNode)(_component_gmp_place_rating),
                                (0, $9xflP.createVNode)(_component_gmp_place_type),
                                (0, $9xflP.createVNode)(_component_gmp_place_attribution, {
                                    "light-scheme-color": "gray",
                                    "dark-scheme-color": "gray"
                                })
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        })) : (0, $9xflP.createCommentVNode)("", true)
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("i69LM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2d05d921de969ee$export$2e2bcd8739ae039; });
let $d2d05d921de969ee$var$NOOP = ()=>{};
var $d2d05d921de969ee$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lIvrI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $639f8bd766415426$export$2e2bcd8739ae039; });

var $9xflP = parcelRequire("9xflP");

var $7KlvO = parcelRequire("7KlvO");

var $7VdiA = parcelRequire("7VdiA");
var $639f8bd766415426$export$2e2bcd8739ae039 = (0, $9xflP.defineComponent)({
    name: 'ReviewList',
    props: {
        list: {
            type: Array
        }
    },
    methods: {
        abbreviateText: $7VdiA.abbreviateText,
        formatDateToSince: $7KlvO.formatDateToSince
    }
});

});
parcelRegister("7KlvO", function(module, exports) {

$parcel$export(module.exports, "formatDateToSince", function () { return $4b8777ae80625229$export$1b42d32ef0c7f60f; });

var $gOIrB = parcelRequire("gOIrB");
function $4b8777ae80625229$export$3ae94a2503e890a1(text, toFormat, fromFormat) {
    if (!text) return text;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(text, fromFormat).format(toFormat);
}
function $4b8777ae80625229$export$8989a3ce15c6b236(text) {
    if (!text) return text;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(text).format('DD.MM.YYYY dd. HH:mm');
}
function $4b8777ae80625229$export$1b42d32ef0c7f60f(dateString) {
    if (!dateString) return dateString;
    const now = new Date();
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(dateString).toDate();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 1000 / 60);
    if (minutes < 60) return `${minutes} Minute(n)`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} Stunde(n)`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} Tage(n)`;
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `${weeks} Woche(n)`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} Monat(e)`;
    const years = Math.floor(days / 365);
    return `${years} Jahr(e)`;
}
function $4b8777ae80625229$export$995ec7a44f679f2e(since) {
    if (!since) return since;
    const lowerSince = since.toLowerCase();
    if (!lowerSince.startsWith('vor ')) return since;
    const matches = lowerSince.match(/vor (\d+)\s*(tage?|wochen?|monate?|jahre?)/);
    if (matches) {
        const value = parseInt(matches[1], 10);
        const unit = matches[2];
        const now = new Date();
        let publishedAt;
        switch(unit){
            case 'tag':
            case 'tage':
                publishedAt = new Date(now.getTime() - value * 86400000);
                break;
            case 'woche':
            case 'wochen':
                publishedAt = new Date(now.getTime() - value * 604800000);
                break;
            case 'monat':
            case 'monate':
                publishedAt = new Date(now.setMonth(now.getMonth() - value));
                break;
            case 'jahr':
            case 'jahre':
                publishedAt = new Date(now.setFullYear(now.getFullYear() - value));
                break;
            default:
                return;
        }
        return publishedAt;
    }
}

});

parcelRegister("7VdiA", function(module, exports) {

$parcel$export(module.exports, "textToMarkdown", function () { return $ef5ce415fa20a15e$export$373626d7d6dcda2f; });
$parcel$export(module.exports, "textReplace", function () { return $ef5ce415fa20a15e$export$6049e06498ec9b27; });
$parcel$export(module.exports, "abbreviateText", function () { return $ef5ce415fa20a15e$export$210ebfac3cf68b2d; });

var $iqUC0 = parcelRequire("iqUC0");
function $ef5ce415fa20a15e$export$373626d7d6dcda2f(text, options = {}) {
    if (!text) return;
    const md = new (0, (/*@__PURE__*/$parcel$interopDefault($iqUC0)))({
        html: true,
        ...options
    });
    return md.render(text);
}
function $ef5ce415fa20a15e$export$6049e06498ec9b27(text, dictionary) {
    if (!text || !dictionary) return;
    text = String(text);
    let counter = 3;
    while(counter--)for(let key in dictionary)text = text.replace(new RegExp(key, 'g'), dictionary[key]);
    return text;
}
function $ef5ce415fa20a15e$export$210ebfac3cf68b2d(string, maxLength) {
    const parts = string.split(' ');
    const abbreviatedParts = parts.map((part)=>part[0]);
    return abbreviatedParts.slice(0, maxLength || undefined).join('');
}

});
parcelRegister("iqUC0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ayX49"));

});
parcelRegister("ayX49", function(module, exports) {
// Main parser class
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");

var $lGmCJ = parcelRequire("lGmCJ");

var $2RXFU = parcelRequire("2RXFU");

var $eDfbu = parcelRequire("eDfbu");

var $65Th7 = parcelRequire("65Th7");

var $2HYOP = parcelRequire("2HYOP");

var $5VCtw = parcelRequire("5VCtw");

var $bPz5T = parcelRequire("bPz5T");

var $059EB = parcelRequire("059EB");



var $7b0ae5a5d46e68f6$var$config = {
    default: (parcelRequire("cZxZE")),
    zero: (parcelRequire("9N3iw")),
    commonmark: (parcelRequire("1T83L"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $7b0ae5a5d46e68f6$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $7b0ae5a5d46e68f6$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $7b0ae5a5d46e68f6$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $7b0ae5a5d46e68f6$var$BAD_PROTO_RE.test(str) ? $7b0ae5a5d46e68f6$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $7b0ae5a5d46e68f6$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $7b0ae5a5d46e68f6$var$normalizeLink(url) {
    var parsed = $bPz5T.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $7b0ae5a5d46e68f6$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $059EB.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $bPz5T.encode($bPz5T.format(parsed));
}
function $7b0ae5a5d46e68f6$var$normalizeLinkText(url) {
    var parsed = $bPz5T.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $7b0ae5a5d46e68f6$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $059EB.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $bPz5T.decode($bPz5T.format(parsed), $bPz5T.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $7b0ae5a5d46e68f6$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $7b0ae5a5d46e68f6$var$MarkdownIt)) return new $7b0ae5a5d46e68f6$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$aYb3Y.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $2HYOP();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $65Th7();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $eDfbu();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $2RXFU();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $5VCtw();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $7b0ae5a5d46e68f6$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $7b0ae5a5d46e68f6$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $7b0ae5a5d46e68f6$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $aYb3Y;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $aYb3Y.assign({}, $lGmCJ);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.set = function(options) {
    $aYb3Y.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($aYb3Y.isString(presets)) {
        presetName = presets;
        presets = $7b0ae5a5d46e68f6$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $7b0ae5a5d46e68f6$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $7b0ae5a5d46e68f6$var$MarkdownIt;

});
parcelRegister("aYb3Y", function(module, exports) {

$parcel$export(module.exports, "lib", function () { return $7fc816da909b584f$export$16c08b91f883959a; }, function (v) { return $7fc816da909b584f$export$16c08b91f883959a = v; });
$parcel$export(module.exports, "assign", function () { return $7fc816da909b584f$export$e6e34fd1f2686227; }, function (v) { return $7fc816da909b584f$export$e6e34fd1f2686227 = v; });
$parcel$export(module.exports, "isString", function () { return $7fc816da909b584f$export$844ec244b1367d54; }, function (v) { return $7fc816da909b584f$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "has", function () { return $7fc816da909b584f$export$a4f4bb6b1453fff5; }, function (v) { return $7fc816da909b584f$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "unescapeMd", function () { return $7fc816da909b584f$export$5ccde1ea0c14bb03; }, function (v) { return $7fc816da909b584f$export$5ccde1ea0c14bb03 = v; });
$parcel$export(module.exports, "unescapeAll", function () { return $7fc816da909b584f$export$db8a17c6655f7e2c; }, function (v) { return $7fc816da909b584f$export$db8a17c6655f7e2c = v; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $7fc816da909b584f$export$644a8f5b13b2a36d; }, function (v) { return $7fc816da909b584f$export$644a8f5b13b2a36d = v; });
$parcel$export(module.exports, "fromCodePoint", function () { return $7fc816da909b584f$export$73bfc63873071f74; }, function (v) { return $7fc816da909b584f$export$73bfc63873071f74 = v; });
$parcel$export(module.exports, "escapeHtml", function () { return $7fc816da909b584f$export$4cf11838cdc2a8a8; }, function (v) { return $7fc816da909b584f$export$4cf11838cdc2a8a8 = v; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $7fc816da909b584f$export$f78478f71955b6bc; }, function (v) { return $7fc816da909b584f$export$f78478f71955b6bc = v; });
$parcel$export(module.exports, "isSpace", function () { return $7fc816da909b584f$export$1d5ccafae59b4926; }, function (v) { return $7fc816da909b584f$export$1d5ccafae59b4926 = v; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $7fc816da909b584f$export$3c52dd84024ae72c; }, function (v) { return $7fc816da909b584f$export$3c52dd84024ae72c = v; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $7fc816da909b584f$export$829a0d33ae4e744; }, function (v) { return $7fc816da909b584f$export$829a0d33ae4e744 = v; });
$parcel$export(module.exports, "isPunctChar", function () { return $7fc816da909b584f$export$4888a643af800fc1; }, function (v) { return $7fc816da909b584f$export$4888a643af800fc1 = v; });
$parcel$export(module.exports, "escapeRE", function () { return $7fc816da909b584f$export$bc616c8f7dc20d5d; }, function (v) { return $7fc816da909b584f$export$bc616c8f7dc20d5d = v; });
$parcel$export(module.exports, "normalizeReference", function () { return $7fc816da909b584f$export$20ef46802c8744b; }, function (v) { return $7fc816da909b584f$export$20ef46802c8744b = v; });
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $7fc816da909b584f$export$16c08b91f883959a;
var $7fc816da909b584f$export$e6e34fd1f2686227;
var $7fc816da909b584f$export$844ec244b1367d54;
var $7fc816da909b584f$export$a4f4bb6b1453fff5;
var $7fc816da909b584f$export$5ccde1ea0c14bb03;
var $7fc816da909b584f$export$db8a17c6655f7e2c;
var $7fc816da909b584f$export$644a8f5b13b2a36d;
var $7fc816da909b584f$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $7fc816da909b584f$export$4cf11838cdc2a8a8;
var $7fc816da909b584f$export$f78478f71955b6bc;
var $7fc816da909b584f$export$1d5ccafae59b4926;
var $7fc816da909b584f$export$3c52dd84024ae72c;
var $7fc816da909b584f$export$829a0d33ae4e744;
var $7fc816da909b584f$export$4888a643af800fc1;
var $7fc816da909b584f$export$bc616c8f7dc20d5d;
var $7fc816da909b584f$export$20ef46802c8744b;
'use strict';
function $7fc816da909b584f$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $7fc816da909b584f$var$isString(obj) {
    return $7fc816da909b584f$var$_class(obj) === '[object String]';
}
var $7fc816da909b584f$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $7fc816da909b584f$var$has(object, key) {
    return $7fc816da909b584f$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $7fc816da909b584f$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $7fc816da909b584f$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $7fc816da909b584f$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $7fc816da909b584f$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $7fc816da909b584f$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $7fc816da909b584f$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $7fc816da909b584f$var$UNESCAPE_ALL_RE = new RegExp($7fc816da909b584f$var$UNESCAPE_MD_RE.source + '|' + $7fc816da909b584f$var$ENTITY_RE.source, 'gi');
var $7fc816da909b584f$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $dcsgL = parcelRequire("dcsgL");
function $7fc816da909b584f$var$replaceEntityPattern(match, name) {
    var code;
    if ($7fc816da909b584f$var$has($dcsgL, name)) return $dcsgL[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $7fc816da909b584f$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($7fc816da909b584f$var$isValidEntityCode(code)) return $7fc816da909b584f$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $7fc816da909b584f$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($7fc816da909b584f$var$UNESCAPE_MD_RE, '$1');
}
function $7fc816da909b584f$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($7fc816da909b584f$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $7fc816da909b584f$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $7fc816da909b584f$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $7fc816da909b584f$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $7fc816da909b584f$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $7fc816da909b584f$var$replaceUnsafeChar(ch) {
    return $7fc816da909b584f$var$HTML_REPLACEMENTS[ch];
}
function $7fc816da909b584f$var$escapeHtml(str) {
    if ($7fc816da909b584f$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($7fc816da909b584f$var$HTML_ESCAPE_REPLACE_RE, $7fc816da909b584f$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $7fc816da909b584f$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $7fc816da909b584f$var$escapeRE(str) {
    return str.replace($7fc816da909b584f$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $7fc816da909b584f$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $7fc816da909b584f$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $craDZ = parcelRequire("craDZ");
// Currently without astral characters support.
function $7fc816da909b584f$var$isPunctChar(ch) {
    return $craDZ.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $7fc816da909b584f$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $7fc816da909b584f$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$7fc816da909b584f$export$16c08b91f883959a = {};

$7fc816da909b584f$export$16c08b91f883959a.mdurl = (parcelRequire("bPz5T"));

$7fc816da909b584f$export$16c08b91f883959a.ucmicro = (parcelRequire("1utYC"));
$7fc816da909b584f$export$e6e34fd1f2686227 = $7fc816da909b584f$var$assign;
$7fc816da909b584f$export$844ec244b1367d54 = $7fc816da909b584f$var$isString;
$7fc816da909b584f$export$a4f4bb6b1453fff5 = $7fc816da909b584f$var$has;
$7fc816da909b584f$export$5ccde1ea0c14bb03 = $7fc816da909b584f$var$unescapeMd;
$7fc816da909b584f$export$db8a17c6655f7e2c = $7fc816da909b584f$var$unescapeAll;
$7fc816da909b584f$export$644a8f5b13b2a36d = $7fc816da909b584f$var$isValidEntityCode;
$7fc816da909b584f$export$73bfc63873071f74 = $7fc816da909b584f$var$fromCodePoint;
$7fc816da909b584f$export$4cf11838cdc2a8a8 = $7fc816da909b584f$var$escapeHtml;
$7fc816da909b584f$export$f78478f71955b6bc = $7fc816da909b584f$var$arrayReplaceAt;
$7fc816da909b584f$export$1d5ccafae59b4926 = $7fc816da909b584f$var$isSpace;
$7fc816da909b584f$export$3c52dd84024ae72c = $7fc816da909b584f$var$isWhiteSpace;
$7fc816da909b584f$export$829a0d33ae4e744 = $7fc816da909b584f$var$isMdAsciiPunct;
$7fc816da909b584f$export$4888a643af800fc1 = $7fc816da909b584f$var$isPunctChar;
$7fc816da909b584f$export$bc616c8f7dc20d5d = $7fc816da909b584f$var$escapeRE;
$7fc816da909b584f$export$20ef46802c8744b = $7fc816da909b584f$var$normalizeReference;

});
parcelRegister("dcsgL", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("hy82V"));

});
parcelRegister("hy82V", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("craDZ", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("bPz5T", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $89cfae14f414accf$export$c564cdbbe6da493; }, function (v) { return $89cfae14f414accf$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $89cfae14f414accf$export$2f872c0f2117be69; }, function (v) { return $89cfae14f414accf$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "format", function () { return $89cfae14f414accf$export$d9468344d3651243; }, function (v) { return $89cfae14f414accf$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "parse", function () { return $89cfae14f414accf$export$98e6a39c04603d36; }, function (v) { return $89cfae14f414accf$export$98e6a39c04603d36 = v; });
var $89cfae14f414accf$export$c564cdbbe6da493;
var $89cfae14f414accf$export$2f872c0f2117be69;
var $89cfae14f414accf$export$d9468344d3651243;
var $89cfae14f414accf$export$98e6a39c04603d36;
'use strict';

$89cfae14f414accf$export$c564cdbbe6da493 = (parcelRequire("6V0rO"));

$89cfae14f414accf$export$2f872c0f2117be69 = (parcelRequire("9q6Yg"));

$89cfae14f414accf$export$d9468344d3651243 = (parcelRequire("hZi0T"));

$89cfae14f414accf$export$98e6a39c04603d36 = (parcelRequire("3C8ES"));

});
parcelRegister("6V0rO", function(module, exports) {
'use strict';
var $509869d22c7180f7$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $509869d22c7180f7$var$getEncodeCache(exclude) {
    var i, ch, cache = $509869d22c7180f7$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $509869d22c7180f7$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $509869d22c7180f7$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $509869d22c7180f7$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $509869d22c7180f7$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$509869d22c7180f7$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$509869d22c7180f7$var$encode.componentChars = "-_.!~*'()";
module.exports = $509869d22c7180f7$var$encode;

});

parcelRegister("9q6Yg", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $6dbbf30bd7e4bfe7$var$decodeCache = {};
function $6dbbf30bd7e4bfe7$var$getDecodeCache(exclude) {
    var i, ch, cache = $6dbbf30bd7e4bfe7$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $6dbbf30bd7e4bfe7$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $6dbbf30bd7e4bfe7$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $6dbbf30bd7e4bfe7$var$decode.defaultChars;
    cache = $6dbbf30bd7e4bfe7$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$6dbbf30bd7e4bfe7$var$decode.defaultChars = ';/?:@&=+$,#';
$6dbbf30bd7e4bfe7$var$decode.componentChars = '';
module.exports = $6dbbf30bd7e4bfe7$var$decode;

});

parcelRegister("hZi0T", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("3C8ES", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $2a1ba30d37f5831b$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $2a1ba30d37f5831b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $2a1ba30d37f5831b$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$2a1ba30d37f5831b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$2a1ba30d37f5831b$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$2a1ba30d37f5831b$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($2a1ba30d37f5831b$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$2a1ba30d37f5831b$var$autoEscape = [
    '\''
].concat($2a1ba30d37f5831b$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$2a1ba30d37f5831b$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($2a1ba30d37f5831b$var$autoEscape), $2a1ba30d37f5831b$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $2a1ba30d37f5831b$var$hostnameMaxLen = 255, $2a1ba30d37f5831b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $2a1ba30d37f5831b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$2a1ba30d37f5831b$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$2a1ba30d37f5831b$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $2a1ba30d37f5831b$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $2a1ba30d37f5831b$var$Url) return url;
    var u = new $2a1ba30d37f5831b$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$2a1ba30d37f5831b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $2a1ba30d37f5831b$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $2a1ba30d37f5831b$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $2a1ba30d37f5831b$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$2a1ba30d37f5831b$var$hostlessProtocol[proto] && (slashes || proto && !$2a1ba30d37f5831b$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $2a1ba30d37f5831b$var$hostEndingChars.length; i++){
            hec = rest.indexOf($2a1ba30d37f5831b$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $2a1ba30d37f5831b$var$nonHostChars.length; i++){
            hec = rest.indexOf($2a1ba30d37f5831b$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($2a1ba30d37f5831b$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($2a1ba30d37f5831b$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($2a1ba30d37f5831b$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $2a1ba30d37f5831b$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($2a1ba30d37f5831b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$2a1ba30d37f5831b$var$Url.prototype.parseHost = function(host) {
    var port = $2a1ba30d37f5831b$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $2a1ba30d37f5831b$var$urlParse;

});


parcelRegister("1utYC", function(module, exports) {

$parcel$export(module.exports, "Any", function () { return $115fd88c9f5d286f$export$b24b633b1364b94b; }, function (v) { return $115fd88c9f5d286f$export$b24b633b1364b94b = v; });
$parcel$export(module.exports, "Cc", function () { return $115fd88c9f5d286f$export$15dafbac7aec8a57; }, function (v) { return $115fd88c9f5d286f$export$15dafbac7aec8a57 = v; });
$parcel$export(module.exports, "Cf", function () { return $115fd88c9f5d286f$export$239cff0cce87eb56; }, function (v) { return $115fd88c9f5d286f$export$239cff0cce87eb56 = v; });
$parcel$export(module.exports, "P", function () { return $115fd88c9f5d286f$export$56c0d5a1e737357d; }, function (v) { return $115fd88c9f5d286f$export$56c0d5a1e737357d = v; });
$parcel$export(module.exports, "Z", function () { return $115fd88c9f5d286f$export$dc98b0b04f4c7758; }, function (v) { return $115fd88c9f5d286f$export$dc98b0b04f4c7758 = v; });
var $115fd88c9f5d286f$export$b24b633b1364b94b;
var $115fd88c9f5d286f$export$15dafbac7aec8a57;
var $115fd88c9f5d286f$export$239cff0cce87eb56;
var $115fd88c9f5d286f$export$56c0d5a1e737357d;
var $115fd88c9f5d286f$export$dc98b0b04f4c7758;
'use strict';

$115fd88c9f5d286f$export$b24b633b1364b94b = (parcelRequire("1FSrq"));

$115fd88c9f5d286f$export$15dafbac7aec8a57 = (parcelRequire("ld5SC"));

$115fd88c9f5d286f$export$239cff0cce87eb56 = (parcelRequire("ciLjR"));

$115fd88c9f5d286f$export$56c0d5a1e737357d = (parcelRequire("craDZ"));

$115fd88c9f5d286f$export$dc98b0b04f4c7758 = (parcelRequire("53fjN"));

});
parcelRegister("1FSrq", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("ld5SC", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("ciLjR", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("53fjN", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});



parcelRegister("lGmCJ", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", function () { return $fc8f11d56b726a38$export$2a2c8612930e58d0; }, function (v) { return $fc8f11d56b726a38$export$2a2c8612930e58d0 = v; });
$parcel$export(module.exports, "parseLinkDestination", function () { return $fc8f11d56b726a38$export$22bd24080f95f2b3; }, function (v) { return $fc8f11d56b726a38$export$22bd24080f95f2b3 = v; });
$parcel$export(module.exports, "parseLinkTitle", function () { return $fc8f11d56b726a38$export$89650c5477a69db9; }, function (v) { return $fc8f11d56b726a38$export$89650c5477a69db9 = v; });
// Just a shortcut for bulk export
var $fc8f11d56b726a38$export$2a2c8612930e58d0;
var $fc8f11d56b726a38$export$22bd24080f95f2b3;
var $fc8f11d56b726a38$export$89650c5477a69db9;
'use strict';

$fc8f11d56b726a38$export$2a2c8612930e58d0 = (parcelRequire("kGZt9"));

$fc8f11d56b726a38$export$22bd24080f95f2b3 = (parcelRequire("hAJPK"));

$fc8f11d56b726a38$export$89650c5477a69db9 = (parcelRequire("lRGI9"));

});
parcelRegister("kGZt9", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("hAJPK", function(module, exports) {
// Parse link destination
//
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $cce95a155c1efe89$require$unescapeAll = $aYb3Y.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $cce95a155c1efe89$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $cce95a155c1efe89$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("lRGI9", function(module, exports) {
// Parse link title
//
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $feafadc02af7beaa$require$unescapeAll = $aYb3Y.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $feafadc02af7beaa$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("2RXFU", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $216ed23504bc5d1c$require$assign = $aYb3Y.assign;

var $aYb3Y = parcelRequire("aYb3Y");
var $216ed23504bc5d1c$require$unescapeAll = $aYb3Y.unescapeAll;

var $aYb3Y = parcelRequire("aYb3Y");
var $216ed23504bc5d1c$require$escapeHtml = $aYb3Y.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $216ed23504bc5d1c$var$default_rules = {};
$216ed23504bc5d1c$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $216ed23504bc5d1c$require$escapeHtml(token.content) + '</code>';
};
$216ed23504bc5d1c$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $216ed23504bc5d1c$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$216ed23504bc5d1c$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $216ed23504bc5d1c$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $216ed23504bc5d1c$require$escapeHtml(token.content);
    else highlighted = $216ed23504bc5d1c$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$216ed23504bc5d1c$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$216ed23504bc5d1c$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$216ed23504bc5d1c$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$216ed23504bc5d1c$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $216ed23504bc5d1c$require$escapeHtml(tokens[idx].content);
};
$216ed23504bc5d1c$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$216ed23504bc5d1c$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $216ed23504bc5d1c$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $216ed23504bc5d1c$require$assign({}, $216ed23504bc5d1c$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $216ed23504bc5d1c$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $216ed23504bc5d1c$require$escapeHtml(token.attrs[i][0]) + '="' + $216ed23504bc5d1c$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $216ed23504bc5d1c$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $216ed23504bc5d1c$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $216ed23504bc5d1c$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $216ed23504bc5d1c$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $216ed23504bc5d1c$var$Renderer;

});

parcelRegister("eDfbu", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $2Mr15 = parcelRequire("2Mr15");







var $aa707c845256ac5b$var$_rules = [
    [
        'normalize',
        (parcelRequire("9WZiT"))
    ],
    [
        'block',
        (parcelRequire("4IgTR"))
    ],
    [
        'inline',
        (parcelRequire("fFMEP"))
    ],
    [
        'linkify',
        (parcelRequire("6pBZH"))
    ],
    [
        'replacements',
        (parcelRequire("3hqmb"))
    ],
    [
        'smartquotes',
        (parcelRequire("jktWl"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("juM4O"))
    ]
];
/**
 * new Core()
 **/ function $aa707c845256ac5b$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $2Mr15();
    for(var i = 0; i < $aa707c845256ac5b$var$_rules.length; i++)this.ruler.push($aa707c845256ac5b$var$_rules[i][0], $aa707c845256ac5b$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $aa707c845256ac5b$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$aa707c845256ac5b$var$Core.prototype.State = (parcelRequire("2YuXA"));
module.exports = $aa707c845256ac5b$var$Core;

});
parcelRegister("2Mr15", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $2065056568c05fb2$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$2065056568c05fb2$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$2065056568c05fb2$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2065056568c05fb2$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2065056568c05fb2$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2065056568c05fb2$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2065056568c05fb2$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $2065056568c05fb2$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $2065056568c05fb2$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $2065056568c05fb2$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $2065056568c05fb2$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $2065056568c05fb2$var$Ruler;

});

parcelRegister("9WZiT", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $73e915772886a8f3$var$NEWLINES_RE = /\r\n?|\n/g;
var $73e915772886a8f3$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($73e915772886a8f3$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($73e915772886a8f3$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("4IgTR", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("fFMEP", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("6pBZH", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $4ab28cb71243dc4e$require$arrayReplaceAt = $aYb3Y.arrayReplaceAt;
function $4ab28cb71243dc4e$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $4ab28cb71243dc4e$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($4ab28cb71243dc4e$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($4ab28cb71243dc4e$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $4ab28cb71243dc4e$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("3hqmb", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $26376783e1d0eb68$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $26376783e1d0eb68$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $26376783e1d0eb68$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $26376783e1d0eb68$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $26376783e1d0eb68$var$replaceFn(match, name) {
    return $26376783e1d0eb68$var$SCOPED_ABBR[name.toLowerCase()];
}
function $26376783e1d0eb68$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($26376783e1d0eb68$var$SCOPED_ABBR_RE, $26376783e1d0eb68$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $26376783e1d0eb68$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($26376783e1d0eb68$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($26376783e1d0eb68$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $26376783e1d0eb68$var$replace_scoped(state.tokens[blkIdx].children);
        if ($26376783e1d0eb68$var$RARE_RE.test(state.tokens[blkIdx].content)) $26376783e1d0eb68$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("jktWl", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $e1271c093734934b$require$isWhiteSpace = $aYb3Y.isWhiteSpace;

var $aYb3Y = parcelRequire("aYb3Y");
var $e1271c093734934b$require$isPunctChar = $aYb3Y.isPunctChar;

var $aYb3Y = parcelRequire("aYb3Y");
var $e1271c093734934b$require$isMdAsciiPunct = $aYb3Y.isMdAsciiPunct;
var $e1271c093734934b$var$QUOTE_TEST_RE = /['"]/;
var $e1271c093734934b$var$QUOTE_RE = /['"]/g;
var $e1271c093734934b$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $e1271c093734934b$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $e1271c093734934b$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $e1271c093734934b$var$QUOTE_RE.lastIndex = pos;
            t = $e1271c093734934b$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $e1271c093734934b$require$isMdAsciiPunct(lastChar) || $e1271c093734934b$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $e1271c093734934b$require$isMdAsciiPunct(nextChar) || $e1271c093734934b$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $e1271c093734934b$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $e1271c093734934b$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $e1271c093734934b$var$replaceAt(token.content, t.index, $e1271c093734934b$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $e1271c093734934b$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $e1271c093734934b$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $e1271c093734934b$var$replaceAt(token.content, t.index, $e1271c093734934b$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$e1271c093734934b$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $e1271c093734934b$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("juM4O", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("2YuXA", function(module, exports) {
// Core state object
//
'use strict';

var $5fZxP = parcelRequire("5fZxP");
function $22a9336b2bc21a6d$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$22a9336b2bc21a6d$var$StateCore.prototype.Token = $5fZxP;
module.exports = $22a9336b2bc21a6d$var$StateCore;

});
parcelRegister("5fZxP", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $3d3e17f0599573eb$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $3d3e17f0599573eb$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $3d3e17f0599573eb$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $3d3e17f0599573eb$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $3d3e17f0599573eb$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $3d3e17f0599573eb$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $3d3e17f0599573eb$var$Token;

});



parcelRegister("65Th7", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $2Mr15 = parcelRequire("2Mr15");











var $46fe162f0b71d6c7$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("g0UGB")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("6jbil"))
    ],
    [
        'fence',
        (parcelRequire("38lbj")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("bddBi")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("b7URC")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("3jFpG")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("5OAWR"))
    ],
    [
        'html_block',
        (parcelRequire("5US41")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("iMpr9")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("979wk"))
    ],
    [
        'paragraph',
        (parcelRequire("1VFQZ"))
    ]
];
/**
 * new ParserBlock()
 **/ function $46fe162f0b71d6c7$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $2Mr15();
    for(var i = 0; i < $46fe162f0b71d6c7$var$_rules.length; i++)this.ruler.push($46fe162f0b71d6c7$var$_rules[i][0], $46fe162f0b71d6c7$var$_rules[i][1], {
        alt: ($46fe162f0b71d6c7$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$46fe162f0b71d6c7$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $46fe162f0b71d6c7$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$46fe162f0b71d6c7$var$ParserBlock.prototype.State = (parcelRequire("kyAkc"));
module.exports = $46fe162f0b71d6c7$var$ParserBlock;

});
parcelRegister("g0UGB", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $ba889e2069e851f8$require$isSpace = $aYb3Y.isSpace;
function $ba889e2069e851f8$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $ba889e2069e851f8$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$ba889e2069e851f8$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $ba889e2069e851f8$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$ba889e2069e851f8$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $ba889e2069e851f8$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $ba889e2069e851f8$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $ba889e2069e851f8$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $ba889e2069e851f8$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $ba889e2069e851f8$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("6jbil", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("38lbj", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("bddBi", function(module, exports) {
// Block quotes
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $829b7567b7e286e9$require$isSpace = $aYb3Y.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($829b7567b7e286e9$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("b7URC", function(module, exports) {
// Horizontal rule
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $819c751e0d0d9b38$require$isSpace = $aYb3Y.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$819c751e0d0d9b38$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("3jFpG", function(module, exports) {
// Lists
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $26a345448246d322$require$isSpace = $aYb3Y.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $26a345448246d322$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$26a345448246d322$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $26a345448246d322$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$26a345448246d322$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $26a345448246d322$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $26a345448246d322$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $26a345448246d322$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $26a345448246d322$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $26a345448246d322$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $26a345448246d322$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("5OAWR", function(module, exports) {
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $43be48758c09ee62$require$normalizeReference = $aYb3Y.normalizeReference;

var $aYb3Y = parcelRequire("aYb3Y");
var $43be48758c09ee62$require$isSpace = $aYb3Y.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($43be48758c09ee62$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($43be48758c09ee62$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$43be48758c09ee62$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$43be48758c09ee62$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $43be48758c09ee62$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("5US41", function(module, exports) {
// HTML block
'use strict';

var $iz7er = parcelRequire("iz7er");

var $8b2ch = parcelRequire("8b2ch");
var $44ec1ea831120446$require$HTML_OPEN_CLOSE_TAG_RE = $8b2ch.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $44ec1ea831120446$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $iz7er.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($44ec1ea831120446$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $44ec1ea831120446$var$HTML_SEQUENCES.length; i++){
        if ($44ec1ea831120446$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $44ec1ea831120446$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $44ec1ea831120446$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$44ec1ea831120446$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($44ec1ea831120446$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("iz7er", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("8b2ch", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", function () { return $5f410e1b4eaca300$export$6db61d2c3a16e419; }, function (v) { return $5f410e1b4eaca300$export$6db61d2c3a16e419 = v; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $5f410e1b4eaca300$export$cd48660d06f74639; }, function (v) { return $5f410e1b4eaca300$export$cd48660d06f74639 = v; });
// Regexps to match html elements
var $5f410e1b4eaca300$export$6db61d2c3a16e419;
var $5f410e1b4eaca300$export$cd48660d06f74639;
'use strict';
var $5f410e1b4eaca300$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $5f410e1b4eaca300$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $5f410e1b4eaca300$var$single_quoted = "'[^']*'";
var $5f410e1b4eaca300$var$double_quoted = '"[^"]*"';
var $5f410e1b4eaca300$var$attr_value = '(?:' + $5f410e1b4eaca300$var$unquoted + '|' + $5f410e1b4eaca300$var$single_quoted + '|' + $5f410e1b4eaca300$var$double_quoted + ')';
var $5f410e1b4eaca300$var$attribute = '(?:\\s+' + $5f410e1b4eaca300$var$attr_name + '(?:\\s*=\\s*' + $5f410e1b4eaca300$var$attr_value + ')?)';
var $5f410e1b4eaca300$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $5f410e1b4eaca300$var$attribute + '*\\s*\\/?>';
var $5f410e1b4eaca300$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $5f410e1b4eaca300$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $5f410e1b4eaca300$var$processing = '<[?][\\s\\S]*?[?]>';
var $5f410e1b4eaca300$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $5f410e1b4eaca300$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $5f410e1b4eaca300$var$HTML_TAG_RE = new RegExp('^(?:' + $5f410e1b4eaca300$var$open_tag + '|' + $5f410e1b4eaca300$var$close_tag + '|' + $5f410e1b4eaca300$var$comment + '|' + $5f410e1b4eaca300$var$processing + '|' + $5f410e1b4eaca300$var$declaration + '|' + $5f410e1b4eaca300$var$cdata + ')');
var $5f410e1b4eaca300$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $5f410e1b4eaca300$var$open_tag + '|' + $5f410e1b4eaca300$var$close_tag + ')');
$5f410e1b4eaca300$export$6db61d2c3a16e419 = $5f410e1b4eaca300$var$HTML_TAG_RE;
$5f410e1b4eaca300$export$cd48660d06f74639 = $5f410e1b4eaca300$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("iMpr9", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $dac070eba4bc3858$require$isSpace = $aYb3Y.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$dac070eba4bc3858$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $dac070eba4bc3858$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("979wk", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("1VFQZ", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("kyAkc", function(module, exports) {
// Parser state class
'use strict';

var $5fZxP = parcelRequire("5fZxP");

var $aYb3Y = parcelRequire("aYb3Y");
var $ef7328fd616b30f0$require$isSpace = $aYb3Y.isSpace;
function $ef7328fd616b30f0$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($ef7328fd616b30f0$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$ef7328fd616b30f0$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $5fZxP(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$ef7328fd616b30f0$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$ef7328fd616b30f0$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$ef7328fd616b30f0$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$ef7328fd616b30f0$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$ef7328fd616b30f0$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$ef7328fd616b30f0$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$ef7328fd616b30f0$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$ef7328fd616b30f0$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$ef7328fd616b30f0$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($ef7328fd616b30f0$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$ef7328fd616b30f0$var$StateBlock.prototype.Token = $5fZxP;
module.exports = $ef7328fd616b30f0$var$StateBlock;

});


parcelRegister("2HYOP", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $2Mr15 = parcelRequire("2Mr15");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $1f8ec64b74376623$var$_rules = [
    [
        'text',
        (parcelRequire("aMllU"))
    ],
    [
        'linkify',
        (parcelRequire("eVZlD"))
    ],
    [
        'newline',
        (parcelRequire("jUDxm"))
    ],
    [
        'escape',
        (parcelRequire("aPqqg"))
    ],
    [
        'backticks',
        (parcelRequire("dxLqt"))
    ],
    [
        'strikethrough',
        (parcelRequire("elrma")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("2DT4X")).tokenize
    ],
    [
        'link',
        (parcelRequire("gUNCI"))
    ],
    [
        'image',
        (parcelRequire("7xEmn"))
    ],
    [
        'autolink',
        (parcelRequire("1kweQ"))
    ],
    [
        'html_inline',
        (parcelRequire("2OFUW"))
    ],
    [
        'entity',
        (parcelRequire("z91fZ"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $1f8ec64b74376623$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("7HmNE"))
    ],
    [
        'strikethrough',
        (parcelRequire("elrma")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("2DT4X")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("fOC1y"))
    ]
];
/**
 * new ParserInline()
 **/ function $1f8ec64b74376623$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $2Mr15();
    for(i = 0; i < $1f8ec64b74376623$var$_rules.length; i++)this.ruler.push($1f8ec64b74376623$var$_rules[i][0], $1f8ec64b74376623$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $2Mr15();
    for(i = 0; i < $1f8ec64b74376623$var$_rules2.length; i++)this.ruler2.push($1f8ec64b74376623$var$_rules2[i][0], $1f8ec64b74376623$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$1f8ec64b74376623$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$1f8ec64b74376623$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $1f8ec64b74376623$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$1f8ec64b74376623$var$ParserInline.prototype.State = (parcelRequire("9lP5P"));
module.exports = $1f8ec64b74376623$var$ParserInline;

});
parcelRegister("aMllU", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $7d8ef33a111a63d5$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$7d8ef33a111a63d5$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("eVZlD", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $adf5f9fb60612791$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($adf5f9fb60612791$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("jUDxm", function(module, exports) {
// Proceess '\n'
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $03bdb554abd294be$require$isSpace = $aYb3Y.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $03bdb554abd294be$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("aPqqg", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $7e2329c5709b8d2b$require$isSpace = $aYb3Y.isSpace;
var $7e2329c5709b8d2b$var$ESCAPED = [];
for(var $7e2329c5709b8d2b$var$i = 0; $7e2329c5709b8d2b$var$i < 256; $7e2329c5709b8d2b$var$i++)$7e2329c5709b8d2b$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $7e2329c5709b8d2b$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$7e2329c5709b8d2b$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $7e2329c5709b8d2b$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("dxLqt", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("elrma", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $a7183f49bd2d4bbe$export$660b2ee2d4fb4eff; }, function (v) { return $a7183f49bd2d4bbe$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $a7183f49bd2d4bbe$export$7b804a0e0ce836d9; }, function (v) { return $a7183f49bd2d4bbe$export$7b804a0e0ce836d9 = v; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a7183f49bd2d4bbe$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a7183f49bd2d4bbe$export$7b804a0e0ce836d9;
'use strict';
$a7183f49bd2d4bbe$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a7183f49bd2d4bbe$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$a7183f49bd2d4bbe$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a7183f49bd2d4bbe$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a7183f49bd2d4bbe$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("2DT4X", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $1ec9f2d11c8b1cd7$export$660b2ee2d4fb4eff; }, function (v) { return $1ec9f2d11c8b1cd7$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $1ec9f2d11c8b1cd7$export$7b804a0e0ce836d9; }, function (v) { return $1ec9f2d11c8b1cd7$export$7b804a0e0ce836d9 = v; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $1ec9f2d11c8b1cd7$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $1ec9f2d11c8b1cd7$export$7b804a0e0ce836d9;
'use strict';
$1ec9f2d11c8b1cd7$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $1ec9f2d11c8b1cd7$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$1ec9f2d11c8b1cd7$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $1ec9f2d11c8b1cd7$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $1ec9f2d11c8b1cd7$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("gUNCI", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $c5085e78a484d231$require$normalizeReference = $aYb3Y.normalizeReference;

var $aYb3Y = parcelRequire("aYb3Y");
var $c5085e78a484d231$require$isSpace = $aYb3Y.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$c5085e78a484d231$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$c5085e78a484d231$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$c5085e78a484d231$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$c5085e78a484d231$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("7xEmn", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $aYb3Y = parcelRequire("aYb3Y");
var $57daec1a13964cd1$require$normalizeReference = $aYb3Y.normalizeReference;

var $aYb3Y = parcelRequire("aYb3Y");
var $57daec1a13964cd1$require$isSpace = $aYb3Y.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$57daec1a13964cd1$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$57daec1a13964cd1$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$57daec1a13964cd1$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$57daec1a13964cd1$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("1kweQ", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $0f80aa9817aba92a$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $0f80aa9817aba92a$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($0f80aa9817aba92a$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($0f80aa9817aba92a$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("2OFUW", function(module, exports) {
// Process html tags
'use strict';

var $8b2ch = parcelRequire("8b2ch");
var $20d0c43b6be2e31e$require$HTML_TAG_RE = $8b2ch.HTML_TAG_RE;
function $20d0c43b6be2e31e$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $20d0c43b6be2e31e$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $20d0c43b6be2e31e$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$20d0c43b6be2e31e$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($20d0c43b6be2e31e$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($20d0c43b6be2e31e$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($20d0c43b6be2e31e$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("z91fZ", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $dcsgL = parcelRequire("dcsgL");

var $aYb3Y = parcelRequire("aYb3Y");
var $069a4409e171841e$require$has = $aYb3Y.has;

var $aYb3Y = parcelRequire("aYb3Y");
var $069a4409e171841e$require$isValidEntityCode = $aYb3Y.isValidEntityCode;

var $aYb3Y = parcelRequire("aYb3Y");
var $069a4409e171841e$require$fromCodePoint = $aYb3Y.fromCodePoint;
var $069a4409e171841e$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $069a4409e171841e$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($069a4409e171841e$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $069a4409e171841e$require$isValidEntityCode(code) ? $069a4409e171841e$require$fromCodePoint(code) : $069a4409e171841e$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($069a4409e171841e$var$NAMED_RE);
        if (match) {
            if ($069a4409e171841e$require$has($dcsgL, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $dcsgL[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("7HmNE", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $59ae3c1df79e1926$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $59ae3c1df79e1926$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $59ae3c1df79e1926$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("fOC1y", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("9lP5P", function(module, exports) {
// Inline parser state
'use strict';

var $5fZxP = parcelRequire("5fZxP");

var $aYb3Y = parcelRequire("aYb3Y");
var $6cedb53e737af5b6$require$isWhiteSpace = $aYb3Y.isWhiteSpace;

var $aYb3Y = parcelRequire("aYb3Y");
var $6cedb53e737af5b6$require$isPunctChar = $aYb3Y.isPunctChar;

var $aYb3Y = parcelRequire("aYb3Y");
var $6cedb53e737af5b6$require$isMdAsciiPunct = $aYb3Y.isMdAsciiPunct;
function $6cedb53e737af5b6$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$6cedb53e737af5b6$var$StateInline.prototype.pushPending = function() {
    var token = new $5fZxP('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$6cedb53e737af5b6$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $5fZxP(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$6cedb53e737af5b6$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $6cedb53e737af5b6$require$isMdAsciiPunct(lastChar) || $6cedb53e737af5b6$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $6cedb53e737af5b6$require$isMdAsciiPunct(nextChar) || $6cedb53e737af5b6$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $6cedb53e737af5b6$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $6cedb53e737af5b6$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$6cedb53e737af5b6$var$StateInline.prototype.Token = $5fZxP;
module.exports = $6cedb53e737af5b6$var$StateInline;

});


parcelRegister("5VCtw", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $45101effa111c3ca$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $45101effa111c3ca$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $45101effa111c3ca$var$isString(obj) {
    return $45101effa111c3ca$var$_class(obj) === '[object String]';
}
function $45101effa111c3ca$var$isObject(obj) {
    return $45101effa111c3ca$var$_class(obj) === '[object Object]';
}
function $45101effa111c3ca$var$isRegExp(obj) {
    return $45101effa111c3ca$var$_class(obj) === '[object RegExp]';
}
function $45101effa111c3ca$var$isFunction(obj) {
    return $45101effa111c3ca$var$_class(obj) === '[object Function]';
}
function $45101effa111c3ca$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $45101effa111c3ca$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $45101effa111c3ca$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $45101effa111c3ca$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $45101effa111c3ca$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $45101effa111c3ca$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $45101effa111c3ca$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $45101effa111c3ca$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $45101effa111c3ca$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $45101effa111c3ca$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $45101effa111c3ca$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bgjI0"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($45101effa111c3ca$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($45101effa111c3ca$var$isObject(val)) {
            if ($45101effa111c3ca$var$isRegExp(val.validate)) compiled.validate = $45101effa111c3ca$var$createValidator(val.validate);
            else if ($45101effa111c3ca$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($45101effa111c3ca$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $45101effa111c3ca$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($45101effa111c3ca$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $45101effa111c3ca$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($45101effa111c3ca$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $45101effa111c3ca$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $45101effa111c3ca$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $45101effa111c3ca$var$createMatch(self, shift) {
    var match = new $45101effa111c3ca$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $45101effa111c3ca$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $45101effa111c3ca$var$LinkifyIt)) return new $45101effa111c3ca$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($45101effa111c3ca$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $45101effa111c3ca$var$assign({}, $45101effa111c3ca$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $45101effa111c3ca$var$assign({}, $45101effa111c3ca$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $45101effa111c3ca$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $45101effa111c3ca$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $45101effa111c3ca$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $45101effa111c3ca$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($45101effa111c3ca$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($45101effa111c3ca$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $45101effa111c3ca$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $45101effa111c3ca$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $45101effa111c3ca$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $45101effa111c3ca$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $45101effa111c3ca$var$LinkifyIt;

});
parcelRegister("bgjI0", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("1FSrq")).source;
    re.src_Cc = (parcelRequire("ld5SC")).source;
    re.src_Z = (parcelRequire("53fjN")).source;
    re.src_P = (parcelRequire("craDZ")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("059EB", function(module, exports) {

$parcel$export(module.exports, "toUnicode", function () { return $0003ffd1afdfc582$export$110c810e8727e62b; });
$parcel$export(module.exports, "toASCII", function () { return $0003ffd1afdfc582$export$69111c4ea6e0c4a0; });
'use strict';
/** Highest positive signed 32-bit float value */ const $0003ffd1afdfc582$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $0003ffd1afdfc582$var$base = 36;
const $0003ffd1afdfc582$var$tMin = 1;
const $0003ffd1afdfc582$var$tMax = 26;
const $0003ffd1afdfc582$var$skew = 38;
const $0003ffd1afdfc582$var$damp = 700;
const $0003ffd1afdfc582$var$initialBias = 72;
const $0003ffd1afdfc582$var$initialN = 128; // 0x80
const $0003ffd1afdfc582$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $0003ffd1afdfc582$var$regexPunycode = /^xn--/;
const $0003ffd1afdfc582$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $0003ffd1afdfc582$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $0003ffd1afdfc582$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $0003ffd1afdfc582$var$baseMinusTMin = $0003ffd1afdfc582$var$base - $0003ffd1afdfc582$var$tMin;
const $0003ffd1afdfc582$var$floor = Math.floor;
const $0003ffd1afdfc582$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $0003ffd1afdfc582$var$error(type) {
    throw new RangeError($0003ffd1afdfc582$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $0003ffd1afdfc582$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $0003ffd1afdfc582$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($0003ffd1afdfc582$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $0003ffd1afdfc582$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $0003ffd1afdfc582$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $0003ffd1afdfc582$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $0003ffd1afdfc582$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $0003ffd1afdfc582$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $0003ffd1afdfc582$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $0003ffd1afdfc582$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $0003ffd1afdfc582$var$floor(delta / $0003ffd1afdfc582$var$damp) : delta >> 1;
    delta += $0003ffd1afdfc582$var$floor(delta / numPoints);
    for(; delta > $0003ffd1afdfc582$var$baseMinusTMin * $0003ffd1afdfc582$var$tMax >> 1; k += $0003ffd1afdfc582$var$base)delta = $0003ffd1afdfc582$var$floor(delta / $0003ffd1afdfc582$var$baseMinusTMin);
    return $0003ffd1afdfc582$var$floor(k + ($0003ffd1afdfc582$var$baseMinusTMin + 1) * delta / (delta + $0003ffd1afdfc582$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $0003ffd1afdfc582$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $0003ffd1afdfc582$var$initialN;
    let bias = $0003ffd1afdfc582$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($0003ffd1afdfc582$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $0003ffd1afdfc582$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $0003ffd1afdfc582$var$base;; k += $0003ffd1afdfc582$var$base){
            if (index >= inputLength) $0003ffd1afdfc582$var$error('invalid-input');
            const digit = $0003ffd1afdfc582$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $0003ffd1afdfc582$var$base) $0003ffd1afdfc582$var$error('invalid-input');
            if (digit > $0003ffd1afdfc582$var$floor(($0003ffd1afdfc582$var$maxInt - i) / w)) $0003ffd1afdfc582$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $0003ffd1afdfc582$var$tMin : k >= bias + $0003ffd1afdfc582$var$tMax ? $0003ffd1afdfc582$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $0003ffd1afdfc582$var$base - t;
            if (w > $0003ffd1afdfc582$var$floor($0003ffd1afdfc582$var$maxInt / baseMinusT)) $0003ffd1afdfc582$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $0003ffd1afdfc582$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($0003ffd1afdfc582$var$floor(i / out) > $0003ffd1afdfc582$var$maxInt - n) $0003ffd1afdfc582$var$error('overflow');
        n += $0003ffd1afdfc582$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $0003ffd1afdfc582$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $0003ffd1afdfc582$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $0003ffd1afdfc582$var$initialN;
    let delta = 0;
    let bias = $0003ffd1afdfc582$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($0003ffd1afdfc582$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($0003ffd1afdfc582$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $0003ffd1afdfc582$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $0003ffd1afdfc582$var$floor(($0003ffd1afdfc582$var$maxInt - delta) / handledCPCountPlusOne)) $0003ffd1afdfc582$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $0003ffd1afdfc582$var$maxInt) $0003ffd1afdfc582$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $0003ffd1afdfc582$var$base;; k += $0003ffd1afdfc582$var$base){
                    const t = k <= bias ? $0003ffd1afdfc582$var$tMin : k >= bias + $0003ffd1afdfc582$var$tMax ? $0003ffd1afdfc582$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $0003ffd1afdfc582$var$base - t;
                    output.push($0003ffd1afdfc582$var$stringFromCharCode($0003ffd1afdfc582$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $0003ffd1afdfc582$var$floor(qMinusT / baseMinusT);
                }
                output.push($0003ffd1afdfc582$var$stringFromCharCode($0003ffd1afdfc582$var$digitToBasic(q, 0)));
                bias = $0003ffd1afdfc582$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $0003ffd1afdfc582$export$110c810e8727e62b = function(input) {
    return $0003ffd1afdfc582$var$mapDomain(input, function(string) {
        return $0003ffd1afdfc582$var$regexPunycode.test(string) ? $0003ffd1afdfc582$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $0003ffd1afdfc582$export$69111c4ea6e0c4a0 = function(input) {
    return $0003ffd1afdfc582$var$mapDomain(input, function(string) {
        return $0003ffd1afdfc582$var$regexNonASCII.test(string) ? 'xn--' + $0003ffd1afdfc582$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $0003ffd1afdfc582$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $0003ffd1afdfc582$export$c1700176c90f250f,
        'encode': $0003ffd1afdfc582$export$f999239d9b149395
    },
    'decode': $0003ffd1afdfc582$export$2f872c0f2117be69,
    'encode': $0003ffd1afdfc582$export$c564cdbbe6da493,
    'toASCII': $0003ffd1afdfc582$export$69111c4ea6e0c4a0,
    'toUnicode': $0003ffd1afdfc582$export$110c810e8727e62b
};
var $0003ffd1afdfc582$export$2e2bcd8739ae039 = $0003ffd1afdfc582$var$punycode;

});

parcelRegister("cZxZE", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("9N3iw", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("1T83L", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});





parcelRegister("6SeFs", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $501329eda6b48e40$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $501329eda6b48e40$var$_hoisted_1 = {
    key: 0,
    class: "review-list-wrapper"
};
const $501329eda6b48e40$var$_hoisted_2 = {
    class: "review-head"
};
const $501329eda6b48e40$var$_hoisted_3 = {
    class: "img-circle"
};
const $501329eda6b48e40$var$_hoisted_4 = {
    class: "review-body"
};
const $501329eda6b48e40$var$_hoisted_5 = {
    class: "rating"
};
const $501329eda6b48e40$var$_hoisted_6 = {
    class: "stars"
};
const $501329eda6b48e40$var$_hoisted_7 = {
    class: "published-at"
};
const $501329eda6b48e40$var$_hoisted_8 = {
    class: "text"
};
function $501329eda6b48e40$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.list ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $501329eda6b48e40$var$_hoisted_1, [
        ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)(_ctx.list, (review)=>{
            return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                key: review._id,
                class: "review-wrapper"
            }, [
                (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_2, [
                    (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_3, (0, $9xflP.toDisplayString)(_ctx.abbreviateText(review.authorName, 2)), 1),
                    (0, $9xflP.createTextVNode)(" " + (0, $9xflP.toDisplayString)(review.authorName), 1)
                ]),
                (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_4, [
                    (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_5, [
                        (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_6, [
                            ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)(Array.from(Array(5)), (value)=>{
                                return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                                    key: value
                                }, [
                                    (0, $9xflP.createTextVNode)((0, $9xflP.toDisplayString)(value) + " ", 1),
                                    _cache[0] || (_cache[0] = (0, $9xflP.createElementVNode)("i", {
                                        class: "fa fa-star"
                                    }, null, -1))
                                ], 64);
                            }), 128))
                        ]),
                        (0, $9xflP.createElementVNode)("span", $501329eda6b48e40$var$_hoisted_7, " vor " + (0, $9xflP.toDisplayString)(_ctx.formatDateToSince(review.publishedAt)), 1)
                    ]),
                    (0, $9xflP.createElementVNode)("div", $501329eda6b48e40$var$_hoisted_8, (0, $9xflP.toDisplayString)(review.text), 1)
                ])
            ]);
        }), 128))
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("e0XEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33f56fd779ea6c5$export$2e2bcd8739ae039; });
let $a33f56fd779ea6c5$var$NOOP = ()=>{};
var $a33f56fd779ea6c5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("aTo9X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7ee1c80e753ddeda$export$2e2bcd8739ae039; });
var $7ee1c80e753ddeda$export$2e2bcd8739ae039 = {
    data () {
        return {
            menuVisible: false
        };
    },
    methods: {
        toggleMobileMenu () {
            this.menuVisible = !this.menuVisible;
        }
    }
};

});

parcelRegister("3ECrT", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2a92eeb24a388535$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $2a92eeb24a388535$var$_hoisted_1 = {
    class: "row navigation navigation-small"
};
const $2a92eeb24a388535$var$_hoisted_2 = {
    key: 0,
    class: "navigation-items"
};
function $2a92eeb24a388535$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("section", $2a92eeb24a388535$var$_hoisted_1, [
        (0, $9xflP.createElementVNode)("button", {
            class: "btn btn-warning",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.toggleMobileMenu && $options.toggleMobileMenu(...args))
        }, [
            $data.menuVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                key: 0
            }, [
                _cache[1] || (_cache[1] = (0, $9xflP.createTextVNode)(" Men\xfc verstecken ", -1)),
                _cache[2] || (_cache[2] = (0, $9xflP.createElementVNode)("i", {
                    class: "fa fa-remove fa-2x"
                }, null, -1))
            ], 64)) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                key: 1
            }, [
                _cache[3] || (_cache[3] = (0, $9xflP.createTextVNode)(" Men\xfc anzeigen ", -1)),
                _cache[4] || (_cache[4] = (0, $9xflP.createElementVNode)("i", {
                    class: "fa fa-bars fa-2x"
                }, null, -1))
            ], 64))
        ]),
        $data.menuVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $2a92eeb24a388535$var$_hoisted_2, [
            (0, $9xflP.renderSlot)(_ctx.$slots, "default")
        ])) : (0, $9xflP.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("dhFoX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9abcfa5e0f8f02d2$export$2e2bcd8739ae039; });
let $9abcfa5e0f8f02d2$var$NOOP = ()=>{};
var $9abcfa5e0f8f02d2$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bJ0YQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $456b2117180bdc30$export$2e2bcd8739ae039; });

var $3nC6D = parcelRequire("3nC6D");
var $456b2117180bdc30$var$Theme = /*#__PURE__*/ function(Theme) {
    Theme["DARK"] = "theme-dark";
    Theme["LIGHT"] = "theme-light";
    Theme["TEST"] = "theme-test";
    return Theme;
}($456b2117180bdc30$var$Theme || {});
const $456b2117180bdc30$var$localStorageKey = 'sw-theme';
const $456b2117180bdc30$var$stageMapping = {
    [(0, $3nC6D.Stage).DEV]: {
        ["theme-dark"]: true,
        ["theme-light"]: true,
        ["theme-test"]: true
    },
    [(0, $3nC6D.Stage).TEST]: {
        ["theme-dark"]: true,
        ["theme-test"]: true
    },
    [(0, $3nC6D.Stage).LIVE]: null
};
var $456b2117180bdc30$export$2e2bcd8739ae039 = {
    name: 'ThemeSwitcher',
    data () {
        return {
            theme: $456b2117180bdc30$var$Theme,
            currentTheme: null
        };
    },
    computed: {
        isVisible () {
            return !!$456b2117180bdc30$var$stageMapping[appConfig.stage];
        }
    },
    methods: {
        isThemeVisible (theme) {
            return $456b2117180bdc30$var$stageMapping[appConfig.stage][theme];
        },
        toggleTheme (theme) {
            if (this.currentTheme === theme) return;
            const htmlClassList = document.querySelector('html').classList;
            Object.values($456b2117180bdc30$var$Theme).forEach((item)=>{
                htmlClassList.remove(item);
            });
            htmlClassList.add(theme);
            localStorage.setItem($456b2117180bdc30$var$localStorageKey, theme);
            this.currentTheme = theme;
        }
    },
    beforeMount () {
        const theme = localStorage.getItem($456b2117180bdc30$var$localStorageKey);
        if (theme) this.toggleTheme(theme);
    }
};

});
parcelRegister("3nC6D", function(module, exports) {

$parcel$export(module.exports, "Stage", function () { return $fb823a528495aef6$export$208cd1682bd0e4b6; });
var $fb823a528495aef6$export$208cd1682bd0e4b6 = /*#__PURE__*/ function(Stage) {
    Stage[Stage["LIVE"] = 1] = "LIVE";
    Stage[Stage["TEST"] = 2] = "TEST";
    Stage[Stage["DEV"] = 3] = "DEV";
    return Stage;
}({});

});


parcelRegister("dhw3M", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9ab5bb59c58081c1$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $9ab5bb59c58081c1$var$_hoisted_1 = {
    key: 0,
    id: "theme-switcher"
};
const $9ab5bb59c58081c1$var$_hoisted_2 = {
    class: "btn-group btn-group-xs"
};
function $9ab5bb59c58081c1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $options.isVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $9ab5bb59c58081c1$var$_hoisted_1, [
        (0, $9xflP.createElementVNode)("div", $9ab5bb59c58081c1$var$_hoisted_2, [
            $options.isThemeVisible($data.theme.DARK) ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("i", {
                key: 0,
                title: "Design: Dunkel",
                class: (0, $9xflP.normalizeClass)([
                    "fa fa-moon-o btn btn-xs btn-dark",
                    $data.theme.DARK === $data.currentTheme ? 'active' : ''
                ]),
                onClick: _cache[0] || (_cache[0] = ($event)=>$options.toggleTheme($data.theme.DARK))
            }, null, 2)) : (0, $9xflP.createCommentVNode)("", true),
            $options.isThemeVisible($data.theme.TEST) ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("i", {
                key: 1,
                title: "Design: Testsystem",
                class: (0, $9xflP.normalizeClass)([
                    "fa fa-shield btn btn-xs btn-dark",
                    $data.theme.TEST === $data.currentTheme ? 'active' : ''
                ]),
                onClick: _cache[1] || (_cache[1] = ($event)=>$options.toggleTheme($data.theme.TEST))
            }, null, 2)) : (0, $9xflP.createCommentVNode)("", true),
            $options.isThemeVisible($data.theme.LIGHT) ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("i", {
                key: 2,
                title: "Design: Hell",
                class: (0, $9xflP.normalizeClass)([
                    "fa fa-sun-o btn btn-xs btn-dark",
                    $data.theme.LIGHT === $data.currentTheme ? 'active' : ''
                ]),
                onClick: _cache[2] || (_cache[2] = ($event)=>$options.toggleTheme($data.theme.LIGHT))
            }, null, 2)) : (0, $9xflP.createCommentVNode)("", true)
        ])
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("cxk3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $920820d9b5eba16f$export$2e2bcd8739ae039; });
let $920820d9b5eba16f$var$NOOP = ()=>{};
var $920820d9b5eba16f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lwDoh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fabb24488475f026$export$2e2bcd8739ae039; });

var $iMiHg = parcelRequire("iMiHg");

var $7VdiA = parcelRequire("7VdiA");
const $fabb24488475f026$var$webinarContentCode = 'page.online-courses.webinar';
const $fabb24488475f026$var$recordContentCode = 'page.online-courses.record';
var $fabb24488475f026$export$2e2bcd8739ae039 = {
    components: {
        CourseInformationBox: $iMiHg.default
    },
    data () {
        return {
            courseLoader: true
        };
    },
    computed: {
        webinarContent () {
            return this.$store.state.contentItems && this.$store.state.contentItems.find((item)=>item.code === $fabb24488475f026$var$webinarContentCode);
        },
        recordContent () {
            return this.$store.state.contentItems && this.$store.state.contentItems.find((item)=>item.code === $fabb24488475f026$var$recordContentCode);
        },
        webinars () {
            if (!this.$store.state.courses) return;
            return this.$store.state.courses.filter((cycle)=>!!cycle.webinar && !!cycle.active);
        },
        recordings () {
            if (!this.$store.state.courses) return;
            return this.$store.state.courses.filter((cycle)=>!!cycle.recording && !!cycle.active);
        }
    },
    methods: {
        textToMarkdown: $7VdiA.textToMarkdown
    },
    mounted () {
        this.$store.dispatch('loadContentItem', 'page.online-courses.webinar');
        this.$store.dispatch('loadContentItem', 'page.online-courses.record');
        this.$store.dispatch('loadCycles').then(()=>{
            this.$store.dispatch('loadCourses', {
                with: [
                    'page'
                ]
            }).then(()=>{
                this.courseLoader = false;
            });
        });
    }
};

});
parcelRegister("iMiHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabb3682ba78b9fe$export$2e2bcd8739ae039; });
let $dabb3682ba78b9fe$var$script;




let $dabb3682ba78b9fe$var$initialize = ()=>{
    $dabb3682ba78b9fe$var$script = (parcelRequire("6NQAH"));
    if ($dabb3682ba78b9fe$var$script.__esModule) $dabb3682ba78b9fe$var$script = $dabb3682ba78b9fe$var$script.default;
    $dabb3682ba78b9fe$var$script.render = (parcelRequire("c44PQ")).render;
    $dabb3682ba78b9fe$var$script.__cssModules = {};
    (parcelRequire("pq8u2")).default($dabb3682ba78b9fe$var$script);
    $dabb3682ba78b9fe$var$script.__scopeId = 'data-v-7e12c1';
    $dabb3682ba78b9fe$var$script.__file = "CourseInformationBox.vue";
};
$dabb3682ba78b9fe$var$initialize();
var $dabb3682ba78b9fe$export$2e2bcd8739ae039 = $dabb3682ba78b9fe$var$script;

});
parcelRegister("6NQAH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4f401d2b1829a6ef$export$2e2bcd8739ae039; });

var $1yw87 = parcelRequire("1yw87");

var $7VdiA = parcelRequire("7VdiA");
var $4f401d2b1829a6ef$export$2e2bcd8739ae039 = {
    name: 'CourseInformationBox',
    props: [
        'course'
    ],
    computed: {
        cycles () {
            if (!this.course.cycles) return;
            return this.course.cycles.filter((cycle)=>(0, $1yw87.isPublicVisible)(cycle, this.course));
        }
    },
    methods: {
        textToMarkdown: $7VdiA.textToMarkdown,
        createCycleDateRange (cycle) {
            return `${(0, $1yw87.cycleDateRange)(cycle)} (${(0, $1yw87.cycleDay)(cycle)}) um ${(0, $1yw87.cycleStartTime)(cycle)} Uhr`;
        }
    }
};

});
parcelRegister("1yw87", function(module, exports) {

$parcel$export(module.exports, "cycleDuration", function () { return $88199af5f2bd0cdd$export$41d81237553f4e1b; });
$parcel$export(module.exports, "cycleStartTime", function () { return $88199af5f2bd0cdd$export$28639e5bf5f45ef1; });
$parcel$export(module.exports, "cycleDateRange", function () { return $88199af5f2bd0cdd$export$5a06f4112dc74afe; });
$parcel$export(module.exports, "cycleTimeRange", function () { return $88199af5f2bd0cdd$export$44ca234d191805b5; });
$parcel$export(module.exports, "cycleDay", function () { return $88199af5f2bd0cdd$export$58cfb71d5e8f9cbe; });
$parcel$export(module.exports, "isCycleFull", function () { return $88199af5f2bd0cdd$export$ec569ebdf1ff983c; });
$parcel$export(module.exports, "isCycleStarted", function () { return $88199af5f2bd0cdd$export$eace28d44b99e1ab; });
$parcel$export(module.exports, "isCycleRunning", function () { return $88199af5f2bd0cdd$export$1b4851ea5a641185; });
$parcel$export(module.exports, "isPublicVisible", function () { return $88199af5f2bd0cdd$export$e7f756f24948435c; });
$parcel$export(module.exports, "isOnWaitList", function () { return $88199af5f2bd0cdd$export$e299631dcc0930de; });

var $gOIrB = parcelRequire("gOIrB");
const $88199af5f2bd0cdd$var$now = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))();
function $88199af5f2bd0cdd$export$41d81237553f4e1b(cycle) {
    if (!cycle) return;
    const dateFrom = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date);
    const dateTo = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateTo.date);
    const time1 = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))({
        hour: dateFrom.hour(),
        minute: dateFrom.minute()
    });
    const time2 = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))({
        hour: dateTo.hour(),
        minute: dateTo.minute()
    });
    const duration = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB))).duration(time2.diff(time1));
    return duration.asMinutes();
}
function $88199af5f2bd0cdd$export$28639e5bf5f45ef1(cycle) {
    return cycle && (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date).format('HH:mm');
}
function $88199af5f2bd0cdd$export$5a06f4112dc74afe(cycle) {
    return cycle && [
        (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date).format('DD.MM.YY'),
        (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateTo.date).format('DD.MM.YY')
    ].join(' - ');
}
function $88199af5f2bd0cdd$export$44ca234d191805b5(cycle) {
    return cycle && [
        $88199af5f2bd0cdd$export$28639e5bf5f45ef1(cycle),
        (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateTo.date).format('HH:mm')
    ].join(' - ');
}
function $88199af5f2bd0cdd$export$58cfb71d5e8f9cbe(cycle, short = false) {
    return cycle && (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date).format(short ? 'dd' : 'dddd');
}
function $88199af5f2bd0cdd$export$ec569ebdf1ff983c(cycle, course) {
    return cycle && course && (cycle.participants || []).length >= course.maxParticipants;
}
function $88199af5f2bd0cdd$export$eace28d44b99e1ab(cycle) {
    return cycle?.dateFrom && (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))());
}
function $88199af5f2bd0cdd$export$8ffa3508d7d5687e(cycle) {
    return cycle?.dateTo && (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateTo.date).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))());
}
function $88199af5f2bd0cdd$export$1b4851ea5a641185(cycle) {
    return cycle && $88199af5f2bd0cdd$export$eace28d44b99e1ab(cycle) && !$88199af5f2bd0cdd$export$8ffa3508d7d5687e(cycle);
}
function $88199af5f2bd0cdd$export$715ff22480ee8c2c(cycle, course) {
    if (!cycle || !course) return false;
    return course.active && cycle.active !== false && !!cycle.dateFrom && (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.dateFrom.date).isAfter($88199af5f2bd0cdd$var$now, 'days') && (!cycle.internPlanningDate || (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.internPlanningDate).isSameOrBefore($88199af5f2bd0cdd$var$now, 'days'));
}
function $88199af5f2bd0cdd$export$e7f756f24948435c(cycle, course) {
    if (!cycle || !course) return false;
    return course.active && cycle.active !== false && cycle.dateFrom && (!cycle.publicPlanningDate || (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))(cycle.publicPlanningDate).isSameOrBefore($88199af5f2bd0cdd$var$now, 'days'));
}
function $88199af5f2bd0cdd$export$9ae1de2925de8b73(cycle, email) {
    if (!cycle || !email) return;
    return [
        ...cycle.participants,
        ...cycle.waitList,
        ...cycle.banList
    ].find((participant)=>participant.email === email);
}
function $88199af5f2bd0cdd$export$84d412a2317c4a1c(cycle, participantId) {
    if (!cycle || !participantId) return false;
    return (cycle.participants || []).some((participant)=>participant.id === participantId);
}
function $88199af5f2bd0cdd$export$e299631dcc0930de(cycle, participantId) {
    if (!cycle || !participantId) return false;
    return (cycle.waitList || []).some((participant)=>participant.id === participantId);
}
function $88199af5f2bd0cdd$export$208b9c730135728(cycle, participantId) {
    if (!cycle || !participantId) return false;
    return (cycle.banList || []).some((participant)=>participant.id === participantId);
}

});


parcelRegister("c44PQ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8c899bf016eea830$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $8c899bf016eea830$var$_hoisted_1 = {
    class: "course-information-box panel panel-dark btn-group-vertical"
};
const $8c899bf016eea830$var$_hoisted_2 = {
    class: "panel-heading"
};
const $8c899bf016eea830$var$_hoisted_3 = {
    key: 0
};
const $8c899bf016eea830$var$_hoisted_4 = {
    class: "panel-body"
};
const $8c899bf016eea830$var$_hoisted_5 = [
    "innerHTML"
];
const $8c899bf016eea830$var$_hoisted_6 = {
    class: "list-group"
};
const $8c899bf016eea830$var$_hoisted_7 = {
    key: 0,
    class: "list-group-item list-group-item-warning"
};
const $8c899bf016eea830$var$_hoisted_8 = {
    key: 1,
    class: "big-loader fa fa-spinner fa-pulse"
};
const $8c899bf016eea830$var$_hoisted_9 = [
    "href"
];
function $8c899bf016eea830$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $8c899bf016eea830$var$_hoisted_1, [
        (0, $9xflP.createElementVNode)("h3", $8c899bf016eea830$var$_hoisted_2, [
            (0, $9xflP.createTextVNode)((0, $9xflP.toDisplayString)($props.course.title) + " ", 1),
            !$props.course.active ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("span", $8c899bf016eea830$var$_hoisted_3, "noch in Planung")) : (0, $9xflP.createCommentVNode)("", true)
        ]),
        (0, $9xflP.createElementVNode)("div", $8c899bf016eea830$var$_hoisted_4, [
            (0, $9xflP.createElementVNode)("div", {
                innerHTML: $options.textToMarkdown($props.course.textDescriptionList)
            }, null, 8, $8c899bf016eea830$var$_hoisted_5),
            !$props.course.recording ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                key: 0
            }, [
                $options.cycles ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                    key: 0
                }, [
                    $options.cycles.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                        key: 0
                    }, [
                        _cache[2] || (_cache[2] = (0, $9xflP.createElementVNode)("br", null, null, -1)),
                        (0, $9xflP.createElementVNode)("ul", $8c899bf016eea830$var$_hoisted_6, [
                            _cache[1] || (_cache[1] = (0, $9xflP.createElementVNode)("li", {
                                class: "list-group-item list-group-item-info"
                            }, "Termine:", -1)),
                            ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.cycles, (cycle)=>{
                                return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("li", {
                                    class: "list-group-item",
                                    key: 'cycle-' + cycle._id
                                }, [
                                    (0, $9xflP.createTextVNode)((0, $9xflP.toDisplayString)($options.createCycleDateRange(cycle)) + " ", 1),
                                    cycle.note ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $8c899bf016eea830$var$_hoisted_7, [
                                        _cache[0] || (_cache[0] = (0, $9xflP.createElementVNode)("i", {
                                            class: "fa fa-info-circle fa-lg text-info"
                                        }, null, -1)),
                                        (0, $9xflP.createElementVNode)("strong", null, (0, $9xflP.toDisplayString)(cycle.note), 1)
                                    ])) : (0, $9xflP.createCommentVNode)("", true)
                                ]);
                            }), 128))
                        ])
                    ], 64)) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                        key: 1
                    }, [
                        _cache[3] || (_cache[3] = (0, $9xflP.createElementVNode)("br", null, null, -1)),
                        _cache[4] || (_cache[4] = (0, $9xflP.createElementVNode)("div", {
                            class: "alert alert-info"
                        }, " aktuell werden keine Termine angeboten ", -1))
                    ], 64))
                ], 64)) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $8c899bf016eea830$var$_hoisted_8))
            ], 64)) : (0, $9xflP.createCommentVNode)("", true)
        ]),
        $props.course.active && $props.course.page ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("a", {
            key: 0,
            href: `/${$props.course.page.url}`,
            class: "btn btn-lg btn-warning btn-block"
        }, "zur Kursbuchung", 8, $8c899bf016eea830$var$_hoisted_9)) : (0, $9xflP.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("pq8u2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04c69bf2074a2a69$export$2e2bcd8739ae039; });
let $04c69bf2074a2a69$var$NOOP = ()=>{};
var $04c69bf2074a2a69$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("ePL3k", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $acca53cd46a40c46$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $acca53cd46a40c46$var$_hoisted_1 = {
    class: "online-courses"
};
const $acca53cd46a40c46$var$_hoisted_2 = {
    key: 0
};
const $acca53cd46a40c46$var$_hoisted_3 = [
    "innerHTML"
];
const $acca53cd46a40c46$var$_hoisted_4 = {
    class: "recordings-wrapper"
};
const $acca53cd46a40c46$var$_hoisted_5 = {
    key: 0,
    class: "big-loader fa fa-spinner fa-pulse fa-2x"
};
const $acca53cd46a40c46$var$_hoisted_6 = {
    key: 0,
    class: "alert alert-info"
};
const $acca53cd46a40c46$var$_hoisted_7 = {
    key: 1
};
const $acca53cd46a40c46$var$_hoisted_8 = [
    "innerHTML"
];
const $acca53cd46a40c46$var$_hoisted_9 = {
    class: "webinars-wrapper"
};
const $acca53cd46a40c46$var$_hoisted_10 = {
    key: 0,
    class: "big-loader fa fa-spinner fa-pulse fa-2x"
};
const $acca53cd46a40c46$var$_hoisted_11 = {
    key: 0,
    class: "alert alert-info"
};
function $acca53cd46a40c46$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_course_information_box = (0, $9xflP.resolveComponent)("course-information-box");
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_1, [
        $options.recordings && $options.recordings.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_2, [
            _cache[0] || (_cache[0] = (0, $9xflP.createElementVNode)("h2", null, "Onlinekurs / Aufzeichnung", -1)),
            $options.recordContent ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                key: 0,
                class: "course-content",
                innerHTML: $options.textToMarkdown($options.recordContent.value)
            }, null, 8, $acca53cd46a40c46$var$_hoisted_3)) : (0, $9xflP.createCommentVNode)("", true),
            (0, $9xflP.createElementVNode)("div", $acca53cd46a40c46$var$_hoisted_4, [
                $data.courseLoader ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_5)) : (0, $9xflP.createCommentVNode)("", true),
                $options.recordings ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                    key: 1
                }, [
                    !$options.recordings.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_6, " Wir bereiten gerade die Onlinekurse f\xfcr Sie vor. Schauen Sie bitte demn\xe4chst nochmal vorbei. ")) : (0, $9xflP.createCommentVNode)("", true),
                    ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.recordings, (course)=>{
                        return (0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_course_information_box, {
                            key: 'recording-' + course._id,
                            course: course
                        }, null, 8, [
                            "course"
                        ]);
                    }), 128))
                ], 64)) : (0, $9xflP.createCommentVNode)("", true)
            ])
        ])) : (0, $9xflP.createCommentVNode)("", true),
        $options.webinars && $options.webinars.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_7, [
            _cache[1] || (_cache[1] = (0, $9xflP.createElementVNode)("h2", null, "Live\xfcbertragungen", -1)),
            $options.webinarContent ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                key: 0,
                class: "course-content",
                innerHTML: $options.textToMarkdown($options.webinarContent.value)
            }, null, 8, $acca53cd46a40c46$var$_hoisted_8)) : (0, $9xflP.createCommentVNode)("", true),
            (0, $9xflP.createElementVNode)("div", $acca53cd46a40c46$var$_hoisted_9, [
                $data.courseLoader ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_10)) : (0, $9xflP.createCommentVNode)("", true),
                $options.webinars ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                    key: 1
                }, [
                    !$options.webinars.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $acca53cd46a40c46$var$_hoisted_11, " Webinare werden zur Zeit nicht angeboten. ")) : (0, $9xflP.createCommentVNode)("", true),
                    ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.webinars, (course)=>{
                        return (0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_course_information_box, {
                            key: 'webinar-' + course._id,
                            course: course
                        }, null, 8, [
                            "course"
                        ]);
                    }), 128))
                ], 64)) : (0, $9xflP.createCommentVNode)("", true)
            ])
        ])) : (0, $9xflP.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("3CJ66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a37e71c63e81e2c$export$2e2bcd8739ae039; });
let $2a37e71c63e81e2c$var$NOOP = ()=>{};
var $2a37e71c63e81e2c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("jYIw2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $df681a1514a96176$export$2e2bcd8739ae039; });

var $fkTrN = parcelRequire("fkTrN");

var $59Tqr = parcelRequire("59Tqr");

var $i9CMh = parcelRequire("i9CMh");

var $7VdiA = parcelRequire("7VdiA");

var $OHljw = parcelRequire("OHljw");

var $1yw87 = parcelRequire("1yw87");

var $8vZiU = parcelRequire("8vZiU");
const $df681a1514a96176$var$CourseBox = {
    props: [
        'cycle',
        'concept'
    ],
    methods: {
        isCycleRunning: $1yw87.isCycleRunning,
        cycleDateRange: $1yw87.cycleDateRange,
        cycleDay: $1yw87.cycleDay,
        cycleTimeRange: $1yw87.cycleTimeRange,
        cycleDuration: $1yw87.cycleDuration,
        createParticipantLabel (cycle) {
            if (this.concept.maxParticipants - cycle.participantCount === 1) return '<div class="label label-danger">noch 1 Platz frei</div>';
            if (cycle.participantCount >= this.concept.maxParticipants && (0, $1yw87.isCycleRunning)(cycle)) return '<div class="label label-default">ausgebucht</div>';
            if (cycle.participantCount >= this.concept.maxParticipants) return '<div class="label label-warning">Warteliste</div>';
            if (cycle.participantCount >= this.concept.maxParticipants / 2) return `<div class="label label-info">noch ${this.concept.maxParticipants - cycle.participantCount} Pl\xe4tze frei</div>`;
            return '<div class="label label-primary">Pl\xe4tze frei</div>';
        }
    },
    template: `
    <div
      v-if="cycle"
      class="panel panel-dark"
    >
      <div class="panel-body">
        <div class="cycle-facts">
          <div>
            <i class="fa fa-calendar-o"></i>
            {{ cycleDateRange(cycle) }} ({{ cycleDay(cycle) }})
          </div>
          <div>
            <i class="fa fa-hourglass-start"></i>
            {{ concept.weekCount }} Wochen
          </div>
          <div>
            <i class="fa fa-clock-o"></i>
            {{ cycleTimeRange(cycle) }} Uhr ({{ cycleDuration(cycle) }} Minuten)
          </div>
          <div v-if="cycle.address">
            <i class="fa fa-map-pin"></i>
            {{ cycle.address }}
          </div>
          <div>
            <i class="fa fa-money"></i>
            {{ concept.fee }} \u{20AC}
          </div>
          <div v-html="createParticipantLabel(cycle)"></div>
        </div>

        {{ cycle.note }}
      </div>
      <div class="panel-footer" style="padding: 0">
        <button v-if="isCycleRunning(cycle)" class="btn btn-default" style="width: 100%" disabled>gestartet</button>
        <a
          v-else
          class="btn btn-warning btn-lg"
          style="width: 100%"
          :href="'./anmeldung?id=' + cycle._id"
        >anmelden</a
        >
      </div>
    </div>
  `
};
var $df681a1514a96176$export$2e2bcd8739ae039 = {
    data () {
        return {
            page: null,
            concept: null,
            cycles: null,
            dictionary: null,
            similarConcepts: null
        };
    },
    components: {
        NewsletterAndContactButton: $8vZiU.default,
        CourseBox: $df681a1514a96176$var$CourseBox
    },
    computed: {
        newCycles () {
            if (!this.cycles || !this.concept) return [];
            return this.cycles.filter((cycle)=>!(0, $1yw87.isCycleStarted)(cycle) && (0, $1yw87.isPublicVisible)(cycle, this.concept));
        },
        runningCycles () {
            if (!this.cycles || !this.concept) return [];
            return this.cycles.filter((cycle)=>(0, $1yw87.isCycleRunning)(cycle));
        }
    },
    methods: {
        textReplace: $7VdiA.textReplace
    },
    async mounted () {
        const conceptUrl = window.location.pathname;
        this.page = await (0, $59Tqr.getPages)({
            urls: [
                conceptUrl
            ],
            skip: 0,
            take: 1
        }).then(([page])=>page);
        if (!this.page) return;
        this.concept = await (0, $fkTrN.getConcept)(this.page.id);
        if (!this.concept) return;
        (0, $OHljw.getDictionary)({
            course: this.concept
        }).then((dictionary)=>this.dictionary = dictionary);
        this.cycles = await (0, $i9CMh.getCycles)({
            courseId: this.concept._id
        }, {
            fields: {
                address: 1,
                active: 1,
                courseId: 1,
                dateFrom: 1,
                dateTo: 1,
                internPlanningDate: 1,
                leader: 1,
                publicPlanningDate: 1,
                note: 1
            }
        });
        (0, $fkTrN.getConcepts)({
            active: true,
            recording: !!this.concept.recording,
            webinar: !!this.concept.webinar
        }, {
            with: [
                'page'
            ]
        }).then((concepts)=>{
            this.similarConcepts = concepts.filter((concept)=>concept._id !== this.concept._id && concept.page?.url);
        });
    }
};

});
parcelRegister("fkTrN", function(module, exports) {

$parcel$export(module.exports, "getConcept", function () { return $024a9b40e33c15fb$export$b45b44159e4d8129; });
$parcel$export(module.exports, "getConcepts", function () { return $024a9b40e33c15fb$export$db620dd0d4a1ae5f; });

var $jwmSk = parcelRequire("jwmSk");

var $hkrtv = parcelRequire("hkrtv");

var $9owtR = parcelRequire("9owtR");

var $2aHjq = parcelRequire("2aHjq");
const $024a9b40e33c15fb$var$cacheName = (0, $2aHjq.CacheNames).CONCEPTS;
function $024a9b40e33c15fb$export$b45b44159e4d8129(conceptId, options = {}) {
    const cacheId = [
        $024a9b40e33c15fb$var$cacheName,
        conceptId,
        options
    ];
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/courses/', {
            params: {
                id: conceptId,
                ...options
            }
        }).then((result)=>result.data));
    return result;
}
function $024a9b40e33c15fb$export$db620dd0d4a1ae5f(params = {}, options = {}) {
    const cacheId = [
        $024a9b40e33c15fb$var$cacheName,
        params,
        options
    ];
    const mappedParams = {
        ...params,
        ...params.ids && {
            ids: params.ids.join(',')
        },
        ...options.with && {
            with: options.with.join(',')
        }
    };
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/courses/', {
            params: mappedParams
        }).then((result)=>result.data));
    return result;
}
function $024a9b40e33c15fb$export$2f7448fca98bbdcd(params = {}, options = {}) {
    (0, $9owtR.useCache)().clearCache($024a9b40e33c15fb$var$cacheName);
    return $024a9b40e33c15fb$export$db620dd0d4a1ae5f(params, options);
}

});
parcelRegister("jwmSk", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $f3b0402caf65546f$export$dd0a697e1782aedd; });

var $9owtR = parcelRequire("9owtR");
var $f3b0402caf65546f$export$79e2d9500680dd96 = /*#__PURE__*/ function(SortDirection) {
    SortDirection[SortDirection["ASC"] = 1] = "ASC";
    SortDirection[SortDirection["DESC"] = -1] = "DESC";
    return SortDirection;
}({});
function $f3b0402caf65546f$export$dd0a697e1782aedd(cacheId, query) {
    const { getCached: getCached, setCache: setCache } = (0, $9owtR.useCache)();
    const cacheValued = getCached(cacheId);
    if (cacheValued !== undefined) return {
        result: Promise.resolve(cacheValued)
    };
    const value = query();
    setCache(cacheId, value);
    return {
        result: value
    };
}

});
parcelRegister("9owtR", function(module, exports) {

$parcel$export(module.exports, "useCache", function () { return $0516fd80b38ee568$export$c6e89b6bb9436bc0; });
const $0516fd80b38ee568$var$cache = {};
function $0516fd80b38ee568$export$c6e89b6bb9436bc0() {
    function generateHash(cacheId) {
        return JSON.stringify(cacheId);
    }
    function setCache(cacheId, value) {
        const [name] = cacheId;
        const hash = generateHash(cacheId);
        $0516fd80b38ee568$var$cache[name] = $0516fd80b38ee568$var$cache[name] ?? {};
        $0516fd80b38ee568$var$cache[name][hash] = value;
    }
    function clearCache(cacheName) {
        delete $0516fd80b38ee568$var$cache[cacheName];
    }
    function getCached(cacheId) {
        const [name] = cacheId;
        const hash = generateHash(cacheId);
        return $0516fd80b38ee568$var$cache[name]?.[hash];
    }
    return {
        setCache: setCache,
        getCached: getCached,
        clearCache: clearCache
    };
}

});


parcelRegister("2aHjq", function(module, exports) {

$parcel$export(module.exports, "CacheNames", function () { return $440f1291135d3c9f$export$9f9b8a2463c5f163; });
var $440f1291135d3c9f$export$9f9b8a2463c5f163 = /*#__PURE__*/ function(CacheNames) {
    CacheNames["ACCOUNTS"] = "accounts";
    CacheNames["BILLS"] = "bills";
    CacheNames["CERTIFICATES"] = "certificates";
    CacheNames["VOUCHERS"] = "vouchers";
    CacheNames["CYCLES"] = "cycles";
    CacheNames["CONCEPTS"] = "concepts";
    CacheNames["CONTENT_ITEMS"] = "content-items";
    CacheNames["EXCLUDED_DATES"] = "excluded-dates";
    CacheNames["EXCHANGE_DATES"] = "exchange-dates";
    CacheNames["EXTERNAL_COMPANIES"] = "external-companies";
    CacheNames["MAILS"] = "mails";
    CacheNames["PARTICIPANTS"] = "participants";
    CacheNames["IMAGES"] = "images";
    CacheNames["PAGES"] = "pages";
    return CacheNames;
}({});

});


parcelRegister("59Tqr", function(module, exports) {

$parcel$export(module.exports, "getPages", function () { return $f7d1d6bce2cd38bf$export$f4348e32a399a3d5; });

var $jwmSk = parcelRequire("jwmSk");

var $hkrtv = parcelRequire("hkrtv");

var $9owtR = parcelRequire("9owtR");

var $2aHjq = parcelRequire("2aHjq");
const $f7d1d6bce2cd38bf$var$cacheName = (0, $2aHjq.CacheNames).PAGES;
const $f7d1d6bce2cd38bf$var$baseUrl = '/api/pages';
function $f7d1d6bce2cd38bf$export$c2a6433281518c91(id) {
    if (!id) return null;
    const cacheId = [
        $f7d1d6bce2cd38bf$var$cacheName,
        id
    ];
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get($f7d1d6bce2cd38bf$var$baseUrl, {
            params: {
                id: id
            }
        }).then((result)=>result.data));
    return result ?? null;
}
async function $f7d1d6bce2cd38bf$export$138e7cff111abfd(id, data) {
    const result = await (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).put($f7d1d6bce2cd38bf$var$baseUrl, {
        page: data
    }, {
        params: {
            id: id
        }
    });
    (0, $9owtR.useCache)().clearCache($f7d1d6bce2cd38bf$var$cacheName);
    return result.data;
}
async function $f7d1d6bce2cd38bf$export$e2e7d6d4180a0567(id, orderDirection, orderWidth = 1) {
    const result = await (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).patch(`${$f7d1d6bce2cd38bf$var$baseUrl}/reorder`, {
        orderDirection: orderDirection,
        orderWidth: orderWidth
    }, {
        params: {
            id: id
        }
    });
    (0, $9owtR.useCache)().clearCache($f7d1d6bce2cd38bf$var$cacheName);
    return result.data;
}
function $f7d1d6bce2cd38bf$export$f4348e32a399a3d5(params = {}) {
    const cacheId = [
        $f7d1d6bce2cd38bf$var$cacheName,
        params
    ];
    const mappedParams = {
        ...params,
        ...params.urls && {
            urls: params.urls.join(',')
        },
        ...params.ids && {
            ids: params.ids.join(',')
        }
    };
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get($f7d1d6bce2cd38bf$var$baseUrl, {
            params: mappedParams
        }).then((result)=>result.data));
    return result;
}
function $f7d1d6bce2cd38bf$export$42e67990392818b1(params = {}) {
    (0, $9owtR.useCache)().clearCache($f7d1d6bce2cd38bf$var$cacheName);
    return $f7d1d6bce2cd38bf$export$f4348e32a399a3d5(params);
}

});

parcelRegister("i9CMh", function(module, exports) {

$parcel$export(module.exports, "getCycles", function () { return $6ee0949809b40ccb$export$f24b1c788cd64e7e; });

var $jwmSk = parcelRequire("jwmSk");

var $hkrtv = parcelRequire("hkrtv");

var $9owtR = parcelRequire("9owtR");

var $2aHjq = parcelRequire("2aHjq");
const $6ee0949809b40ccb$var$cacheName = (0, $2aHjq.CacheNames).CYCLES;
function $6ee0949809b40ccb$export$20bec882c441c9d4(cycleId, options = {}) {
    const cacheId = [
        $6ee0949809b40ccb$var$cacheName,
        cycleId,
        options
    ];
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/cycles/', {
            params: {
                id: cycleId,
                ...options
            }
        }).then((result)=>result.data.cycle));
    return result;
}
function $6ee0949809b40ccb$export$58eaadc70916d09d(cycleId, options = {}) {
    (0, $9owtR.useCache)().clearCache($6ee0949809b40ccb$var$cacheName);
    return $6ee0949809b40ccb$export$20bec882c441c9d4(cycleId, options);
}
function $6ee0949809b40ccb$export$f24b1c788cd64e7e(params = {}, options = {}) {
    const cacheId = [
        $6ee0949809b40ccb$var$cacheName,
        params,
        options
    ];
    const mappedParams = {
        ...params,
        ...params.ids && {
            ids: params.ids.join(',')
        },
        ...options
    };
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/cycles/', {
            params: mappedParams
        }).then((result)=>result.data.cycles));
    return result;
}
async function $6ee0949809b40ccb$export$453a93ea92d2cd19() {
    const result = await (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).delete('/api/cycles/outdated');
    (0, $9owtR.useCache)().clearCache($6ee0949809b40ccb$var$cacheName);
    return result.data;
}

});

parcelRegister("OHljw", function(module, exports) {

$parcel$export(module.exports, "getDictionary", function () { return $ab34b807141909f0$export$475a61335fef548c; });

var $hkrtv = parcelRequire("hkrtv");

var $jwmSk = parcelRequire("jwmSk");
function $ab34b807141909f0$export$475a61335fef548c({ dummy: dummy, course: course, cycle: cycle, participant: participant } = {}) {
    const params = {
        dummy: dummy,
        courseId: course?._id,
        cycleId: cycle?._id,
        participantId: participant?.id
    };
    const cacheId = [
        'dictionary',
        params
    ];
    const { result: result } = (0, $jwmSk.useQuery)(cacheId, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/data-content-items/', {
            params: params
        }).then((result)=>result.data));
    return result;
}

});

parcelRegister("8vZiU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6330c5a98e2b1b44$export$2e2bcd8739ae039; });
let $6330c5a98e2b1b44$var$script;



let $6330c5a98e2b1b44$var$initialize = ()=>{
    $6330c5a98e2b1b44$var$script = (parcelRequire("g2HNs"));
    if ($6330c5a98e2b1b44$var$script.__esModule) $6330c5a98e2b1b44$var$script = $6330c5a98e2b1b44$var$script.default;
    $6330c5a98e2b1b44$var$script.render = (parcelRequire("2KJOa")).render;
    (parcelRequire("5taDt")).default($6330c5a98e2b1b44$var$script);
    $6330c5a98e2b1b44$var$script.__scopeId = 'data-v-b715d7';
    $6330c5a98e2b1b44$var$script.__file = "NewsletterAndContactButton.vue";
};
$6330c5a98e2b1b44$var$initialize();
var $6330c5a98e2b1b44$export$2e2bcd8739ae039 = $6330c5a98e2b1b44$var$script;

});
parcelRegister("g2HNs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $badece5dcecf016a$export$2e2bcd8739ae039; });
var $badece5dcecf016a$export$2e2bcd8739ae039 = {
    name: 'NewsletterAndContactButton',
    data () {
        return {
            widgetIsOpen: false
        };
    },
    methods: {
        showNewsletterWidget () {
            this.widgetIsOpen = true;
        }
    }
};

});

parcelRegister("2KJOa", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $20136930305ca04e$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $20136930305ca04e$var$_hoisted_1 = {
    key: 0,
    src: "https://ionos-772cdfb6b.sendserver.email/hp/Fz1d1VTwkCpJvZ6qmlb3SQ/signup",
    style: {
        "width": "100%",
        "border-width": "0px",
        "background-color": "#ffffff",
        "height": "215px"
    },
    border: "0"
};
function $20136930305ca04e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", null, [
        (0, $9xflP.createElementVNode)("button", {
            class: "btn btn-warning",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.showNewsletterWidget && $options.showNewsletterWidget(...args))
        }, " ich m\xf6chte \xfcber neue Kurstermine informiert werden "),
        _cache[1] || (_cache[1] = (0, $9xflP.createElementVNode)("br", null, null, -1)),
        _cache[2] || (_cache[2] = (0, $9xflP.createElementVNode)("br", null, null, -1)),
        $data.widgetIsOpen ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("iframe", $20136930305ca04e$var$_hoisted_1)) : (0, $9xflP.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("5taDt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb7e93823755eea$export$2e2bcd8739ae039; });
let $3fb7e93823755eea$var$NOOP = ()=>{};
var $3fb7e93823755eea$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("ct83q", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $913e70e07976e981$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $913e70e07976e981$var$_hoisted_1 = {
    key: 0,
    id: "main-content"
};
const $913e70e07976e981$var$_hoisted_2 = [
    "innerHTML"
];
const $913e70e07976e981$var$_hoisted_3 = {
    key: 1,
    class: "text-center"
};
const $913e70e07976e981$var$_hoisted_4 = [
    "innerHTML"
];
const $913e70e07976e981$var$_hoisted_5 = {
    key: 3,
    class: "text-center",
    style: {
        "margin-bottom": "20px"
    }
};
const $913e70e07976e981$var$_hoisted_6 = [
    "href"
];
const $913e70e07976e981$var$_hoisted_7 = {
    class: "cycles"
};
const $913e70e07976e981$var$_hoisted_8 = {
    class: "cycles"
};
const $913e70e07976e981$var$_hoisted_9 = {
    key: 1,
    class: "big-loader fa fa-spinner fa-pulse fa-2x"
};
const $913e70e07976e981$var$_hoisted_10 = [
    "innerHTML"
];
const $913e70e07976e981$var$_hoisted_11 = [
    "innerHTML"
];
const $913e70e07976e981$var$_hoisted_12 = {
    key: 5,
    class: "row",
    style: {
        "margin-bottom": "20px"
    }
};
const $913e70e07976e981$var$_hoisted_13 = {
    class: "col-xs-12",
    style: {
        "display": "flex",
        "flex-wrap": "wrap",
        "gap": "8px"
    }
};
const $913e70e07976e981$var$_hoisted_14 = [
    "href"
];
function $913e70e07976e981$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NewsletterAndContactButton = (0, $9xflP.resolveComponent)("NewsletterAndContactButton");
    const _component_CourseBox = (0, $9xflP.resolveComponent)("CourseBox");
    return $data.concept ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $913e70e07976e981$var$_hoisted_1, [
        $data.concept.textDescription ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
            key: 0,
            innerHTML: $options.textReplace($data.concept.textDescription, $data.dictionary)
        }, null, 8, $913e70e07976e981$var$_hoisted_2)) : (0, $9xflP.createCommentVNode)("", true),
        !$data.concept.recording ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $913e70e07976e981$var$_hoisted_3, [
            (0, $9xflP.createVNode)(_component_NewsletterAndContactButton)
        ])) : (0, $9xflP.createCommentVNode)("", true),
        $data.concept.textDescription2 ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
            key: 2,
            innerHTML: $options.textReplace($data.concept.textDescription2, $data.dictionary)
        }, null, 8, $913e70e07976e981$var$_hoisted_4)) : (0, $9xflP.createCommentVNode)("", true),
        $data.concept.recording ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $913e70e07976e981$var$_hoisted_5, [
            (0, $9xflP.createElementVNode)("a", {
                href: `/kurse/anmeldung?course=${$data.concept._id}`,
                class: "btn btn-lg btn-warning",
                style: {
                    "width": "200px"
                }
            }, "Jetzt anmelden", 8, $913e70e07976e981$var$_hoisted_6)
        ])) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
            key: 4
        }, [
            $options.newCycles && $options.newCycles.length || $options.runningCycles && $options.runningCycles.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), {
                key: 0
            }, [
                (0, $9xflP.createElementVNode)("div", $913e70e07976e981$var$_hoisted_7, [
                    ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.newCycles, (cycle)=>{
                        return (0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_CourseBox, {
                            cycle: cycle,
                            concept: $data.concept
                        }, null, 8, [
                            "cycle",
                            "concept"
                        ]);
                    }), 256))
                ]),
                (0, $9xflP.createElementVNode)("div", $913e70e07976e981$var$_hoisted_8, [
                    ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($options.runningCycles, (cycle)=>{
                        return (0, $9xflP.openBlock)(), (0, $9xflP.createBlock)(_component_CourseBox, {
                            cycle: cycle,
                            concept: $data.concept
                        }, null, 8, [
                            "cycle",
                            "concept"
                        ]);
                    }), 256))
                ])
            ], 64)) : (0, $9xflP.createCommentVNode)("", true),
            !$data.cycles ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $913e70e07976e981$var$_hoisted_9)) : !$data.cycles.length && $data.concept.textNoCurrentCycles ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("p", {
                key: 2,
                innerHTML: $options.textReplace($data.concept.textNoCurrentCycles, $data.dictionary)
            }, null, 8, $913e70e07976e981$var$_hoisted_10)) : (0, $9xflP.createCommentVNode)("", true),
            $data.concept.textAlternatives ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", {
                key: 3,
                innerHTML: $data.concept.textAlternatives,
                style: {
                    "margin-bottom": "20px"
                }
            }, null, 8, $913e70e07976e981$var$_hoisted_11)) : (0, $9xflP.createCommentVNode)("", true)
        ], 64)),
        $data.similarConcepts && $data.similarConcepts.length ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $913e70e07976e981$var$_hoisted_12, [
            _cache[0] || (_cache[0] = (0, $9xflP.createElementVNode)("div", {
                class: "col-xs-12"
            }, [
                (0, $9xflP.createElementVNode)("h3", null, "Weitere beliebte Pr\xe4ventionskurse")
            ], -1)),
            (0, $9xflP.createElementVNode)("div", $913e70e07976e981$var$_hoisted_13, [
                ((0, $9xflP.openBlock)(true), (0, $9xflP.createElementBlock)((0, $9xflP.Fragment), null, (0, $9xflP.renderList)($data.similarConcepts, (similarConcept)=>{
                    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("a", {
                        class: "btn btn-warning btn-lg",
                        href: `/${similarConcept.page.url}`,
                        role: "button",
                        style: {
                            "flex": "1 1 auto"
                        }
                    }, (0, $9xflP.toDisplayString)(similarConcept.page.navigationTitle), 9, $913e70e07976e981$var$_hoisted_14);
                }), 256))
            ])
        ])) : (0, $9xflP.createCommentVNode)("", true)
    ])) : (0, $9xflP.createCommentVNode)("", true);
}

});

parcelRegister("egGRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a633cdd3d36ea11a$export$2e2bcd8739ae039; });
let $a633cdd3d36ea11a$var$NOOP = ()=>{};
var $a633cdd3d36ea11a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bkWut", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $840eeef546b5f832$export$2e2bcd8739ae039; });

var $b8UNe = parcelRequire("b8UNe");

var $dxPYx = parcelRequire("dxPYx");

var $kJDlT = parcelRequire("kJDlT");

var $3zLav = parcelRequire("3zLav");
var $840eeef546b5f832$export$2e2bcd8739ae039 = {
    name: 'ContactBar',
    components: {
        ButtonSpinner: $kJDlT.default
    },
    data () {
        return {
            isSwitching: false
        };
    },
    computed: {
        imageKitStage () {
            return (0, $3zLav.getImageKitStage)();
        },
        loginVisible () {
            return !this.includedInPath([
                '/onlinekurs'
            ]);
        },
        logoutVisible () {
            const exclusions = [
                (0, $b8UNe.loginRoute),
                (0, $b8UNe.requestNewPasswordRoute)
            ];
            return !this.loginVisible && !this.includedInPath(exclusions);
        },
        switchParticipantVisible () {
            if (!this.logoutVisible) return false;
            if (this.includedInPath([
                (0, $b8UNe.participantSelectionRoute)
            ])) return false;
            const user = (0, $dxPYx.getUser)();
            return this.isSwitching || user.isAdminLogin || !!user?.participantId && user?.totalNumberOfParticipants > 1;
        }
    },
    methods: {
        includedInPath (paths) {
            if (!this.$route) return false;
            return paths.some((path)=>this.$route.href?.indexOf(path) !== -1);
        },
        resetParticipant () {
            this.isSwitching = true;
            (0, $dxPYx.setUser)({
                ...(0, $dxPYx.getUser)(),
                participantId: null,
                conceptId: null,
                cycleId: null
            });
            this.$router.push((0, $b8UNe.participantSelectionRoute));
            setTimeout(()=>{
                this.isSwitching = false;
            }, 1000);
        }
    }
};

});
parcelRegister("b8UNe", function(module, exports) {

$parcel$export(module.exports, "loginRoute", function () { return $b5ce7bf8de7ccba6$export$798bfdbebc5ea68e; });
$parcel$export(module.exports, "requestNewPasswordRoute", function () { return $b5ce7bf8de7ccba6$export$f097ca5e00dc4726; });
$parcel$export(module.exports, "participantSelectionRoute", function () { return $b5ce7bf8de7ccba6$export$c7dcab05017ec142; });
const $b5ce7bf8de7ccba6$export$798bfdbebc5ea68e = '/login';
const $b5ce7bf8de7ccba6$export$f41d2607c3906adf = '/logout';
const $b5ce7bf8de7ccba6$export$f097ca5e00dc4726 = '/passwort-vergessen';
const $b5ce7bf8de7ccba6$export$22ab3728454df904 = '/kursbereich';
const $b5ce7bf8de7ccba6$export$ab650f4791342574 = '/kursbereich/aufzeichnung';
const $b5ce7bf8de7ccba6$export$2f41847e31eb8eac = '/kursanmeldung';
const $b5ce7bf8de7ccba6$export$fa62c8d514b3de42 = '/passwort-erstellen';
const $b5ce7bf8de7ccba6$export$a24ebca7a145ef3f = '/konto-upgrade';
const $b5ce7bf8de7ccba6$export$c7dcab05017ec142 = '/teilnehmer';
const $b5ce7bf8de7ccba6$export$5bb25eb2323b5f3d = '/aktivierung';
const $b5ce7bf8de7ccba6$export$187f4ee7d1f3419a = '/automatische-folgekursbuchung';
const $b5ce7bf8de7ccba6$export$58cdff8c4e0a4eb3 = '/dokumente';
const $b5ce7bf8de7ccba6$export$3352a89fd8d85885 = $b5ce7bf8de7ccba6$export$22ab3728454df904;

});

parcelRegister("dxPYx", function(module, exports) {

$parcel$export(module.exports, "getUser", function () { return $a75b0e0d6923cce2$export$7cbf767827cd68ba; });
$parcel$export(module.exports, "setUser", function () { return $a75b0e0d6923cce2$export$8b6bb3dd62a01be2; });

var $jDqC8 = parcelRequire("jDqC8");

var $hVJai = parcelRequire("hVJai");
const { getUser: $a75b0e0d6923cce2$export$7cbf767827cd68ba, isAuthenticated: $a75b0e0d6923cce2$export$83d11f23a23d4a7c, setUser: $a75b0e0d6923cce2$export$8b6bb3dd62a01be2 } = (0, $jDqC8.default)((0, $hVJai.AuthKey).Online);

});
parcelRegister("jDqC8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e802d82bc0bdd24$export$2e2bcd8739ae039; });

var $9xflP = parcelRequire("9xflP");

var $9OUjr = parcelRequire("9OUjr");
var $8e802d82bc0bdd24$export$2e2bcd8739ae039 = (authKey)=>{
    const authCookieName = `${authKey}-auth`;
    const authUserName = `${authKey}-user`;
    const authCookie = (0, $9OUjr.default)(authCookieName);
    const userState = (0, $9xflP.reactive)({
        user: null,
        setUser (user) {
            this.user = user;
        }
    });
    function isAuthenticated() {
        return !!authCookie.get();
    }
    function setUser(newUser) {
        if (newUser) {
            localStorage.setItem(authUserName, JSON.stringify(newUser));
            authCookie.set();
            userState.setUser({
                ...newUser
            });
        } else {
            localStorage.removeItem(authUserName);
            authCookie.remove();
            userState.setUser(null);
        }
    }
    function getUser() {
        return userState.user;
    }
    function refreshLogin() {
        setUser(JSON.parse(localStorage.getItem(authUserName)) ?? null);
    }
    refreshLogin();
    return {
        isAuthenticated: isAuthenticated,
        setUser: setUser,
        getUser: getUser,
        refreshLogin: refreshLogin
    };
};

});
parcelRegister("9OUjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7264771075854520$export$2e2bcd8739ae039; });

var $gOIrB = parcelRequire("gOIrB");

var $ldBoL = parcelRequire("ldBoL");
const $7264771075854520$var$expiresIn = 0.5; // days
var $7264771075854520$export$2e2bcd8739ae039 = (cookieName)=>({
        get: ()=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($ldBoL))).get(cookieName);
        },
        set: ()=>{
            const expires = (0, (/*@__PURE__*/$parcel$interopDefault($gOIrB)))().add($7264771075854520$var$expiresIn * 24, "hours").format("YYYYMMDD-HHMM");
            (0, (/*@__PURE__*/$parcel$interopDefault($ldBoL))).set(cookieName, expires, {
                expires: $7264771075854520$var$expiresIn
            });
        },
        remove: ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($ldBoL))).set(cookieName, 0, {
                expires: 0
            });
        }
    });

});
parcelRegister("ldBoL", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});



parcelRegister("hVJai", function(module, exports) {

$parcel$export(module.exports, "AuthKey", function () { return $851c7b1eba401b3c$export$4b065582cbeb6a54; });
var $851c7b1eba401b3c$export$4b065582cbeb6a54 = /*#__PURE__*/ function(AuthKey) {
    AuthKey["Manager"] = "manager";
    AuthKey["Online"] = "online";
    return AuthKey;
}({});

});


parcelRegister("kJDlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f186891ddd0ac70e$export$2e2bcd8739ae039; });
let $f186891ddd0ac70e$var$script;




let $f186891ddd0ac70e$var$initialize = ()=>{
    $f186891ddd0ac70e$var$script = (parcelRequire("gdGt1"));
    if ($f186891ddd0ac70e$var$script.__esModule) $f186891ddd0ac70e$var$script = $f186891ddd0ac70e$var$script.default;
    $f186891ddd0ac70e$var$script.render = (parcelRequire("fPXvD")).render;
    $f186891ddd0ac70e$var$script.__cssModules = {};
    (parcelRequire("feth9")).default($f186891ddd0ac70e$var$script);
    $f186891ddd0ac70e$var$script.__scopeId = 'data-v-e4e900';
    $f186891ddd0ac70e$var$script.__file = "ButtonSpinner.vue";
};
$f186891ddd0ac70e$var$initialize();
var $f186891ddd0ac70e$export$2e2bcd8739ae039 = $f186891ddd0ac70e$var$script;

});
parcelRegister("gdGt1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6492e20046a8114e$export$2e2bcd8739ae039; });

var $9xflP = parcelRequire("9xflP");
var $6492e20046a8114e$export$2e2bcd8739ae039 = (0, $9xflP.defineComponent)({
    name: 'ButtonSpinner',
    props: {
        isSpinning: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        }
    },
    emits: [
        'click'
    ]
});

});

parcelRegister("fPXvD", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b879c7bde588f125$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $b879c7bde588f125$var$_hoisted_1 = [
    "disabled"
];
const $b879c7bde588f125$var$_hoisted_2 = {
    key: 0,
    class: "spinner-wrapper"
};
function $b879c7bde588f125$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("button", {
        disabled: _ctx.isSpinning || _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('click')),
        class: "button-spinner"
    }, [
        _ctx.isSpinning ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("span", $b879c7bde588f125$var$_hoisted_2, [
            ..._cache[1] || (_cache[1] = [
                (0, $9xflP.createElementVNode)("i", {
                    class: "fa fa-spinner fa-pulse"
                }, null, -1)
            ])
        ])) : (0, $9xflP.createCommentVNode)("", true),
        (0, $9xflP.createElementVNode)("span", {
            class: (0, $9xflP.normalizeClass)({
                invisible: _ctx.isSpinning
            })
        }, [
            (0, $9xflP.renderSlot)(_ctx.$slots, "default")
        ], 2)
    ], 8, $b879c7bde588f125$var$_hoisted_1);
}

});

parcelRegister("feth9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16edf5b199c1e2d$export$2e2bcd8739ae039; });
let $b16edf5b199c1e2d$var$NOOP = ()=>{};
var $b16edf5b199c1e2d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3zLav", function(module, exports) {

$parcel$export(module.exports, "getImageKitStage", function () { return $9ee9439126153048$export$331492790b543649; });

var $3nC6D = parcelRequire("3nC6D");
var $9ee9439126153048$var$ImageKitStage = /*#__PURE__*/ function(ImageKitStage) {
    ImageKitStage["DEV"] = "dev";
    ImageKitStage["TEST"] = "test";
    ImageKitStage["LIVE"] = "live";
    return ImageKitStage;
}($9ee9439126153048$var$ImageKitStage || {});
const $9ee9439126153048$var$stageMapping = {
    [(0, $3nC6D.Stage).DEV]: "dev",
    [(0, $3nC6D.Stage).TEST]: "test",
    [(0, $3nC6D.Stage).LIVE]: "live"
};
function $9ee9439126153048$export$331492790b543649() {
    return $9ee9439126153048$var$stageMapping[appConfig.stage];
}

});


parcelRegister("lTqOk", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ff038814b6ac81cd$export$b3890eb0ae9dca99; });

var $9xflP = parcelRequire("9xflP");
const $ff038814b6ac81cd$var$_hoisted_1 = {
    class: "contact-bar-wrapper"
};
const $ff038814b6ac81cd$var$_hoisted_2 = {
    key: 0,
    class: "teaser"
};
const $ff038814b6ac81cd$var$_hoisted_3 = {
    class: "contact-bar"
};
const $ff038814b6ac81cd$var$_hoisted_4 = {
    key: 0,
    class: "hidden-xs"
};
const $ff038814b6ac81cd$var$_hoisted_5 = [
    "src"
];
const $ff038814b6ac81cd$var$_hoisted_6 = {
    class: "contact-data"
};
const $ff038814b6ac81cd$var$_hoisted_7 = {
    key: 0,
    class: "hidden-xs"
};
const $ff038814b6ac81cd$var$_hoisted_8 = {
    class: "action-buttons"
};
const $ff038814b6ac81cd$var$_hoisted_9 = {
    key: 0,
    class: "online-login"
};
const $ff038814b6ac81cd$var$_hoisted_10 = {
    key: 1,
    class: "flex-row"
};
const $ff038814b6ac81cd$var$_hoisted_11 = {
    key: 0,
    class: "switch-participant"
};
const $ff038814b6ac81cd$var$_hoisted_12 = {
    key: 1,
    class: "online-logout"
};
function $ff038814b6ac81cd$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_button_spinner = (0, $9xflP.resolveComponent)("button-spinner");
    return (0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_1, [
        $options.loginVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_2, [
            ..._cache[0] || (_cache[0] = [
                (0, $9xflP.createElementVNode)("div", {
                    style: {
                        "font-size": "24px",
                        "font-weight": "bold",
                        "width": "100%",
                        "margin": "10px 0"
                    }
                }, " krankenkassenzertifizierte & bezuschusste Sportkurse ", -1)
            ])
        ])) : (0, $9xflP.createCommentVNode)("", true),
        (0, $9xflP.createElementVNode)("div", $ff038814b6ac81cd$var$_hoisted_3, [
            $options.loginVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_4, [
                (0, $9xflP.createElementVNode)("img", {
                    src: `https://ik.imagekit.io/eyesonly/tr:w-48,fl-h/${$options.imageKitStage}/Sahra%20Theraband`,
                    alt: "Sahra Weber - Personal Trainer"
                }, null, 8, $ff038814b6ac81cd$var$_hoisted_5)
            ])) : (0, $9xflP.createCommentVNode)("", true),
            (0, $9xflP.createElementVNode)("div", $ff038814b6ac81cd$var$_hoisted_6, [
                $options.loginVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_7, [
                    ..._cache[1] || (_cache[1] = [
                        (0, $9xflP.createElementVNode)("div", null, "Sahra Weber", -1),
                        (0, $9xflP.createElementVNode)("div", null, "Diplom Sportwissenschaftlerin", -1)
                    ])
                ])) : (0, $9xflP.createCommentVNode)("", true),
                _cache[2] || (_cache[2] = (0, $9xflP.createStaticVNode)("<div class=\"contact-links\" data-v-d9a716><div data-v-d9a716><i class=\"fa fa-envelope\" data-v-d9a716></i><a href=\"mailto:info@sahra-weber.de?subject=Kontaktanfrage\" data-v-d9a716>info@sahra-weber.de</a></div><div data-v-d9a716><i class=\"fa fa-phone\" data-v-d9a716></i><a href=\"tel:+491778737773\" data-v-d9a716>0177 / 87 37 773</a></div></div><div data-v-d9a716><table data-v-d9a716><tbody data-v-d9a716><tr data-v-d9a716><td data-v-d9a716><i class=\"fa fa-clock-o\" data-v-d9a716></i></td><td data-v-d9a716>Mo-Do</td><td data-v-d9a716>10-18 Uhr</td></tr><tr data-v-d9a716><td data-v-d9a716></td><td data-v-d9a716>Fr</td><td data-v-d9a716>10-15 Uhr</td></tr></tbody></table></div>", 2))
            ]),
            (0, $9xflP.createElementVNode)("div", $ff038814b6ac81cd$var$_hoisted_8, [
                $options.loginVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_9, [
                    ..._cache[3] || (_cache[3] = [
                        (0, $9xflP.createElementVNode)("a", {
                            class: "btn btn-warning btn-lg",
                            title: "Zum Onlinekurs-Kundenportal",
                            href: "/onlinekurs"
                        }, [
                            (0, $9xflP.createElementVNode)("i", {
                                class: "fa fa-user-circle"
                            }),
                            (0, $9xflP.createTextVNode)(" Login ")
                        ], -1)
                    ])
                ])) : ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_10, [
                    $options.switchParticipantVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_11, [
                        (0, $9xflP.createVNode)(_component_button_spinner, {
                            "is-spinning": $data.isSwitching,
                            class: "btn btn-warning btn-sm",
                            title: "Teilnehmer wechseln",
                            onClick: $options.resetParticipant
                        }, {
                            default: (0, $9xflP.withCtx)(()=>[
                                    ..._cache[4] || (_cache[4] = [
                                        (0, $9xflP.createElementVNode)("i", {
                                            class: "fa fa-exchange"
                                        }, null, -1),
                                        (0, $9xflP.createTextVNode)(" Kurs wechseln ", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "is-spinning",
                            "onClick"
                        ])
                    ])) : (0, $9xflP.createCommentVNode)("", true),
                    $options.logoutVisible ? ((0, $9xflP.openBlock)(), (0, $9xflP.createElementBlock)("div", $ff038814b6ac81cd$var$_hoisted_12, [
                        ..._cache[5] || (_cache[5] = [
                            (0, $9xflP.createElementVNode)("a", {
                                class: "btn btn-warning btn-sm",
                                title: "abmelden",
                                href: "/onlinekurs/logout"
                            }, [
                                (0, $9xflP.createElementVNode)("i", {
                                    class: "fa fa-power-off"
                                }),
                                (0, $9xflP.createTextVNode)(" Abmelden ")
                            ], -1)
                        ])
                    ])) : (0, $9xflP.createCommentVNode)("", true)
                ]))
            ])
        ])
    ]);
}

});

parcelRegister("lhAxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e786d4f9317c87$export$2e2bcd8739ae039; });
let $f7e786d4f9317c87$var$NOOP = ()=>{};
var $f7e786d4f9317c87$export$2e2bcd8739ae039 = (script)=>{};

});

var $6cf7a554e7597734$exports = {};
$parcel$extendImportMap({
    "cIVpX": "Signup.f4d8a2c5.js",
    "gAE4i": "confirmation.9cd8cd13.js",
    "8NJB5": "pdfmake.c8a23293.js",
    "818ka": "vfs_fonts.c7433157.js",
    "gRuWI": "confirmation.f6ac11cd.css",
    "2CqEm": "Signup.87797c97.css"
});

var $b34e6f37d1bfb589$export$6576b9de878968d6 = /*#__PURE__*/ function(OrderDirection) {
    OrderDirection["UP"] = "up";
    OrderDirection["DOWN"] = "down";
    return OrderDirection;
}({});


var $5f817a7c5c23d373$exports = {};
//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

(function(global, factory) {
    factory((parcelRequire("gOIrB")));
})($5f817a7c5c23d373$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var monthsParse = [
        /^jan/i,
        /^feb/i,
        /^mär/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dez/i
    ], monthsRegex = /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|Jan\.?|Feb\.?|Mär\.?|Apr\.?|Jun\.?|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i;
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                'eine Minute',
                'einer Minute'
            ],
            h: [
                'eine Stunde',
                'einer Stunde'
            ],
            d: [
                'ein Tag',
                'einem Tag'
            ],
            dd: [
                number + ' Tage',
                number + ' Tagen'
            ],
            w: [
                'eine Woche',
                'einer Woche'
            ],
            M: [
                'ein Monat',
                'einem Monat'
            ],
            MM: [
                number + ' Monate',
                number + ' Monaten'
            ],
            y: [
                'ein Jahr',
                'einem Jahr'
            ],
            yy: [
                number + ' Jahre',
                number + ' Jahren'
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    var de = moment.defineLocale('de', {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split('_'),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split('_'),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)/i,
        monthsShortStrictRegex: /^(Jan\.?|Feb\.?|März|Mär\.?|Apr\.?|Mai|Juni|Jun\.?|Juli|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return de;
});



var $9xflP = parcelRequire("9xflP");
/*!
 * vuex v4.0.2
 * (c) 2021 Evan You
 * @license MIT
 */ 
var $9xflP = parcelRequire("9xflP");
function $d5dfd80f39111566$export$5a2d366b2d9f38f6() {
    return $d5dfd80f39111566$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $d5dfd80f39111566$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $d5dfd80f39111566$export$bc32a04c49ed7464 = typeof Proxy === 'function';


const $9a413ef5e4dd2533$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $9a413ef5e4dd2533$export$a0897f44accbe922 = 'plugin:settings:set';



let $e71807574e9828ab$var$supported;
let $e71807574e9828ab$var$perf;
function $e71807574e9828ab$export$70d26280bc1ca547() {
    var _a;
    if ($e71807574e9828ab$var$supported !== undefined) return $e71807574e9828ab$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $e71807574e9828ab$var$supported = true;
        $e71807574e9828ab$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $e71807574e9828ab$var$supported = true;
        $e71807574e9828ab$var$perf = globalThis.perf_hooks.performance;
    } else $e71807574e9828ab$var$supported = false;
    return $e71807574e9828ab$var$supported;
}
function $e71807574e9828ab$export$461939dd4422153() {
    return $e71807574e9828ab$export$70d26280bc1ca547() ? $e71807574e9828ab$var$perf.now() : Date.now();
}


class $031dc6d900f64aab$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $e71807574e9828ab$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $9a413ef5e4dd2533$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $822887c75210f552$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $d5dfd80f39111566$export$c22522a4dfa48e9c)();
    const hook = (0, $d5dfd80f39111566$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $d5dfd80f39111566$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $9a413ef5e4dd2533$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $031dc6d900f64aab$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


var $52e611b349343813$export$67bdc3ac2df6c0d1 = 'store';
function $52e611b349343813$export$6ccbb43953eebf8(key) {
    if (key === void 0) key = null;
    return (0, $9xflP.inject)(key !== null ? key : $52e611b349343813$export$67bdc3ac2df6c0d1);
}
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */ function $52e611b349343813$var$find(list, f) {
    return list.filter(f)[0];
}
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */ function $52e611b349343813$var$deepCopy(obj, cache) {
    if (cache === void 0) cache = [];
    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') return obj;
    // if obj is hit, it is in circular structure
    var hit = $52e611b349343813$var$find(cache, function(c) {
        return c.original === obj;
    });
    if (hit) return hit.copy;
    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy: copy
    });
    Object.keys(obj).forEach(function(key) {
        copy[key] = $52e611b349343813$var$deepCopy(obj[key], cache);
    });
    return copy;
}
/**
 * forEach for object
 */ function $52e611b349343813$var$forEachValue(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
function $52e611b349343813$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $52e611b349343813$var$isPromise(val) {
    return val && typeof val.then === 'function';
}
function $52e611b349343813$var$assert(condition, msg) {
    if (!condition) throw new Error("[vuex] " + msg);
}
function $52e611b349343813$var$partial(fn, arg) {
    return function() {
        return fn(arg);
    };
}
function $52e611b349343813$var$genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    return function() {
        var i = subs.indexOf(fn);
        if (i > -1) subs.splice(i, 1);
    };
}
function $52e611b349343813$var$resetStore(store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state;
    // init all modules
    $52e611b349343813$var$installModule(store, state, [], store._modules.root, true);
    // reset state
    $52e611b349343813$var$resetStoreState(store, state, hot);
}
function $52e611b349343813$var$resetStoreState(store, state, hot) {
    var oldState = store._state;
    // bind store public getters
    store.getters = {};
    // reset local getters cache
    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computedObj = {};
    $52e611b349343813$var$forEachValue(wrappedGetters, function(fn, key) {
        // use computed to leverage its lazy-caching mechanism
        // direct inline function use will lead to closure preserving oldState.
        // using partial to return function with only arguments preserved in closure environment.
        computedObj[key] = $52e611b349343813$var$partial(fn, store);
        Object.defineProperty(store.getters, key, {
            // TODO: use `computed` when it's possible. at the moment we can't due to
            // https://github.com/vuejs/vuex/pull/1883
            get: function() {
                return computedObj[key]();
            },
            enumerable: true // for local getters
        });
    });
    store._state = (0, $9xflP.reactive)({
        data: state
    });
    // enable strict mode for new state
    if (store.strict) $52e611b349343813$var$enableStrictMode(store);
    if (oldState) {
        if (hot) // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function() {
            oldState.data = null;
        });
    }
}
function $52e611b349343813$var$installModule(store, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store._modules.getNamespace(path);
    // register in namespace map
    if (module.namespaced) {
        if (store._modulesNamespaceMap[namespace] && true) console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
        store._modulesNamespaceMap[namespace] = module;
    }
    // set state
    if (!isRoot && !hot) {
        var parentState = $52e611b349343813$var$getNestedState(rootState, path.slice(0, -1));
        var moduleName = path[path.length - 1];
        store._withCommit(function() {
            if (moduleName in parentState) console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
            parentState[moduleName] = module.state;
        });
    }
    var local = module.context = $52e611b349343813$var$makeLocalContext(store, namespace, path);
    module.forEachMutation(function(mutation, key) {
        var namespacedType = namespace + key;
        $52e611b349343813$var$registerMutation(store, namespacedType, mutation, local);
    });
    module.forEachAction(function(action, key) {
        var type = action.root ? key : namespace + key;
        var handler = action.handler || action;
        $52e611b349343813$var$registerAction(store, type, handler, local);
    });
    module.forEachGetter(function(getter, key) {
        var namespacedType = namespace + key;
        $52e611b349343813$var$registerGetter(store, namespacedType, getter, local);
    });
    module.forEachChild(function(child, key) {
        $52e611b349343813$var$installModule(store, rootState, path.concat(key), child, hot);
    });
}
/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */ function $52e611b349343813$var$makeLocalContext(store, namespace, path) {
    var noNamespace = namespace === '';
    var local = {
        dispatch: noNamespace ? store.dispatch : function(_type, _payload, _options) {
            var args = $52e611b349343813$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._actions[type]) {
                    console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            return store.dispatch(type, payload);
        },
        commit: noNamespace ? store.commit : function(_type, _payload, _options) {
            var args = $52e611b349343813$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._mutations[type]) {
                    console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            store.commit(type, payload, options);
        }
    };
    // getters and state object must be gotten lazily
    // because they will be changed by state update
    Object.defineProperties(local, {
        getters: {
            get: noNamespace ? function() {
                return store.getters;
            } : function() {
                return $52e611b349343813$var$makeLocalGetters(store, namespace);
            }
        },
        state: {
            get: function() {
                return $52e611b349343813$var$getNestedState(store.state, path);
            }
        }
    });
    return local;
}
function $52e611b349343813$var$makeLocalGetters(store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
        var gettersProxy = {};
        var splitPos = namespace.length;
        Object.keys(store.getters).forEach(function(type) {
            // skip if the target getter is not match this namespace
            if (type.slice(0, splitPos) !== namespace) return;
            // extract local getter type
            var localType = type.slice(splitPos);
            // Add a port to the getters proxy.
            // Define as getter property because
            // we do not want to evaluate the getters in this time.
            Object.defineProperty(gettersProxy, localType, {
                get: function() {
                    return store.getters[type];
                },
                enumerable: true
            });
        });
        store._makeLocalGettersCache[namespace] = gettersProxy;
    }
    return store._makeLocalGettersCache[namespace];
}
function $52e611b349343813$var$registerMutation(store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
        handler.call(store, local.state, payload);
    });
}
function $52e611b349343813$var$registerAction(store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
        var res = handler.call(store, {
            dispatch: local.dispatch,
            commit: local.commit,
            getters: local.getters,
            state: local.state,
            rootGetters: store.getters,
            rootState: store.state
        }, payload);
        if (!$52e611b349343813$var$isPromise(res)) res = Promise.resolve(res);
        if (store._devtoolHook) return res.catch(function(err) {
            store._devtoolHook.emit('vuex:error', err);
            throw err;
        });
        else return res;
    });
}
function $52e611b349343813$var$registerGetter(store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
        console.error("[vuex] duplicate getter key: " + type);
        return;
    }
    store._wrappedGetters[type] = function wrappedGetter(store) {
        return rawGetter(local.state, local.getters, store.state, store.getters // root getters
        );
    };
}
function $52e611b349343813$var$enableStrictMode(store) {
    (0, $9xflP.watch)(function() {
        return store._state.data;
    }, function() {
        $52e611b349343813$var$assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }, {
        deep: true,
        flush: 'sync'
    });
}
function $52e611b349343813$var$getNestedState(state, path) {
    return path.reduce(function(state, key) {
        return state[key];
    }, state);
}
function $52e611b349343813$var$unifyObjectStyle(type, payload, options) {
    if ($52e611b349343813$var$isObject(type) && type.type) {
        options = payload;
        payload = type;
        type = type.type;
    }
    $52e611b349343813$var$assert(typeof type === 'string', "expects string as the type, but found " + typeof type + ".");
    return {
        type: type,
        payload: payload,
        options: options
    };
}
var $52e611b349343813$var$LABEL_VUEX_BINDINGS = 'vuex bindings';
var $52e611b349343813$var$MUTATIONS_LAYER_ID = 'vuex:mutations';
var $52e611b349343813$var$ACTIONS_LAYER_ID = 'vuex:actions';
var $52e611b349343813$var$INSPECTOR_ID = 'vuex';
var $52e611b349343813$var$actionId = 0;
function $52e611b349343813$var$addDevtools(app, store) {
    (0, $822887c75210f552$export$63b9a9bba9f20f3e)({
        id: 'org.vuejs.vuex',
        app: app,
        label: 'Vuex',
        homepage: 'https://next.vuex.vuejs.org/',
        logo: 'https://vuejs.org/images/icons/favicon-96x96.png',
        packageName: 'vuex',
        componentStateTypes: [
            $52e611b349343813$var$LABEL_VUEX_BINDINGS
        ]
    }, function(api) {
        api.addTimelineLayer({
            id: $52e611b349343813$var$MUTATIONS_LAYER_ID,
            label: 'Vuex Mutations',
            color: $52e611b349343813$var$COLOR_LIME_500
        });
        api.addTimelineLayer({
            id: $52e611b349343813$var$ACTIONS_LAYER_ID,
            label: 'Vuex Actions',
            color: $52e611b349343813$var$COLOR_LIME_500
        });
        api.addInspector({
            id: $52e611b349343813$var$INSPECTOR_ID,
            label: 'Vuex',
            icon: 'storage',
            treeFilterPlaceholder: 'Filter stores...'
        });
        api.on.getInspectorTree(function(payload) {
            if (payload.app === app && payload.inspectorId === $52e611b349343813$var$INSPECTOR_ID) {
                if (payload.filter) {
                    var nodes = [];
                    $52e611b349343813$var$flattenStoreForInspectorTree(nodes, store._modules.root, payload.filter, '');
                    payload.rootNodes = nodes;
                } else payload.rootNodes = [
                    $52e611b349343813$var$formatStoreForInspectorTree(store._modules.root, '')
                ];
            }
        });
        api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $52e611b349343813$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                $52e611b349343813$var$makeLocalGetters(store, modulePath);
                payload.state = $52e611b349343813$var$formatStoreForInspectorState($52e611b349343813$var$getStoreModule(store._modules, modulePath), modulePath === 'root' ? store.getters : store._makeLocalGettersCache, modulePath);
            }
        });
        api.on.editInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $52e611b349343813$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                var path = payload.path;
                if (modulePath !== 'root') path = modulePath.split('/').filter(Boolean).concat(path);
                store._withCommit(function() {
                    payload.set(store._state.data, path, payload.state.value);
                });
            }
        });
        store.subscribe(function(mutation, state) {
            var data = {};
            if (mutation.payload) data.payload = mutation.payload;
            data.state = state;
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e611b349343813$var$INSPECTOR_ID);
            api.sendInspectorState($52e611b349343813$var$INSPECTOR_ID);
            api.addTimelineEvent({
                layerId: $52e611b349343813$var$MUTATIONS_LAYER_ID,
                event: {
                    time: Date.now(),
                    title: mutation.type,
                    data: data
                }
            });
        });
        store.subscribeAction({
            before: function(action, state) {
                var data = {};
                if (action.payload) data.payload = action.payload;
                action._id = $52e611b349343813$var$actionId++;
                action._time = Date.now();
                data.state = state;
                api.addTimelineEvent({
                    layerId: $52e611b349343813$var$ACTIONS_LAYER_ID,
                    event: {
                        time: action._time,
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'start',
                        data: data
                    }
                });
            },
            after: function(action, state) {
                var data = {};
                var duration = Date.now() - action._time;
                data.duration = {
                    _custom: {
                        type: 'duration',
                        display: duration + "ms",
                        tooltip: 'Action duration',
                        value: duration
                    }
                };
                if (action.payload) data.payload = action.payload;
                data.state = state;
                api.addTimelineEvent({
                    layerId: $52e611b349343813$var$ACTIONS_LAYER_ID,
                    event: {
                        time: Date.now(),
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'end',
                        data: data
                    }
                });
            }
        });
    });
}
// extracted from tailwind palette
var $52e611b349343813$var$COLOR_LIME_500 = 0x84cc16;
var $52e611b349343813$var$COLOR_DARK = 0x666666;
var $52e611b349343813$var$COLOR_WHITE = 0xffffff;
var $52e611b349343813$var$TAG_NAMESPACED = {
    label: 'namespaced',
    textColor: $52e611b349343813$var$COLOR_WHITE,
    backgroundColor: $52e611b349343813$var$COLOR_DARK
};
/**
 * @param {string} path
 */ function $52e611b349343813$var$extractNameFromPath(path) {
    return path && path !== 'root' ? path.split('/').slice(-2, -1)[0] : 'Root';
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorNode}
 */ function $52e611b349343813$var$formatStoreForInspectorTree(module, path) {
    return {
        id: path || 'root',
        // all modules end with a `/`, we want the last segment only
        // cart/ -> cart
        // nested/cart/ -> cart
        label: $52e611b349343813$var$extractNameFromPath(path),
        tags: module.namespaced ? [
            $52e611b349343813$var$TAG_NAMESPACED
        ] : [],
        children: Object.keys(module._children).map(function(moduleName) {
            return $52e611b349343813$var$formatStoreForInspectorTree(module._children[moduleName], path + moduleName + '/');
        })
    };
}
/**
 * @param {import('@vue/devtools-api').CustomInspectorNode[]} result
 * @param {*} module
 * @param {string} filter
 * @param {string} path
 */ function $52e611b349343813$var$flattenStoreForInspectorTree(result, module, filter, path) {
    if (path.includes(filter)) result.push({
        id: path || 'root',
        label: path.endsWith('/') ? path.slice(0, path.length - 1) : path || 'Root',
        tags: module.namespaced ? [
            $52e611b349343813$var$TAG_NAMESPACED
        ] : []
    });
    Object.keys(module._children).forEach(function(moduleName) {
        $52e611b349343813$var$flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + '/');
    });
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorState}
 */ function $52e611b349343813$var$formatStoreForInspectorState(module, getters, path) {
    getters = path === 'root' ? getters : getters[path];
    var gettersKeys = Object.keys(getters);
    var storeState = {
        state: Object.keys(module.state).map(function(key) {
            return {
                key: key,
                editable: true,
                value: module.state[key]
            };
        })
    };
    if (gettersKeys.length) {
        var tree = $52e611b349343813$var$transformPathsToObjectTree(getters);
        storeState.getters = Object.keys(tree).map(function(key) {
            return {
                key: key.endsWith('/') ? $52e611b349343813$var$extractNameFromPath(key) : key,
                editable: false,
                value: $52e611b349343813$var$canThrow(function() {
                    return tree[key];
                })
            };
        });
    }
    return storeState;
}
function $52e611b349343813$var$transformPathsToObjectTree(getters) {
    var result = {};
    Object.keys(getters).forEach(function(key) {
        var path = key.split('/');
        if (path.length > 1) {
            var target = result;
            var leafKey = path.pop();
            path.forEach(function(p) {
                if (!target[p]) target[p] = {
                    _custom: {
                        value: {},
                        display: p,
                        tooltip: 'Module',
                        abstract: true
                    }
                };
                target = target[p]._custom.value;
            });
            target[leafKey] = $52e611b349343813$var$canThrow(function() {
                return getters[key];
            });
        } else result[key] = $52e611b349343813$var$canThrow(function() {
            return getters[key];
        });
    });
    return result;
}
function $52e611b349343813$var$getStoreModule(moduleMap, path) {
    var names = path.split('/').filter(function(n) {
        return n;
    });
    return names.reduce(function(module, moduleName, i) {
        var child = module[moduleName];
        if (!child) throw new Error("Missing module \"" + moduleName + "\" for path \"" + path + "\".");
        return i === names.length - 1 ? child : child._children;
    }, path === 'root' ? moduleMap : moduleMap.root._children);
}
function $52e611b349343813$var$canThrow(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
// Base data struct for store's module, package with some attribute and method
var $52e611b349343813$var$Module = function Module(rawModule, runtime) {
    this.runtime = runtime;
    // Store some children item
    this._children = Object.create(null);
    // Store the origin module object which passed by programmer
    this._rawModule = rawModule;
    var rawState = rawModule.state;
    // Store the origin module's state
    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};
var $52e611b349343813$var$prototypeAccessors$1 = {
    namespaced: {
        configurable: true
    }
};
$52e611b349343813$var$prototypeAccessors$1.namespaced.get = function() {
    return !!this._rawModule.namespaced;
};
$52e611b349343813$var$Module.prototype.addChild = function addChild(key, module) {
    this._children[key] = module;
};
$52e611b349343813$var$Module.prototype.removeChild = function removeChild(key) {
    delete this._children[key];
};
$52e611b349343813$var$Module.prototype.getChild = function getChild(key) {
    return this._children[key];
};
$52e611b349343813$var$Module.prototype.hasChild = function hasChild(key) {
    return key in this._children;
};
$52e611b349343813$var$Module.prototype.update = function update(rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;
    if (rawModule.actions) this._rawModule.actions = rawModule.actions;
    if (rawModule.mutations) this._rawModule.mutations = rawModule.mutations;
    if (rawModule.getters) this._rawModule.getters = rawModule.getters;
};
$52e611b349343813$var$Module.prototype.forEachChild = function forEachChild(fn) {
    $52e611b349343813$var$forEachValue(this._children, fn);
};
$52e611b349343813$var$Module.prototype.forEachGetter = function forEachGetter(fn) {
    if (this._rawModule.getters) $52e611b349343813$var$forEachValue(this._rawModule.getters, fn);
};
$52e611b349343813$var$Module.prototype.forEachAction = function forEachAction(fn) {
    if (this._rawModule.actions) $52e611b349343813$var$forEachValue(this._rawModule.actions, fn);
};
$52e611b349343813$var$Module.prototype.forEachMutation = function forEachMutation(fn) {
    if (this._rawModule.mutations) $52e611b349343813$var$forEachValue(this._rawModule.mutations, fn);
};
Object.defineProperties($52e611b349343813$var$Module.prototype, $52e611b349343813$var$prototypeAccessors$1);
var $52e611b349343813$var$ModuleCollection = function ModuleCollection(rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
};
$52e611b349343813$var$ModuleCollection.prototype.get = function get(path) {
    return path.reduce(function(module, key) {
        return module.getChild(key);
    }, this.root);
};
$52e611b349343813$var$ModuleCollection.prototype.getNamespace = function getNamespace(path) {
    var module = this.root;
    return path.reduce(function(namespace, key) {
        module = module.getChild(key);
        return namespace + (module.namespaced ? key + '/' : '');
    }, '');
};
$52e611b349343813$var$ModuleCollection.prototype.update = function update$1(rawRootModule) {
    $52e611b349343813$var$update([], this.root, rawRootModule);
};
$52e611b349343813$var$ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
    var this$1$1 = this;
    if (runtime === void 0) runtime = true;
    $52e611b349343813$var$assertRawModule(path, rawModule);
    var newModule = new $52e611b349343813$var$Module(rawModule, runtime);
    if (path.length === 0) this.root = newModule;
    else {
        var parent = this.get(path.slice(0, -1));
        parent.addChild(path[path.length - 1], newModule);
    }
    // register nested modules
    if (rawModule.modules) $52e611b349343813$var$forEachValue(rawModule.modules, function(rawChildModule, key) {
        this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
};
$52e611b349343813$var$ModuleCollection.prototype.unregister = function unregister(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);
    if (!child) {
        console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
        return;
    }
    if (!child.runtime) return;
    parent.removeChild(key);
};
$52e611b349343813$var$ModuleCollection.prototype.isRegistered = function isRegistered(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    if (parent) return parent.hasChild(key);
    return false;
};
function $52e611b349343813$var$update(path, targetModule, newModule) {
    $52e611b349343813$var$assertRawModule(path, newModule);
    // update target module
    targetModule.update(newModule);
    // update nested modules
    if (newModule.modules) for(var key in newModule.modules){
        if (!targetModule.getChild(key)) {
            console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
            return;
        }
        $52e611b349343813$var$update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
}
var $52e611b349343813$var$functionAssert = {
    assert: function(value) {
        return typeof value === 'function';
    },
    expected: 'function'
};
var $52e611b349343813$var$objectAssert = {
    assert: function(value) {
        return typeof value === 'function' || typeof value === 'object' && typeof value.handler === 'function';
    },
    expected: 'function or object with "handler" function'
};
var $52e611b349343813$var$assertTypes = {
    getters: $52e611b349343813$var$functionAssert,
    mutations: $52e611b349343813$var$functionAssert,
    actions: $52e611b349343813$var$objectAssert
};
function $52e611b349343813$var$assertRawModule(path, rawModule) {
    Object.keys($52e611b349343813$var$assertTypes).forEach(function(key) {
        if (!rawModule[key]) return;
        var assertOptions = $52e611b349343813$var$assertTypes[key];
        $52e611b349343813$var$forEachValue(rawModule[key], function(value, type) {
            $52e611b349343813$var$assert(assertOptions.assert(value), $52e611b349343813$var$makeAssertionMessage(path, key, type, value, assertOptions.expected));
        });
    });
}
function $52e611b349343813$var$makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
    if (path.length > 0) buf += " in module \"" + path.join('.') + "\"";
    buf += " is " + JSON.stringify(value) + ".";
    return buf;
}
function $52e611b349343813$export$f51a9068ac82ea43(options) {
    return new $52e611b349343813$export$390f32400eaf98c9(options);
}
var $52e611b349343813$export$390f32400eaf98c9 = function Store(options) {
    var this$1$1 = this;
    if (options === void 0) options = {};
    $52e611b349343813$var$assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    $52e611b349343813$var$assert(this instanceof Store, "store must be called with the new operator.");
    var plugins = options.plugins;
    if (plugins === void 0) plugins = [];
    var strict = options.strict;
    if (strict === void 0) strict = false;
    var devtools = options.devtools;
    // store internal state
    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new $52e611b349343813$var$ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._makeLocalGettersCache = Object.create(null);
    this._devtools = devtools;
    // bind commit and dispatch to self
    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    this.dispatch = function boundDispatch(type, payload) {
        return dispatch.call(store, type, payload);
    };
    this.commit = function boundCommit(type, payload, options) {
        return commit.call(store, type, payload, options);
    };
    // strict mode
    this.strict = strict;
    var state = this._modules.root.state;
    // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters
    $52e611b349343813$var$installModule(this, state, [], this._modules.root);
    // initialize the store state, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)
    $52e611b349343813$var$resetStoreState(this, state);
    // apply plugins
    plugins.forEach(function(plugin) {
        return plugin(this$1$1);
    });
};
var $52e611b349343813$var$prototypeAccessors = {
    state: {
        configurable: true
    }
};
$52e611b349343813$export$390f32400eaf98c9.prototype.install = function install(app, injectKey) {
    app.provide(injectKey || $52e611b349343813$export$67bdc3ac2df6c0d1, this);
    app.config.globalProperties.$store = this;
    var useDevtools = this._devtools !== undefined ? this._devtools : true;
    if (useDevtools) $52e611b349343813$var$addDevtools(app, this);
};
$52e611b349343813$var$prototypeAccessors.state.get = function() {
    return this._state.data;
};
$52e611b349343813$var$prototypeAccessors.state.set = function(v) {
    $52e611b349343813$var$assert(false, "use store.replaceState() to explicit replace store state.");
};
$52e611b349343813$export$390f32400eaf98c9.prototype.commit = function commit(_type, _payload, _options) {
    var this$1$1 = this;
    // check object-style commit
    var ref = $52e611b349343813$var$unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;
    var mutation = {
        type: type,
        payload: payload
    };
    var entry = this._mutations[type];
    if (!entry) {
        console.error("[vuex] unknown mutation type: " + type);
        return;
    }
    this._withCommit(function() {
        entry.forEach(function commitIterator(handler) {
            handler(payload);
        });
    });
    this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function(sub) {
        return sub(mutation, this$1$1.state);
    });
    if (options && options.silent) console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
};
$52e611b349343813$export$390f32400eaf98c9.prototype.dispatch = function dispatch(_type, _payload) {
    var this$1$1 = this;
    // check object-style dispatch
    var ref = $52e611b349343813$var$unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;
    var action = {
        type: type,
        payload: payload
    };
    var entry = this._actions[type];
    if (!entry) {
        console.error("[vuex] unknown action type: " + type);
        return;
    }
    try {
        this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
        .filter(function(sub) {
            return sub.before;
        }).forEach(function(sub) {
            return sub.before(action, this$1$1.state);
        });
    } catch (e) {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
    }
    var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
        return handler(payload);
    })) : entry[0](payload);
    return new Promise(function(resolve, reject) {
        result.then(function(res) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.after;
                }).forEach(function(sub) {
                    return sub.after(action, this$1$1.state);
                });
            } catch (e) {
                console.warn("[vuex] error in after action subscribers: ");
                console.error(e);
            }
            resolve(res);
        }, function(error) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.error;
                }).forEach(function(sub) {
                    return sub.error(action, this$1$1.state, error);
                });
            } catch (e) {
                console.warn("[vuex] error in error action subscribers: ");
                console.error(e);
            }
            reject(error);
        });
    });
};
$52e611b349343813$export$390f32400eaf98c9.prototype.subscribe = function subscribe(fn, options) {
    return $52e611b349343813$var$genericSubscribe(fn, this._subscribers, options);
};
$52e611b349343813$export$390f32400eaf98c9.prototype.subscribeAction = function subscribeAction(fn, options) {
    var subs = typeof fn === 'function' ? {
        before: fn
    } : fn;
    return $52e611b349343813$var$genericSubscribe(subs, this._actionSubscribers, options);
};
$52e611b349343813$export$390f32400eaf98c9.prototype.watch = function watch$1(getter, cb, options) {
    var this$1$1 = this;
    $52e611b349343813$var$assert(typeof getter === 'function', "store.watch only accepts a function.");
    return (0, $9xflP.watch)(function() {
        return getter(this$1$1.state, this$1$1.getters);
    }, cb, Object.assign({}, options));
};
$52e611b349343813$export$390f32400eaf98c9.prototype.replaceState = function replaceState(state) {
    var this$1$1 = this;
    this._withCommit(function() {
        this$1$1._state.data = state;
    });
};
$52e611b349343813$export$390f32400eaf98c9.prototype.registerModule = function registerModule(path, rawModule, options) {
    if (options === void 0) options = {};
    if (typeof path === 'string') path = [
        path
    ];
    $52e611b349343813$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    $52e611b349343813$var$assert(path.length > 0, 'cannot register the root module by using registerModule.');
    this._modules.register(path, rawModule);
    $52e611b349343813$var$installModule(this, this.state, path, this._modules.get(path), options.preserveState);
    // reset store to update getters...
    $52e611b349343813$var$resetStoreState(this, this.state);
};
$52e611b349343813$export$390f32400eaf98c9.prototype.unregisterModule = function unregisterModule(path) {
    var this$1$1 = this;
    if (typeof path === 'string') path = [
        path
    ];
    $52e611b349343813$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    this._modules.unregister(path);
    this._withCommit(function() {
        var parentState = $52e611b349343813$var$getNestedState(this$1$1.state, path.slice(0, -1));
        delete parentState[path[path.length - 1]];
    });
    $52e611b349343813$var$resetStore(this);
};
$52e611b349343813$export$390f32400eaf98c9.prototype.hasModule = function hasModule(path) {
    if (typeof path === 'string') path = [
        path
    ];
    $52e611b349343813$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    return this._modules.isRegistered(path);
};
$52e611b349343813$export$390f32400eaf98c9.prototype.hotUpdate = function hotUpdate(newOptions) {
    this._modules.update(newOptions);
    $52e611b349343813$var$resetStore(this, true);
};
$52e611b349343813$export$390f32400eaf98c9.prototype._withCommit = function _withCommit(fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
};
Object.defineProperties($52e611b349343813$export$390f32400eaf98c9.prototype, $52e611b349343813$var$prototypeAccessors);
/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */ var $52e611b349343813$export$a337c713bdba072 = $52e611b349343813$var$normalizeNamespace(function(namespace, states) {
    var res = {};
    if (!$52e611b349343813$var$isValidMap(states)) console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    $52e611b349343813$var$normalizeMap(states).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedState() {
            var state = this.$store.state;
            var getters = this.$store.getters;
            if (namespace) {
                var module = $52e611b349343813$var$getModuleByNamespace(this.$store, 'mapState', namespace);
                if (!module) return;
                state = module.context.state;
                getters = module.context.getters;
            }
            return typeof val === 'function' ? val.call(this, state, getters) : state[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $52e611b349343813$export$6763e3aa6121e797 = $52e611b349343813$var$normalizeNamespace(function(namespace, mutations) {
    var res = {};
    if (!$52e611b349343813$var$isValidMap(mutations)) console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    $52e611b349343813$var$normalizeMap(mutations).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedMutation() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // Get the commit method from store
            var commit = this.$store.commit;
            if (namespace) {
                var module = $52e611b349343813$var$getModuleByNamespace(this.$store, 'mapMutations', namespace);
                if (!module) return;
                commit = module.context.commit;
            }
            return typeof val === 'function' ? val.apply(this, [
                commit
            ].concat(args)) : commit.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */ var $52e611b349343813$export$74d9085e6d5a97cb = $52e611b349343813$var$normalizeNamespace(function(namespace, getters) {
    var res = {};
    if (!$52e611b349343813$var$isValidMap(getters)) console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    $52e611b349343813$var$normalizeMap(getters).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        // The namespace has been mutated by normalizeNamespace
        val = namespace + val;
        res[key] = function mappedGetter() {
            if (namespace && !$52e611b349343813$var$getModuleByNamespace(this.$store, 'mapGetters', namespace)) return;
            if (!(val in this.$store.getters)) {
                console.error("[vuex] unknown getter: " + val);
                return;
            }
            return this.$store.getters[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $52e611b349343813$export$1d73b9b98821f6dc = $52e611b349343813$var$normalizeNamespace(function(namespace, actions) {
    var res = {};
    if (!$52e611b349343813$var$isValidMap(actions)) console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    $52e611b349343813$var$normalizeMap(actions).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedAction() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // get dispatch function from store
            var dispatch = this.$store.dispatch;
            if (namespace) {
                var module = $52e611b349343813$var$getModuleByNamespace(this.$store, 'mapActions', namespace);
                if (!module) return;
                dispatch = module.context.dispatch;
            }
            return typeof val === 'function' ? val.apply(this, [
                dispatch
            ].concat(args)) : dispatch.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */ var $52e611b349343813$export$22ea1818d73549dc = function(namespace) {
    return {
        mapState: $52e611b349343813$export$a337c713bdba072.bind(null, namespace),
        mapGetters: $52e611b349343813$export$74d9085e6d5a97cb.bind(null, namespace),
        mapMutations: $52e611b349343813$export$6763e3aa6121e797.bind(null, namespace),
        mapActions: $52e611b349343813$export$1d73b9b98821f6dc.bind(null, namespace)
    };
};
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */ function $52e611b349343813$var$normalizeMap(map) {
    if (!$52e611b349343813$var$isValidMap(map)) return [];
    return Array.isArray(map) ? map.map(function(key) {
        return {
            key: key,
            val: key
        };
    }) : Object.keys(map).map(function(key) {
        return {
            key: key,
            val: map[key]
        };
    });
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */ function $52e611b349343813$var$isValidMap(map) {
    return Array.isArray(map) || $52e611b349343813$var$isObject(map);
}
/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */ function $52e611b349343813$var$normalizeNamespace(fn) {
    return function(namespace, map) {
        if (typeof namespace !== 'string') {
            map = namespace;
            namespace = '';
        } else if (namespace.charAt(namespace.length - 1) !== '/') namespace += '/';
        return fn(namespace, map);
    };
}
/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */ function $52e611b349343813$var$getModuleByNamespace(store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];
    if (!module) console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    return module;
}
// Credits: borrowed code from fcomb/redux-logger
function $52e611b349343813$export$fe2e61603b61130d(ref) {
    if (ref === void 0) ref = {};
    var collapsed = ref.collapsed;
    if (collapsed === void 0) collapsed = true;
    var filter = ref.filter;
    if (filter === void 0) filter = function(mutation, stateBefore, stateAfter) {
        return true;
    };
    var transformer = ref.transformer;
    if (transformer === void 0) transformer = function(state) {
        return state;
    };
    var mutationTransformer = ref.mutationTransformer;
    if (mutationTransformer === void 0) mutationTransformer = function(mut) {
        return mut;
    };
    var actionFilter = ref.actionFilter;
    if (actionFilter === void 0) actionFilter = function(action, state) {
        return true;
    };
    var actionTransformer = ref.actionTransformer;
    if (actionTransformer === void 0) actionTransformer = function(act) {
        return act;
    };
    var logMutations = ref.logMutations;
    if (logMutations === void 0) logMutations = true;
    var logActions = ref.logActions;
    if (logActions === void 0) logActions = true;
    var logger = ref.logger;
    if (logger === void 0) logger = console;
    return function(store) {
        var prevState = $52e611b349343813$var$deepCopy(store.state);
        if (typeof logger === 'undefined') return;
        if (logMutations) store.subscribe(function(mutation, state) {
            var nextState = $52e611b349343813$var$deepCopy(state);
            if (filter(mutation, prevState, nextState)) {
                var formattedTime = $52e611b349343813$var$getFormattedTime();
                var formattedMutation = mutationTransformer(mutation);
                var message = "mutation " + mutation.type + formattedTime;
                $52e611b349343813$var$startMessage(logger, message, collapsed);
                logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
                logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
                logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
                $52e611b349343813$var$endMessage(logger);
            }
            prevState = nextState;
        });
        if (logActions) store.subscribeAction(function(action, state) {
            if (actionFilter(action, state)) {
                var formattedTime = $52e611b349343813$var$getFormattedTime();
                var formattedAction = actionTransformer(action);
                var message = "action " + action.type + formattedTime;
                $52e611b349343813$var$startMessage(logger, message, collapsed);
                logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
                $52e611b349343813$var$endMessage(logger);
            }
        });
    };
}
function $52e611b349343813$var$startMessage(logger, message, collapsed) {
    var startMessage = collapsed ? logger.groupCollapsed : logger.group;
    // render
    try {
        startMessage.call(logger, message);
    } catch (e) {
        logger.log(message);
    }
}
function $52e611b349343813$var$endMessage(logger) {
    try {
        logger.groupEnd();
    } catch (e) {
        logger.log("\u2014\u2014 log end \u2014\u2014");
    }
}
function $52e611b349343813$var$getFormattedTime() {
    var time = new Date();
    return " @ " + $52e611b349343813$var$pad(time.getHours(), 2) + ":" + $52e611b349343813$var$pad(time.getMinutes(), 2) + ":" + $52e611b349343813$var$pad(time.getSeconds(), 2) + "." + $52e611b349343813$var$pad(time.getMilliseconds(), 3);
}
function $52e611b349343813$var$repeat(str, times) {
    return new Array(times + 1).join(str);
}
function $52e611b349343813$var$pad(num, maxLength) {
    return $52e611b349343813$var$repeat('0', maxLength - num.toString().length) + num;
}
var $52e611b349343813$var$index = {
    version: '4.0.2',
    Store: $52e611b349343813$export$390f32400eaf98c9,
    storeKey: $52e611b349343813$export$67bdc3ac2df6c0d1,
    createStore: $52e611b349343813$export$f51a9068ac82ea43,
    useStore: $52e611b349343813$export$6ccbb43953eebf8,
    mapState: $52e611b349343813$export$a337c713bdba072,
    mapMutations: $52e611b349343813$export$6763e3aa6121e797,
    mapGetters: $52e611b349343813$export$74d9085e6d5a97cb,
    mapActions: $52e611b349343813$export$1d73b9b98821f6dc,
    createNamespacedHelpers: $52e611b349343813$export$22ea1818d73549dc,
    createLogger: $52e611b349343813$export$fe2e61603b61130d
};
var $52e611b349343813$export$2e2bcd8739ae039 = $52e611b349343813$var$index;



var $hkrtv = parcelRequire("hkrtv");
const $e8a194d9c86cc9b2$var$LoadTexts = ({ commit: commit })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/texts/').then((response)=>{
        const texts = (response.data || []).reduce((reduced, textData)=>{
            reduced[textData.key] = textData.content;
            return reduced;
        }, {});
        commit('SET_TEXTS', texts);
    }).catch((error)=>commit('ADD_ERROR_MESSAGE', 'TEXTS_NOT_LOADED'));
};
var $e8a194d9c86cc9b2$export$2e2bcd8739ae039 = $e8a194d9c86cc9b2$var$LoadTexts;



var $hkrtv = parcelRequire("hkrtv");
const $7c0963a8afc29f55$var$state = {
    contentItems: void 0
};
const $7c0963a8afc29f55$var$mutations = {
    SET_CONTENT_ITEMS (state, items) {
        state.contentItems = state.contentItems || [];
        state.contentItems.splice(0, state.contentItems.length);
        state.contentItems.push(...items);
    },
    ADD_CONTENT_ITEMS (state, items) {
        state.contentItems = state.contentItems || [];
        state.contentItems.push(...items);
    },
    ADD_CONTENT_ITEM (state, item) {
        state.contentItems = state.contentItems || [];
        state.contentItems.push(item);
    },
    UPDATE_CONTENT_ITEM (state, item) {
        state.contentItems = state.contentItems || [];
        const foundItem = state.contentItems.find((stateItem)=>stateItem.code === item.code);
        if (foundItem) Object.assign(foundItem, item);
    },
    REMOVE_CONTENT_ITEM (state, id) {
        state.contentItems = (state.contentItems || []).filter((item)=>item._id !== id);
    }
};
const $7c0963a8afc29f55$var$actions = {
    loadContentItems ({ commit: commit, state: state }) {
        if (state.contentItems) return Promise.resolve();
        return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get("/api/content-items").then((result)=>{
            commit("SET_CONTENT_ITEMS", result.data);
        }).catch((ignore)=>commit("ADD_ERROR_MESSAGE", "CONTENT_ITEMS_NOT_LOADED"));
    },
    loadContentItem ({ commit: commit, state: state }, code) {
        if (state.contentItems && state.contentItems.find((item)=>item.code === code)) return Promise.resolve();
        return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get("/api/content-items", {
            params: {
                code: code
            }
        }).then((result)=>{
            commit("ADD_CONTENT_ITEMS", result.data);
        }).catch((ignore)=>commit("ADD_ERROR_MESSAGE", "CONTENT_ITEM_NOT_LOADED"));
    },
    storeContentItem ({ commit: commit }, data) {
        if (data.createdAt) return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).put("/api/content-items", {
            contentItem: data
        }).then((result)=>{
            commit("UPDATE_CONTENT_ITEM", result.data);
        });
        else return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).post("/api/content-items", {
            contentItem: data
        }).then((result)=>{
            commit("ADD_CONTENT_ITEM", result.data);
        });
    },
    removeContentItem ({ commit: commit }, id) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).delete("/api/content-items", {
            params: {
                id: id
            }
        }).then(()=>{
            commit("REMOVE_CONTENT_ITEM", id);
        });
    }
};
var $7c0963a8afc29f55$export$2e2bcd8739ae039 = {
    state: $7c0963a8afc29f55$var$state,
    mutations: $7c0963a8afc29f55$var$mutations,
    actions: $7c0963a8afc29f55$var$actions
};



var $hkrtv = parcelRequire("hkrtv");
const $88194b66e41b957c$var$state = {
    texts: void 0
};
const $88194b66e41b957c$var$mutations = {
    SET_TEXTS (state, texts) {
        state.texts = texts;
    }
};
const $88194b66e41b957c$var$actions = {
    loadTexts ({ commit: commit, state: state }) {
        if (state.texts) return Promise.resolve();
        return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get("/api/texts/").then((response)=>{
            const texts = (response.data || []).reduce((reduced, textData)=>({
                    ...reduced,
                    [textData.key]: textData.content
                }), {});
            commit("SET_TEXTS", texts);
        }).catch((ignore)=>commit("ADD_ERROR_MESSAGE", "TEXTS_NOT_LOADED"));
    }
};
var $88194b66e41b957c$export$2e2bcd8739ae039 = {
    state: $88194b66e41b957c$var$state,
    mutations: $88194b66e41b957c$var$mutations,
    actions: $88194b66e41b957c$var$actions
};



var $hkrtv = parcelRequire("hkrtv");
const $9e73890b8fa06c19$var$connectCyclesWithCourses = (cycles = [], courses = [])=>{
    courses.forEach((course)=>course.cycles = cycles.filter((cycle)=>cycle.courseId === course._id));
};
const $9e73890b8fa06c19$var$store = {
    plugins: [
        (0, $e8a194d9c86cc9b2$export$2e2bcd8739ae039)
    ],
    state: {
        // old content items - "texts"
        courses: void 0,
        cycles: void 0,
        ...(0, $7c0963a8afc29f55$export$2e2bcd8739ae039).state,
        ...(0, $88194b66e41b957c$export$2e2bcd8739ae039).state
    },
    mutations: {
        SET_COURSES (state, courses) {
            state.courses = courses;
            $9e73890b8fa06c19$var$connectCyclesWithCourses(state.cycles, state.courses);
        },
        SET_CYCLES (state, cycles) {
            state.cycles = cycles;
            $9e73890b8fa06c19$var$connectCyclesWithCourses(state.cycles, state.courses);
        },
        ...(0, $7c0963a8afc29f55$export$2e2bcd8739ae039).mutations,
        ...(0, $88194b66e41b957c$export$2e2bcd8739ae039).mutations
    },
    actions: {
        loadCourses ({ commit: commit, state: state }, { with: w } = {}) {
            if (state.courses) return Promise.resolve();
            return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/courses/', {
                params: {
                    ...w && {
                        with: w.join(',')
                    }
                }
            }).then(({ data: data })=>{
                commit('SET_COURSES', data);
            }).catch((ignore)=>commit('ADD_ERROR_MESSAGE', 'COURSES_NOT_LOADED'));
        },
        loadCycles ({ commit: commit, state: state }, { force: force } = {}) {
            if (!force && state.cycles) return Promise.resolve();
            return (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get('/api/cycles/', {}).then(({ data: data })=>{
                commit('SET_CYCLES', data.cycles);
            }).catch((ignore)=>commit('ADD_ERROR_MESSAGE', 'CYCLES_NOT_LOADED'));
        },
        ...(0, $7c0963a8afc29f55$export$2e2bcd8739ae039).actions,
        ...(0, $88194b66e41b957c$export$2e2bcd8739ae039).actions
    }
};
var $9e73890b8fa06c19$export$2e2bcd8739ae039 = $9e73890b8fa06c19$var$store;



var $9xflP = parcelRequire("9xflP");

function $9daae95e2271d3c3$export$2e2bcd8739ae039(Vue) {
    Vue.component('Signup', (0, $9xflP.defineAsyncComponent)(()=>(parcelRequire("3rLfV"))));
}


// This is a magic string replaced by rollup
const $1b0684eb85058674$export$31499a9cd224b78c = "9.29.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $a8a54d01550cceb5$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $420cbd4351e05ac9$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $420cbd4351e05ac9$export$c8bfa33e4e8ae492((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1));
    return 0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $420cbd4351e05ac9$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $1b0684eb85058674$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $1b0684eb85058674$export$31499a9cd224b78c] = __SENTRY__[0, $1b0684eb85058674$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $420cbd4351e05ac9$export$7e223ec222791509(name, creator, obj = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $1b0684eb85058674$export$31499a9cd224b78c] = __SENTRY__[0, $1b0684eb85058674$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4d9a3b90bc4bf260$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $589337cb438129b2$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$e6127cc7fe7395c3(wat) {
    switch($589337cb438129b2$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $589337cb438129b2$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$var$isBuiltin(wat, className) {
    return $589337cb438129b2$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$9f9636d330b71954(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$ef9e2056653f0c8e(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$12e869b2a583f783(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$844ec244b1367d54(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$c3825b437cbdea5c(wat) {
    return wat === null || $589337cb438129b2$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$53b83ca8eaab0383(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $589337cb438129b2$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $589337cb438129b2$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$49841c62b9eff15(wat) {
    return $589337cb438129b2$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $589337cb438129b2$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$bc2894c7158efbac(wat) {
    return $589337cb438129b2$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $589337cb438129b2$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $589337cb438129b2$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $589337cb438129b2$export$49034edbe6b62415(request, Request);
}



const $29d8eea2d8941562$var$WINDOW = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
const $29d8eea2d8941562$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $29d8eea2d8941562$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $29d8eea2d8941562$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $29d8eea2d8941562$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $29d8eea2d8941562$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($29d8eea2d8941562$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $589337cb438129b2$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $29d8eea2d8941562$export$1cfafeee2987818b() {
    try {
        return $29d8eea2d8941562$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $29d8eea2d8941562$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$29d8eea2d8941562$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/** Prefix for logging strings */ const $176facbb7e775926$var$PREFIX = 'Sentry Logger ';
const $176facbb7e775926$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $176facbb7e775926$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $176facbb7e775926$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($176facbb7e775926$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $176facbb7e775926$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $176facbb7e775926$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) $176facbb7e775926$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $176facbb7e775926$export$cda52e2a8927a2ca(()=>{
                (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).console[name](`${$176facbb7e775926$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $176facbb7e775926$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $176facbb7e775926$export$af88d00dbe7f521 = (0, $420cbd4351e05ac9$export$7e223ec222791509)('logger', $176facbb7e775926$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $8a164c7c8b40ded1$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $8a164c7c8b40ded1$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $8a164c7c8b40ded1$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $589337cb438129b2$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $8a164c7c8b40ded1$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $589337cb438129b2$export$844ec244b1367d54)(value)) return false;
    if ((0, $589337cb438129b2$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $589337cb438129b2$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $8a164c7c8b40ded1$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$8a164c7c8b40ded1$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $c81bf7dc777f388b$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $c81bf7dc777f388b$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $c81bf7dc777f388b$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $c81bf7dc777f388b$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $c81bf7dc777f388b$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c81bf7dc777f388b$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $c81bf7dc777f388b$export$62ff257738bf57f5(value) {
    if ((0, $589337cb438129b2$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$c81bf7dc777f388b$var$getOwnProperties(value)
    };
    else if ((0, $589337cb438129b2$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $c81bf7dc777f388b$var$serializeEventTarget(value.target),
            currentTarget: $c81bf7dc777f388b$var$serializeEventTarget(value.currentTarget),
            ...$c81bf7dc777f388b$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $589337cb438129b2$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $c81bf7dc777f388b$var$serializeEventTarget(target) {
    try {
        return (0, $589337cb438129b2$export$45a5e7f76e0caa8d)(target) ? (0, $29d8eea2d8941562$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $c81bf7dc777f388b$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $c81bf7dc777f388b$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($c81bf7dc777f388b$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $8a164c7c8b40ded1$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $8a164c7c8b40ded1$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $c81bf7dc777f388b$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $c81bf7dc777f388b$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $c81bf7dc777f388b$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($c81bf7dc777f388b$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($c81bf7dc777f388b$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $c81bf7dc777f388b$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $c81bf7dc777f388b$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $c81bf7dc777f388b$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $589337cb438129b2$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $9c59e8e75b362707$var$getCrypto() {
    const gbl = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $9c59e8e75b362707$export$19f53698e68b2496(crypto = $9c59e8e75b362707$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $9c59e8e75b362707$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $9c59e8e75b362707$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $9c59e8e75b362707$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $9c59e8e75b362707$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $9c59e8e75b362707$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $9c59e8e75b362707$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $9c59e8e75b362707$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $9c59e8e75b362707$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $9c59e8e75b362707$export$d364f2020ab30578(input) {
    const match = input.match($9c59e8e75b362707$var$SEMVER_REGEXP) || [];
    const major = $9c59e8e75b362707$var$_parseInt(match[1]);
    const minor = $9c59e8e75b362707$var$_parseInt(match[2]);
    const patch = $9c59e8e75b362707$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $9c59e8e75b362707$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $8a164c7c8b40ded1$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $8a164c7c8b40ded1$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $8a164c7c8b40ded1$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $9c59e8e75b362707$export$6de4ffac6a2f1098(exception) {
    if ($9c59e8e75b362707$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $9c59e8e75b362707$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $363ccd4c925357ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $363ccd4c925357ec$export$7740643b9eeaf0c4() {
    return Date.now() / $363ccd4c925357ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $363ccd4c925357ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $363ccd4c925357ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $363ccd4c925357ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $363ccd4c925357ec$export$ee52dced521e3e18 = $363ccd4c925357ec$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $363ccd4c925357ec$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $363ccd4c925357ec$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $363ccd4c925357ec$export$baf075a948ffc0bf() {
    if (!$363ccd4c925357ec$var$cachedTimeOrigin) $363ccd4c925357ec$var$cachedTimeOrigin = $363ccd4c925357ec$var$getBrowserTimeOrigin();
    return $363ccd4c925357ec$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $7664cda0b615cfc9$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $9c59e8e75b362707$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$7664cda0b615cfc9$var$sessionToJSON(session)
    };
    if (context) $7664cda0b615cfc9$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $7664cda0b615cfc9$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $9c59e8e75b362707$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $7664cda0b615cfc9$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $7664cda0b615cfc9$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $7664cda0b615cfc9$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}


/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $4adeb2517eb84001$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $4adeb2517eb84001$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $dd608bdde5b3e930$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dd608bdde5b3e930$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(scope, $dd608bdde5b3e930$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$dd608bdde5b3e930$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dd608bdde5b3e930$export$91f063ebb8eff307(scope) {
    return scope[$dd608bdde5b3e930$var$SCOPE_SPAN_FIELD];
}






/**
 * Generate a random, valid trace ID.
 */ function $0d4e27b27a85ee3f$export$dc6d7ea554bcce10() {
    return (0, $9c59e8e75b362707$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $0d4e27b27a85ee3f$export$295213bc4d0c54ad() {
    return (0, $9c59e8e75b362707$export$19f53698e68b2496)().substring(16);
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $7cbe92f81cf2caa5$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $7cbe92f81cf2caa5$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $7cbe92f81cf2caa5$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $dd608bdde5b3e930$export$3f25fa50c18e20ca)(newScope, (0, $dd608bdde5b3e930$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $7664cda0b615cfc9$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $7cbe92f81cf2caa5$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $589337cb438129b2$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $dd608bdde5b3e930$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $7cbe92f81cf2caa5$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $363ccd4c925357ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $8a164c7c8b40ded1$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dd608bdde5b3e930$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $4adeb2517eb84001$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $9c59e8e75b362707$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $176facbb7e775926$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $9c59e8e75b362707$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $176facbb7e775926$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $9c59e8e75b362707$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $176facbb7e775926$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $0f9bcf87c19e2620$export$6f1b9191db9c4d5() {
    return (0, $420cbd4351e05ac9$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $0f9bcf87c19e2620$export$de9862929b76bf57() {
    return (0, $420cbd4351e05ac9$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $8b764d5875e16830$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $8b764d5875e16830$var$getAsyncContextStack() {
    const registry = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const sentry = (0, $420cbd4351e05ac9$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $8b764d5875e16830$export$d36ec451f120cfba((0, $0f9bcf87c19e2620$export$6f1b9191db9c4d5)(), (0, $0f9bcf87c19e2620$export$de9862929b76bf57)());
}
function $8b764d5875e16830$var$withScope(callback) {
    return $8b764d5875e16830$var$getAsyncContextStack().withScope(callback);
}
function $8b764d5875e16830$var$withSetScope(scope, callback) {
    const stack = $8b764d5875e16830$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $8b764d5875e16830$var$withIsolationScope(callback) {
    return $8b764d5875e16830$var$getAsyncContextStack().withScope(()=>{
        return callback($8b764d5875e16830$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $8b764d5875e16830$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $8b764d5875e16830$var$withIsolationScope,
        withScope: $8b764d5875e16830$var$withScope,
        withSetScope: $8b764d5875e16830$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $8b764d5875e16830$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$8b764d5875e16830$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$8b764d5875e16830$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $cfdb81ddf007a497$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const sentry = (0, $420cbd4351e05ac9$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $cfdb81ddf007a497$export$f639b0c2752203be(carrier) {
    const sentry = (0, $420cbd4351e05ac9$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $8b764d5875e16830$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $9f847727088f1638$export$c7be4b0125a10cba() {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $9f847727088f1638$export$68f3af03034c9e90() {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9f847727088f1638$export$aa55d5ab8e05984f() {
    return (0, $420cbd4351e05ac9$export$7e223ec222791509)('globalScope', ()=>new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $9f847727088f1638$export$ec58d9285c204497(...rest) {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $9f847727088f1638$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $9f847727088f1638$export$6bb76d6eba7e258c() {
    return $9f847727088f1638$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $9f847727088f1638$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $0d4e27b27a85ee3f$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $cb7813bc2c23bfa5$export$849dbeeeda01ae98 = 'production';







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $af7003ba16c6a6cf$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($af7003ba16c6a6cf$var$States || ($af7003ba16c6a6cf$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $af7003ba16c6a6cf$export$1fda8aa4d135f8aa(value) {
    return new $af7003ba16c6a6cf$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $af7003ba16c6a6cf$export$78e43115b553f358(reason) {
    return new $af7003ba16c6a6cf$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $af7003ba16c6a6cf$export$6f292d4960313241 {
    constructor(executor){
        this._state = $af7003ba16c6a6cf$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $af7003ba16c6a6cf$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $af7003ba16c6a6cf$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $af7003ba16c6a6cf$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $af7003ba16c6a6cf$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $af7003ba16c6a6cf$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $af7003ba16c6a6cf$var$States.PENDING) return;
            if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($af7003ba16c6a6cf$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($af7003ba16c6a6cf$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $152d95f08bbd6f09$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $af7003ba16c6a6cf$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && processor.id && result === null && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(result)) result.then((final)=>$152d95f08bbd6f09$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $152d95f08bbd6f09$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $006aa228d845c600$var$parsedStackResults;
let $006aa228d845c600$var$lastKeysCount;
let $006aa228d845c600$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $006aa228d845c600$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($006aa228d845c600$var$cachedFilenameDebugIds && debugIdKeys.length === $006aa228d845c600$var$lastKeysCount) return $006aa228d845c600$var$cachedFilenameDebugIds;
    $006aa228d845c600$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $006aa228d845c600$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$006aa228d845c600$var$parsedStackResults) $006aa228d845c600$var$parsedStackResults = {};
        const result = $006aa228d845c600$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $006aa228d845c600$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $006aa228d845c600$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $006aa228d845c600$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $006aa228d845c600$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}





const $0468f98f82a2901b$var$STACKTRACE_FRAME_LIMIT = 50;
const $0468f98f82a2901b$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $0468f98f82a2901b$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0468f98f82a2901b$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0468f98f82a2901b$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0468f98f82a2901b$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0468f98f82a2901b$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0468f98f82a2901b$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $0468f98f82a2901b$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0468f98f82a2901b$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0468f98f82a2901b$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0468f98f82a2901b$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($0468f98f82a2901b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0468f98f82a2901b$var$STRIP_FRAME_REGEXP.test($0468f98f82a2901b$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0468f98f82a2901b$var$STRIP_FRAME_REGEXP.test($0468f98f82a2901b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $0468f98f82a2901b$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $0468f98f82a2901b$var$getLastStackFrame(localStack).filename,
            function: frame.function || $0468f98f82a2901b$export$27c7e15d453fc0ac
        }));
}
function $0468f98f82a2901b$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $0468f98f82a2901b$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $0468f98f82a2901b$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $0468f98f82a2901b$var$defaultFunctionName;
        return fn.name || $0468f98f82a2901b$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0468f98f82a2901b$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $0468f98f82a2901b$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28dd2fd7a5a23398$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $28dd2fd7a5a23398$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $28dd2fd7a5a23398$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $28dd2fd7a5a23398$export$a3295358bff77e(object, depth);
    if ($28dd2fd7a5a23398$var$jsonSize(normalized) > maxSize) return $28dd2fd7a5a23398$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $28dd2fd7a5a23398$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $28dd2fd7a5a23398$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $28dd2fd7a5a23398$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $28dd2fd7a5a23398$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $c81bf7dc777f388b$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $28dd2fd7a5a23398$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $28dd2fd7a5a23398$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $589337cb438129b2$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $589337cb438129b2$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $0468f98f82a2901b$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $28dd2fd7a5a23398$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $28dd2fd7a5a23398$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $28dd2fd7a5a23398$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28dd2fd7a5a23398$var$jsonSize(value) {
    return $28dd2fd7a5a23398$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $28dd2fd7a5a23398$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $28dd2fd7a5a23398$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $2318cd9d6e86bae3$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $2318cd9d6e86bae3$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $2318cd9d6e86bae3$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $2318cd9d6e86bae3$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $2318cd9d6e86bae3$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $2318cd9d6e86bae3$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $2318cd9d6e86bae3$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $2318cd9d6e86bae3$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $2318cd9d6e86bae3$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $2318cd9d6e86bae3$export$1efec95406bbe327 = 'sentry.profile_id';
const $2318cd9d6e86bae3$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $2318cd9d6e86bae3$export$b016f89ac1066ec = 'cache.hit';
const $2318cd9d6e86bae3$export$3110e4c3f4386399 = 'cache.key';
const $2318cd9d6e86bae3$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $2318cd9d6e86bae3$export$be7a251980e7e946 = 'http.request.method';
const $2318cd9d6e86bae3$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $2318cd9d6e86bae3$export$ff77b5fd5b2d627b = 'sentry.link.type';



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $89ce7ff72468c0b4$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $9f847727088f1638$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $89ce7ff72468c0b4$export$5008da00b1b6dee6 = $89ce7ff72468c0b4$export$1f70765132c3c225;






const $40e6519088eb8e17$export$136e25984ba4a383 = 0;
const $40e6519088eb8e17$export$58f7963109c806fc = 1;
const $40e6519088eb8e17$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $40e6519088eb8e17$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $40e6519088eb8e17$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $40e6519088eb8e17$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $40e6519088eb8e17$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $40e6519088eb8e17$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $40e6519088eb8e17$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $fde9b79c0b4f89b4$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $fde9b79c0b4f89b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $fde9b79c0b4f89b4$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(span, $fde9b79c0b4f89b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(span, $fde9b79c0b4f89b4$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $fde9b79c0b4f89b4$export$c08fbc656a245d03(span) {
    return {
        scope: span[$fde9b79c0b4f89b4$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$fde9b79c0b4f89b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $cda8c85e3d706d74$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}





const $3f23568cd7f2d021$export$6e69537d67fa20f = 'sentry-';
const $3f23568cd7f2d021$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $3f23568cd7f2d021$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $3f23568cd7f2d021$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $3f23568cd7f2d021$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($3f23568cd7f2d021$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($3f23568cd7f2d021$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $3f23568cd7f2d021$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$3f23568cd7f2d021$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $3f23568cd7f2d021$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $3f23568cd7f2d021$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $589337cb438129b2$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $3f23568cd7f2d021$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $3f23568cd7f2d021$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $3f23568cd7f2d021$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $3f23568cd7f2d021$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $3f23568cd7f2d021$export$bdd844ddb2def819) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $7c3ac25d62fd1957$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $7c3ac25d62fd1957$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($7c3ac25d62fd1957$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $7c3ac25d62fd1957$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $7c3ac25d62fd1957$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $3f23568cd7f2d021$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $7c3ac25d62fd1957$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $7c3ac25d62fd1957$export$f35d907436da45cf(traceId = (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)(), spanId = (0, $0d4e27b27a85ee3f$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $7c3ac25d62fd1957$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $cda8c85e3d706d74$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $cda8c85e3d706d74$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $9c37aa7fc05fb850$export$208d5b368507fb8b = 0x0;
const $9c37aa7fc05fb850$export$eb571cd9b5d98de8 = 0x1;
let $9c37aa7fc05fb850$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $9c37aa7fc05fb850$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $9c37aa7fc05fb850$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $9c37aa7fc05fb850$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $9c37aa7fc05fb850$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $fde9b79c0b4f89b4$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $0d4e27b27a85ee3f$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $9c37aa7fc05fb850$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $9c37aa7fc05fb850$export$5caecac1caaf3a71(span);
    return (0, $7c3ac25d62fd1957$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $9c37aa7fc05fb850$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $9c37aa7fc05fb850$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $9c37aa7fc05fb850$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $9c37aa7fc05fb850$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $9c37aa7fc05fb850$var$ensureTimestampInSeconds(input.getTime());
    return (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $9c37aa7fc05fb850$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $9c37aa7fc05fb850$export$92d8c23565496537(span) {
    if ($9c37aa7fc05fb850$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($9c37aa7fc05fb850$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $9c37aa7fc05fb850$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $9c37aa7fc05fb850$export$3f7581298f56c6d7(endTime) || undefined,
            status: $9c37aa7fc05fb850$export$e238a77ea3a8cd66(status),
            op: attributes[0, $2318cd9d6e86bae3$export$1a413bd9a88fdb09],
            origin: attributes[0, $2318cd9d6e86bae3$export$cca8dd30f57f805e],
            links: $9c37aa7fc05fb850$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $9c37aa7fc05fb850$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $9c37aa7fc05fb850$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $9c37aa7fc05fb850$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $9c37aa7fc05fb850$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $9c37aa7fc05fb850$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $40e6519088eb8e17$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $40e6519088eb8e17$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $9c37aa7fc05fb850$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $9c37aa7fc05fb850$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $9c37aa7fc05fb850$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$9c37aa7fc05fb850$var$ROOT_SPAN_FIELD] || span;
    (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(childSpan, $9c37aa7fc05fb850$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD]) span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(span, $9c37aa7fc05fb850$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $9c37aa7fc05fb850$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD]) span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $9c37aa7fc05fb850$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($9c37aa7fc05fb850$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD] ? Array.from(span[$9c37aa7fc05fb850$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $9c37aa7fc05fb850$export$c4c6a79b1260ca1b(span) {
    return span[$9c37aa7fc05fb850$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $9c37aa7fc05fb850$export$1be426a8e585c83e() {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dd608bdde5b3e930$export$91f063ebb8eff307)((0, $9f847727088f1638$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $9c37aa7fc05fb850$export$d11691ff45a3e535() {
    if (!$9c37aa7fc05fb850$var$hasShownSpanDropWarning) {
        (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $9c37aa7fc05fb850$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $9c37aa7fc05fb850$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $2318cd9d6e86bae3$export$d7a7d984b0791405)]: 'custom',
        [(0, $2318cd9d6e86bae3$export$165ce9a229f6f050)]: name
    });
}





/** Regular expression used to extract org ID from a DSN host. */ const $e2d32e60cd07c64c$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $e2d32e60cd07c64c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $e2d32e60cd07c64c$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $e2d32e60cd07c64c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $e2d32e60cd07c64c$export$b892860177f70a30(str) {
    const match = $e2d32e60cd07c64c$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $e2d32e60cd07c64c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $e2d32e60cd07c64c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $e2d32e60cd07c64c$var$validateDsn(dsn) {
    if (!(0, $4d9a3b90bc4bf260$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$e2d32e60cd07c64c$var$isValidProtocol(protocol)) {
        (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $e2d32e60cd07c64c$export$5914f4e7748c29c9(host) {
    const match = host.match($e2d32e60cd07c64c$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $e2d32e60cd07c64c$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $e2d32e60cd07c64c$export$b892860177f70a30(from) : $e2d32e60cd07c64c$var$dsnFromComponents(from);
    if (!components || !$e2d32e60cd07c64c$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $0f6b86da9822f971$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $0f6b86da9822f971$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(spanWithMaybeDsc, $0f6b86da9822f971$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0f6b86da9822f971$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $e2d32e60cd07c64c$export$5914f4e7748c29c9)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $cb7813bc2c23bfa5$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $0f6b86da9822f971$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $0f6b86da9822f971$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0f6b86da9822f971$export$a117f995597e25df(span) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $2318cd9d6e86bae3$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $2318cd9d6e86bae3$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$0f6b86da9822f971$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $3f23568cd7f2d021$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $0f6b86da9822f971$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $2318cd9d6e86bae3$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $89ce7ff72468c0b4$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $9c37aa7fc05fb850$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $fde9b79c0b4f89b4$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $0f6b86da9822f971$export$95cf936fdacaff7b(span) {
    const dsc = $0f6b86da9822f971$export$a117f995597e25df(span);
    return (0, $3f23568cd7f2d021$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $95e0bbecc085a6e9$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $95e0bbecc085a6e9$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $95e0bbecc085a6e9$var$applySpanToEvent(event, span);
    $95e0bbecc085a6e9$var$applyFingerprintToEvent(event, fingerprint);
    $95e0bbecc085a6e9$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $95e0bbecc085a6e9$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $95e0bbecc085a6e9$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $95e0bbecc085a6e9$export$b1a120a2871faa46(data, 'extra', extra);
    $95e0bbecc085a6e9$export$b1a120a2871faa46(data, 'tags', tags);
    $95e0bbecc085a6e9$export$b1a120a2871faa46(data, 'user', user);
    $95e0bbecc085a6e9$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $4adeb2517eb84001$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $95e0bbecc085a6e9$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $4adeb2517eb84001$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $95e0bbecc085a6e9$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $95e0bbecc085a6e9$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $95e0bbecc085a6e9$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $95e0bbecc085a6e9$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $9c37aa7fc05fb850$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $0f6b86da9822f971$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $95e0bbecc085a6e9$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $d0e6a99ba053fa7a$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $9c59e8e75b362707$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $363ccd4c925357ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $d0e6a99ba053fa7a$export$d7e04067a6fbc882(prepared, options);
    $d0e6a99ba053fa7a$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $d0e6a99ba053fa7a$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $d0e6a99ba053fa7a$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $9f847727088f1638$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $95e0bbecc085a6e9$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $95e0bbecc085a6e9$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $95e0bbecc085a6e9$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $152d95f08bbd6f09$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $d0e6a99ba053fa7a$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $d0e6a99ba053fa7a$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $d0e6a99ba053fa7a$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $cb7813bc2c23bfa5$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $8a164c7c8b40ded1$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $d0e6a99ba053fa7a$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $006aa228d845c600$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $d0e6a99ba053fa7a$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $d0e6a99ba053fa7a$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $d0e6a99ba053fa7a$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $28dd2fd7a5a23398$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $28dd2fd7a5a23398$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $28dd2fd7a5a23398$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $28dd2fd7a5a23398$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $28dd2fd7a5a23398$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $28dd2fd7a5a23398$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $28dd2fd7a5a23398$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $d0e6a99ba053fa7a$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $d0e6a99ba053fa7a$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($d0e6a99ba053fa7a$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($d0e6a99ba053fa7a$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $d0e6a99ba053fa7a$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $7cbe92f81cf2caa5$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $d0e6a99ba053fa7a$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $d0e6a99ba053fa7a$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$d0e6a99ba053fa7a$var$captureContextKeys.includes(key));
}







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $c37e2caa280569a6$export$f5282963edea4a68(exception, hint) {
    return (0, $9f847727088f1638$export$c7be4b0125a10cba)().captureException(exception, (0, $d0e6a99ba053fa7a$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $c37e2caa280569a6$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $9f847727088f1638$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $c37e2caa280569a6$export$1462b974fdcf6ba2(event, hint) {
    return (0, $9f847727088f1638$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $c37e2caa280569a6$export$2f04de43fe27971a(name, context) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $c37e2caa280569a6$export$bb4922da0dd51b92(extras) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $c37e2caa280569a6$export$8e8e7789d42ed61d(key, extra) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $c37e2caa280569a6$export$74a8fb34822092e6(tags) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $c37e2caa280569a6$export$a37d07ee78eb4569(key, value) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $c37e2caa280569a6$export$8b6bb3dd62a01be2(user) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $c37e2caa280569a6$export$5d4e9fd7fac8e617() {
    return (0, $9f847727088f1638$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c37e2caa280569a6$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (!client) (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $9c59e8e75b362707$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c37e2caa280569a6$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $c37e2caa280569a6$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $c37e2caa280569a6$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $9f847727088f1638$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c37e2caa280569a6$export$4909b86c8034bf73(timeout) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c37e2caa280569a6$export$8360e631d277ea4d(timeout) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $c37e2caa280569a6$export$3f95c6f800b78024() {
    return !!(0, $9f847727088f1638$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $c37e2caa280569a6$export$3b029eb57ac4d562() {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $c37e2caa280569a6$export$9aac0b9f77928fbf(callback) {
    (0, $9f847727088f1638$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $c37e2caa280569a6$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)();
    const currentScope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $7664cda0b615cfc9$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $7664cda0b615cfc9$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $c37e2caa280569a6$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $c37e2caa280569a6$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)();
    const currentScope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $7664cda0b615cfc9$export$56521d9ba90f62ee)(session);
    $c37e2caa280569a6$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $c37e2caa280569a6$var$_sendSessionUpdate() {
    const isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)();
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $c37e2caa280569a6$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $c37e2caa280569a6$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $c37e2caa280569a6$var$_sendSessionUpdate();
}





const $d15a2ccb48c4b914$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $d15a2ccb48c4b914$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $d15a2ccb48c4b914$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $d15a2ccb48c4b914$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $d15a2ccb48c4b914$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $d15a2ccb48c4b914$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $d15a2ccb48c4b914$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $d15a2ccb48c4b914$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($d15a2ccb48c4b914$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $d15a2ccb48c4b914$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $d15a2ccb48c4b914$export$2d8f5188773bcddd(integration) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $d15a2ccb48c4b914$export$2323046b9414659f(fn) {
    return fn;
}




const $802790f037fd704b$var$INTEGRATION_NAME = 'Dedupe';
const $802790f037fd704b$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $802790f037fd704b$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($802790f037fd704b$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $802790f037fd704b$export$6d39aa44cd0c7567 = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($802790f037fd704b$var$_dedupeIntegration);
/** only exported for tests. */ function $802790f037fd704b$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($802790f037fd704b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($802790f037fd704b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $802790f037fd704b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$802790f037fd704b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$802790f037fd704b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $802790f037fd704b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $802790f037fd704b$var$_getExceptionFromEvent(previousEvent);
    const currentException = $802790f037fd704b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$802790f037fd704b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$802790f037fd704b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $802790f037fd704b$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $0468f98f82a2901b$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $0468f98f82a2901b$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $802790f037fd704b$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $802790f037fd704b$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $cdd93176211eae30$var$originalFunctionToString;
const $cdd93176211eae30$var$INTEGRATION_NAME = 'FunctionToString';
const $cdd93176211eae30$var$SETUP_CLIENTS = new WeakMap();
const $cdd93176211eae30$var$_functionToStringIntegration = ()=>{
    return {
        name: $cdd93176211eae30$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $cdd93176211eae30$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $c81bf7dc777f388b$export$e6cc1e135e2092e5)(this);
                    const context = $cdd93176211eae30$var$SETUP_CLIENTS.has((0, $9f847727088f1638$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $cdd93176211eae30$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $cdd93176211eae30$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $cdd93176211eae30$export$7918117e9202e4fb = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($cdd93176211eae30$var$_functionToStringIntegration);



/**
 * Get a list of possible event messages from a Sentry event.
 */ function $987a17157b67cb7c$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}





// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fac6d470bddaeab8$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $fac6d470bddaeab8$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $fac6d470bddaeab8$export$9a84f518c163c552 = (0, $d15a2ccb48c4b914$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $fac6d470bddaeab8$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $fac6d470bddaeab8$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $fac6d470bddaeab8$var$_mergeOptions(options, clientOptions);
            }
            return $fac6d470bddaeab8$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $fac6d470bddaeab8$export$cb3c5c2ceb9818ba = (0, $d15a2ccb48c4b914$export$2323046b9414659f)((options = {})=>{
    return {
        ...$fac6d470bddaeab8$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $fac6d470bddaeab8$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fac6d470bddaeab8$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $fac6d470bddaeab8$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($fac6d470bddaeab8$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($fac6d470bddaeab8$var$_isUselessError(event)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($fac6d470bddaeab8$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}.\nUrl: ${$fac6d470bddaeab8$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$fac6d470bddaeab8$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}.\nUrl: ${$fac6d470bddaeab8$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($fac6d470bddaeab8$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $fac6d470bddaeab8$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $987a17157b67cb7c$export$d55a97c329cacfcc)(event).some((message)=>(0, $8a164c7c8b40ded1$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $fac6d470bddaeab8$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $8a164c7c8b40ded1$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $fac6d470bddaeab8$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $fac6d470bddaeab8$var$_getEventFilterUrl(event);
    return !url ? false : (0, $8a164c7c8b40ded1$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $fac6d470bddaeab8$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $fac6d470bddaeab8$var$_getEventFilterUrl(event);
    return !url ? true : (0, $8a164c7c8b40ded1$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $fac6d470bddaeab8$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $fac6d470bddaeab8$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $fac6d470bddaeab8$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $9c59e8e75b362707$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $fac6d470bddaeab8$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $8d5a228c83d9aa33$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) (0, $176facbb7e775926$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $8d5a228c83d9aa33$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $8d5a228c83d9aa33$export$ecb76f41d43c0e43(client) {
    (0, $9f847727088f1638$export$c7be4b0125a10cba)().setClient(client);
}



const $bf7015ded34a695e$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $bf7015ded34a695e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $bf7015ded34a695e$var$_getIngestEndpoint(dsn) {
    return `${$bf7015ded34a695e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $bf7015ded34a695e$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $bf7015ded34a695e$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $bf7015ded34a695e$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$bf7015ded34a695e$var$_getIngestEndpoint(dsn)}?${$bf7015ded34a695e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $bf7015ded34a695e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $e2d32e60cd07c64c$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$bf7015ded34a695e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $e2d32e60cd07c64c$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}












/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $844234cfaaa4e7f6$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $844234cfaaa4e7f6$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $844234cfaaa4e7f6$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $844234cfaaa4e7f6$export$604a45d95a155e2b(envelope, types) {
    return $844234cfaaa4e7f6$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $844234cfaaa4e7f6$var$encodeUTF8(input) {
    const carrier = (0, $420cbd4351e05ac9$export$c8bfa33e4e8ae492)((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $844234cfaaa4e7f6$var$decodeUTF8(input) {
    const carrier = (0, $420cbd4351e05ac9$export$c8bfa33e4e8ae492)((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $844234cfaaa4e7f6$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $844234cfaaa4e7f6$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $844234cfaaa4e7f6$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $28dd2fd7a5a23398$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $844234cfaaa4e7f6$var$concatBuffers(parts);
}
function $844234cfaaa4e7f6$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $844234cfaaa4e7f6$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $844234cfaaa4e7f6$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($844234cfaaa4e7f6$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $844234cfaaa4e7f6$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $844234cfaaa4e7f6$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $844234cfaaa4e7f6$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $844234cfaaa4e7f6$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $844234cfaaa4e7f6$export$b11169581eeaf237(type) {
    return $844234cfaaa4e7f6$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $844234cfaaa4e7f6$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $844234cfaaa4e7f6$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $e2d32e60cd07c64c$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $94c998eb136aa5f8$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $94c998eb136aa5f8$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $844234cfaaa4e7f6$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $e2d32e60cd07c64c$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $94c998eb136aa5f8$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $844234cfaaa4e7f6$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $94c998eb136aa5f8$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $844234cfaaa4e7f6$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $94c998eb136aa5f8$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $0f6b86da9822f971$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $e2d32e60cd07c64c$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $9c37aa7fc05fb850$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $9c37aa7fc05fb850$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $844234cfaaa4e7f6$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(headers, items);
}











/**
 * Converts a transaction event to a span JSON object.
 */ function $ac96cbb80903e123$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $2318cd9d6e86bae3$export$1efec95406bbe327],
        exclusive_time: data?.[0, $2318cd9d6e86bae3$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $ac96cbb80903e123$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $2318cd9d6e86bae3$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $2318cd9d6e86bae3$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $2336f8696ade9715$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $363ccd4c925357ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}








/* eslint-disable max-lines */ const $6cf218271a2b9727$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $6cf218271a2b9727$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $6cf218271a2b9727$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $6cf218271a2b9727$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $6cf218271a2b9727$var$_makeInternalError(message) {
    return {
        message: message,
        [$6cf218271a2b9727$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $6cf218271a2b9727$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$6cf218271a2b9727$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $6cf218271a2b9727$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $6cf218271a2b9727$var$INTERNAL_ERROR_SYMBOL in error;
}
function $6cf218271a2b9727$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $6cf218271a2b9727$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $6cf218271a2b9727$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $e2d32e60cd07c64c$export$128827c3562ec0cb)(options.dsn);
        else (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $bf7015ded34a695e$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $9c59e8e75b362707$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $9c59e8e75b362707$export$6de4ffac6a2f1098)(exception)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log($6cf218271a2b9727$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $9c59e8e75b362707$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $589337cb438129b2$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $589337cb438129b2$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $9c59e8e75b362707$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $9c59e8e75b362707$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log($6cf218271a2b9727$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $7664cda0b615cfc9$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $d15a2ccb48c4b914$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $d15a2ccb48c4b914$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $94c998eb136aa5f8$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $844234cfaaa4e7f6$export$d650323442802f6f)(env, (0, $844234cfaaa4e7f6$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $cb7813bc2c23bfa5$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn($6cf218271a2b9727$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn($6cf218271a2b9727$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $94c998eb136aa5f8$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $d15a2ccb48c4b914$export$51abed9797baa598)(this, integrations);
        (0, $d15a2ccb48c4b914$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $7664cda0b615cfc9$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $af7003ba16c6a6cf$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $d0e6a99ba053fa7a$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $9f847727088f1638$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $0f6b86da9822f971$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $9f847727088f1638$export$c7be4b0125a10cba)(), isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)()) {
        if ((0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && $6cf218271a2b9727$var$isErrorEvent(event)) (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Captured error event \`${(0, $987a17157b67cb7c$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) {
                if ($6cf218271a2b9727$var$_isDoNotSendEventError(reason)) (0, $176facbb7e775926$export$af88d00dbe7f521).log(reason.message);
                else if ($6cf218271a2b9727$var$_isInternalError(reason)) (0, $176facbb7e775926$export$af88d00dbe7f521).warn(reason.message);
                else (0, $176facbb7e775926$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $6cf218271a2b9727$var$isTransactionEvent(event);
        const isError = $6cf218271a2b9727$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $cda8c85e3d706d74$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $af7003ba16c6a6cf$export$78e43115b553f358)($6cf218271a2b9727$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $6cf218271a2b9727$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $6cf218271a2b9727$var$processBeforeSend(this, options, prepared, hint);
            return $6cf218271a2b9727$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $6cf218271a2b9727$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($6cf218271a2b9727$var$_isDoNotSendEventError(reason) || $6cf218271a2b9727$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $6cf218271a2b9727$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $2336f8696ade9715$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $e2d32e60cd07c64c$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $6cf218271a2b9727$export$4f22f74eddb7716a = $6cf218271a2b9727$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $6cf218271a2b9727$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $589337cb438129b2$export$53b83ca8eaab0383)(event) && event !== null) throw $6cf218271a2b9727$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $6cf218271a2b9727$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $589337cb438129b2$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $6cf218271a2b9727$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $6cf218271a2b9727$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($6cf218271a2b9727$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($6cf218271a2b9727$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $ac96cbb80903e123$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $9c37aa7fc05fb850$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $4adeb2517eb84001$export$4950aa0f605343fb)(event, (0, $ac96cbb80903e123$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $9c37aa7fc05fb850$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $6cf218271a2b9727$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $6cf218271a2b9727$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $6cf218271a2b9727$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $9f847727088f1638$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $9c37aa7fc05fb850$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $9c37aa7fc05fb850$export$46c6fbd1d265ebf0)(span) : (0, $9f847727088f1638$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $0f6b86da9822f971$export$a117f995597e25df)(span) : (0, $0f6b86da9822f971$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}










/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $6f9f435b6b65d44f$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $04a1871b8d8bbf38$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $04a1871b8d8bbf38$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $e2d32e60cd07c64c$export$44d472fbb931a776)(dsn);
    return (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(headers, [
        $04a1871b8d8bbf38$export$efdf3b13edb1118e(logs)
    ]);
}


const $174234c32d07109b$var$MAX_LOG_BUFFER_SIZE = 100;
// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
(0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $174234c32d07109b$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $174234c32d07109b$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $174234c32d07109b$export$743ba6f7ec19225f(client, serializedLog) {
    const logBuffer = $174234c32d07109b$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, [
        serializedLog
    ]);
    else {
        (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $174234c32d07109b$var$MAX_LOG_BUFFER_SIZE) $174234c32d07109b$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $174234c32d07109b$export$3ab3d16b9eebd986(beforeLog, client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)(), currentScope = (0, $9f847727088f1638$export$c7be4b0125a10cba)(), captureSerializedLog = $174234c32d07109b$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $6cf218271a2b9727$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: user } = $174234c32d07109b$var$getMergedScopeData(currentScope);
    // Only attach user to log attributes if sendDefaultPii is enabled
    if (client.getOptions().sendDefaultPii) {
        const { id: id, email: email, username: username } = user;
        $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
        $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
        $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    }
    $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $589337cb438129b2$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $dd608bdde5b3e930$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $174234c32d07109b$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $6f9f435b6b65d44f$export$4fb50c0840d636d1)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $174234c32d07109b$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $174234c32d07109b$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $174234c32d07109b$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $04a1871b8d8bbf38$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $174234c32d07109b$export$5365c9902fb9e770(client) {
    return (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $174234c32d07109b$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $9f847727088f1638$export$aa55d5ab8e05984f)().getScopeData();
    (0, $95e0bbecc085a6e9$export$25ac7e259a513db4)(scopeData, (0, $9f847727088f1638$export$68f3af03034c9e90)().getScopeData());
    (0, $95e0bbecc085a6e9$export$25ac7e259a513db4)(scopeData, currentScope.getScopeData());
    return scopeData;
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $4bc438c68de95f0b$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $4bc438c68de95f0b$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $5af3b6741fff5864$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $1b0684eb85058674$export$31499a9cd224b78c)
            })),
        version: (0, $1b0684eb85058674$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $d105212be8ef3e08$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $d105212be8ef3e08$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $dc9ba0e80928e41f$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $dc9ba0e80928e41f$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $dc9ba0e80928e41f$export$2e9ae379995d99e3(ex),
        value: $dc9ba0e80928e41f$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $dc9ba0e80928e41f$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $dc9ba0e80928e41f$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $28dd2fd7a5a23398$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $dc9ba0e80928e41f$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $589337cb438129b2$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $dc9ba0e80928e41f$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $dc9ba0e80928e41f$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $dc9ba0e80928e41f$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $dc9ba0e80928e41f$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $dc9ba0e80928e41f$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $dc9ba0e80928e41f$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $dc9ba0e80928e41f$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $dc9ba0e80928e41f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $dc9ba0e80928e41f$var$getSkipFirstStackStringLines(ex) {
    if (ex && $dc9ba0e80928e41f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $dc9ba0e80928e41f$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $dc9ba0e80928e41f$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $dc9ba0e80928e41f$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $dc9ba0e80928e41f$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dc9ba0e80928e41f$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($dc9ba0e80928e41f$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $dc9ba0e80928e41f$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $dc9ba0e80928e41f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $dc9ba0e80928e41f$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $dc9ba0e80928e41f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $dc9ba0e80928e41f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $589337cb438129b2$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $dc9ba0e80928e41f$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $589337cb438129b2$export$ef9e2056653f0c8e)(exception) || (0, $589337cb438129b2$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $dc9ba0e80928e41f$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $589337cb438129b2$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $dc9ba0e80928e41f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $9c59e8e75b362707$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $589337cb438129b2$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $dc9ba0e80928e41f$var$eventFromError(stackParser, exception);
    if ((0, $589337cb438129b2$export$53b83ca8eaab0383)(exception) || (0, $589337cb438129b2$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $dc9ba0e80928e41f$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dc9ba0e80928e41f$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9c59e8e75b362707$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $dc9ba0e80928e41f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $dc9ba0e80928e41f$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $589337cb438129b2$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $dc9ba0e80928e41f$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $c81bf7dc777f388b$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $589337cb438129b2$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $589337cb438129b2$export$9671ea99bd126ace)(exception)) {
        const className = $dc9ba0e80928e41f$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $dc9ba0e80928e41f$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $dc9ba0e80928e41f$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $5b5d30d493d52e2d$export$56d8a8a25bd48b81 = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
let $5b5d30d493d52e2d$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $5b5d30d493d52e2d$export$b79738ab10c590b2() {
    return $5b5d30d493d52e2d$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $5b5d30d493d52e2d$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $5b5d30d493d52e2d$var$ignoreOnError++;
    setTimeout(()=>{
        $5b5d30d493d52e2d$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $5b5d30d493d52e2d$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $c81bf7dc777f388b$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$5b5d30d493d52e2d$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $5b5d30d493d52e2d$export$1265a142ff5ba165();
            (0, $9f847727088f1638$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $9c59e8e75b362707$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $9c59e8e75b362707$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $c37e2caa280569a6$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $c81bf7dc777f388b$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $5b5d30d493d52e2d$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $29d8eea2d8941562$export$1cfafeee2987818b)();
    const { referrer: referrer } = $5b5d30d493d52e2d$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $5b5d30d493d52e2d$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $bb5bd6b9d5062a3d$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $bb5bd6b9d5062a3d$export$1df9218a526d318d extends (0, $6cf218271a2b9727$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $bb5bd6b9d5062a3d$export$4e107b20a7f977(options);
        const sdkSource = (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $d105212be8ef3e08$export$8ad33f488b1ab046)();
        (0, $5af3b6741fff5864$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments?.enableLogs;
        if ((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs)) (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $174234c32d07109b$export$f8ed83d3b6a0b504)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $174234c32d07109b$export$f8ed83d3b6a0b504)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $174234c32d07109b$export$f8ed83d3b6a0b504)(this);
                }, $bb5bd6b9d5062a3d$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $4bc438c68de95f0b$export$3e12ad68afa434ac));
            this.on('beforeSendSession', (0, $4bc438c68de95f0b$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $dc9ba0e80928e41f$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $dc9ba0e80928e41f$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $bb5bd6b9d5062a3d$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $8ef58dc7c2709363$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $8ef58dc7c2709363$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $8ef58dc7c2709363$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $363ccd4c925357ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







// We keep the handlers globally
const $c3748baef1be3a96$var$handlers = {};
const $c3748baef1be3a96$var$instrumented = {};
/** Add a handler function. */ function $c3748baef1be3a96$export$a4e09611e30da72e(type, handler) {
    $c3748baef1be3a96$var$handlers[type] = $c3748baef1be3a96$var$handlers[type] || [];
    $c3748baef1be3a96$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $c3748baef1be3a96$export$b17eab759a1cb5fe() {
    Object.keys($c3748baef1be3a96$var$handlers).forEach((key)=>{
        $c3748baef1be3a96$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $c3748baef1be3a96$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$c3748baef1be3a96$var$instrumented[type]) {
        $c3748baef1be3a96$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $c3748baef1be3a96$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $c3748baef1be3a96$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $0468f98f82a2901b$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ec3cc6fa6feba73$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $5ec3cc6fa6feba73$var$instrumentConsole);
}
function $5ec3cc6fa6feba73$var$instrumentConsole() {
    if (!('console' in (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1))) return;
    (0, $176facbb7e775926$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).console)) return;
        (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $176facbb7e775926$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $c3748baef1be3a96$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $176facbb7e775926$export$77c4ce905194557b)[level];
                log?.apply((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}






const $5feb8845cb140bed$var$WINDOW = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $5feb8845cb140bed$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $5feb8845cb140bed$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $5feb8845cb140bed$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $5feb8845cb140bed$export$67fc34576016d6ec() {
    return 'history' in $5feb8845cb140bed$var$WINDOW && !!$5feb8845cb140bed$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $5feb8845cb140bed$export$edf3cb81fd7d2a3e = $5feb8845cb140bed$var$_isFetchSupported;
function $5feb8845cb140bed$var$_isFetchSupported() {
    if (!('fetch' in $5feb8845cb140bed$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5feb8845cb140bed$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $5feb8845cb140bed$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$5feb8845cb140bed$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5feb8845cb140bed$export$d5f608b368e73f38($5feb8845cb140bed$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $5feb8845cb140bed$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5feb8845cb140bed$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $5feb8845cb140bed$export$531055a6c684a70a() {
    return 'ReportingObserver' in $5feb8845cb140bed$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $5feb8845cb140bed$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5feb8845cb140bed$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6aca7650fd219aea$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, ()=>$6aca7650fd219aea$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $6aca7650fd219aea$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, ()=>$6aca7650fd219aea$var$instrumentFetch($6aca7650fd219aea$var$streamHandler));
}
function $6aca7650fd219aea$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $5feb8845cb140bed$export$c82d238e23c40b21)()) return;
    (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $6aca7650fd219aea$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $6aca7650fd219aea$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $c3748baef1be3a96$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $c3748baef1be3a96$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $c3748baef1be3a96$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $589337cb438129b2$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $6aca7650fd219aea$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $6aca7650fd219aea$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $6aca7650fd219aea$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $c3748baef1be3a96$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $6aca7650fd219aea$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $6aca7650fd219aea$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($6aca7650fd219aea$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $6aca7650fd219aea$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $6aca7650fd219aea$var$getUrlFromResource(url),
            method: $6aca7650fd219aea$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $6aca7650fd219aea$var$getUrlFromResource(arg),
        method: $6aca7650fd219aea$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $6aca7650fd219aea$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $589337cb438129b2$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $aca86d62216cb8fb$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $06146234430e0089$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $06146234430e0089$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $06146234430e0089$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $06146234430e0089$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $06146234430e0089$export$5339fcdc8e2a427c(url) {
    if ($06146234430e0089$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $06146234430e0089$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $06146234430e0089$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $06146234430e0089$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $2318cd9d6e86bae3$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $2318cd9d6e86bae3$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $2318cd9d6e86bae3$export$d7a7d984b0791405] = 'route';
    }
    if (request?.method) attributes[0, $2318cd9d6e86bae3$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $2318cd9d6e86bae3$export$d7a7d984b0791405] = 'route';
        }
        if (!$06146234430e0089$export$e258e13805402ba7(urlObject)) {
            attributes[0, $2318cd9d6e86bae3$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $06146234430e0089$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $06146234430e0089$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $06146234430e0089$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $06146234430e0089$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $111d85c50ec35f56$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $90f2dab71d5db1d2$export$56d8a8a25bd48b81 = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);


const $a0a377cc979a64fb$var$DEBOUNCE_DURATION = 1000;
let $a0a377cc979a64fb$var$debounceTimerID;
let $a0a377cc979a64fb$var$lastCapturedEventType;
let $a0a377cc979a64fb$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a0a377cc979a64fb$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $a0a377cc979a64fb$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $a0a377cc979a64fb$export$3014bbf0af0e1d4a() {
    if (!(0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $c3748baef1be3a96$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $a0a377cc979a64fb$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $a0a377cc979a64fb$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $a0a377cc979a64fb$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $a0a377cc979a64fb$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $a0a377cc979a64fb$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $a0a377cc979a64fb$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $a0a377cc979a64fb$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $a0a377cc979a64fb$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($a0a377cc979a64fb$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $c81bf7dc777f388b$export$e73679ffaf56810e)(target, '_sentryId', (0, $9c59e8e75b362707$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$a0a377cc979a64fb$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $a0a377cc979a64fb$var$lastCapturedEventType = event.type;
            $a0a377cc979a64fb$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($a0a377cc979a64fb$var$debounceTimerID);
        $a0a377cc979a64fb$var$debounceTimerID = (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).setTimeout(()=>{
            $a0a377cc979a64fb$var$lastCapturedEventTargetId = undefined;
            $a0a377cc979a64fb$var$lastCapturedEventType = undefined;
        }, $a0a377cc979a64fb$var$DEBOUNCE_DURATION);
    };
}
function $a0a377cc979a64fb$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $ce8273d9bc6d10d7$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ce8273d9bc6d10d7$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $ce8273d9bc6d10d7$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $ce8273d9bc6d10d7$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ce8273d9bc6d10d7$var$lastHref;
        $ce8273d9bc6d10d7$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $c3748baef1be3a96$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $5feb8845cb140bed$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $ce8273d9bc6d10d7$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $ce8273d9bc6d10d7$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $ce8273d9bc6d10d7$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $c3748baef1be3a96$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $ce8273d9bc6d10d7$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $9f2469494cfb8866$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9f2469494cfb8866$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $9f2469494cfb8866$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $9f2469494cfb8866$export$c67d533bf77cbf54() {
    if (!(0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $589337cb438129b2$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $9f2469494cfb8866$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$9f2469494cfb8866$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$9f2469494cfb8866$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $c3748baef1be3a96$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$9f2469494cfb8866$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $589337cb438129b2$export$844ec244b1367d54)(header) && (0, $589337cb438129b2$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$9f2469494cfb8866$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $363ccd4c925357ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $c3748baef1be3a96$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $9f2469494cfb8866$var$parseXhrUrlArg(url) {
    if ((0, $589337cb438129b2$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $edc2799e935626eb$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8df539b4156e83a4$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8df539b4156e83a4$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8df539b4156e83a4$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8df539b4156e83a4$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $5ec3cc6fa6feba73$export$1d6e0d073f9e6723)($8df539b4156e83a4$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $a0a377cc979a64fb$export$5aeffd3db2cf9df7)($8df539b4156e83a4$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $9f2469494cfb8866$export$26ace48dd54c9aea)($8df539b4156e83a4$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $6aca7650fd219aea$export$f75d3c772c923df0)($8df539b4156e83a4$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ce8273d9bc6d10d7$export$3f18c56c58114e75)($8df539b4156e83a4$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8df539b4156e83a4$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8df539b4156e83a4$export$c079d904b326663a = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($8df539b4156e83a4$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8df539b4156e83a4$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        (0, $8ef58dc7c2709363$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $9c59e8e75b362707$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8df539b4156e83a4$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8df539b4156e83a4$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $edc2799e935626eb$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8df539b4156e83a4$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8df539b4156e83a4$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8df539b4156e83a4$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8df539b4156e83a4$var$_isEvent(event) ? event.target : event;
            target = (0, $29d8eea2d8941562$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $29d8eea2d8941562$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $8ef58dc7c2709363$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8df539b4156e83a4$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $111d85c50ec35f56$export$d771ef054122c30a)(handlerData.level),
            message: (0, $8a164c7c8b40ded1$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $8a164c7c8b40ded1$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $8ef58dc7c2709363$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8df539b4156e83a4$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $9f2469494cfb8866$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $aca86d62216cb8fb$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $8ef58dc7c2709363$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8df539b4156e83a4$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $8ef58dc7c2709363$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $aca86d62216cb8fb$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $8ef58dc7c2709363$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8df539b4156e83a4$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $06146234430e0089$export$7a5253c0f62e0150)((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $06146234430e0089$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $06146234430e0089$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $8ef58dc7c2709363$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8df539b4156e83a4$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $0df144546ad14f76$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $0df144546ad14f76$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $0df144546ad14f76$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $0df144546ad14f76$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81), 'setTimeout', $0df144546ad14f76$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81), 'setInterval', $0df144546ad14f76$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $c81bf7dc777f388b$export$9563e054e6f787fb)((0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81), 'requestAnimationFrame', $0df144546ad14f76$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81)) (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $0df144546ad14f76$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $0df144546ad14f76$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$0df144546ad14f76$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $0df144546ad14f76$export$59bfe9f1c76150e = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($0df144546ad14f76$var$_browserApiErrorsIntegration);
function $0df144546ad14f76$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $5b5d30d493d52e2d$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $0468f98f82a2901b$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $0df144546ad14f76$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $5b5d30d493d52e2d$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $0468f98f82a2901b$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $0df144546ad14f76$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $0468f98f82a2901b$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $c81bf7dc777f388b$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $0468f98f82a2901b$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $5b5d30d493d52e2d$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $0df144546ad14f76$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($0df144546ad14f76$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $5b5d30d493d52e2d$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $0468f98f82a2901b$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $0df144546ad14f76$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $5b5d30d493d52e2d$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $0468f98f82a2901b$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $c81bf7dc777f388b$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $0df144546ad14f76$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $0df144546ad14f76$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $e517113fd2b197aa$export$1baa7880e357371c = (0, $d15a2ccb48c4b914$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $edc2799e935626eb$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $c37e2caa280569a6$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $c37e2caa280569a6$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $ce8273d9bc6d10d7$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $c37e2caa280569a6$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $c37e2caa280569a6$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $74c884a26c0be767$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $74c884a26c0be767$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $74c884a26c0be767$var$instrumentError);
}
function $74c884a26c0be767$var$instrumentError() {
    $74c884a26c0be767$var$_oldOnErrorHandler = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $c3748baef1be3a96$export$b18c893e424d3127)('error', handlerData);
        if ($74c884a26c0be767$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $74c884a26c0be767$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $bbff295c2646e3da$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bbff295c2646e3da$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $c3748baef1be3a96$export$a4e09611e30da72e)(type, handler);
    (0, $c3748baef1be3a96$export$e18d6c5462c01368)(type, $bbff295c2646e3da$var$instrumentUnhandledRejection);
}
function $bbff295c2646e3da$var$instrumentUnhandledRejection() {
    $bbff295c2646e3da$var$_oldOnUnhandledRejectionHandler = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $c3748baef1be3a96$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($bbff295c2646e3da$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $bbff295c2646e3da$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $173bfbb2c5073bf7$var$INTEGRATION_NAME = 'GlobalHandlers';
const $173bfbb2c5073bf7$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $173bfbb2c5073bf7$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $173bfbb2c5073bf7$var$_installGlobalOnErrorHandler(client);
                $173bfbb2c5073bf7$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $173bfbb2c5073bf7$var$_installGlobalOnUnhandledRejectionHandler(client);
                $173bfbb2c5073bf7$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $173bfbb2c5073bf7$export$66acc70e8cf2b71a = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($173bfbb2c5073bf7$var$_globalHandlersIntegration);
function $173bfbb2c5073bf7$var$_installGlobalOnErrorHandler(client) {
    (0, $74c884a26c0be767$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $173bfbb2c5073bf7$var$getOptions();
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client || (0, $5b5d30d493d52e2d$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $173bfbb2c5073bf7$var$_enhanceEventWithInitialFrame((0, $dc9ba0e80928e41f$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $c37e2caa280569a6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $173bfbb2c5073bf7$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $bbff295c2646e3da$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $173bfbb2c5073bf7$var$getOptions();
        if ((0, $9f847727088f1638$export$6bb76d6eba7e258c)() !== client || (0, $5b5d30d493d52e2d$export$b79738ab10c590b2)()) return;
        const error = $173bfbb2c5073bf7$var$_getUnhandledRejectionError(e);
        const event = (0, $589337cb438129b2$export$c3825b437cbdea5c)(error) ? $173bfbb2c5073bf7$var$_eventFromRejectionWithPrimitive(error) : (0, $dc9ba0e80928e41f$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $c37e2caa280569a6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $173bfbb2c5073bf7$var$_getUnhandledRejectionError(error) {
    if ((0, $589337cb438129b2$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $173bfbb2c5073bf7$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $173bfbb2c5073bf7$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $589337cb438129b2$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $29d8eea2d8941562$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $0468f98f82a2901b$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $173bfbb2c5073bf7$var$globalHandlerLog(type) {
    (0, $edc2799e935626eb$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $173bfbb2c5073bf7$var$getOptions() {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e6c3efc36a3f7a48$export$1378794447170364 = (0, $d15a2ccb48c4b914$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).navigator && !(0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).location && !(0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $5b5d30d493d52e2d$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $38fc78f09d72c92c$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $589337cb438129b2$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $38fc78f09d72c92c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $38fc78f09d72c92c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $589337cb438129b2$export$49034edbe6b62415)(error[key], Error)) {
        $38fc78f09d72c92c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $38fc78f09d72c92c$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $38fc78f09d72c92c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $589337cb438129b2$export$49034edbe6b62415)(childError, Error)) {
            $38fc78f09d72c92c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $38fc78f09d72c92c$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $38fc78f09d72c92c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $38fc78f09d72c92c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $38fc78f09d72c92c$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $875819ec8c58a828$var$DEFAULT_KEY = 'cause';
const $875819ec8c58a828$var$DEFAULT_LIMIT = 5;
const $875819ec8c58a828$var$INTEGRATION_NAME = 'LinkedErrors';
const $875819ec8c58a828$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $875819ec8c58a828$var$DEFAULT_LIMIT;
    const key = options.key || $875819ec8c58a828$var$DEFAULT_KEY;
    return {
        name: $875819ec8c58a828$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $38fc78f09d72c92c$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $dc9ba0e80928e41f$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $875819ec8c58a828$export$ebabb00eb7f3a395 = (0, $d15a2ccb48c4b914$export$2323046b9414659f)($875819ec8c58a828$var$_linkedErrorsIntegration);



const $0cc9da64a9e6702b$var$OPERA10_PRIORITY = 10;
const $0cc9da64a9e6702b$var$OPERA11_PRIORITY = 20;
const $0cc9da64a9e6702b$var$CHROME_PRIORITY = 30;
const $0cc9da64a9e6702b$var$WINJS_PRIORITY = 40;
const $0cc9da64a9e6702b$var$GECKO_PRIORITY = 50;
function $0cc9da64a9e6702b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $0468f98f82a2901b$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $0cc9da64a9e6702b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $0cc9da64a9e6702b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $0cc9da64a9e6702b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $0cc9da64a9e6702b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $0cc9da64a9e6702b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $0cc9da64a9e6702b$var$createFrame(filename, (0, $0468f98f82a2901b$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $0cc9da64a9e6702b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $0cc9da64a9e6702b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $0cc9da64a9e6702b$var$extractSafariExtensionDetails(parts[1] || (0, $0468f98f82a2901b$export$27c7e15d453fc0ac), parts[2]);
        return $0cc9da64a9e6702b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $0cc9da64a9e6702b$export$263a749fff749872 = [
    $0cc9da64a9e6702b$var$CHROME_PRIORITY,
    $0cc9da64a9e6702b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $0cc9da64a9e6702b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $0cc9da64a9e6702b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $0cc9da64a9e6702b$var$gecko = (line)=>{
    const parts = $0cc9da64a9e6702b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $0cc9da64a9e6702b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $0468f98f82a2901b$export$27c7e15d453fc0ac);
        [func, filename] = $0cc9da64a9e6702b$var$extractSafariExtensionDetails(func, filename);
        return $0cc9da64a9e6702b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $0cc9da64a9e6702b$export$cdba47a5dd2804d = [
    $0cc9da64a9e6702b$var$GECKO_PRIORITY,
    $0cc9da64a9e6702b$var$gecko
];
const $0cc9da64a9e6702b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $0cc9da64a9e6702b$var$winjs = (line)=>{
    const parts = $0cc9da64a9e6702b$var$winjsRegex.exec(line);
    return parts ? $0cc9da64a9e6702b$var$createFrame(parts[2], parts[1] || (0, $0468f98f82a2901b$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $0cc9da64a9e6702b$export$179460296da408e8 = [
    $0cc9da64a9e6702b$var$WINJS_PRIORITY,
    $0cc9da64a9e6702b$var$winjs
];
const $0cc9da64a9e6702b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $0cc9da64a9e6702b$var$opera10 = (line)=>{
    const parts = $0cc9da64a9e6702b$var$opera10Regex.exec(line);
    return parts ? $0cc9da64a9e6702b$var$createFrame(parts[2], parts[3] || (0, $0468f98f82a2901b$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $0cc9da64a9e6702b$export$f892b52c880ffc7a = [
    $0cc9da64a9e6702b$var$OPERA10_PRIORITY,
    $0cc9da64a9e6702b$var$opera10
];
const $0cc9da64a9e6702b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $0cc9da64a9e6702b$var$opera11 = (line)=>{
    const parts = $0cc9da64a9e6702b$var$opera11Regex.exec(line);
    return parts ? $0cc9da64a9e6702b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $0468f98f82a2901b$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $0cc9da64a9e6702b$export$af11af13f09fb0dc = [
    $0cc9da64a9e6702b$var$OPERA11_PRIORITY,
    $0cc9da64a9e6702b$var$opera11
];
const $0cc9da64a9e6702b$export$7197c0fe6554c079 = [
    $0cc9da64a9e6702b$export$263a749fff749872,
    $0cc9da64a9e6702b$export$cdba47a5dd2804d
];
const $0cc9da64a9e6702b$export$2b2b997d81bf3907 = (0, $0468f98f82a2901b$export$a5739666fb2d03d4)(...$0cc9da64a9e6702b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $0cc9da64a9e6702b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $0468f98f82a2901b$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $682e43d242262045$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $682e43d242262045$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $af7003ba16c6a6cf$export$78e43115b553f358)($682e43d242262045$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $af7003ba16c6a6cf$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $64655b0e60d13e12$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $64655b0e60d13e12$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $64655b0e60d13e12$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $64655b0e60d13e12$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $64655b0e60d13e12$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $64655b0e60d13e12$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $64655b0e60d13e12$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $64655b0e60d13e12$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $800302990c5d3b0f$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $800302990c5d3b0f$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $682e43d242262045$export$85a4f67f852183e6)(options.bufferSize || $800302990c5d3b0f$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $844234cfaaa4e7f6$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $844234cfaaa4e7f6$export$b11169581eeaf237)(type);
            if ((0, $64655b0e60d13e12$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $844234cfaaa4e7f6$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $844234cfaaa4e7f6$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $844234cfaaa4e7f6$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $844234cfaaa4e7f6$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $64655b0e60d13e12$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $682e43d242262045$export$c8667f1887a128dc)) {
                (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $af7003ba16c6a6cf$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6f7cb5d06be3d655$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $53c4b854532a1f6f$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $53c4b854532a1f6f$export$e464f4a514ac28a8(name) {
    const cached = $53c4b854532a1f6f$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $5feb8845cb140bed$export$d5f608b368e73f38)(impl)) return $53c4b854532a1f6f$var$cachedImplementations[name] = impl.bind((0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81));
    const document = (0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $6f7cb5d06be3d655$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $53c4b854532a1f6f$var$cachedImplementations[name] = impl.bind((0, $90f2dab71d5db1d2$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $53c4b854532a1f6f$export$8aa36702e8c8978(name) {
    $53c4b854532a1f6f$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $53c4b854532a1f6f$export$e7aa7bc5c1b3cfb3(...rest) {
    return $53c4b854532a1f6f$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $53c4b854532a1f6f$export$831dc9f2ab0a617b(...rest) {
    return $53c4b854532a1f6f$export$e464f4a514ac28a8('setTimeout')(...rest);
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $d961473794044663$export$b2311068c46d7cc8(options, nativeFetch = (0, $53c4b854532a1f6f$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $53c4b854532a1f6f$export$8aa36702e8c8978)('fetch');
            return (0, $af7003ba16c6a6cf$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $53c4b854532a1f6f$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $af7003ba16c6a6cf$export$78e43115b553f358)(e);
        }
    }
    return (0, $800302990c5d3b0f$export$d09f50d9ab7f7b69)(options, makeRequest);
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $7de1ff375154f515$export$dc236a86065879fc() {
    if ($7de1ff375154f515$var$_isEmbeddedBrowserExtension()) {
        if (0, $edc2799e935626eb$export$16a28057038b10ef) (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $7de1ff375154f515$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $29d8eea2d8941562$export$1cfafeee2987818b)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81) === (0, $5b5d30d493d52e2d$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $70f1d0e9f0f343cc$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $fac6d470bddaeab8$export$cb3c5c2ceb9818ba)(),
        (0, $cdd93176211eae30$export$7918117e9202e4fb)(),
        (0, $0df144546ad14f76$export$59bfe9f1c76150e)(),
        (0, $8df539b4156e83a4$export$c079d904b326663a)(),
        (0, $173bfbb2c5073bf7$export$66acc70e8cf2b71a)(),
        (0, $875819ec8c58a828$export$ebabb00eb7f3a395)(),
        (0, $802790f037fd704b$export$6d39aa44cd0c7567)(),
        (0, $e6c3efc36a3f7a48$export$1378794447170364)(),
        (0, $e517113fd2b197aa$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $70f1d0e9f0f343cc$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $7de1ff375154f515$export$dc236a86065879fc)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $0468f98f82a2901b$export$1d5cf88b347146d4)(options.stackParser || (0, $0cc9da64a9e6702b$export$2b2b997d81bf3907)),
        integrations: (0, $d15a2ccb48c4b914$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $70f1d0e9f0f343cc$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $d961473794044663$export$b2311068c46d7cc8)
    };
    return (0, $8d5a228c83d9aa33$export$5333c3f1c58d9bc1)((0, $bb5bd6b9d5062a3d$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $70f1d0e9f0f343cc$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $70f1d0e9f0f343cc$export$4e4d8b287d028b6b(callback) {
    callback();
}




const $8ab14a448800bd97$export$9ee0f498807aae17 = [
    'activate',
    'mount'
];


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $031850af1cc1ebfe$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// Vendored from https://github.com/vuejs/vue/blob/612fb89547711cacb030a3893a0065b785802860/src/core/util/debug.js
// with types only changes.
// The MIT License (MIT)
// Copyright (c) 2013-present, Yuxi (Evan) You
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
const $cb7786a3afbf1a46$var$classifyRE = /(?:^|[-_])(\w)/g;
const $cb7786a3afbf1a46$var$classify = (str)=>str.replace($cb7786a3afbf1a46$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, '');
const $cb7786a3afbf1a46$var$ROOT_COMPONENT_NAME = '<Root>';
const $cb7786a3afbf1a46$var$ANONYMOUS_COMPONENT_NAME = '<Anonymous>';
const $cb7786a3afbf1a46$var$repeat = (str, n)=>{
    return str.repeat(n);
};
const $cb7786a3afbf1a46$export$d82a8172625b3af9 = (vm, includeFile)=>{
    if (!vm) return $cb7786a3afbf1a46$var$ANONYMOUS_COMPONENT_NAME;
    if (vm.$root === vm) return $cb7786a3afbf1a46$var$ROOT_COMPONENT_NAME;
    // https://github.com/getsentry/sentry-javascript/issues/5204 $options can be undefined
    if (!vm.$options) return $cb7786a3afbf1a46$var$ANONYMOUS_COMPONENT_NAME;
    const options = vm.$options;
    let name = options.name || options._componentTag || options.__name;
    const file = options.__file;
    if (!name && file) {
        const match = file.match(/([^/\\]+)\.vue$/);
        if (match) name = match[1];
    }
    return (name ? `<${$cb7786a3afbf1a46$var$classify(name)}>` : $cb7786a3afbf1a46$var$ANONYMOUS_COMPONENT_NAME) + (file && includeFile !== false ? ` at ${file}` : '');
};
const $cb7786a3afbf1a46$export$83873098448601e3 = (vm)=>{
    if (vm && (vm._isVue || vm.__isVue) && vm.$parent) {
        const tree = [];
        let currentRecursiveSequence = 0;
        while(vm){
            if (tree.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const last = tree[tree.length - 1];
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (last.constructor === vm.constructor) {
                    currentRecursiveSequence++;
                    vm = vm.$parent; // eslint-disable-line no-param-reassign
                    continue;
                } else if (currentRecursiveSequence > 0) {
                    tree[tree.length - 1] = [
                        last,
                        currentRecursiveSequence
                    ];
                    currentRecursiveSequence = 0;
                }
            }
            tree.push(vm);
            vm = vm.$parent; // eslint-disable-line no-param-reassign
        }
        const formattedTree = tree.map((vm, i)=>`${(i === 0 ? '---> ' : $cb7786a3afbf1a46$var$repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? `${$cb7786a3afbf1a46$export$d82a8172625b3af9(vm[0])}... (${vm[1]} recursive calls)` : $cb7786a3afbf1a46$export$d82a8172625b3af9(vm))}`).join('\n');
        return `\n\nfound in\n\n${formattedTree}`;
    }
    return `\n\n(found in ${$cb7786a3afbf1a46$export$d82a8172625b3af9(vm)})`;
};


const $3a6f32fd2d39f93a$export$7c9633ecb845dba0 = (app, options)=>{
    const { errorHandler: originalErrorHandler } = app.config;
    app.config.errorHandler = (error, vm, lifecycleHook)=>{
        const componentName = (0, $cb7786a3afbf1a46$export$d82a8172625b3af9)(vm, false);
        const trace = vm ? (0, $cb7786a3afbf1a46$export$83873098448601e3)(vm) : '';
        const metadata = {
            componentName: componentName,
            lifecycleHook: lifecycleHook,
            trace: trace
        };
        if (options.attachProps && vm) {
            // Vue2 - $options.propsData
            // Vue3 - $props
            if (vm.$options?.propsData) metadata.propsData = vm.$options.propsData;
            else if (vm.$props) metadata.propsData = vm.$props;
        }
        // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
        setTimeout(()=>{
            (0, $c37e2caa280569a6$export$f5282963edea4a68)(error, {
                captureContext: {
                    contexts: {
                        vue: metadata
                    }
                },
                mechanism: {
                    handled: !!originalErrorHandler,
                    type: 'vue'
                }
            });
        });
        // Check if the current `app.config.errorHandler` is explicitly set by the user before calling it.
        if (typeof originalErrorHandler === 'function' && app.config.errorHandler) originalErrorHandler.call(app, error, vm, lifecycleHook);
        else throw error;
    };
};








/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $07dd3b62c3b844d0$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $07dd3b62c3b844d0$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $07dd3b62c3b844d0$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $589337cb438129b2$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}













/**
 * Print a log message for a started span.
 */ function $dcc80101bad48bba$export$2f3d84e767c9592b(span) {
    if (!(0, $4d9a3b90bc4bf260$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $9c37aa7fc05fb850$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $176facbb7e775926$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $dcc80101bad48bba$export$b77c830667a4d630(span) {
    if (!(0, $4d9a3b90bc4bf260$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $176facbb7e775926$export$af88d00dbe7f521).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $f7f50f925c5c8c56$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $89ce7ff72468c0b4$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $cda8c85e3d706d74$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $86a36c16d6aa6d6c$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $0d4e27b27a85ee3f$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $9c37aa7fc05fb850$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
















/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $5e18a830ed1296c3$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $9c37aa7fc05fb850$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $2318cd9d6e86bae3$export$69cd5c610c7bb96a)]: value,
            [(0, $2318cd9d6e86bae3$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $5e18a830ed1296c3$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $2318cd9d6e86bae3$export$f5f95cff026507b5];
        const value = attributes[0, $2318cd9d6e86bae3$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $9808c6b58856b18f$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $9808c6b58856b18f$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $0d4e27b27a85ee3f$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $2318cd9d6e86bae3$export$cca8dd30f57f805e)]: 'manual',
            [(0, $2318cd9d6e86bae3$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $9c37aa7fc05fb850$export$eb571cd9b5d98de8) : (0, $9c37aa7fc05fb850$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $9c37aa7fc05fb850$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $2318cd9d6e86bae3$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $9c37aa7fc05fb850$export$3f7581298f56c6d7)(endTimestamp);
        (0, $dcc80101bad48bba$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $2318cd9d6e86bae3$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $9c37aa7fc05fb850$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $2318cd9d6e86bae3$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $2318cd9d6e86bae3$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $2318cd9d6e86bae3$export$fea48ba9f4550879],
            measurements: (0, $5e18a830ed1296c3$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $9c37aa7fc05fb850$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('[Tracing] Adding an event to span:', name);
        const time = $9808c6b58856b18f$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $363ccd4c925357ec$export$ee52dced521e3e18)();
        const attributes = $9808c6b58856b18f$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $9c37aa7fc05fb850$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $9808c6b58856b18f$var$sendSpanEnvelope((0, $94c998eb136aa5f8$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $fde9b79c0b4f89b4$export$c08fbc656a245d03)(this).scope || (0, $9f847727088f1638$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$9808c6b58856b18f$var$isFullFinishedSpan((0, $9c37aa7fc05fb850$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $fde9b79c0b4f89b4$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $9c37aa7fc05fb850$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$9808c6b58856b18f$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $9c37aa7fc05fb850$export$92d8c23565496537)(span)).filter($9808c6b58856b18f$var$isFullFinishedSpan);
        const source = this._attributes[0, $2318cd9d6e86bae3$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $2318cd9d6e86bae3$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $2318cd9d6e86bae3$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $9c37aa7fc05fb850$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $9808c6b58856b18f$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $9808c6b58856b18f$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $0f6b86da9822f971$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $5e18a830ed1296c3$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $9808c6b58856b18f$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $9808c6b58856b18f$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $9808c6b58856b18f$var$isStandaloneSpan(span) {
    return span instanceof $9808c6b58856b18f$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $9808c6b58856b18f$var$sendSpanEnvelope(envelope) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $64a57ab2a539e567$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $64a57ab2a539e567$export$a1bd95187356f372(options, callback) {
    const acs = $64a57ab2a539e567$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $64a57ab2a539e567$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $9f847727088f1638$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $64a57ab2a539e567$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
            const parentSpan = $64a57ab2a539e567$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $86a36c16d6aa6d6c$export$d6636b700b76c516)() : $64a57ab2a539e567$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dd608bdde5b3e930$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $07dd3b62c3b844d0$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $40e6519088eb8e17$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $64a57ab2a539e567$export$c10292ad04b92aea(options, callback) {
    const acs = $64a57ab2a539e567$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $64a57ab2a539e567$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $9f847727088f1638$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $64a57ab2a539e567$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
            const parentSpan = $64a57ab2a539e567$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $86a36c16d6aa6d6c$export$d6636b700b76c516)() : $64a57ab2a539e567$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dd608bdde5b3e930$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $07dd3b62c3b844d0$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $9c37aa7fc05fb850$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $40e6519088eb8e17$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $64a57ab2a539e567$export$63dbba021a6b4047(options) {
    const acs = $64a57ab2a539e567$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $64a57ab2a539e567$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $9f847727088f1638$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$64a57ab2a539e567$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $9f847727088f1638$export$c7be4b0125a10cba)();
        const parentSpan = $64a57ab2a539e567$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $86a36c16d6aa6d6c$export$d6636b700b76c516)();
        return $64a57ab2a539e567$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $64a57ab2a539e567$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    const acs = (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $9f847727088f1638$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $7c3ac25d62fd1957$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $64a57ab2a539e567$export$e57ac09b143d92a2(span, callback) {
    const acs = $64a57ab2a539e567$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $9f847727088f1638$export$ec58d9285c204497)((scope)=>{
        (0, $dd608bdde5b3e930$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $64a57ab2a539e567$export$869298f9835abc68(callback) {
    const acs = $64a57ab2a539e567$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $9f847727088f1638$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$64a57ab2a539e567$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$64a57ab2a539e567$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $64a57ab2a539e567$export$f90b03291402f553(callback) {
    return (0, $9f847727088f1638$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $0d4e27b27a85ee3f$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $64a57ab2a539e567$export$e57ac09b143d92a2(null, callback);
    });
}
function $64a57ab2a539e567$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $89ce7ff72468c0b4$export$1f70765132c3c225)()) {
        const span = new (0, $86a36c16d6aa6d6c$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $0f6b86da9822f971$export$a117f995597e25df)(span)
            };
            (0, $0f6b86da9822f971$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $9f847727088f1638$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $64a57ab2a539e567$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $9c37aa7fc05fb850$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $0f6b86da9822f971$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $9c37aa7fc05fb850$export$5caecac1caaf3a71)(parentSpan);
        span = $64a57ab2a539e567$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $0f6b86da9822f971$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $64a57ab2a539e567$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $0f6b86da9822f971$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $dcc80101bad48bba$export$2f3d84e767c9592b)(span);
    (0, $fde9b79c0b4f89b4$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $64a57ab2a539e567$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $9c37aa7fc05fb850$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $64a57ab2a539e567$var$getAcs() {
    const carrier = (0, $420cbd4351e05ac9$export$19eade501500c6c1)();
    return (0, $cfdb81ddf007a497$export$f639b0c2752203be)(carrier);
}
function $64a57ab2a539e567$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$64a57ab2a539e567$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $f7f50f925c5c8c56$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $cda8c85e3d706d74$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $9808c6b58856b18f$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $2318cd9d6e86bae3$export$d7a7d984b0791405)]: 'custom',
            [(0, $2318cd9d6e86bae3$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $4d9a3b90bc4bf260$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $64a57ab2a539e567$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$64a57ab2a539e567$var$SUPPRESS_TRACING_KEY] ? false : (0, $9c37aa7fc05fb850$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $9808c6b58856b18f$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $86a36c16d6aa6d6c$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $9c37aa7fc05fb850$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $64a57ab2a539e567$var$getParentSpan(scope) {
    const span = (0, $dd608bdde5b3e930$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $9f847727088f1638$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $9c37aa7fc05fb850$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $64a57ab2a539e567$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $64a57ab2a539e567$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}






const $4d664a86f6cade40$var$VUE_OP = 'ui.vue';
// Mappings from operation to corresponding lifecycle hook.
const $4d664a86f6cade40$var$HOOKS = {
    activate: [
        'activated',
        'deactivated'
    ],
    create: [
        'beforeCreate',
        'created'
    ],
    // Vue 3
    unmount: [
        'beforeUnmount',
        'unmounted'
    ],
    // Vue 2
    destroy: [
        'beforeDestroy',
        'destroyed'
    ],
    mount: [
        'beforeMount',
        'mounted'
    ],
    update: [
        'beforeUpdate',
        'updated'
    ]
};
/** End the top-level component span and activity with a debounce configured using `timeout` option */ function $4d664a86f6cade40$var$maybeEndRootComponentSpan(vm, timestamp, timeout) {
    if (vm.$_sentryRootComponentSpanTimer) clearTimeout(vm.$_sentryRootComponentSpanTimer);
    vm.$_sentryRootComponentSpanTimer = setTimeout(()=>{
        if (vm.$root?.$_sentryRootComponentSpan) {
            vm.$root.$_sentryRootComponentSpan.end(timestamp);
            vm.$root.$_sentryRootComponentSpan = undefined;
        }
    }, timeout);
}
/** Find if the current component exists in the provided `TracingOptions.trackComponents` array option. */ function $4d664a86f6cade40$export$6a287d7b5ce1290(trackComponents, formattedName) {
    function extractComponentName(name) {
        return name.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, '$1');
    }
    const isMatched = trackComponents.some((compo)=>{
        return extractComponentName(formattedName) === extractComponentName(compo);
    });
    return isMatched;
}
const $4d664a86f6cade40$export$b7a7e504222a44a3 = (options = {})=>{
    const hooks = (options.hooks || []).concat((0, $8ab14a448800bd97$export$9ee0f498807aae17))// Removing potential duplicates
    .filter((value, index, self)=>self.indexOf(value) === index);
    const mixins = {};
    const rootComponentSpanFinalTimeout = options.timeout || 2000;
    for (const operation of hooks){
        // Retrieve corresponding hooks from Vue lifecycle.
        // eg. mount => ['beforeMount', 'mounted']
        const internalHooks = $4d664a86f6cade40$var$HOOKS[operation];
        if (!internalHooks) {
            (0, $031850af1cc1ebfe$export$16a28057038b10ef) && (0, $176facbb7e775926$export$af88d00dbe7f521).warn(`Unknown hook: ${operation}`);
            continue;
        }
        for (const internalHook of internalHooks)mixins[internalHook] = function() {
            const isRootComponent = this.$root === this;
            // 1. Root Component span creation
            if (isRootComponent) {
                this.$_sentryRootComponentSpan = this.$_sentryRootComponentSpan || (0, $64a57ab2a539e567$export$63dbba021a6b4047)({
                    name: 'Application Render',
                    op: `${$4d664a86f6cade40$var$VUE_OP}.render`,
                    attributes: {
                        [(0, $2318cd9d6e86bae3$export$cca8dd30f57f805e)]: 'auto.ui.vue'
                    },
                    onlyIfParent: true
                });
                // call debounced end function once directly, just in case no child components call it
                $4d664a86f6cade40$var$maybeEndRootComponentSpan(this, (0, $363ccd4c925357ec$export$ee52dced521e3e18)(), rootComponentSpanFinalTimeout);
            }
            // 2. Component tracking filter
            const componentName = (0, $cb7786a3afbf1a46$export$d82a8172625b3af9)(this, false);
            const shouldTrack = isRootComponent || // We always want to track the root component
            (Array.isArray(options.trackComponents) ? $4d664a86f6cade40$export$6a287d7b5ce1290(options.trackComponents, componentName) : options.trackComponents);
            // We always want to track root component
            if (!shouldTrack) {
                // even if we don't track `this` component, we still want to end the root span eventually
                $4d664a86f6cade40$var$maybeEndRootComponentSpan(this, (0, $363ccd4c925357ec$export$ee52dced521e3e18)(), rootComponentSpanFinalTimeout);
                return;
            }
            this.$_sentryComponentSpans = this.$_sentryComponentSpans || {};
            // 3. Span lifecycle management based on the hook type
            const isBeforeHook = internalHook === internalHooks[0];
            const activeSpan = this.$root?.$_sentryRootComponentSpan || (0, $9c37aa7fc05fb850$export$1be426a8e585c83e)();
            if (isBeforeHook) // Starting a new span in the "before" hook
            {
                if (activeSpan) {
                    // Cancel any existing span for this operation (safety measure)
                    // We're actually not sure if it will ever be the case that cleanup hooks were not called.
                    // However, we had users report that spans didn't end, so we end the span before
                    // starting a new one, just to be sure.
                    const oldSpan = this.$_sentryComponentSpans[operation];
                    if (oldSpan) oldSpan.end();
                    this.$_sentryComponentSpans[operation] = (0, $64a57ab2a539e567$export$63dbba021a6b4047)({
                        name: `Vue ${componentName}`,
                        op: `${$4d664a86f6cade40$var$VUE_OP}.${operation}`,
                        attributes: {
                            [(0, $2318cd9d6e86bae3$export$cca8dd30f57f805e)]: 'auto.ui.vue'
                        },
                        // UI spans should only be created if there is an active root span (transaction)
                        onlyIfParent: true
                    });
                }
            } else {
                // The span should already be added via the first handler call (in the 'before' hook)
                const span = this.$_sentryComponentSpans[operation];
                // The before hook did not start the tracking span, so the span was not added.
                // This is probably because it happened before there is an active transaction
                if (!span) return; // Skip if no span was created in the "before" hook
                span.end();
                // For any "after" hook, also schedule the root component span to end
                $4d664a86f6cade40$var$maybeEndRootComponentSpan(this, (0, $363ccd4c925357ec$export$ee52dced521e3e18)(), rootComponentSpanFinalTimeout);
            }
        };
    }
    return mixins;
};


const $a387d79934d38278$var$globalWithVue = (0, $a8a54d01550cceb5$export$f1a6cdb1459e81d1);
const $a387d79934d38278$var$DEFAULT_CONFIG = {
    Vue: $a387d79934d38278$var$globalWithVue.Vue,
    attachProps: true,
    attachErrorHandler: true,
    tracingOptions: {
        hooks: (0, $8ab14a448800bd97$export$9ee0f498807aae17),
        timeout: 2000,
        trackComponents: false
    }
};
const $a387d79934d38278$var$INTEGRATION_NAME = 'Vue';
const $a387d79934d38278$export$9a1c8cf2dd242ec3 = (0, $d15a2ccb48c4b914$export$2323046b9414659f)((integrationOptions = {})=>{
    return {
        name: $a387d79934d38278$var$INTEGRATION_NAME,
        setup (client) {
            const options = {
                ...$a387d79934d38278$var$DEFAULT_CONFIG,
                ...client.getOptions(),
                ...integrationOptions
            };
            if (!options.Vue && !options.app) {
                (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
                    // eslint-disable-next-line no-console
                    console.warn('[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured. Update your `Sentry.init` call with an appropriate config option: `app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2).');
                });
                return;
            }
            if (options.app) {
                const apps = Array.isArray(options.app) ? options.app : [
                    options.app
                ];
                apps.forEach((app)=>$a387d79934d38278$var$vueInit(app, options));
            } else if (options.Vue) $a387d79934d38278$var$vueInit(options.Vue, options);
        }
    };
});
const $a387d79934d38278$var$vueInit = (app, options)=>{
    if (0, $031850af1cc1ebfe$export$16a28057038b10ef) {
        // Check app is not mounted yet - should be mounted _after_ init()!
        // This is _somewhat_ private, but in the case that this doesn't exist we simply ignore it
        // See: https://github.com/vuejs/core/blob/eb2a83283caa9de0a45881d860a3cbd9d0bdd279/packages/runtime-core/src/component.ts#L394
        const appWithInstance = app;
        const isMounted = appWithInstance._instance?.isMounted;
        if (isMounted === true) (0, $176facbb7e775926$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`.');
        });
    }
    if (options.attachErrorHandler) (0, $3a6f32fd2d39f93a$export$7c9633ecb845dba0)(app, options);
    if ((0, $89ce7ff72468c0b4$export$1f70765132c3c225)(options)) app.mixin((0, $4d664a86f6cade40$export$b7a7e504222a44a3)(options.tracingOptions));
};


/**
 * Inits the Vue SDK
 */ function $3c19591962d133d3$export$2cd8252107eb640b(options = {}) {
    const opts = {
        defaultIntegrations: [
            ...(0, $70f1d0e9f0f343cc$export$5783b2920b1d62b9)(options),
            (0, $a387d79934d38278$export$9a1c8cf2dd242ec3)()
        ],
        ...options
    };
    (0, $5af3b6741fff5864$export$b9f95b027256052c)(opts, 'vue');
    return (0, $70f1d0e9f0f343cc$export$2cd8252107eb640b)(opts);
}



var $3nC6D = parcelRequire("3nC6D");
function $fc76a1f4dc8c458a$export$bc172ba1e1ec36b() {
    // if (appConfig.stage === Stage.DEV) {
    //   return;
    // }
    const stageMapping = {
        [(0, $3nC6D.Stage).LIVE]: 'FE-live',
        [(0, $3nC6D.Stage).TEST]: 'FE-test',
        [(0, $3nC6D.Stage).DEV]: 'FE-dev'
    };
    $3c19591962d133d3$export$2cd8252107eb640b({
        dsn: 'https://283574c00547490684d89a0eda42146f@o144610.ingest.us.sentry.io/1187521',
        environment: stageMapping[appConfig.stage]
    });
}
function $fc76a1f4dc8c458a$export$58da9968c3170cb1(error, text) {
    error.message = [
        error.message,
        text
    ].filter(Boolean).join('---');
    console.error(error);
    $c37e2caa280569a6$export$f5282963edea4a68(error);
}


var $96ab73bc46503854$export$2e2bcd8739ae039 = {
    install: (app)=>{
        function showError({ error: error, text: text }) {
            error && (0, $fc76a1f4dc8c458a$export$58da9968c3170cb1)(error, text);
            const content = [
                text,
                error && `[${error.toString()}]`
            ].filter(Boolean);
            app._context.provides.$swal('FEHLER', content, 'error');
        }
        app.config.globalProperties.$appMessage = {
            showError: showError,
            catchError (text) {
                return (error)=>showError({
                        error: error,
                        text: text
                    });
            }
        };
    }
};



let $0128437ff5e98274$var$script;




let $0128437ff5e98274$var$initialize = ()=>{
    $0128437ff5e98274$var$script = (parcelRequire("hSYxp"));
    if ($0128437ff5e98274$var$script.__esModule) $0128437ff5e98274$var$script = $0128437ff5e98274$var$script.default;
    $0128437ff5e98274$var$script.render = (parcelRequire("dcxto")).render;
    $0128437ff5e98274$var$script.__cssModules = {};
    (parcelRequire("a6UOl")).default($0128437ff5e98274$var$script);
    $0128437ff5e98274$var$script.__scopeId = 'data-v-aa6da4';
    $0128437ff5e98274$var$script.__file = "Slider.vue";
};
$0128437ff5e98274$var$initialize();
var $0128437ff5e98274$export$2e2bcd8739ae039 = $0128437ff5e98274$var$script;


let $ede9dcc9770498dd$var$script;




let $ede9dcc9770498dd$var$initialize = ()=>{
    $ede9dcc9770498dd$var$script = (parcelRequire("9V2sX"));
    if ($ede9dcc9770498dd$var$script.__esModule) $ede9dcc9770498dd$var$script = $ede9dcc9770498dd$var$script.default;
    $ede9dcc9770498dd$var$script.render = (parcelRequire("1leoA")).render;
    $ede9dcc9770498dd$var$script.__cssModules = {};
    (parcelRequire("ib9j0")).default($ede9dcc9770498dd$var$script);
    $ede9dcc9770498dd$var$script.__scopeId = 'data-v-e400e9';
    $ede9dcc9770498dd$var$script.__file = "Benefits.vue";
};
$ede9dcc9770498dd$var$initialize();
var $ede9dcc9770498dd$export$2e2bcd8739ae039 = $ede9dcc9770498dd$var$script;


let $0584e59be78d5df8$var$script;




let $0584e59be78d5df8$var$initialize = ()=>{
    $0584e59be78d5df8$var$script = (parcelRequire("9j7JG"));
    if ($0584e59be78d5df8$var$script.__esModule) $0584e59be78d5df8$var$script = $0584e59be78d5df8$var$script.default;
    $0584e59be78d5df8$var$script.render = (parcelRequire("iKBar")).render;
    $0584e59be78d5df8$var$script.__cssModules = {};
    (parcelRequire("hA3cl")).default($0584e59be78d5df8$var$script);
    $0584e59be78d5df8$var$script.__scopeId = 'data-v-1b0900';
    $0584e59be78d5df8$var$script.__file = "MapView.vue";
};
$0584e59be78d5df8$var$initialize();
var $0584e59be78d5df8$export$2e2bcd8739ae039 = $0584e59be78d5df8$var$script;


let $1217301e7ea19e19$var$script;




let $1217301e7ea19e19$var$initialize = ()=>{
    $1217301e7ea19e19$var$script = (parcelRequire("a95Vi"));
    if ($1217301e7ea19e19$var$script.__esModule) $1217301e7ea19e19$var$script = $1217301e7ea19e19$var$script.default;
    $1217301e7ea19e19$var$script.render = (parcelRequire("87HJt")).render;
    $1217301e7ea19e19$var$script.__cssModules = {};
    (parcelRequire("i69LM")).default($1217301e7ea19e19$var$script);
    $1217301e7ea19e19$var$script.__scopeId = 'data-v-d068a9';
    $1217301e7ea19e19$var$script.__file = "MapPlace.vue";
};
$1217301e7ea19e19$var$initialize();
var $1217301e7ea19e19$export$2e2bcd8739ae039 = $1217301e7ea19e19$var$script;


let $9a6e60725db6d122$var$script;




let $9a6e60725db6d122$var$initialize = ()=>{
    $9a6e60725db6d122$var$script = (parcelRequire("lIvrI"));
    if ($9a6e60725db6d122$var$script.__esModule) $9a6e60725db6d122$var$script = $9a6e60725db6d122$var$script.default;
    $9a6e60725db6d122$var$script.render = (parcelRequire("6SeFs")).render;
    $9a6e60725db6d122$var$script.__cssModules = {};
    (parcelRequire("e0XEF")).default($9a6e60725db6d122$var$script);
    $9a6e60725db6d122$var$script.__scopeId = 'data-v-ac834d';
    $9a6e60725db6d122$var$script.__file = "ReviewList.vue";
};
$9a6e60725db6d122$var$initialize();
var $9a6e60725db6d122$export$2e2bcd8739ae039 = $9a6e60725db6d122$var$script;


let $07746779c8cedcfb$var$script;




let $07746779c8cedcfb$var$initialize = ()=>{
    $07746779c8cedcfb$var$script = (parcelRequire("aTo9X"));
    if ($07746779c8cedcfb$var$script.__esModule) $07746779c8cedcfb$var$script = $07746779c8cedcfb$var$script.default;
    $07746779c8cedcfb$var$script.render = (parcelRequire("3ECrT")).render;
    $07746779c8cedcfb$var$script.__cssModules = {};
    (parcelRequire("dhFoX")).default($07746779c8cedcfb$var$script);
    $07746779c8cedcfb$var$script.__scopeId = 'data-v-e94a1f';
    $07746779c8cedcfb$var$script.__file = "SmallNavigation.vue";
};
$07746779c8cedcfb$var$initialize();
var $07746779c8cedcfb$export$2e2bcd8739ae039 = $07746779c8cedcfb$var$script;


let $675d893b96d428b6$var$script;




let $675d893b96d428b6$var$initialize = ()=>{
    $675d893b96d428b6$var$script = (parcelRequire("bJ0YQ"));
    if ($675d893b96d428b6$var$script.__esModule) $675d893b96d428b6$var$script = $675d893b96d428b6$var$script.default;
    $675d893b96d428b6$var$script.render = (parcelRequire("dhw3M")).render;
    $675d893b96d428b6$var$script.__cssModules = {};
    (parcelRequire("cxk3R")).default($675d893b96d428b6$var$script);
    $675d893b96d428b6$var$script.__scopeId = 'data-v-32cb06';
    $675d893b96d428b6$var$script.__file = "ThemeSwitcher.vue";
};
$675d893b96d428b6$var$initialize();
var $675d893b96d428b6$export$2e2bcd8739ae039 = $675d893b96d428b6$var$script;


let $852f51a7f7387df8$var$script;




let $852f51a7f7387df8$var$initialize = ()=>{
    $852f51a7f7387df8$var$script = (parcelRequire("lwDoh"));
    if ($852f51a7f7387df8$var$script.__esModule) $852f51a7f7387df8$var$script = $852f51a7f7387df8$var$script.default;
    $852f51a7f7387df8$var$script.render = (parcelRequire("ePL3k")).render;
    $852f51a7f7387df8$var$script.__cssModules = {};
    (parcelRequire("3CJ66")).default($852f51a7f7387df8$var$script);
    $852f51a7f7387df8$var$script.__scopeId = 'data-v-61b805';
    $852f51a7f7387df8$var$script.__file = "OnlineCourses.vue";
};
$852f51a7f7387df8$var$initialize();
var $852f51a7f7387df8$export$2e2bcd8739ae039 = $852f51a7f7387df8$var$script;


let $ad878aef071d8cb8$var$script;




let $ad878aef071d8cb8$var$initialize = ()=>{
    $ad878aef071d8cb8$var$script = (parcelRequire("jYIw2"));
    if ($ad878aef071d8cb8$var$script.__esModule) $ad878aef071d8cb8$var$script = $ad878aef071d8cb8$var$script.default;
    $ad878aef071d8cb8$var$script.render = (parcelRequire("ct83q")).render;
    $ad878aef071d8cb8$var$script.__cssModules = {};
    (parcelRequire("egGRc")).default($ad878aef071d8cb8$var$script);
    $ad878aef071d8cb8$var$script.__scopeId = 'data-v-00fe7d';
    $ad878aef071d8cb8$var$script.__file = "CourseOverview.vue";
};
$ad878aef071d8cb8$var$initialize();
var $ad878aef071d8cb8$export$2e2bcd8739ae039 = $ad878aef071d8cb8$var$script;


let $87a5aa05f6933949$var$script;




let $87a5aa05f6933949$var$initialize = ()=>{
    $87a5aa05f6933949$var$script = (parcelRequire("bkWut"));
    if ($87a5aa05f6933949$var$script.__esModule) $87a5aa05f6933949$var$script = $87a5aa05f6933949$var$script.default;
    $87a5aa05f6933949$var$script.render = (parcelRequire("lTqOk")).render;
    $87a5aa05f6933949$var$script.__cssModules = {};
    (parcelRequire("lhAxj")).default($87a5aa05f6933949$var$script);
    $87a5aa05f6933949$var$script.__scopeId = 'data-v-d9a716';
    $87a5aa05f6933949$var$script.__file = "ContactBar.vue";
};
$87a5aa05f6933949$var$initialize();
var $87a5aa05f6933949$export$2e2bcd8739ae039 = $87a5aa05f6933949$var$script;



var $8vZiU = parcelRequire("8vZiU");

var $3nC6D = parcelRequire("3nC6D");
globalThis.__VUE_PROD_DEVTOOLS__ = appConfig.stage !== (0, $3nC6D.Stage).LIVE;
const $392de7b86cf3c739$var$store = (0, $52e611b349343813$export$f51a9068ac82ea43)((0, $9e73890b8fa06c19$export$2e2bcd8739ae039));
const $392de7b86cf3c739$var$app = (0, $9xflP.createApp)({
    components: {
        Slider: $0128437ff5e98274$export$2e2bcd8739ae039,
        Benefits: $ede9dcc9770498dd$export$2e2bcd8739ae039,
        MapView: $0584e59be78d5df8$export$2e2bcd8739ae039,
        MapPlace: $1217301e7ea19e19$export$2e2bcd8739ae039,
        ReviewList: $9a6e60725db6d122$export$2e2bcd8739ae039,
        SmallNavigation: $07746779c8cedcfb$export$2e2bcd8739ae039,
        ThemeSwitcher: $675d893b96d428b6$export$2e2bcd8739ae039,
        OnlineCourses: $852f51a7f7387df8$export$2e2bcd8739ae039,
        CourseOverview: $ad878aef071d8cb8$export$2e2bcd8739ae039,
        ContactBar: $87a5aa05f6933949$export$2e2bcd8739ae039,
        NewsletterAndContactButton: $8vZiU.default
    }
});
$392de7b86cf3c739$var$app.use($392de7b86cf3c739$var$store);
$392de7b86cf3c739$var$app.use((0, $9daae95e2271d3c3$export$2e2bcd8739ae039));
$392de7b86cf3c739$var$app.use((0, $96ab73bc46503854$export$2e2bcd8739ae039));
(0, $fc76a1f4dc8c458a$export$bc172ba1e1ec36b)();
$392de7b86cf3c739$var$app.mount('#frontpage');

})();
//# sourceMappingURL=frontpage.js.map
